

Shopify.money_format = "{{amount}}";
Shopify.money = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  var symbol = document.querySelector('body').getAttribute('data-currency-symbol');
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value) + symbol;
};
window.theme = window.theme || {};

window.Slate = window.Slate || {};

/**
 *
 *  Slate a11y-helpers
 *
 */
Slate.A11yHelpers = (function() {
  var A11yHelpers = function() {
    this.init();

    $('.in-page-link').on(
      'click',
      $.proxy(function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }, this)
    );
  };

  A11yHelpers.prototype.init = function() {
    // on init, check if we need to set page focus
    var hash = window.location.hash;
    if (hash) {
      if (document.getElementById(hash.slice(1))) {
        this.pageLinkFocus($(hash));
      }
    }
  };

  A11yHelpers.prototype.trapFocus = function($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');
    $(document).on(eventName, function(evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  A11yHelpers.prototype.removeTrapFocus = function($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  /*
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area
   * so that next `tab` is where user expects
   * if focusing a link, just $link.focus();
  */
  A11yHelpers.prototype.pageLinkFocus = function($element) {
    if (!$element.length) return;

    $element.get(0).tabIndex = -1;
    $element.focus().addClass('js-focus-hidden');
    $element.one('blur', function() {
      $element.removeClass('js-focus-hidden').removeAttr('tabindex');
    });
  };

  return A11yHelpers;
})();

/**
 *
 *  Slate uri-helpers
 *
 */

// Based off the node module query-string https://github.com/sindresorhus/query-string
('use strict');
Slate.QueryString = (function() {
  var _encode = function(value) {
    return encodeURIComponent(value);
  };

  return {
    parse: function(str) {
      var ret = Object.create(null);

      if (typeof str !== 'string') {
        return ret;
      }

      str = str.trim().replace(/^(\?|#|&)/, '');

      if (!str) {
        return ret;
      }

      str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;

        key = decodeURIComponent(key);

        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);

        if (ret[key] === undefined) {
          ret[key] = val;
        } else if (Array.isArray(ret[key])) {
          ret[key].push(val);
        } else {
          ret[key] = [ret[key], val];
        }
      });

      return ret;
    },

    stringify: function(obj) {
      return obj
        ? Object.keys(obj)
            .sort()
            .map(function(key) {
              var val = obj[key];

              if (val === undefined) {
                return '';
              }

              if (val === null) {
                return key;
              }

              if (Array.isArray(val)) {
                var result = [];

                val
                  .slice()
                  .sort()
                  .forEach(function(val2) {
                    if (val2 === undefined) return;

                    if (val2 === null) {
                      result.push(_encode(key));
                    } else {
                      result.push(_encode(key) + '=' + _encode(val2));
                    }
                  });

                return result.join('&');
              }

              return _encode(key) + '=' + _encode(val);
            })
            .filter(function(x) {
              return x.length > 0;
            })
            .join('&')
        : '';
    }
  };
})();

/**
 *
 *  Initialize function for all Slate JS.
 *  - call any functions required on page load here.
 *
 */
Slate.init = function() {
  new Slate.A11yHelpers();
  Slate.checkUrlHash();
  Slate.initEventListeners();
  Slate.resetPasswordSuccess();
  Slate.customerAddressForm();
  Slate.rteElements();
  Slate.giftCardTemplate();
};

Slate.initEventListeners = function() {
  // Show reset password form
  $('#RecoverPassword').on('click', function(evt) {
    evt.preventDefault();
    Slate.toggleRecoverPasswordForm();
  });

  // Hide reset password form
  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    Slate.toggleRecoverPasswordForm();
  });
};

/**
 *
 *  Show/Hide recover password form
 *
 */
Slate.toggleRecoverPasswordForm = function() {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
};

/**
 *
 *  Show reset password success message
 *
 */
Slate.resetPasswordSuccess = function() {
  var $formState = $('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!$formState.length) return;

  // show success message
  $('#ResetSuccess').removeClass('hide');
};

/**
 *
 *  Show/hide customer address forms
 *
 */
Slate.customerAddressForm = function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) return;

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      {
        hideElement: 'AddressProvinceContainerNew'
      }
    );
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var addressUrl = $el.data('address-url');
    var confirmMessage = $el.data('confirm-message');
    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink(addressUrl, {
        parameters: { _method: 'delete' }
      });
    }
  });
};

/**
 *
 *  Wrap tables in the RTE with a scrollable div
 *  so they cannot break the layout if too wide.
 *  Wrap videos in div to force responsive layout.
 *
 */
Slate.rteElements = function() {
  $('.rte table').wrap('<div class="rte__table-wrapper"></div>');

  var $iframeVideo = $(
    'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
  );
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function() {
    // Add wrapper to make video responsive
    if (!$(this).parents('.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function() {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

/**
 *
 *  Adjust option_selection.js labels based on variant default values
 *
 */
Slate.simplifyVariantLabels = function(product, container) {
  // option_selection.js does not add a label if there is only one variant option.
  // Add one as long as it is not 'Title' (Shopify's default), add one.
  if (product.options.length === 1 && product.options[0] !== 'Title') {
    $('.selector-wrapper:eq(0)', container).prepend(
      '<label for="ProductSelect-option-0">' + product.options[0] + '</label>'
    );
  }
};

/**
 *
 *  Gift card template helpers
 *
 */
Slate.giftCardTemplate = function() {
  if (!$('body').hasClass('template-giftcard')) return;

  new QRCode(document.getElementById('QrCode'), {
    text: $('#QrCode').data('identifier'),
    width: 120,
    height: 120
  });

  $('#PrintGiftCard').on('click', function() {
    window.print();
  });

  /*=============================================================================
    Auto-select gift card code on click, based on ID passed to the function
  ==============================================================================*/
  $('.giftcard__code').on('click', { element: 'GiftCardDigits' }, selectText);

  function selectText(evt) {
    var doc = document,
      text = doc.getElementById(evt.data.element),
      range;

    if (doc.body.createTextRange) {
      // ms method
      range = doc.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      // moz, opera, webkit method
      var selection = window.getSelection();

      range = doc.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
};

/**
 *
 *  Check URL for reset password hash
 *
 */
Slate.checkUrlHash = function() {
  var hash = window.location.hash;

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    Slate.toggleRecoverPasswordForm();
  }
};

// Initialize Slate's JS on docready
$(Slate.init);

theme.strings = {
  addToCart: "Aan winkelwagen toevoegen",
  itemAddedToCart: "Artikel toegevoegd aan winkelwagen!",
  soldOut: "Uitverkocht",
  unavailable: "Niet beschikbaar",
  viewCart: "Winkelwagen bekijken",
  zoomClose: "Sluiten (esc)",
  zoomPrev: "Vorige (pijltoets links)",
  zoomNext: "Volgende (pijltoets rechts)"
};

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});

/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isIE7=-1!==c.indexOf("MSIE 7."),b.isIE8=-1!==c.indexOf("MSIE 8."),b.isLowIE=b.isIE7||b.isIE8,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",b.ev=c.mainEl&&c.mainEl.length?c.mainEl.eq(0):d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.wrap.css(b.fixedContentPos?{overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}:{top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),b.currTemplate[d]=f?a(f):!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||2!==c.which&&!c.ctrlKey&&!c.metaKey){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(a,c){if(void 0===c||c===!1)return!0;if(e=a.split("_"),e.length>1){var d=b.find(p+"-"+e[0]);if(d.length>0){var f=e[1];"replaceWith"===f?d[0]!==c[0]&&d.replaceWith(c):"img"===f?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(p+"-"+a).html(c)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery",g=Boolean(a.fn.mfpFastClick);return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s),h=g?"mfpFastClick":"click";e[h](function(){b.prev()}),f[h](function(){b.next()}),b.isIE7&&(x("b",e[0],!1,!0),x("a",e[0],!1,!0),x("b",f[0],!1,!0),x("a",f[0],!1,!0)),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowLeft&&g&&b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){v.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g,h=a(this);if(c){var i,j,k,l,m,n;h.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,v.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0],(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)&&(l=!0,d())}).on("touchend"+f,function(a){d(),l||n>1||(g=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){g=!1},b),e())})})}h.on("click"+f,function(){g||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&v.off("touchmove"+f+" touchend"+f)}}(),A()});

/*
 * jQuery FlexSlider v2.2.2
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
!function(a){a.flexslider=function(b,c){var d=a(b);d.vars=a.extend({},a.flexslider.defaults,c);var j,e=d.vars.namespace,f=window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture,g=("ontouchstart"in window||f||window.DocumentTouch&&document instanceof DocumentTouch)&&d.vars.touch,h="click touchend MSPointerUp",i="",k="vertical"===d.vars.direction,l=d.vars.reverse,m=d.vars.itemWidth>0,n="fade"===d.vars.animation,o=""!==d.vars.asNavFor,p={},q=!0;a.data(b,"flexslider",d),p={init:function(){d.animating=!1,d.currentSlide=parseInt(d.vars.startAt?d.vars.startAt:0,10),isNaN(d.currentSlide)&&(d.currentSlide=0),d.animatingTo=d.currentSlide,d.atEnd=0===d.currentSlide||d.currentSlide===d.last,d.containerSelector=d.vars.selector.substr(0,d.vars.selector.search(" ")),d.slides=a(d.vars.selector,d),d.container=a(d.containerSelector,d),d.count=d.slides.length,d.syncExists=a(d.vars.sync).length>0,"slide"===d.vars.animation&&(d.vars.animation="swing"),d.prop=k?"top":"marginLeft",d.args={},d.manualPause=!1,d.stopped=!1,d.started=!1,d.startTimeout=null,d.transitions=!d.vars.video&&!n&&d.vars.useCSS&&function(){var a=document.createElement("div"),b=["perspectiveProperty","WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var c in b)if(void 0!==a.style[b[c]])return d.pfx=b[c].replace("Perspective","").toLowerCase(),d.prop="-"+d.pfx+"-transform",!0;return!1}(),d.ensureAnimationEnd="",""!==d.vars.controlsContainer&&(d.controlsContainer=a(d.vars.controlsContainer).length>0&&a(d.vars.controlsContainer)),""!==d.vars.manualControls&&(d.manualControls=a(d.vars.manualControls).length>0&&a(d.vars.manualControls)),d.vars.randomize&&(d.slides.sort(function(){return Math.round(Math.random())-.5}),d.container.empty().append(d.slides)),d.doMath(),d.setup("init"),d.vars.controlNav&&p.controlNav.setup(),d.vars.directionNav&&p.directionNav.setup(),d.vars.keyboard&&(1===a(d.containerSelector).length||d.vars.multipleKeyboard)&&a(document).bind("keyup",function(a){var b=a.keyCode;if(!d.animating&&(39===b||37===b)){var c=39===b?d.getTarget("next"):37===b?d.getTarget("prev"):!1;d.flexAnimate(c,d.vars.pauseOnAction)}}),d.vars.mousewheel&&d.bind("mousewheel",function(a,b){a.preventDefault();var f=0>b?d.getTarget("next"):d.getTarget("prev");d.flexAnimate(f,d.vars.pauseOnAction)}),d.vars.pausePlay&&p.pausePlay.setup(),d.vars.slideshow&&d.vars.pauseInvisible&&p.pauseInvisible.init(),d.vars.slideshow&&(d.vars.pauseOnHover&&d.hover(function(){d.manualPlay||d.manualPause||d.pause()},function(){d.manualPause||d.manualPlay||d.stopped||d.play()}),d.vars.pauseInvisible&&p.pauseInvisible.isHidden()||(d.vars.initDelay>0?d.startTimeout=setTimeout(d.play,d.vars.initDelay):d.play())),o&&p.asNav.setup(),g&&d.vars.touch&&p.touch(),(!n||n&&d.vars.smoothHeight)&&a(window).bind("resize orientationchange focus",p.resize),d.find("img").attr("draggable","false"),setTimeout(function(){d.vars.start(d)},200)},asNav:{setup:function(){d.asNav=!0,d.animatingTo=Math.floor(d.currentSlide/d.move),d.currentItem=d.currentSlide,d.slides.removeClass(e+"active-slide").eq(d.currentItem).addClass(e+"active-slide"),f?(b._slider=d,d.slides.each(function(){var b=this;b._gesture=new MSGesture,b._gesture.target=b,b.addEventListener("MSPointerDown",function(a){a.preventDefault(),a.currentTarget._gesture&&a.currentTarget._gesture.addPointer(a.pointerId)},!1),b.addEventListener("MSGestureTap",function(b){b.preventDefault();var c=a(this),e=c.index();a(d.vars.asNavFor).data("flexslider").animating||c.hasClass("active")||(d.direction=d.currentItem<e?"next":"prev",d.flexAnimate(e,d.vars.pauseOnAction,!1,!0,!0))})})):d.slides.on(h,function(b){b.preventDefault();var c=a(this),f=c.index(),g=c.offset().left-a(d).scrollLeft();0>=g&&c.hasClass(e+"active-slide")?d.flexAnimate(d.getTarget("prev"),!0):a(d.vars.asNavFor).data("flexslider").animating||c.hasClass(e+"active-slide")||(d.direction=d.currentItem<f?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction,!1,!0,!0))})}},controlNav:{setup:function(){d.manualControls?p.controlNav.setupManual():p.controlNav.setupPaging()},setupPaging:function(){var f,g,b="thumbnails"===d.vars.controlNav?"control-thumbs":"control-paging",c=1;if(d.controlNavScaffold=a('<ol class="'+e+"control-nav "+e+b+'"></ol>'),d.pagingCount>1)for(var j=0;j<d.pagingCount;j++){if(g=d.slides.eq(j),f="thumbnails"===d.vars.controlNav?'<img src="'+g.attr("data-thumb")+'"/>':"<a>"+c+"</a>","thumbnails"===d.vars.controlNav&&!0===d.vars.thumbCaptions){var k=g.attr("data-thumbcaption");""!=k&&void 0!=k&&(f+='<span class="'+e+'caption">'+k+"</span>")}d.controlNavScaffold.append("<li>"+f+"</li>"),c++}d.controlsContainer?a(d.controlsContainer).append(d.controlNavScaffold):d.append(d.controlNavScaffold),p.controlNav.set(),p.controlNav.active(),d.controlNavScaffold.delegate("a, img",h,function(b){if(b.preventDefault(),""===i||i===b.type){var c=a(this),f=d.controlNav.index(c);c.hasClass(e+"active")||(d.direction=f>d.currentSlide?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction))}""===i&&(i=b.type),p.setToClearWatchedEvent()})},setupManual:function(){d.controlNav=d.manualControls,p.controlNav.active(),d.controlNav.bind(h,function(b){if(b.preventDefault(),""===i||i===b.type){var c=a(this),f=d.controlNav.index(c);c.hasClass(e+"active")||(d.direction=f>d.currentSlide?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction))}""===i&&(i=b.type),p.setToClearWatchedEvent()})},set:function(){var b="thumbnails"===d.vars.controlNav?"img":"a";d.controlNav=a("."+e+"control-nav li "+b,d.controlsContainer?d.controlsContainer:d)},active:function(){d.controlNav.removeClass(e+"active").eq(d.animatingTo).addClass(e+"active")},update:function(b,c){d.pagingCount>1&&"add"===b?d.controlNavScaffold.append(a("<li><a>"+d.count+"</a></li>")):1===d.pagingCount?d.controlNavScaffold.find("li").remove():d.controlNav.eq(c).closest("li").remove(),p.controlNav.set(),d.pagingCount>1&&d.pagingCount!==d.controlNav.length?d.update(c,b):p.controlNav.active()}},directionNav:{setup:function(){var b=a('<ul class="'+e+'direction-nav"><li><a class="'+e+'prev" href="#">'+d.vars.prevText+'</a></li><li><a class="'+e+'next" href="#">'+d.vars.nextText+"</a></li></ul>");d.controlsContainer?(a(d.controlsContainer).append(b),d.directionNav=a("."+e+"direction-nav li a",d.controlsContainer)):(d.append(b),d.directionNav=a("."+e+"direction-nav li a",d)),p.directionNav.update(),d.directionNav.bind(h,function(b){b.preventDefault();var c;(""===i||i===b.type)&&(c=a(this).hasClass(e+"next")?d.getTarget("next"):d.getTarget("prev"),d.flexAnimate(c,d.vars.pauseOnAction)),""===i&&(i=b.type),p.setToClearWatchedEvent()})},update:function(){var a=e+"disabled";1===d.pagingCount?d.directionNav.addClass(a).attr("tabindex","-1"):d.vars.animationLoop?d.directionNav.removeClass(a).removeAttr("tabindex"):0===d.animatingTo?d.directionNav.removeClass(a).filter("."+e+"prev").addClass(a).attr("tabindex","-1"):d.animatingTo===d.last?d.directionNav.removeClass(a).filter("."+e+"next").addClass(a).attr("tabindex","-1"):d.directionNav.removeClass(a).removeAttr("tabindex")}},pausePlay:{setup:function(){var b=a('<div class="'+e+'pauseplay"><a></a></div>');d.controlsContainer?(d.controlsContainer.append(b),d.pausePlay=a("."+e+"pauseplay a",d.controlsContainer)):(d.append(b),d.pausePlay=a("."+e+"pauseplay a",d)),p.pausePlay.update(d.vars.slideshow?e+"pause":e+"play"),d.pausePlay.bind(h,function(b){b.preventDefault(),(""===i||i===b.type)&&(a(this).hasClass(e+"pause")?(d.manualPause=!0,d.manualPlay=!1,d.pause()):(d.manualPause=!1,d.manualPlay=!0,d.play())),""===i&&(i=b.type),p.setToClearWatchedEvent()})},update:function(a){"play"===a?d.pausePlay.removeClass(e+"pause").addClass(e+"play").html(d.vars.playText):d.pausePlay.removeClass(e+"play").addClass(e+"pause").html(d.vars.pauseText)}},touch:function(){function r(f){d.animating?f.preventDefault():(window.navigator.msPointerEnabled||1===f.touches.length)&&(d.pause(),g=k?d.h:d.w,i=Number(new Date),o=f.touches[0].pageX,p=f.touches[0].pageY,e=m&&l&&d.animatingTo===d.last?0:m&&l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:m&&d.currentSlide===d.last?d.limit:m?(d.itemW+d.vars.itemMargin)*d.move*d.currentSlide:l?(d.last-d.currentSlide+d.cloneOffset)*g:(d.currentSlide+d.cloneOffset)*g,a=k?p:o,c=k?o:p,b.addEventListener("touchmove",s,!1),b.addEventListener("touchend",t,!1))}function s(b){o=b.touches[0].pageX,p=b.touches[0].pageY,h=k?a-p:a-o,j=k?Math.abs(h)<Math.abs(o-c):Math.abs(h)<Math.abs(p-c);var f=500;(!j||Number(new Date)-i>f)&&(b.preventDefault(),!n&&d.transitions&&(d.vars.animationLoop||(h/=0===d.currentSlide&&0>h||d.currentSlide===d.last&&h>0?Math.abs(h)/g+2:1),d.setProps(e+h,"setTouch")))}function t(){if(b.removeEventListener("touchmove",s,!1),d.animatingTo===d.currentSlide&&!j&&null!==h){var k=l?-h:h,m=k>0?d.getTarget("next"):d.getTarget("prev");d.canAdvance(m)&&(Number(new Date)-i<550&&Math.abs(k)>50||Math.abs(k)>g/2)?d.flexAnimate(m,d.vars.pauseOnAction):n||d.flexAnimate(d.currentSlide,d.vars.pauseOnAction,!0)}b.removeEventListener("touchend",t,!1),a=null,c=null,h=null,e=null}function u(a){a.stopPropagation(),d.animating?a.preventDefault():(d.pause(),b._gesture.addPointer(a.pointerId),q=0,g=k?d.h:d.w,i=Number(new Date),e=m&&l&&d.animatingTo===d.last?0:m&&l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:m&&d.currentSlide===d.last?d.limit:m?(d.itemW+d.vars.itemMargin)*d.move*d.currentSlide:l?(d.last-d.currentSlide+d.cloneOffset)*g:(d.currentSlide+d.cloneOffset)*g)}function v(a){a.stopPropagation();var c=a.target._slider;if(c){var d=-a.translationX,f=-a.translationY;return q+=k?f:d,h=q,j=k?Math.abs(q)<Math.abs(-d):Math.abs(q)<Math.abs(-f),a.detail===a.MSGESTURE_FLAG_INERTIA?(setImmediate(function(){b._gesture.stop()}),void 0):((!j||Number(new Date)-i>500)&&(a.preventDefault(),!n&&c.transitions&&(c.vars.animationLoop||(h=q/(0===c.currentSlide&&0>q||c.currentSlide===c.last&&q>0?Math.abs(q)/g+2:1)),c.setProps(e+h,"setTouch"))),void 0)}}function w(b){b.stopPropagation();var d=b.target._slider;if(d){if(d.animatingTo===d.currentSlide&&!j&&null!==h){var f=l?-h:h,k=f>0?d.getTarget("next"):d.getTarget("prev");d.canAdvance(k)&&(Number(new Date)-i<550&&Math.abs(f)>50||Math.abs(f)>g/2)?d.flexAnimate(k,d.vars.pauseOnAction):n||d.flexAnimate(d.currentSlide,d.vars.pauseOnAction,!0)}a=null,c=null,h=null,e=null,q=0}}var a,c,e,g,h,i,j=!1,o=0,p=0,q=0;f?(b.style.msTouchAction="none",b._gesture=new MSGesture,b._gesture.target=b,b.addEventListener("MSPointerDown",u,!1),b._slider=d,b.addEventListener("MSGestureChange",v,!1),b.addEventListener("MSGestureEnd",w,!1)):b.addEventListener("touchstart",r,!1)},resize:function(){!d.animating&&d.is(":visible")&&(m||d.doMath(),n?p.smoothHeight():m?(d.slides.width(d.computedW),d.update(d.pagingCount),d.setProps()):k?(d.viewport.height(d.h),d.setProps(d.h,"setTotal")):(d.vars.smoothHeight&&p.smoothHeight(),d.newSlides.width(d.computedW),d.setProps(d.computedW,"setTotal")))},smoothHeight:function(a){if(!k||n){var b=n?d:d.viewport;a?b.animate({height:d.slides.eq(d.animatingTo).height()},a):b.height(d.slides.eq(d.animatingTo).height())}},sync:function(b){var c=a(d.vars.sync).data("flexslider"),e=d.animatingTo;switch(b){case"animate":c.flexAnimate(e,d.vars.pauseOnAction,!1,!0);break;case"play":c.playing||c.asNav||c.play();break;case"pause":c.pause()}},uniqueID:function(b){return b.find("[id]").each(function(){var b=a(this);b.attr("id",b.attr("id")+"_clone")}),b},pauseInvisible:{visProp:null,init:function(){var a=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var b=0;b<a.length;b++)a[b]+"Hidden"in document&&(p.pauseInvisible.visProp=a[b]+"Hidden");if(p.pauseInvisible.visProp){var c=p.pauseInvisible.visProp.replace(/[H|h]idden/,"")+"visibilitychange";document.addEventListener(c,function(){p.pauseInvisible.isHidden()?d.startTimeout?clearTimeout(d.startTimeout):d.pause():d.started?d.play():d.vars.initDelay>0?setTimeout(d.play,d.vars.initDelay):d.play()})}},isHidden:function(){return document[p.pauseInvisible.visProp]||!1}},setToClearWatchedEvent:function(){clearTimeout(j),j=setTimeout(function(){i=""},3e3)}},d.flexAnimate=function(b,c,f,h,i){if(d.vars.animationLoop||b===d.currentSlide||(d.direction=b>d.currentSlide?"next":"prev"),o&&1===d.pagingCount&&(d.direction=d.currentItem<b?"next":"prev"),!d.animating&&(d.canAdvance(b,i)||f)&&d.is(":visible")){if(o&&h){var j=a(d.vars.asNavFor).data("flexslider");if(d.atEnd=0===b||b===d.count-1,j.flexAnimate(b,!0,!1,!0,i),d.direction=d.currentItem<b?"next":"prev",j.direction=d.direction,Math.ceil((b+1)/d.visible)-1===d.currentSlide||0===b)return d.currentItem=b,d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),!1;d.currentItem=b,d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),b=Math.floor(b/d.visible)}if(d.animating=!0,d.animatingTo=b,c&&d.pause(),d.vars.before(d),d.syncExists&&!i&&p.sync("animate"),d.vars.controlNav&&p.controlNav.active(),m||d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),d.atEnd=0===b||b===d.last,d.vars.directionNav&&p.directionNav.update(),b===d.last&&(d.vars.end(d),d.vars.animationLoop||d.pause()),n)g?(d.slides.eq(d.currentSlide).css({opacity:0,zIndex:1}),d.slides.eq(b).css({opacity:1,zIndex:2}),d.wrapup(q)):(d.slides.eq(d.currentSlide).css({zIndex:1}).animate({opacity:0},d.vars.animationSpeed,d.vars.easing),d.slides.eq(b).css({zIndex:2}).animate({opacity:1},d.vars.animationSpeed,d.vars.easing,d.wrapup));else{var r,s,t,q=k?d.slides.filter(":first").height():d.computedW;m?(r=d.vars.itemMargin,t=(d.itemW+r)*d.move*d.animatingTo,s=t>d.limit&&1!==d.visible?d.limit:t):s=0===d.currentSlide&&b===d.count-1&&d.vars.animationLoop&&"next"!==d.direction?l?(d.count+d.cloneOffset)*q:0:d.currentSlide===d.last&&0===b&&d.vars.animationLoop&&"prev"!==d.direction?l?0:(d.count+1)*q:l?(d.count-1-b+d.cloneOffset)*q:(b+d.cloneOffset)*q,d.setProps(s,"",d.vars.animationSpeed),d.transitions?(d.vars.animationLoop&&d.atEnd||(d.animating=!1,d.currentSlide=d.animatingTo),d.container.unbind("webkitTransitionEnd transitionend"),d.container.bind("webkitTransitionEnd transitionend",function(){clearTimeout(d.ensureAnimationEnd),d.wrapup(q)}),clearTimeout(d.ensureAnimationEnd),d.ensureAnimationEnd=setTimeout(function(){d.wrapup(q)},d.vars.animationSpeed+100)):d.container.animate(d.args,d.vars.animationSpeed,d.vars.easing,function(){d.wrapup(q)})}d.vars.smoothHeight&&p.smoothHeight(d.vars.animationSpeed)}},d.wrapup=function(a){n||m||(0===d.currentSlide&&d.animatingTo===d.last&&d.vars.animationLoop?d.setProps(a,"jumpEnd"):d.currentSlide===d.last&&0===d.animatingTo&&d.vars.animationLoop&&d.setProps(a,"jumpStart")),d.animating=!1,d.currentSlide=d.animatingTo,d.vars.after(d)},d.animateSlides=function(){!d.animating&&q&&d.flexAnimate(d.getTarget("next"))},d.pause=function(){clearInterval(d.animatedSlides),d.animatedSlides=null,d.playing=!1,d.vars.pausePlay&&p.pausePlay.update("play"),d.syncExists&&p.sync("pause")},d.play=function(){d.playing&&clearInterval(d.animatedSlides),d.animatedSlides=d.animatedSlides||setInterval(d.animateSlides,d.vars.slideshowSpeed),d.started=d.playing=!0,d.vars.pausePlay&&p.pausePlay.update("pause"),d.syncExists&&p.sync("play")},d.stop=function(){d.pause(),d.stopped=!0},d.canAdvance=function(a,b){var c=o?d.pagingCount-1:d.last;return b?!0:o&&d.currentItem===d.count-1&&0===a&&"prev"===d.direction?!0:o&&0===d.currentItem&&a===d.pagingCount-1&&"next"!==d.direction?!1:a!==d.currentSlide||o?d.vars.animationLoop?!0:d.atEnd&&0===d.currentSlide&&a===c&&"next"!==d.direction?!1:d.atEnd&&d.currentSlide===c&&0===a&&"next"===d.direction?!1:!0:!1},d.getTarget=function(a){return d.direction=a,"next"===a?d.currentSlide===d.last?0:d.currentSlide+1:0===d.currentSlide?d.last:d.currentSlide-1},d.setProps=function(a,b,c){var e=function(){var c=a?a:(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo,e=function(){if(m)return"setTouch"===b?a:l&&d.animatingTo===d.last?0:l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:d.animatingTo===d.last?d.limit:c;switch(b){case"setTotal":return l?(d.count-1-d.currentSlide+d.cloneOffset)*a:(d.currentSlide+d.cloneOffset)*a;case"setTouch":return l?a:a;case"jumpEnd":return l?a:d.count*a;case"jumpStart":return l?d.count*a:a;default:return a}}();return-1*e+"px"}();d.transitions&&(e=k?"translate3d(0,"+e+",0)":"translate3d("+e+",0,0)",c=void 0!==c?c/1e3+"s":"0s",d.container.css("-"+d.pfx+"-transition-duration",c),d.container.css("transition-duration",c)),d.args[d.prop]=e,(d.transitions||void 0===c)&&d.container.css(d.args),d.container.css("transform",e)},d.setup=function(b){if(n)d.slides.css({width:"100%","float":"left",marginRight:"-100%",position:"relative"}),"init"===b&&(g?d.slides.css({opacity:0,display:"block",webkitTransition:"opacity "+d.vars.animationSpeed/1e3+"s ease",zIndex:1}).eq(d.currentSlide).css({opacity:1,zIndex:2}):d.slides.css({opacity:0,display:"block",zIndex:1}).eq(d.currentSlide).css({zIndex:2}).animate({opacity:1},d.vars.animationSpeed,d.vars.easing)),d.vars.smoothHeight&&p.smoothHeight();else{var c,f;"init"===b&&(d.viewport=a('<div class="'+e+'viewport"></div>').css({overflow:"hidden",position:"relative"}).appendTo(d).append(d.container),d.cloneCount=0,d.cloneOffset=0,l&&(f=a.makeArray(d.slides).reverse(),d.slides=a(f),d.container.empty().append(d.slides))),d.vars.animationLoop&&!m&&(d.cloneCount=2,d.cloneOffset=1,"init"!==b&&d.container.find(".clone").remove(),p.uniqueID(d.slides.first().clone().addClass("clone").attr("aria-hidden","true")).appendTo(d.container),p.uniqueID(d.slides.last().clone().addClass("clone").attr("aria-hidden","true")).prependTo(d.container)),d.newSlides=a(d.vars.selector,d),c=l?d.count-1-d.currentSlide+d.cloneOffset:d.currentSlide+d.cloneOffset,k&&!m?(d.container.height(200*(d.count+d.cloneCount)+"%").css("position","absolute").width("100%"),setTimeout(function(){d.newSlides.css({display:"block"}),d.doMath(),d.viewport.height(d.h),d.setProps(c*d.h,"init")},"init"===b?100:0)):(d.container.width(200*(d.count+d.cloneCount)+"%"),d.setProps(c*d.computedW,"init"),setTimeout(function(){d.doMath(),d.newSlides.css({width:d.computedW,"float":"left",display:"block"}),d.vars.smoothHeight&&p.smoothHeight()},"init"===b?100:0))}m||d.slides.removeClass(e+"active-slide").eq(d.currentSlide).addClass(e+"active-slide"),d.vars.init(d)},d.doMath=function(){var a=d.slides.first(),b=d.vars.itemMargin,c=d.vars.minItems,e=d.vars.maxItems;d.w=void 0===d.viewport?d.width():d.viewport.width(),d.h=a.height(),d.boxPadding=a.outerWidth()-a.width(),m?(d.itemT=d.vars.itemWidth+b,d.minW=c?c*d.itemT:d.w,d.maxW=e?e*d.itemT-b:d.w,d.itemW=d.minW>d.w?(d.w-b*(c-1))/c:d.maxW<d.w?(d.w-b*(e-1))/e:d.vars.itemWidth>d.w?d.w:d.vars.itemWidth,d.visible=Math.floor(d.w/d.itemW),d.move=d.vars.move>0&&d.vars.move<d.visible?d.vars.move:d.visible,d.pagingCount=Math.ceil((d.count-d.visible)/d.move+1),d.last=d.pagingCount-1,d.limit=1===d.pagingCount?0:d.vars.itemWidth>d.w?d.itemW*(d.count-1)+b*(d.count-1):(d.itemW+b)*d.count-d.w-b):(d.itemW=d.w,d.pagingCount=d.count,d.last=d.count-1),d.computedW=d.itemW-d.boxPadding},d.update=function(a,b){d.doMath(),m||(a<d.currentSlide?d.currentSlide+=1:a<=d.currentSlide&&0!==a&&(d.currentSlide-=1),d.animatingTo=d.currentSlide),d.vars.controlNav&&!d.manualControls&&("add"===b&&!m||d.pagingCount>d.controlNav.length?p.controlNav.update("add"):("remove"===b&&!m||d.pagingCount<d.controlNav.length)&&(m&&d.currentSlide>d.last&&(d.currentSlide-=1,d.animatingTo-=1),p.controlNav.update("remove",d.last))),d.vars.directionNav&&p.directionNav.update()},d.addSlide=function(b,c){var e=a(b);d.count+=1,d.last=d.count-1,k&&l?void 0!==c?d.slides.eq(d.count-c).after(e):d.container.prepend(e):void 0!==c?d.slides.eq(c).before(e):d.container.append(e),d.update(c,"add"),d.slides=a(d.vars.selector+":not(.clone)",d),d.setup(),d.vars.added(d)},d.removeSlide=function(b){var c=isNaN(b)?d.slides.index(a(b)):b;d.count-=1,d.last=d.count-1,isNaN(b)?a(b,d.slides).remove():k&&l?d.slides.eq(d.last).remove():d.slides.eq(b).remove(),d.doMath(),d.update(c,"remove"),d.slides=a(d.vars.selector+":not(.clone)",d),d.setup(),d.vars.removed(d)},p.init()},a(window).blur(function(){focused=!1}).focus(function(){focused=!0}),a.flexslider.defaults={namespace:"flex-",selector:".slides > li",animation:"fade",easing:"swing",direction:"horizontal",reverse:!1,animationLoop:!0,smoothHeight:!1,startAt:0,slideshow:!0,slideshowSpeed:7e3,animationSpeed:600,initDelay:0,randomize:!1,thumbCaptions:!1,pauseOnAction:!0,pauseOnHover:!1,pauseInvisible:!0,useCSS:!0,touch:!0,video:!1,controlNav:!0,directionNav:!0,prevText:"Previous",nextText:"Next",keyboard:!0,multipleKeyboard:!1,mousewheel:!1,pausePlay:!1,pauseText:"Pause",playText:"Play",controlsContainer:"",manualControls:"",sync:"",asNavFor:"",itemWidth:0,itemMargin:0,minItems:1,maxItems:0,move:0,allowOneSlide:!0,start:function(){},before:function(){},after:function(){},end:function(){},added:function(){},removed:function(){},init:function(){}},a.fn.flexslider=function(b){if(void 0===b&&(b={}),"object"==typeof b)return this.each(function(){var c=a(this),d=b.selector?b.selector:".slides > li",e=c.find(d);1===e.length&&b.allowOneSlide===!0||0===e.length?(e.fadeIn(400),b.start&&b.start(c)):void 0===c.data("flexslider")&&new a.flexslider(this,b)});var c=a(this).data("flexslider");switch(b){case"play":c.play();break;case"pause":c.pause();break;case"stop":c.stop();break;case"next":c.flexAnimate(c.getTarget("next"),!0);break;case"prev":case"previous":c.flexAnimate(c.getTarget("prev"),!0);break;default:"number"==typeof b&&c.flexAnimate(b,!0)}}}(jQuery);

/*!
	Zoom v1.7.13 - 2014-04-29
	Enlarge images on click or mouseover.
	(c) 2014 Jack Moore - http://www.jacklmoore.com/zoom
	license: http://www.opensource.org/licenses/mit-license.php
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,m,l,r,s,f=o(t).css("position"),h=o(n);return t.style.position=/(absolute|fixed)/.test(f)?f:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=o(t).outerWidth(),u=o(t).outerHeight(),n===t?(m=c,a=u):(m=h.outerWidth(),a=h.outerHeight()),l=(e.width-c)/m,r=(e.height-u)/a,s=h.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,m),0),e.style.left=t*-l+"px",e.style.top=n*-r+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e,i=o.extend({},t,n||{}),u=i.target||this,c=this,a=o(c),m=document.createElement("img"),l=o(m),r="mousemove.zoom",s=!1,f=!1;(i.url||(e=a.find("img"),e[0]&&(i.url=e.data("src")||e.attr("src")),i.url))&&(function(){var o=u.style.position,t=u.style.overflow;a.one("zoom.destroy",function(){a.off(".zoom"),u.style.position=o,u.style.overflow=t,l.remove()})}(),m.onload=function(){function t(t){e.init(),e.move(t),l.stop().fadeTo(o.support.opacity?i.duration:0,1,o.isFunction(i.onZoomIn)?i.onZoomIn.call(m):!1)}function n(){l.stop().fadeTo(i.duration,0,o.isFunction(i.onZoomOut)?i.onZoomOut.call(m):!1)}var e=o.zoom(u,c,m,i.magnify);"grab"===i.on?a.on("mousedown.zoom",function(i){1===i.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(r,e.move)}),t(i),o(document).on(r,e.move),i.preventDefault())}):"click"===i.on?a.on("click.zoom",function(i){return s?void 0:(s=!0,t(i),o(document).on(r,e.move),o(document).one("click.zoom",function(){n(),s=!1,o(document).off(r,e.move)}),!1)}):"toggle"===i.on?a.on("click.zoom",function(o){s?n():t(o),s=!s}):"mouseover"===i.on&&(e.init(),a.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(r,e.move)),i.touch&&a.on("touchstart.zoom",function(o){o.preventDefault(),f?(f=!1,n()):(f=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),e.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}),o.isFunction(i.callback)&&i.callback.call(m)},m.src=i.url)})},o.fn.zoom.defaults=t})(window.jQuery);

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
}function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
}return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
!r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
})){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
}function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
}),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) return;

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});


/* ================ MODULES ================ */
theme.Hero = (function() {
  theme.sliders = function(slider, sectionId) {
    this.$slider = $(slider);
    this.$sliderContainer = this.$slider.parent();
    this.sectionId = sectionId;
    this.selectors = {
      slide: '[data-slider-item]',
      activeSlide: '.flex-active-slide',
      navigationButton: '[data-slider-navigation]',
      previousArrow: '[data-slider-prev]',
      pauseButton: '[data-slider-pause]',
      textContentMobile: '[data-text-mobile]',
      indicatorDotsContainer: '.flex-control-nav',
      hideSlideClass: 'slide-hide'
    };
    $.extend(theme.strings, {
      loadSlideA11yString: this.$slider.data('slide-nav-a11y'),
      activeSlideA11yString: this.$slider.data('slide-nav-active-a11y')
    });
    this.sliderArgs = {
      animation: this.$slider.data('transition'),
      animationSpeed: 500,
      pauseOnHover: true,
      keyboard: false,
      slideshow: this.$slider.data('autoplay'),
      slideshowSpeed: this.$slider.data('speed'),
      controlNav: true,
      directionNav: false,
      smoothHeight: false,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      controlsContainer: this.$sliderContainer.find('[data-slider-controls]'),
      before: function(slider) {
        var $slider = $(slider);
        $slider.resize();
        $slider
          .find(this.selectors.slide)
          .not(this.selectors.activeSlide)
          .removeClass(this.selectors.hideSlideClass);

        this.showMobileText(slider.animatingTo);
      }.bind(this),
      start: function(slider) {
        this.slideshowA11y(slider);
      }.bind(this),
      after: function(slider) {
        var $slider = $(slider);
        var $slides = $slider.find(this.selectors.slide);
        var $activeSlide = $slider.find(this.selectors.activeSlide);
        var $indicatorDots = this.$sliderContainer.find(
          this.selectors.indicatorDotsContainer + ' a'
        );
        var currentSlide = slider.currentSlide;

        $slider
          .find(this.selectors.slide)
          .not(this.selectors.activeSlide)
          .addClass(this.selectors.hideSlideClass);
        $slider.resize();

        $slides.attr('aria-hidden', true);
        $activeSlide.attr('aria-hidden', false);

        $indicatorDots.each(function(index) {
          var $element = $(this);
          $element.attr('aria-label', slideLabel(currentSlide, index));
          if (index === currentSlide) {
            $element.attr('aria-current', true);
          } else {
            $element.removeAttr('aria-current');
          }
        });
      }.bind(this),
      init: function(slider) {
        var $slider = $(slider);
        var previousArrow = this.selectors.previousArrow;
        $slider
          .find(this.selectors.activeSlide)
          .removeClass(this.selectors.hideSlideClass);

        this.$sliderContainer
          .find(this.selectors.navigationButton)
          .on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              !(evt.keyCode === '13' || evt.keyCode === '32')
            ) {
              return;
            }
            if ($(this).is(previousArrow)) {
              $slider.flexslider('prev');
            } else {
              $slider.flexslider('next');
            }
          });

        if (this.sliderArgs.slideshow) {
          var $pauseButton = this.$sliderContainer.find(
            this.selectors.pauseButton
          );
          var pausedClass = 'is-paused';

          $pauseButton.on('click', function() {
            var $element = $(this);
            var isPaused = $element.hasClass(pausedClass);

            $element.toggleClass(pausedClass, !isPaused).attr({
              'aria-label': isPaused
                ? $element.data('label-pause')
                : $element.data('label-play'),
              'aria-pressed': !isPaused
            });

            if (isPaused) {
              $slider.flexslider('play');
            } else {
              $slider.flexslider('pause');
            }
          });
        }
      }.bind(this)
    };

    this.slideshowA11y = function(slider) {
      var $slider = $(slider);
      var $sliderContainer = this.$sliderContainer;
      var $slides = $slider.find(this.selectors.slide);
      var $activeSlide = $slider.find(this.selectors.activeSlide);
      var sectionId = this.sectionId;
      var $indicatorsContainer = $sliderContainer.find(
        this.selectors.indicatorDotsContainer
      );
      var $indicatorDots = $indicatorsContainer.find('a');

      $sliderContainer
        .on('keyup', this.keyboardNavigation.bind(this))
        .on('focusin', function(evt) {
          if (
            $(this).has(evt.target).length &&
            $slider.attr('aria-live') === 'polite'
          ) {
            return;
          }

          $slider.attr('aria-live', 'polite');
        })
        .on('focusout', function(evt) {
          if ($(this).has(evt.relatedTarget).length) {
            return;
          }

          $slider.removeAttr('aria-live');
        });

      $slides.each(function() {
        $(this).attr('aria-hidden', true);
      });

      $activeSlide.attr('aria-hidden', false);

      // Turn off default listeners set by flexslider
      $indicatorsContainer.off('click touchend MSPointerUp keyup', 'a, img');

      $indicatorDots.each(function(index) {
        var $element = $(this);
        $element
          .attr({
            'aria-label': slideLabel(0, index),
            'data-slide-number': index + 1,
            'aria-controls':
              '#' +
              $slides
                .filter(':not(.clone)')
                .eq(index)
                .attr('id'),
            href: '#flexslider--' + sectionId
          })
          .on('keyup click', function(evt) {
            if (evt.type === 'keyup') {
              if (evt.which === 9) {
                evt.stopImmediatePropagation();
              }
              if (evt.which !== 13 && evt.which !== 32) {
                return;
              }
            }

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number') - 1;

            $slider.flexslider(slideNumber);

            if (evt.type === 'keyup' || evt.detail === 0) {
              $sliderContainer.focus();
            }
          });

        if (index === 0) {
          $element.attr('aria-current', true);
        }
      });
    };

    this.showMobileText = function(slideIndex) {
      var $allTextContent = this.$sliderContainer.find(
        this.selectors.textContentMobile
      );
      var $currentTextContent = $allTextContent.filter(
        '[data-mobile-slide-text=' + slideIndex + ']'
      );
      $allTextContent.hide();
      $currentTextContent.show();
    };

    this.keyboardNavigation = function(evt) {
      if (evt.keyCode === 37) {
        this.$slider.flexslider('prev');
      }
      if (evt.keyCode === 39) {
        this.$slider.flexslider('next');
      }
    };

    if (this.$slider.length) {
      if (this.$slider.find('li').length === 1) {
        this.sliderArgs.slideshow = false;
        this.sliderArgs.slideshowSpeed = 0;
        this.sliderArgs.controlNav = false;
        this.sliderArgs.directionNav = false;
        this.sliderArgs.touch = false;
      }

      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      var slideshow = this.$slider.flexslider(this.sliderArgs);

      this.showMobileText(0);

      return slideshow;
    }
  };

  function slideLabel(activeSlideIndex, currentIndex) {
    var label =
      activeSlideIndex === currentIndex
        ? theme.strings.activeSlideA11yString
        : theme.strings.loadSlideA11yString;

    return label.replace('[slide_number]', currentIndex + 1);
  }

  return theme.sliders;
})();


/* ================ Sections ================ */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    this.sectionId = $container.attr('data-section-id');

    this.selectors = {
      $html: $('html'),
      $addToCartBtn: $('#AddToCart', this.$container),
      $productPrice: $('#ProductPrice', this.$container),
      $comparePrice: $('#ComparePrice', this.$container),
      $comparePriceA11y: $('#ComparePriceA11y', this.$container),
      $priceA11y: $('#PriceA11y', this.$container),
      $addToCartText: $('#AddToCartText', this.$container),
      $productImageWrappers: $(
        '.product-single__featured-image-wrapper',
        this.$container
      ),
      $productSinglePhotos: $('.product-single__photos', this.$container),
      $productThumbs: $('#ProductThumbs').find(
        '.product-single__thumbnail',
        this.$container
      ),
      $productImageGallery: $('.gallery__item', this.$container),
      $productFullDetails: $('.product-single__full-details', this.$container),
      $tabTrigger: $('.tab-switch__trigger', this.$container),
      $tabContent: $('.tab-switch__content', this.$container),
      $SKU: $('.variant-sku', this.$container),
      $shopifyPaymentButton: $('.shopify-payment-button', this.$container),
      $unitPrice: $('[data-unit-price]', this.$container),
      $unitPriceBaseUnit: $('[data-unit-price-base-unit]', this.$container),
      $unitPriceContainer: $('[data-unit-price-container]', this.$container)
    };

    theme.styleTextLinks();

    if (!$('#ProductJson-' + this.sectionId).html()) return;

    this.zoomType = $container.data('image-zoom-type');
    this.showExtraTab = $container.data('show-extra-tab');
    this.extraTabContent = $container.data('extra-tab-content');
    this.cartEnableAjax = $container.data('cart-enable-ajax');
    this.enableHistoryState = $container.data('enable-history-state') || false;

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + this.sectionId).innerHTML
    );

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.stringOverrides();
      this.initProductVariant();
      this.initBreakpoints();
      this.initThumbnails();

      if (this.cartEnableAjax) {
        this.enableAjax();
      }

      if (!theme.variables.bpSmall && this.zoomType === 'zoom-in') {
        this._productImageZoom();
      } else if (!theme.variables.bpSmall && this.zoomType === 'lightbox') {
        this.productImageGallery();
      }

      if (!this.showExtraTab || this.extraTabContent) {
        this.initProductTabs();
      }
    },

    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    initBreakpoints: function() {
      var self = this;
      var zoomType = $('#ProductSection').data('image-zoom-type');

      enquire.register(theme.variables.mediaQuerySmall, {
        match: function() {
          if (zoomType === 'zoom-in') {
            if (self.selectors.$productImageWrappers.length) {
              // remove event handlers for product zoom on mobile
              self.selectors.$productSinglePhotos.trigger('zoom.destroy');
              self.selectors.$productSinglePhotos.off();
              self.selectors.$productSinglePhotos.removeClass('image-zoom');
            }
          } else if (zoomType === 'lightbox') {
            // remove event handlers for lightbox on mobile
            self.selectors.$productImageGallery.off();
            self.selectors.$productSinglePhotos
              .find('img')
              .removeClass('lightbox');
          }

          theme.variables.bpSmall = true;
        },
        unmatch: function() {
          if (zoomType === 'zoom-in') {
            // Destroy zoom (in case it was already set), then set it up again
            this.selectors.$productSinglePhotos.trigger('zoom.destroy');

            // reinit product zoom
            this.selectors.$productSinglePhotos.each(function() {
              $(this)
                .addClass('image-zoom')
                .zoom({
                  url: $(this)
                    .find('img')
                    .attr('data-zoom')
                });
            });
          } else if (zoomType === 'lightbox') {
            // reinit lightbox
            self.productImageGallery();
            self.selectors.$productSinglePhotos
              .find('img')
              .addClass('lightbox');
          }

          theme.variables.bpSmall = false;
        }
      });
    },

    productImageGallery: function() {
      if (!this.selectors.$productImageGallery.length) return;

      var self = this;

      this.selectors.$productImageGallery.magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tClose: theme.strings.zoomClose,
        removalDelay: 500,
        callbacks: {
          open: function() {
            $('html').css('overflow-y', 'hidden');
          },
          close: function() {
            $('html').css('overflow-y', '');
          }
        },
        gallery: {
          enabled: true,
          navigateByImgClick: false,
          arrowMarkup:
            '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
          tPrev: theme.strings.zoomPrev,
          tNext: theme.strings.zoomNext
        }
      });

      this.selectors.$productSinglePhotos.bind('click', function() {
        var imageId = $(this).attr('data-image-id');
        self.selectors.$productImageGallery
          .filter('[data-image-id="' + imageId + '"]')
          .trigger('click');
      });
    },

    initThumbnails: function() {
      if (!this.selectors.$productThumbs.length) return;

      var self = this;

      // Switch the main image with one of the thumbnails
      // Note: this does not change the variant selected, just the image
      this.selectors.$productThumbs.on('click', function(evt) {
        evt.preventDefault();
        var newImageId = $(this).attr('data-image-id');
        self._switchImage(newImageId);
      });
    },

    initProductVariant: function() {
      var self = this;
      var product = this.productSingleObject;

      var selectCallback = function(variant, selector) {
        self.productPage({
          money_format: theme.moneyFormat,
          variant: variant,
          selector: selector,
          translations: {
            add_to_cart: theme.productStrings.addToCart,
            sold_out: theme.productStrings.soldOut,
            unavailable: theme.productStrings.unavailable
          }
        });
      };

      this.optionSelector = new Shopify.OptionSelectors(
        'ProductSelect-' + this.sectionId,
        {
          product: product,
          onVariantSelected: selectCallback,
          enableHistoryState: this.enableHistoryState
        }
      );

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      Slate.simplifyVariantLabels(this.productSingleObject, this.$container);
    },

    initProductTabs: function() {
      if (!this.selectors.$tabTrigger.length) return;

      var $trigger = this.selectors.$tabTrigger,
        $content = this.selectors.$tabContent,
        $el,
        link;

      // Hide extra content areas with JS and set active tab
      $content.filter(':gt(0)').addClass('is-hidden');
      $trigger.first().addClass('is-active');

      $trigger.on('click', function(evt) {
        evt.preventDefault();
        // set active tab
        $trigger.removeClass('is-active');
        $el = $(this).addClass('is-active');

        // hide all content areas, then show desired one
        link = $el.data('link');
        $content.addClass('is-hidden');
        $content
          .filter('[data-content="' + link + '"]')
          .removeClass('is-hidden');
      });
    },

    productPage: function(options) {
      var self = this;
      var variant = options.variant;

      if (variant) {
        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = variant.featured_image;
          self._switchImage(newImg.id);
        }

        // Update the product price
        this.selectors.$productPrice.html(
          Shopify.formatMoney(variant.price, theme.moneyFormat)
        );
        if($('.baby__product-price').length > 0){
          $('.baby__product-price').html(
                  Shopify.formatMoney(variant.price, theme.moneyFormat)
          );
        }
        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          this.selectors.$comparePrice
            .html(
              Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat)
            )
            .removeClass('hide');
          this.selectors.$productPrice.addClass(
            'product-single__price--on-sale'
          );
          this.selectors.$comparePriceA11y.attr('aria-hidden', 'false');
          this.selectors.$priceA11y.attr('aria-hidden', 'false');
        } else {
          this.selectors.$comparePrice.addClass('hide');
          this.selectors.$productPrice.removeClass(
            'product-single__price--on-sale'
          );
          this.selectors.$comparePriceA11y.attr('aria-hidden', 'true');
        }

        // Update the full details link
        var $link = this.selectors.$productFullDetails;
        if ($link.length) {
          $link.attr(
            'href',
            this.updateUrlParameter($link.attr('href'), 'variant', variant.id)
          );
        }

        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          this.selectors.$addToCartBtn.prop('disabled', false);
          this.selectors.$addToCartText.html(theme.strings.addToCart);
          this.selectors.$shopifyPaymentButton.show();
        } else {
          // Variant is sold out, disable the submit button and change the text
          this.selectors.$addToCartBtn.prop('disabled', true);
          this.selectors.$addToCartText.html(theme.strings.soldOut);
          // this.selectors.$addToCartText.html("<p>Sold Out</p>");
          this.selectors.$shopifyPaymentButton.hide();
        }
        // Show SKU
        this.selectors.$SKU.html(variant.sku);

        // Unit price
        this.selectors.$unitPriceContainer.removeClass(
          'product-unit-price--available'
        );

        if (variant.unit_price_measurement) {
          this.selectors.$unitPrice.html(
            Shopify.formatMoney(variant.unit_price, theme.moneyFormat)
          );
          this.selectors.$unitPriceBaseUnit.html(this._getBaseUnit(variant));
          this.selectors.$unitPriceContainer.addClass(
            'product-unit-price--available'
          );
        }
      } else {
        // The variant doesn't exist, disable submit button and change the text.
        // This may be an error or notice that a specific variant is not available.
        this.selectors.$addToCartBtn.prop('disabled', true);
        this.selectors.$addToCartText.html(theme.strings.unavailable);
        this.selectors.$shopifyPaymentButton.hide();
      }
    },

    updateUrlParameter: function(url, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return url + separator + key + '=' + value;
      }
    },

    enableAjax: function() {
      this.selectors.$addToCartBtn.on('click', function(evt) {
        evt.preventDefault();
        if ($(this).data('ajax-adding')) return;
        $(this).data('ajax-adding', true);
        $('.errors').remove();
        var $addToCartBtn = $('#AddToCartNew:not(.bold_hidden)').first(),
          $addToCartForm = $(this).closest('form'),
          $addToCartText = $addToCartBtn.find('span').first();
        var $realBtn = $(this);
        if ($addToCartForm.length) {
          var preparedForm = typeof window.leOlivePrepareOptionForm === 'function'
            ? window.leOlivePrepareOptionForm($addToCartForm[0])
            : null;
          if (!preparedForm) {
            if (typeof window.leOliveSyncBoldOptionProperties === 'function') {
              window.leOliveSyncBoldOptionProperties($addToCartForm[0]);
            }
            if (typeof window.leOliveRewriteZeroBagEmbroideryPropertyInputs === 'function') {
              window.leOliveRewriteZeroBagEmbroideryPropertyInputs($addToCartForm[0]);
            }
          }
          var restorePlaceholders = preparedForm
            ? preparedForm.restore
            : (typeof window.leOliveDisablePlaceholderOptionFields === 'function'
              ? window.leOliveDisablePlaceholderOptionFields($addToCartForm[0])
              : function () {});
          $addToCartBtn
            .data('add-to-cart', $addToCartText.text())
            .prop('disabled', true)
            .addClass('btn--ajax-disabled');
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            //Bold:PO
            data: window.FormData ? new FormData($addToCartForm[0]) : $addToCartForm.serialize(),
            contentType : false,
            processData : false,
            //Bold:PO
            complete: function () {
              restorePlaceholders();
            },
            success: function(data) {
              $realBtn.data('ajax-adding', false);

              if(typeof window.BOLD !== 'undefined'
                 && typeof window.BOLD.common !== 'undefined'
                 && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                data = window.BOLD.common.cartDoctor.fixItem(data);
              }

              var qty = parseInt(data.quantity, 10) || 1;
              if (theme.cache.$cartCount && theme.cache.$cartCount.length) {
                var currentCount = parseInt(theme.cache.$cartCount.first().text(), 10) || 0;
                theme.cache.$cartCount.text(currentCount + qty);
              }

              try {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: data }));
                document.dispatchEvent(new CustomEvent('cart:updated'));
                document.dispatchEvent(new CustomEvent('cart:update'));
              } catch (err) {}

              theme.afterCartLoad();
              $addToCartBtn.prop('disabled', false);
              $addToCartBtn.removeClass('btn--ajax-disabled');
              addToCartflip($addToCartBtn);
            },
            error: function(XMLHttpRequest) {
              $realBtn.data('ajax-adding', false);
              var data = eval('(' + XMLHttpRequest.responseText + ')');
              var response = data.description;
              var status = XMLHttpRequest.status;
              $addToCartBtn.removeClass('btn--ajax-disabled');
              if (status === 422) {
                $addToCartText.text(theme.strings.soldOut);
              } else {
                $addToCartBtn.prop('disabled', false);
                $addToCartText.text($addToCartBtn.data('add-to-cart'));
              }
              $addToCartBtn.after('<p class="errors">' + response + '</p>');
            }
          });
        } else {
          $realBtn.data('ajax-adding', false);
        }
      });
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.$productImageWrappers.selector +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.$productImageWrappers.selector +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass('hidden');
      $otherImages.addClass('hidden');
    },

    _productImageZoom: function() {
      var zoomType = $('#ProductSection').data('image-zoom-type');

      if (!theme.variables.bpSmall && zoomType === 'zoom-in') {
        if (
          !this.selectors.$productImageWrappers.length ||
          this.selectors.$html.hasClass('supports-touch')
        )
          return;

        // Destroy zoom (in case it was already set), then set it up again
        this.selectors.$productSinglePhotos.trigger('zoom.destroy');

        this.selectors.$productSinglePhotos.each(function() {
          $(this)
            .addClass('image-zoom')
            .zoom({
              url: $(this)
                .find('img')
                .attr('data-zoom'),
              onZoomIn: function() {
                $(this)
                  .prev('img')
                  .fadeOut(150);
              },
              onZoomOut: function() {
                $(this).css('opacity', '0');
                $(this)
                  .prev('img')
                  .show();
              }
            });
        });
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  });

  function addToCartflip($addToCartBtn) {
    $addToCartBtn = $($addToCartBtn).first();
    var $wrap = $addToCartBtn.closest('.product-single__cart-submit-wrapper');
    if ($wrap.length) {
      $wrap.find('.btn--view-cart, .product-single__notification').remove();
    } else {
      $addToCartBtn.siblings('.btn--view-cart, .product-single__notification').remove();
    }

    var cartUrl = $addToCartBtn.data('cart-url') || $('#AddToCart').attr('data-cart-url') || '/cart';

    $addToCartBtn.addClass('btn--unflipped').hide();

    $('<div></div>')
      .text(theme.strings.itemAddedToCart)
      .addClass('product-single__notification')
      .insertAfter($addToCartBtn);

    $('<button></button>')
      .text(theme.strings.viewCart)
      .addClass('btn btn--view-cart btn--secondary')
      .click(function(evt) {
        evt.preventDefault();

        window.location.href = cartUrl;

      })
      .insertAfter($addToCartBtn);

    $('.single-option-selector, [name="quantity"]').bind('click', function() {
      $(this)
        .closest('form')
        .find('.btn--view-cart, .product-single__notification, .errors')
        .remove();
      $(this)
        .closest('form')
        .find('.btn--unflipped')
        .removeClass('.btn--unflipped')
        .show();
    });
  }

  return Product;
})();

window.theme = window.theme || {};

theme.Collection = (function() {
  function Collection(container) {
    var $container = (this.$container = $(container));
    this.sortEnabled = $container.data('sort-enabled');
    this.tagsEnabled = $container.data('tags-enabled');

    this.init();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    init: function() {
      this.stringOverrides();

      if (this.sortEnabled) {
        this.collectionSorting();
      }

      if (this.tagsEnabled) {
        this.collectionTags();
      }
    },

    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.collectionStrings = theme.collectionStrings || {};
      $.extend(theme.strings, theme.collectionStrings);
    },

    collectionSorting: function() {
      /*=============================================================================
        Initialised here because collection liquid object is only available
        on collection pages, and not external JS files
      ==============================================================================*/
      Shopify.queryParams = {};
      if (location.search.length && location.search.indexOf('sort_by')) {
        for (
          var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
          i < aCouples.length;
          i++
        ) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      $(function() {
        $('#SortBy')
          .val(theme.strings.sortBy)
          .bind('change', function() {
            Shopify.queryParams.sort_by = jQuery(this).val();
            if (Shopify.queryParams.page) {
              delete Shopify.queryParams.page;
            }
            location.search = decodeURIComponent(
              jQuery.param(Shopify.queryParams)
            );
          });
      });
    },

    collectionTags: function() {
      var $browseBy = $('#BrowseBy');
      $(function() {
        $browseBy.bind('change', function() {
          location.href = $browseBy.val();
        });
      });
    }
  });

  return Collection;
})();

window.theme = window.theme || {};

theme.FooterSection = (function() {
  function Footer() {
    theme.styleTextLinks();
  }

  return Footer;
})();

window.theme = window.theme || {};

theme.FeaturedContentSection = (function() {
  function FeaturedContent() {
    theme.styleTextLinks();
  }

  return FeaturedContent;
})();

window.theme = window.theme || {};

theme.NewsletterSection = (function() {
  function Newsletter() {
    theme.styleTextLinks();
  }

  return Newsletter;
})();

window.theme = window.theme || {};

var classes = {
  navCollapse: 'site-nav__collapse',
  navExpand: 'site-nav__expand',
  activeSubmenu: 'site-nav__submenu--active',
  collapsedSubmenus: 'site-nav__submenu--collapsed',
  expandedSubmenus: 'site-nav__submenu--expanded'
};

var selectors = {
  submenu: '.site-nav__submenu',
  collapsedSubmenus: '.site-nav__submenu--collapsed',
  expandedSubmenus: '.site-nav__submenu--expanded',
  submenuTrigger: '.site-nav__link',
  submenuTriggerText: '.site-nav__link__text',
  submenuParent: '.site-nav--has-submenu',
  activeSubmenuParent: '.site-nav--active',
  activeSubmenu: '.site-nav__submenu--active',
  mobileMenuTrigger: '#ToggleMobileMenu',
  siteNav: '#SiteNav'
};

theme.SidebarSection = (function() {
  function Sidebar() {
    this.init();

    $(selectors.mobileMenuTrigger).on(
      'click',
      function(evt) {
        var $mobileMenu = $(evt.target).closest(selectors.mobileMenuTrigger);
        evt.preventDefault();
        $mobileMenu.toggleClass('open');
        $(selectors.siteNav).slideToggle(400, function() {
          // Hide submenus on menu toggle
          $(selectors.submenuParent)
            .has(selectors.expandedSubmenus)
            .hideSubmenu(0);
        });
      }.bind(this)
    );
  }

  Sidebar.prototype = _.assignIn({}, Sidebar.prototype, {
    init: function() {
      $(selectors.submenuTrigger).on('click', function() {
        var $trigger = $(this);
        var $parent = $trigger.parent(selectors.submenuParent);
        var shouldExpand = $trigger.hasClass(classes.navExpand);

        if (shouldExpand) {
          // Remove active class from all submenus
          $(selectors.activeSubmenu).removeClass(classes.activeSubmenu);

          // Show submenus with active elements
          var parentElement = $parent
            .find(selectors.collapsedSubmenus)
            .has(selectors.activeSubmenuParent)
            .parent(selectors.submenuParent)
            .not($parent);

          if (parentElement.length) {
            parentElement.showSubmenu(0);
            $parent.showSubmenu(400);
          }

          // Hide all other menus on the same level
          var parentElement = $parent
            .siblings(selectors.submenuParent)
            .has(selectors.expandedSubmenus);

          if (parentElement.length) {
            parentElement.hideSubmenu(400);
          }

        } else {
          $parent.hideSubmenu(400);
        }
      });
    }
  });

  $.fn.showSubmenu = function(duration) {
    // Toggle button
    this.children(selectors.submenuTrigger)
      .removeClass(classes.navExpand)
      .addClass(classes.navCollapse)
      .attr('aria-expanded', true)
      .children(selectors.submenuTriggerText)
      .text('-');

    // Show menu
    this.children(selectors.submenu)
      .addClass(classes.activeSubmenu)
      .addClass(classes.expandedSubmenus)
      .removeClass(classes.collapsedSubmenus)
      .slideDown(duration)
      .attr('aria-hidden', false);

    return this;
  };

  $.fn.hideSubmenu = function(duration) {
    // Toggle button
    this.children(selectors.submenuTrigger)
      .removeClass(classes.navCollapse)
      .addClass(classes.navExpand)
      .attr('aria-expanded', false)
      .children(selectors.submenuTriggerText)
      .text('+');

    // Hide submenu
    this.children(selectors.submenu)
      .addClass(classes.collapsedSubmenus)
      .removeClass(classes.expandedSubmenus)
      .slideUp(duration, function() {
        // Hide all child submenus
        $(this)
          .find(selectors.expandedSubmenus)
          .not(this)
          .parent(selectors.submenuParent)
          .hideSubmenu(0);
      })
      .attr('aria-hidden', true);

    return this;
  };

  return Sidebar;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    this.$container = $(container);
    var id = this.$container.attr('data-section-id');
    var slideshow = (this.slideshow = '#flexslider--' + id);

    theme.slideshows[slideshow] = new theme.Hero(slideshow, id);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var $slide = $(
        '#slide--' + evt.originalEvent.detail.blockId + ':not(.clone)'
      );
      var slideIndex = $slide.data('flexslider-index');
      var $slideImg = $slide.find('img');
      $slideshow.flexslider(slideIndex, true);
      $slideshow.flexslider('pause');

      $slideImg.on('load', this.resizeOnImageLoad($slideImg)).bind(this);
    },

    onSelect: function() {
      var $slideshow = $(this.slideshow);
      var $slideImg = $slideshow.find('img').first();

      $slideImg.on('load', this.resizeOnImageLoad($slideImg)).bind(this);
    },

    onBlockDeselect: function() {
      var $slideshow = $(this.slideshow);
      // Check if we need to resume autoplay
      if (
        $slideshow.data('autoplay') &&
        !$slideshow
          .parent()
          .find('[data-slider-pause]')
          .hasClass('is-paused')
      ) {
        $slideshow.flexslider('play');
      }
    },

    resizeOnImageLoad: function($slideImg) {
      var intervalAttempts = 0;
      var $slideshow = $(this.slideshow);

      // Needed to resize the slider as the on('load') listener doesn't wait until the image has loaded.
      var imageHeightCheck = setInterval(function() {
        intervalAttempts++;
        if (
          $slideImg.length &&
          $slideImg.height() === 0 &&
          intervalAttempts < 10
        ) {
          sizeSlideshow($slideshow);
        } else {
          // clear interval
          sizeSlideshow($slideshow);
          clearInterval(imageHeightCheck);
        }
      }, 500);

      function sizeSlideshow($slideshow) {
        $slideshow.resize();
      }
    }
  }
);

window.theme = window.theme || {};

theme.PasswordContent = (function() {
  function PasswordContent() {
    this.init();
  }

  PasswordContent.prototype = _.assignIn({}, PasswordContent.prototype, {
    init: function() {
      theme.styleTextLinks();

      $('.password-login-toggle').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        closeOnBgClick: false,
        closeBtnInside: false,
        closeOnContentClick: false,
        tClose: "Sluiten (esc)",
        removalDelay: 500,
        callbacks: {
          open: function() {
            window.setTimeout( function() { document.getElementById('Password').focus(); }, 50 );
          },
          close: function() {
            window.setTimeout( function() { document.getElementById('Email').focus(); }, 50 );
          }
        }
      });
      if ( $('.storefront-password-form .errors').size() ) {
        $('.password-login-toggle').click();
      }
    }
  });

  return PasswordContent;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.mapStrings.addressNoResults,
    addressQueryLimit: theme.mapStrings.addressQueryLimit,
    addressError: theme.mapStrings.addressError,
    authError: theme.mapStrings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) return;

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.mapStrings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') return;

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + this.key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + this.key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            // eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) return;

      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var self = this;
    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    $.get(recommendationsSectionUrl).then(function(section) {
      var recommendationsMarkup = $(section).html();
      if (recommendationsMarkup.trim() !== '') {
        self.$container.html(recommendationsMarkup);
      }
    });
  }

  return ProductRecommendations;
})();


// Add theme-related JS after _slate.js.liquid

theme.initCache = function () {
  theme.cache = {
    $html: $('html'),

    // Header and nav
    $cartCount: $('#CartCount'),
    $siteNav: $('#SiteNav'),

    // Product page
    $addToCartBtn: $('#AddToCart'),
    $productPrice: $('#ProductPrice'),
    $comparePrice: $('#ComparePrice'),
    $comparePriceA11y: $('#ComparePriceA11y'),
    $priceA11y: $('#PriceA11y'),
    $addToCartText: $('#AddToCartText'),
    $productImageWrap: $('#ProductPhoto'),
    $productFeaturedImage: $('#ProductPhotoImg'),
    $productThumbs: $('#ProductThumbs').find('.product-single__thumbnail'),
    $productImageGallery: $('.gallery__item'),
    $tabTrigger: $('.tab-switch__trigger'),
    $tabContent: $('.tab-switch__content'),

    // Collection page
    $sortDropdown: $('#SortBy'),
    $tagsDropdown: $('#BrowseBy'),

    // Cart page
    $emptyCart: $('#EmptyCart'),
    cartNoCookies: 'cart--no-cookies'
  };
};

theme.variables = {
  // Breakpoints from src/stylesheets/sass/_variables.scss.liquid
  mediaQuerySmall     : 'screen and (max-width: 749px)',
  mediaQueryMediumUp  : 'screen and (min-width: 750px)',
  bpSmall             : false,
  queryParams         : {}
};

theme.init = function () {
  theme.initCache();
  theme.getQueryParams();
  theme.setBreakpoints();
  theme.stringOverrides();
  theme.styleTextLinks();
  theme.afterCartLoad();

  

  
};

theme.stringOverrides = function () {
  // Override defaults in theme.strings with potential
  // template overrides

  window.productStrings = window.productStrings || {};
  $.extend(theme.strings, window.productStrings);
};

theme.getQueryParams = function () {
  theme.variables.queryParams = Slate.QueryString.parse(location.search);
};

theme.setBreakpoints = function () {
  enquire.register(theme.variables.mediaQuerySmall, {
    match: function () {
      theme.variables.bpSmall = true;
      theme.cache.$siteNav.hide();
    },
    unmatch: function () {
      theme.variables.bpSmall = false;
      theme.cache.$siteNav.show();
    }
  });
};

theme.initCollectionSort = function () {
  if (theme.cache.$sortDropdown.length) {
    theme.cache.$sortDropdown.val(theme.cache.$sortDropdown.data('value'));
  }
};

theme.sortCollection = function () {
  theme.variables.queryParams.sort_by = theme.cache.$sortDropdown.val();
  location.search = Slate.QueryString.stringify(theme.variables.queryParams);
};

theme.filterCollection = function () {
  delete theme.variables.queryParams.page;
  delete theme.variables.queryParams.q;
  if ($.isEmptyObject(theme.variables.queryParams)) {
    location.href = theme.cache.$tagsDropdown.val();
  } else {
    location.href = theme.cache.$tagsDropdown.val() + '?' + Slate.QueryString.stringify(theme.variables.queryParams)
  }
};

theme.styleTextLinks = function () {
  $('.rte').find('a:not(:has(img))').addClass('text-link');
};

theme.afterCartLoad = function(cart) {
  if (!theme.cookiesEnabled()) {
    theme.cache.$emptyCart.addClass(theme.cache.cartNoCookies);
  }

  if (theme._cartRefreshTimer) {
    clearTimeout(theme._cartRefreshTimer);
  }

  theme._cartRefreshTimer = setTimeout(function() {
    $.getJSON('/cart.js', function(cart) {

      if(typeof window.BOLD !== 'undefined'
         && typeof window.BOLD.common !== 'undefined'
         && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        cart = window.BOLD.common.cartDoctor.fix(cart);
      }

      theme.cache.$cartCount.text(cart.item_count);
    });
  }, 80);
};

theme.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};

$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('footer-section', theme.FooterSection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('newsletter-section', theme.NewsletterSection);
  sections.register('sidebar-section', theme.SidebarSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('password-content', theme.PasswordContent);
  sections.register('map', theme.Maps);
  sections.register('product-recommendations', theme.ProductRecommendations);
  var collections = $('.collection-grid > .owl-carousel');

  if (collections.length) {
    collections.owlCarousel({
      dots: false,
      loop: false,
      nav: false,
      responsiveClass: true,
      margin: 0,
      responsive: {
        0: {
          nav: false,
          items: 2
        },
        750: {
//             nav: true,
          items: 2
        },
        990: {
//             nav: true,
          items: 4
        }
      }
    });
  }
  var obj = function () {};

  $(document).on('click', '.site-footer__section-title', function() {
    var title = $(this);
    title.toggleClass('active');
  });

  obj.lastSt = 0;

  obj.data = {
    translations: {
      de: {
        'Embroidery on the glove (+€9.95)': 'Stickerei auf dem Handschuh <span>(+9.95 €)</span>',
        'Embroidery on the chest - kids (€9,95)': 'Stickerei auf der Brust – Kinder <span>(€9,95)</span>',
        'PRE-ORDER SHIPPING END OF APRIL': 'VORBESTELLUNG – VERSAND ENDE APRIL',
        'Choose three symbols (+ €9.95)': 'Wählen Sie drei Symbole <span>(+ 9,95 €)</span>',
        'Choose up to three symbols (+ €3.95 per symbol)': 'Wählen Sie bis zu drei Symbole <span>(+ €3,95 pro Symbol)</span>',
        'Choose one': 'Wähle ein',
        'You are [xxx.xx] away from getting a FREE Christmas Stocking': 'You are [xxx.xx] away from getting a FREE Christmas Stocking',
        'Total (Item Price + extras)': 'Artikelpreis',
        'Item Price (without extras)': 'Artikelpreis <span>(ohne Extras)</span>',
        'Close popup': 'Close popup',
        'Continue shopping': 'Continue shopping',
        'Congratulations! You get a FREE item! (embroidery not included)': 'Congratulations! You get a FREE item! (embroidery not included)',
        'Get FREE Christmas Stocking Now': 'Get FREE Christmas Stocking Now',
        'Enter here': 'Füllen Sie hier aus',
        'You get free shipping!': 'Sie erhalten kostenlosen Versand!',
        "Discount codes and gift cards can be added on the checkout page.": "Rabattcodes und Geschenkkarten können im nächsten Schritt auf der Checkout-Seite hinzugefügt werden.",
//        "Discount codes and gift cards can be added on the checkout page.": "Discount codes can be used below and gift cards can be added on the checkout page.",

        'You have now exceeded the maximum number of 150 characters. Shorten your text a bit!': 'Sie haben jetzt die maximale Anzahl von 150 Zeichen überschritten. Kürzen Sie Ihren Text etwas!',
        'Choose your wish card': 'Wählen Sie Ihre Wunschkarte',

        'Embroidery on the back': 'Personalisierte Stickerei Rücken <span>(+€19.95)</span>',
        'Embroidery on the back (€19.95)': 'Personalisierte Stickerei Rücken <span>(+€19.95)</span>',
        'Back embroidery color': 'Farbe der Stickerei Rücken',
        'Embroidery on the chest': 'Personalisierte Stickerei Brust <span>(+€9.95)</span>',
        'Embroidery on the chest (€9.95)': 'Personalisierte Stickerei Brust <span>(+€9.95)</span>',
        'Embroidery on the towel (€14.95)': 'Stickerei auf dem Handtuch <span>(+€14.95)</span>',
        'Chest embroidery color': 'Farbe der Stickerei Brust',
        'Embroidery color': 'Stickfarbe',
        'Embroidery Color': 'Stickfarbe',
        'Embroidery color (bracelet)': 'Stickfarbe',
        'Embroidery Color on beanie': 'Stickfarbe auf Mütze',
        'Embroidery Color on bib': 'Stickfarbe auf Schlabberlatz',
        'Embroidery Color on blankets': 'Stickfarbe auf Decke',
        'Embroidery Color on baby suit': 'Stickfarbe auf Strampler',
        'Embroidery Color on sock': 'Stickfarbe auf Socke',
        'Embroidery color on headband': 'Stickfarbe auf Stirnband',
        'Yes': 'Ja',
        'No': 'Nein',
        'Embroidery on the mask': 'Persönliche Stickerei auf der Maske <span>(+€9.95)</span>',
        'Embroidery on the face mask (€9.95)': 'Persönliche Stickerei auf der Maske <span>(+€9.95)</span>',
        'Mask embroidery color': 'Stickfarbe auf der Maske',
        'Choose a colour for the embroidery.': 'Wählen Sie eine Farbe für die Stickerei.',
        'Choose embroidery font': 'Stickerei-Schriftart',
        'Choose embroidery font (capital and le olive font only)': 'Stickerei-Schriftart',
        'Make-up bag Embroidery font': 'Stickerei-Schriftart Make-up-Tasche',
        'Choose embroidery font on bib': 'Stickerei-Schriftartt auf Schlabberlatz',
        'Choose embroidery font on blankets': 'Stickerei-Schriftart aus auf Decke',
        'Please choose embroidery font.': 'Bitte wählen Sie die Stickschrift aus.',
        'Gift-wrap this product (€4.95)': 'Füge eine Geschenkverpackung hinzu (€4.95)',
        'Gift-wrap this product (€9.95)': 'Füge eine Geschenkverpackung hinzu (€9.95)',
        'Personalise initials (+€4.95)': 'Personalisierte Initialen (+€4,95)',
        'Personalise Initials (+€4.95)': 'Personalisierte Initialen (+€4,95)',
        'Choose your print colour': 'Wähle deine Druckfarbe',
        'Add a wish card': 'Fügen Sie eine Wunschkarte hinzu',
        '-- Choose Add a wish card --  ': 'Wählen Sie eine Wunschkarte',
        'Enter your personal message': 'Geben Sie Ihre persönliche Nachricht ein',
        'Add FREE Sleep Mask Champagne': 'Fügen Sie KOSTENLOSE Schlafmasken-Champagner hinzu',
        'Add FREE Sleep Mask Midnight Black': 'Fügen Sie KOSTENLOSE Schlafmasken-Mitternachtsschwarz hinzu',
        'Add FREE Sleep Mask Velvet Bordeaux Red': 'KOSTENLOSE Schlafmaske Velvet Bourdeaux Red hinzufügen',
        'Add FREE Sleep Mask Blossom Pink': 'Fügen Sie KOSTENLOSE Schlafmaske Blossom Rosa',
        'Add FREE Sleep Mask Rose Pink': 'Fügen Sie KOSTENLOSE Schlafmaske Rosarot',
        'Add FREE scent card': 'KOSTENLOSE Duftkarte hinzufügen',
        'FREE Embroidery on sleep mask': 'KOSTENLOSE Stickerei auf der Schlafmaske',
        'No, thanks': 'Nein Danke',

        'Embroidery color (for mask)': 'Stickfarbe (maske)',
        'Add a sleep mask? (€14.95)': 'Eine Schlafmaske hinzufügen? <span>(+€14,95)</span>',
        'Embroidery on the sleep mask (€9.95)': 'Stickerei auf Schlafmaske - Name <span>(+€9,95)</span>',
        'Embroidery on the sleep mask - initials (€9.95)': 'Stickerei auf Schlafmaske - Initialen <span>(+€9,95)</span>',
        'Add a scrunchie? (€9.95)': 'Scrunchie hinzufügen (€9.95)',
        'Add matching scrunchie? (€9.95)': 'Scrunchie hinzufügen (€9.95)',

        'Embroidery on bath capes (€9.95)': 'Stickerei auf badecape <span>(+€9,95)</span>',
        'Embroidery on poncho (€9.95)': 'Stickerei auf poncho <span>(+ €9,95)</span>', 
        'Embroidery on bath textiles (€9.95)': 'Stickerei auf badtextilien <span>(+€9,95)</span>',
        'Embroidery on the bath textiles (€9.95)': 'Stickerei auf dem badtextilien <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Stickerei auf decken <span>(+€9,95)</span>',
        'Embroidery on sheets (€9.95)': 'Stickerei auf laken <span>(+€9,95)</span>',
        'Embroidery on cuddle and pacifier cloths (€9.95)': 'Stickerei auf kuschel and chnullertücher <span>(+€9,95)</span>',
        'Embroidery on pacifier (€9.95)': 'Stickerei auf Schnullerkette <span>(+€9,95)</span>',
        'Embroidery on cuddle (€9.95)': 'Stickerei auf kuschel <span>(+€9,95)</span>',
        'Embroidery on hydrophilic cloths (€9.95)': 'Stickerei auf mullwindeln <span>(+€9,95)</span>',
        'Embroidery on backpacks (€9.95)': 'Stickerei auf rucksäcke <span>(+€9,95)</span>',
        'Gift-wrap this product': 'Füge eine Geschenkverpackung hinzu',
        'Embroidery on the sleeve (€9.95)': 'Stickerei am Ärmel <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials (€9.95)': 'Stickerei am Ärmel - Initialen <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials 3 (€9.95)': 'Stickerei am Ärmel - Initialen <span>(+€9,95)</span>',
        'Embroidery on the belt (€9.95)': 'Stickerei auf dem Gürtel <span>(+€9,95)</span>',
        'Embroidery on laptop pouch (€9.95)': 'Stickerei auf Laptophülle <span>(+€9,95)</span>',
        'Embroidery on baby suit (€9.95)': 'Stickerei auf Strampler <span>(+€9,95)</span>',
        'Embroidery on the baby suit (€0.95)': 'Stickerei auf Strampler <span>(+€9,95)</span>',
        'Embroidery on bracelet (€0.95)': 'Stickerei auf Armband <span>(+€9,95)</span>',
        'Embroidery on hat (€9.95)': 'Stickerei auf Hut <span>(+€9,95)</span>',
        'Embroidery on sun hat (€9.95)': 'Stickerei auf Sonnenhut <span>(+€9,95)</span>',
        'Embroidery on the headband (€9.95)': 'Stickerei auf dem Stirnband <span>(+€9,95)</span>',
        'Embroidery at the bottom (€9.95)': 'Stickerei unten Top <span>(+€9,95)</span>',
        'Embroidery on cardigan (€9.95)': 'Stickerei auf Weste <span>(+€9,95)</span>',
        'Embroidery on footmuff (€9.95)': 'Stickerei auf Fußsack <span>(+€9,95)</span>',
        'Embroidery on storage bag (€9.95)': 'Stickerei auf für Box <span>(+€9,95)</span>',
        'Embroidery on cover (€9.95)': 'Stickerei auf Wickelauflagenbezug <span>(+€9,95)</span>',
        'Embroidery on front (€9.95)': 'Stickerei auf der Vorderseite <span>(+€9,95)</span>',
        'Embroidery on teddy front (€14.95)': 'Stickerei auf der Vorderseite <span>(+€14,95)</span>',
        'Embroidery on teddy (+€9,95)': 'Stickerei auf Teddy <span>(+€9,95)</span>',
        'Embroidery on shopper (€9,95)': 'Stickerei auf der Vorderseite <span>(+€9,95)</span>',
        'Embroidery on the front (€9.95)': 'Stickerei auf der Vorderseite <span>(+€9,95)</span>',
        'Embroidery on beanie (€9.95)': 'Stickerei auf Mütze <span>(+€9,95)</span>',
        'Embroidery on bib (€9.95)': 'Stickerei auf Schlabberlatz <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Stickerei auf Decke <span>(+€9,95)</span>',
        'Embroidery on sock (€9.95)': 'Stickerei auf Socke <span>(+€9,95)</span>',
        'Embroidery on mittens (€9.95)': 'Stickerei auf Handschuhe <span>(+€9,95)</span>',
        'Embroidery on the chest (€9.95) - kimono': 'Personalisierte Stickerei Brust - Kimono <span>(+€9,95)</span>',
        'Embroidery on the back (€19.95) - kimono': 'Personalisierte Stickerei Rücken - Kimono <span>(+€19,95)</span>',
        'Embroidery on the chest (€9.95) - pyjama': 'Personalisierte Stickerei Brust - Pyjama <span>(+€9,95)</span>',
        'Embroidery color on kimono': 'Farbe der Stickerei auf Kimono',
        'Embroidery color on pyjama': 'Farbe der Stickerei auf Pyjama',
        'Embroidery on the chest (€9.95) - pyjama kids': 'Personalisierte Stickerei Brust - Kinderpyjama <span>(+€9,95)</span>',
        'Embroidery color on pyjama kids': 'Farbe der Stickerei auf Kinderpyjama',
        'Embroidery on the slipper (€9.95)': 'Stickerei auf Pantoffeln <span>(+€9,95)</span>',
        'Embroidery color on slipper': 'Farbe der Stickerei auf Pantoffeln',
        'Embroidery on pillow - initials (€9.95)': 'Stickerei auf Kissenbezug - Initialen <span>(+€9,95)</span>',
        'Embroidery on pillow - name (€9.95)': 'Stickerei auf Kissenbezug - Name <span>(+€9,95)</span>',
        'Embroidery on chair (€9.95)': 'Stickerei auf Stuhl <span>(+€9,95)</span>',
        'Added': 'Hinzugefügt',
        'FREE Sleep mask': 'GRATIS Schlafmaske',
        'FREE Make-up bag': 'GRATIS Täschchen',
        'Embroidery on cat collar (€9.95)': 'Stickerei auf Katzenhalsband <span>(+€9,95)</span>',
        'Embroidery on dog collar - name (€9.95)': 'Stickerei auf Hundehalsband - Name <span>(+€9,95)</span>',
        'Embroidery on dog collar - number (€9.95)': 'Stickerei auf Hundehalsband - Telefonnummer <span>(+€9,95)</span>',
        'Printing on label (€4.95)': 'Druck auf Etikett <span>(+€4,95)</span>',
        'Embroidery on harness - name (€9.95)': 'Stickerei auf Geschirr - Name <span>(+€9,95)</span>',
        'Embroidery on harness - number (€9.95)': 'Stickerei auf Geschirr - Telefonnummer <span>(+€9,95)</span>',
        'Embroidery on leash - name (€9.95)': 'Stickerei auf Leine - Name <span>(+€9,95)</span>',
        'Embroidery on leash - number (€9.95)': 'Stickerei auf Leine - Telefonnummer <span>(+€9,95)</span>',
        'Printing on leash (€9.95)': 'Druck auf Leine  <span>(+€9,95)</span>',
        'Embroidery on poop bag holder (€9.95)': 'Stickerei auf Kotbeutelhalter <span>(+€9,95)</span>',
        'Printing on poop bag holder (€4.95)': 'Druck auf Kotbeutelhalter <span>(+€4,95)</span>',
        'Choose your leather tag': 'Wähle dein Lederetikett',
        'Heart': 'Herz',
        'Embroidery color for pets': 'Stickfarbe',
        'Choose your print colour for pets': 'Wähle deine Druckfarbe',
        'Embroidery on tanga (+€9,95)': 'Stickerei auf Tanga <span>(+€9,95)</span>',
        'Embroidery on veil (+€9,95)': 'Stickerei auf Schleier <span>(+€9,95)</span>',
        'Embroidery on scarf - initials (+€9,95)': 'Stickerei auf Schal <span>(+€9,95)</span>',
        'Embroidery on scarf (+€9,95)': 'Stickerei auf Schal - Initialen <span>(+€9,95)</span>',
        'Embroidery on dog cushion (+ €9,95)': 'Stickerei auf Hundekissen <span>(+€9,95)</span>',
        'Embroidery on make-up bag (+€9,95)': 'Stickerei auf Make-up-Tasche <span>(+€9,95)</span>',
        'Embroidery on toiletry bag (+€9,95)': 'Stickerei auf Toiletttasche <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Stickerei auf der Pouch <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Stickerei auf der Pouch <span>(+€9,95)</span>',
        'Embroidery on the changing mat (€9.95)': 'Stickerei auf der Wickelunterlage <span>(+€9,95)</span>',

        'GRATIS Geurkaart Bundel': 'GRATIS Duftkarten-Bundle',
        'Le Olive font': 'Le Olive Schriftart',
        'Modern font': 'Moderne Schriftart',
        'Modern font - ALL CAPS only': 'Moderne Schriftart - nur GROSSBUCHSTABEN',
        'Black': 'Schwarz',
        'Red': 'Rot',
        'White': 'Weiss',
        'Silver': 'Silber',
        'Gold': 'Gold',
        'Brown': 'Braun',
        'Light Brown': 'Hellbraun',
        'Dark Brown': 'Dunkelbraun',
        'Lilac': 'Flieder',
        'Grey': 'Grau',
        'Neon Pink': 'Neon rosa',
        'Light Pink': 'Hellrosa',
        'Dark Pink': 'Dunkelrosa',
        'Purple': 'Lila',
        'Orange': 'Orange',
        'Blue': 'Blau',
        'Light Blue': 'Hellblau',
        'Powder Pink': 'Puderrosa',
        'Metallic Rose': 'Roségold',
        'Coral Pink': 'Koralle',
//        'Champagne': 'Champagner',
        'Metallic Green': 'Grün metallic',
        'Sand': 'Sand',
        'Soft Pink': 'Blassrosa',
        'Rose Gold': 'Roségold',
        'Mint Green': 'Minzgrün',
        'Bordeaux Red ': 'Bordeauxrot',
        'Blind Debossed - without color': 'Blindprägung (ohne Farbe)'
      },
      nl: {
        'Embroidery on the glove (+€9.95)': 'Borduring op de ovenhandschoen <span>(+€9.95)</span>',
        'Embroidery on the chest - kids (€9,95)': 'Borduring op de borst – kinderen <span>(€9,95)</span>',
        'Choose three symbols (+ €9.95)': 'Kies drie symbolen <span>(+ €9,95)</span>',
        'Choose up to three symbols (+ €3.95 per symbol)': 'Kies maximaal drie symbolen <span>(+ €3,95 per symbool)</span>',
        'You are [xxx.xx] away from getting a FREE Christmas Stocking': 'You are [xxx.xx] away from getting a FREE Christmas Stocking',
        'Total (Item Price + extras)': 'Artikelprijs',
        'Item Price (without extras)': 'Artikelprijs <span>(zonder extras)</span>',
        'Close popup': 'Close popup',
        'Continue shopping': 'Continue shopping',
        'Congratulations! You get a FREE item! (embroidery not included)': 'Congratulations! You get a FREE item! (embroidery not included)',
        'Get FREE Christmas Stocking Now': 'Get FREE Christmas Stocking Now',
        'Choose one': 'Kies er een',
        'Enter here': 'Vul hier in',
        'You get free shipping!': 'Je ontvangt gratis verzending!',
        "Discount codes and gift cards can be added on the checkout page.": "Kortingscodes en Gift cards kunnen worden toegevoegd in je volgende stap op de checkout pagina.",
//        "Discount codes and gift cards can be added on the checkout page.": "Discount codes can be used below and gift cards can be added on the checkout page.",
        'You have now exceeded the maximum number of 150 characters. Shorten your text a bit!': 'Je overschrijdt nu het maximum aantal van 150 karakters. Kort je tekst iets in!',
        'Choose your wish card': 'Kies je wenskaart',

        'Embroidery on the back (€19.95)': 'Borduring op de rug <span>(+€19,95)</span>',
        'Back embroidery color': 'Kleur opdruk rug',
        'Embroidery on the chest': 'Gepersonaliseerde opdruk borst <span>(+€9,95)</span>',
        'Embroidery on the chest (€9.95)': 'Borduring op de borst <span>(+€9,95)</span>',
        'Embroidery on the towel (€14.95)': 'Borduring op de handdoek <span>(+€14,95)</span>',
        'Chest embroidery color': 'Kleur opdruk borst',
        'Embroidery color': 'Borduurkleur',
        'Embroidery Color': 'Borduurkleur',
        'Embroidery color (bracelet)': 'Borduurkleur',
        'Embroidery Color on beanie': 'Borduurkleur op muts',
        'Embroidery Color on bib': 'Borduurkleur op slabbetje',
        'Embroidery Color on blankets': 'Borduurkleur op deken',
        'Embroidery Color on baby suit': 'Borduurkleur op babypakje',
        'Embroidery Color on sock': 'Borduurkleurop sokje',
        'Embroidery color on headband': 'Borduurkleur op haarband',
        'Yes': 'Ja',
        'No': 'Nee',
        'Embroidery on the mask': 'Persoonlijke opdruk slaapmasker <span>(+€9,95)</span>',
        'Embroidery on the face mask (€9.95)': 'Persoonlijke opdruk mondmasker <span>(+€9,95)</span>',
        'Mask embroidery color': 'Borduurkleur slaapmasker',
        'Choose a colour for the embroidery.': 'Kies een kleur bordering.',
        'Choose embroidery font': 'Borduurlettertype',
        'Choose embroidery font (capital and le olive font only)': 'Borduurlettertype',
        'Make-up bag Embroidery font': 'Borduurlettertype make-uptasje',
        'Choose embroidery font on bib': 'Borduurlettertype op slabbetje',
        'Choose embroidery font on blankets': 'Borduurlettertype op deken',
        'Please choose embroidery font.': 'Kies borduurlettertype.',
        'Gift-wrap this product (€4.95)': 'Voeg een geschenkverpakking toe (€4,95)',
        'Gift-wrap this product (€9.95)': 'Voeg een geschenkverpakking toe (€9,95)',
        'Personalise initials (+€4.95)': 'Personaliseer je initialen (+€4,95)',
        'Personalise Initials (+€4.95)': 'Personaliseer je initialen (+€4,95)',
        'Choose your print colour': 'Kies je print kleur',
        'Add a wish card': 'Een wenskaart toevoegen',
        'Enter your personal message': 'Voeg je persoonlijke boodschap toe',
        'Add FREE Sleep Mask Champagne': 'Voeg GRATIS Champagne Slaapmasker toe',
        'Add FREE Sleep Mask Midnight Black': 'Voeg GRATIS Midnight Black Slaapmasker toe',
        'Add FREE Sleep Mask Velvet Bordeaux Red': 'Voeg GRATIS Velvet Bordeaux Red Slaapmasker toe',
        'Add FREE Sleep Mask Blossom Pink': 'Voeg GRATIS Blossom Pink Slaapmasker toe',
        'Add FREE Sleep Mask Rose Pink': 'Voeg GRATIS Rose Pink Slaapmasker toe',
        'Add FREE scent card': 'Voeg GRATIS geurkaart toe',
        'FREE Embroidery on sleep mask': 'GRATIS borduring op slaapmasker',
        'No, thanks': 'Nee bedankt',
        'Embroidery color (for mask)': 'Borduurkleur (masker)',
        'Add a sleep mask? (€14.95)': 'Slaapmasker toevoegen? <span>(+€14,95)</span>',
        'Embroidery on the sleep mask (€9.95)': 'Borduring op slaapmasker - naam <span>(+€9,95)</span>',
        'Embroidery on the sleep mask - initials (€9.95)': 'Borduring op slaapmasker - initialen <span>(+€9,95)</span>',
        'Add a scrunchie? (€9.95)': 'Scrunchie toevoegen (+€9,95)',
        'Add matching scrunchie? (€9.95)': 'Scrunchie toevoegen (+€9,95)',

        'Embroidery on bath capes (€9.95)': 'Borduring op badcapes <span>(+€9,95)</span>',
        'Embroidery on poncho (€9.95)': 'Borduring op poncho <span>(+ €9,95)</span>',
        'Embroidery on bath textiles (€9.95)': 'Borduring op badtextiel <span>(+€9,95)</span>',
        'Embroidery on the bath textiles (€9.95)': 'Borduring op de badtextiel <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Borduring op dekens <span>(+€9,95)</span>',
        'Embroidery on sheets (€9.95)': 'Borduring op lakens <span>(+€9,95)</span>',
        'Embroidery on cuddle and pacifier cloths (€9.95)': 'Borduring op knuffel en speendoekjes <span>(+€9,95)</span>',
        'Embroidery on pacifier (€9.95)': 'Borduring op speenkoord <span>(+€9,95)</span>',
        'Embroidery on cuddle (€9.95)': 'Borduring op knuffel <span>(+€9,95)</span>',
        'Embroidery on hydrophilic cloths (€9.95)': 'Borduring op hydrofiele doeken <span>(+€9,95)</span>',
        'Embroidery on backpacks (€9.95)': 'Borduring op rugzakjes <span>(+€9,95)</span>',
        'Gift-wrap this product': 'Voeg een geschenkverpakking toe',
        'Embroidery on the sleeve (€9.95)': 'Borduring op de mouw <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials (€9.95)': 'Borduring op de mouw - initialen <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials 3 (€9.95)': 'Borduring op de mouw - initialen <span>(+€9,95)</span>',
        'Embroidery on the belt (€9.95)': 'Borduring op de ceintuur <span>(+€9,95)</span>',

        'Embroidery on laptop pouch (€9.95)': 'Borduring op laptophoes <span>(+€9,95)</span>',
        'Embroidery on baby suit (€9.95)': 'Borduring op babypakje <span>(+€9,95)</span>',
        'Embroidery on the baby suit (€9.95)': 'Borduring op babypakje <span>(+€9,95)</span>',
        'Embroidery on bracelet (€9.95)': 'Borduring op armbandjes <span>(+€9,95)</span>',
        'Embroidery on hat (€9.95)': 'Borduring op hoed <span>(+€9,95)</span>',
        'Embroidery on sun hat (€9.95)': 'Borduring op zonnehoed <span>(+€9,95)</span>',
        'Embroidery on the hat (€9.95)': 'Borduring op hoed <span>(+€9,95)</span>',
        'Embroidery on the headband (€9.95)': 'Borduring op de haarband <span>(+€9,95)</span>',
        'Embroidery at the bottom (€9.95)': 'Borduring onderaan top <span>(+€9,95)</span>',
        'Embroidery on cardigan (€9.95)': 'Borduring op gilet <span>(+€9,95)</span>',
        'Embroidery on footmuff (€9.95)': 'Borduring op voetenzak <span>(+€9,95)</span>',
        'Embroidery on storage bag (€9.95)': 'Borduring op opbergzak <span>(+€9,95)</span>',
        'Embroidery on cover (€9.95)': 'Borduring op aankleedhoes <span>(+€9,95)</span>',
        'Embroidery on front (€9.95)': 'Borduring op de voorzijde <span>(+€9,95)</span>',
        'Embroidery on teddy front (€14.95)': 'Borduring op de voorzijde <span>(+€14,95)</span>',
        'Embroidery on teddy (+€9,95)': 'Borduring op teddy <span>(+€9,95)</span>',
        'Embroidery on shopper (€9,95)': 'Borduring op de voorzijde <span>(+€9,95)</span>',
        'Embroidery on the front (€9.95)': 'Borduring op de voorzijde <span>(+€9,95)</span>',
        'Embroidery on beanie (€9.95)': 'Borduring op muts <span>(+€9,95)</span>',
        'Embroidery on bib (€9.95)': 'Borduring op slabber <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Borduring op deken <span>(+€9,95)</span>',
        'Embroidery on sock (€9.95)': 'Borduring op sokje <span>(+€9,95)</span>',
        'Embroidery on mittens (€9.95)': 'Borduring op wanten <span>(+€9,95)</span>',
        'Embroidery on the chest (€9.95) - kimono': 'Borduring op de borst - kimono <span>(+€9,95)</span>',
        'Embroidery on the back (€19.95) - kimono': 'Borduring op de rug - kimono <span>(+€19,95)</span>',
        'Embroidery on the chest (€9.95) - pyjama': 'Borduring op de borst - pyjama <span>(+€9,95)</span>',
        'Embroidery color on kimono': 'Borduurkleur op kimono',
        'Embroidery color on pyjama': 'Borduurkleur op pyjama',
        'Embroidery on the chest (€9.95) - pyjama kids ': 'Borduring op de borst - pyjama kids <span>(+€9,95)</span>',
        'Embroidery color on pyjama kids': 'Borduurkleur op pyjama kids ',
        'Embroidery on the slipper (€9.95)': 'Borduring op pantoffel <span>(+€9,95)</span>',
        'Embroidery color on slipper': 'Borduurkleur op pantoffel',

        'Design Options': 'Design Opties',
        'Fixed Design': 'Kies een design',
        'Custom Design': 'Creëer je eigen design',
        'You cannot order this item unpersonalised, so choose a design option.': 'Je kunt dit item niet ongepersonaliseerd bestellen. Kies daarom een design optie.',
        'Please choose a fixed design and color options.': 'Kies een ontwerp en kleuropties.',
        'Please choose a font and color options.': 'Kies een lettertype en kleuropties.',
        'Please add text on t-shirt.': 'Voeg een eigen tekst toe op de tekstregels.',
        'Embroidery on pillow - initials (€9.95)': 'Borduring op kussensloop - initialen <span>(+€9,95)</span>',
        'Embroidery on pillow - name (€9.95)': 'Borduring op kussensloop - naam <span>(+€9,95)</span>',
        'Embroidery on chair (€9.95)': 'Borduring op stoel <span>(+€9,95)</span>',
        'Added': 'Toegevoegd',
        'FREE Sleep mask': 'GRATIS slaapmasker',
        'FREE Make-up bag': 'GRATIS pouch',
        'Embroidery on cat collar (€9.95)': 'Borduring op kattenhalsband <span>(+€9,95)</span>',
        'Embroidery on dog collar - name (€9.95)': 'Borduring op hondenhalsband - naam <span>(+€9,95)</span>',
        'Embroidery on dog collar - number (€9.95)': 'Borduring op hondenhalsband - telefoonnummer  <span>(+€9,95)</span>',
        'Printing on label (€4.95)': 'Bedrukking op label <span>(+€4,95)</span>',
        'Embroidery on harness - name (€9.95)': 'Borduring op tuig - naam <span>(+€9,95)</span>',
        'Embroidery on harness - number (€9.95)': 'Borduring op tuig - telefoonnummer<span>(+€9,95)</span>',
        'Embroidery on leash - name (€9.95)': 'Borduring op riem - naam <span>(+€9,95)</span>',
        'Embroidery on leash - number (€9.95)': 'Borduring op riem - telefoonnummer <span>(+€9,95)</span>',
        'Printing on leash (€9.95)': 'Bedrukking op riem <span>(+€9,95)</span>',
        'Embroidery on poop bag holder (€9.95)': 'Borduring op poepzakjeshouder <span>(+€9,95)</span>',
        'Printing on poop bag holder (€4.95)': 'Bedrukking op poepzakjeshouder <span>(+€4,95)</span>',
        'Choose your leather tag': 'Kies je leren label',
        'Heart': 'Hart',
        'Original': 'Origineel',
        'Embroidery color for pets': 'Borduurkleur',
        'Choose your print colour for pets': 'Kies je print kleur',
        'Embroidery on tanga (+€9,95)': 'Borduring op tanga <span>(+€9,95)</span>',
        'Embroidery on veil (+€9,95)': 'Borduring op sluier <span>(+€9,95)</span>',
        'Embroidery on scarf - initials (+€9,95)': 'Borduring op sjaal <span>(+€9,95)</span>',
        'Embroidery on scarf (+€9,95)': 'Borduring op sjaal - initialen <span>(+€9,95)</span>', 
        'Embroidery on dog cushion (+ €9,95)': 'Borduring op hondenkussen <span>(+€9,95)</span>',
        'Embroidery on make-up bag (+€9,95)': 'Borduring op make-uptasje <span>(+€9,95)</span>',
        'Embroidery on toiletry bag (+€9,95)': 'Borduring op toilettasje <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Borduring op de pouch <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Borduring op de pouch <span>(+€9,95)</span>',
        'Embroidery on the changing mat (€9.95)': 'Borduring op de verschoningsmat <span>(+€9,95)</span>',

        'Le Olive font': 'Le Olive lettertype',
        'Modern font': 'Modern lettertype',
        'Modern font - ALL CAPS only': 'Modern lettertype - alleen HOOFDLETTERS',
        'Black': 'Zwart',
        'Red': 'Rood',
        'White': 'Wit',
        'Silver': 'Zilver',
        'Gold': 'Goud',
        'Brown': 'Bruin',
        'Light Brown': 'Licht Bruin',
        'Dark Brown': 'Donker Bruin',
        'Lilac': 'Lila',
        'Grey': 'Grijs',
        'Neon Pink': 'Neon Roze',
        'Light Pink': 'Licht Roze',
        'Dark Pink': 'Donker Roze',
        'Purple': 'Paars',
        'Orange': 'Oranje',
        'Blue': 'Blauw',
        'Light Blue': 'Licht blauw',
        'Powder Pink': 'Poeder roze',
        'Metallic Rose': 'Metallic Rozé',
        'Champagne': 'Champagne',
        'Coral Pink': 'Koraalroze',
        'Metallic Green': 'Metallic Groen',
        'Sand': 'Zand',
        'Soft Pink': 'Zacht Roze',
        'Rose Gold': 'Rose Goud',
        'Mint Green': 'Mint Groen',
        'Blind Debossed - without color': 'Blind debossed (zonder kleur)'
      },
      en: {
        'Embroidery on the glove (+€9.95)': 'Embroidery on the glove <span>(+€9.95)</span>',
        'Embroidery on the chest - kids (€9,95)': 'Embroidery on the chest – kids <span>(€9,95)</span>',
        'You are [xxx.xx] away from getting a FREE Christmas Stocking': 'You are [xxx.xx] away from getting a FREE Christmas Stocking',
        'Choose up to three symbols (+ €3.95 per symbol)': 'Choose up to three symbols <span>(+ €3.95 per symbol)</span>',
        'Close popup': 'Close popup',
        'Total (Item Price + extras)': 'Item Price',
        'Item Price (without extras)': 'Item Price <span>(without extras)</span>',
        'Continue shopping': 'Continue shopping',
        'Congratulations! You get a FREE item! (embroidery not included)': 'Congratulations! You get a FREE item! (embroidery not included)',
        'Get FREE Christmas Stocking Now': 'Get FREE Christmas Stocking Now',
        'You forget which size you would like to have.': 'Please select a size.',
        'You get free shipping!': 'You get free shipping!',
//        "Discount codes and gift cards can be added on the checkout page.": "Discount codes can be used below and gift cards can be added on the checkout page.",

        'Choose one': 'Choose one',
        'Enter here': 'Enter here',
        'Add a sleeping mask?': 'Add a sleeping mask? <span>(+€14,95)</span>',
        'Yes': 'Yes',
        'No': 'No',
        'Embroidery color (bracelet)': 'Embroidery color',
        'Embroidery on the mask': 'Embroidery on the mask <span>(+€9,95)</span>',
        'Embroidery on the face mask (€9.95)': 'Embroidery on the face mask <span>(+€9,95)</span>',
        'Embroidery on teddy front (€14.95)': 'Embroidery on front <span>(+€14,95)</span>',
        'Embroidery on teddy (+€9,95)': 'Embroidery on teddy <span>(+€9,95)</span>',
        'Embroidery on shopper (€9,95)': 'Embroidery on the front <span>(+€9,95)</span>',
        'Embroidery on poncho (€9.95)': 'Embroidery on poncho <span>(+ €9,95)</span>',
        'Embroidery on sun hat (€9.95)': 'Embroidery on sun hat <span>(+€9,95)</span>',
        'Mask embroidery color': 'Mask embroidery color',
        'Choose a colour for the embroidery.': 'Choose a colour for the embroidery.',
        'Choose embroidery font': 'Embroidery font',
        'Choose embroidery font (capital and le olive font only)': 'Embroidery font',
        'Make-up bag Embroidery font': 'Make-up bag Embroidery font',
        'Please choose embroidery font.': 'Please choose embroidery font.',
        'Embroidery on the sleep mask (€9.95)': 'Embroidery on the sleep mask – name <span>(+€9,95)</span>',
        'Embroidery on the sleep mask - initials (€9.95)': 'Embroidery on the sleep mask – initials <span>(+€9,95)</span>',
        'Embroidery on the towel (€14.95)': 'Embroidery on the towel <span>(+€14,95)</span>',
        'Embroidery at the bottom (€9.95)': 'Embroidery bottom top <span>(+€9,95)</span>',
        'Gift-wrap this product': 'Add a gift box',
        'Valentine day promo': 'Valentine’s Day Promotion! A free personalized sleep mask is added to you order. Choose your embroidery here:',

        'Embroidery on cover (€9.95)': 'Embroidery on (clothing) cover <span>(+€9,95)</span>',
        'Embroidery on chair (€9.95)': 'Embroidery on chair <span>(+€9,95)</span>',
        'Embroidery on the bath textiles (€9.95)': 'Embroidery on the bath textiles <span>(+€9,95)</span>',
        'Embroidery on pacifier (€9.95)': 'Embroidery on pacifier <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials (€9.95)': 'Embroidery on sleeve - initials <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials 3 (€9.95)': 'Embroidery on sleeve - initials <span>(+€9,95)</span>',
        'Embroidery Color': 'Embroidery color',
        'Embroidery on cat collar (€9.95)': 'Embroidery on cat collar <span>(+€9,95)</span>',
        'Embroidery on dog collar - name (€9.95)': 'Embroidery on dog collar - name <span>(+€9,95)</span>',
        'Embroidery on dog collar - number (€9.95)': 'Embroidery on dog collar - number <span>(+€9,95)</span>',
        'Printing on label (€4.95)': 'Printing on label <span>(+€4,95)</span>',
        'Embroidery on harness - name (€9.95)': 'Embroidery on harness - name <span>(+€9,95)</span>',
        'Embroidery on harness - number (€9.95)': 'Embroidery on harness - number <span>(+€9,95)</span>',
        'Embroidery on leash - name (€9.95)': 'Embroidery on leash - name <span>(+€9,95)</span>',
        'Embroidery on leash - number (€9.95)': 'Embroidery on leash - number <span>(+€9,95)</span>',
        'Printing on leash (€9.95)': 'Printing on leash <span>(+€9,95)</span>',
        'Embroidery on poop bag holder (€9.95)': 'Embroidery on poop bag holder <span>(+€9,95)</span>',
        'Printing on poop bag holder (€4.95)': 'Printing on poop bag holder <span>(+€4,95)</span>',
        'Choose your leather tag': 'Choose your leather label',
        'Embroidery color for pets': 'Embroidery color',
        'Choose your print colour for pets': 'Choose your print colour',
        'GRATIS Geurkaart Bundel': 'FREE Scent Card Bundle',
        'FREE Make-up bag': 'FREE pouch',
        'Embroidery on make-up bag (+€9,95)': 'Embroidery on make-up bag <span>(+€9,95)</span>',
        'Embroidery on toiletry bag (+€9,95)': 'Embroidery on toiletry bag <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Embroidery on pouch <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Embroidery on pouch <span>(+€9,95)</span>',
        'Embroidery on the changing mat (€9.95)': 'Embroidery on the changing mat <span>(+€9,95)</span>',

        'Black': 'Black',
        'Red': 'Red',
        'White': 'White',
        'Silver': 'Silver',
        'Gold': 'Gold',
        'Brown': 'Brown',
        'Lilac': 'Lilac',
        'Grey': 'Grey',
        'Neon Pink': 'Neon Pink',
        'Light Pink': 'Light Pink',
        'Dark Pink': 'Dark Pink',
        'Purple': 'Purple',
        'Orange': 'Orange',
        'Blue': 'Blue',
        'Light Blue': 'Light Blue',
        'Powder Pink': 'Powder Pink',
        'Metallic Rose': 'Metallic Rosé',
        'Champagne': 'Champagne',
        'Coral Pink': 'Coral Pink',
        'Metallic Green': 'Metallic Groenn',
        'Sand': 'Sand',
//         'Mint Green': 'Mint Green',
        'Soft Pink': 'Soft Pink'
      },
      es: {
        'Embroidery on the glove (+€9.95)': 'Bordado en el guante <span>(+€9.95)</span>',
        'Embroidery on the chest - kids (€9,95)': 'Bordado en el pecho – niños <span>(€9,95)</span>',
        'Choose three symbols (+ €9.95)': 'Elige tres símbolos <span>(+ 9,95 €)</span>',
        'Choose up to three symbols (+ €3.95 per symbol)': 'Elige hasta tres símbolos <span>(+ €3,95 por símbolo)</span>',
        'You are [xxx.xx] away from getting a FREE Christmas Stocking': 'You are [xxx.xx] away from getting a FREE Christmas Stocking',
        'Close popup': 'Close popup',
        'Total (Item Price + extras)': 'Precio del artículo',
        'Item Price (without extras)': 'Artículo Precio <span>(sin extras)</span>',
        'Continue shopping': 'Continue shopping',
        'Congratulations! You get a FREE item! (embroidery not included)': 'Congratulations! You get a FREE item! (embroidery not included)',
        'Get FREE Christmas Stocking Now': 'Get FREE Christmas Stocking Now',
        'Choose one': 'Elige uno',
        'Enter here': 'Rellena aquí',
        'You get free shipping!': 'Los costes de envío son gratis!',
        "Discount codes and gift cards can be added on the checkout page.": "Los códigos de descuento y las tarjetas de regalo se pueden canjear en el próximo paso, en la página de pago.",
//        "Discount codes and gift cards can be added on the checkout page.": "Discount codes can be used below and gift cards can be added on the checkout page.",
        'You have now exceeded the maximum number of 150 characters. Shorten your text a bit!': 'Ha superado el número máximo de 150 caracteres. ¡Acorta tu texto un poco!',
        'Choose your wish card': 'Elige tu tarjeta de deseos',

        'Embroidery on the back': 'Bordado personalizado en la espalda <span>(+€19,95)</span>',
        'Embroidery on the back (€19.95)': 'Bordado personalizado en la espalda <span>(+€19,95)</span>',
        'Back embroidery color': 'Color de bordado en la espalda',
        'Embroidery on the chest': 'Bordado personalizado en el pecho <span>(+€9,95)</span>',
        'Embroidery on the chest (€9.95)': 'Bordado personalizado en el pecho <span>(+€9,95)</span>',
        'Embroidery on the towel (€14.95)': 'Bordado en la toalla <span>(+€14,95)</span>',
        'Chest embroidery color': 'Color de bordado en el pecho',
        'Embroidery color': 'Color de bordado',
        'Embroidery Color': 'Color de bordado',
        'Embroidery color (bracelet)': 'Color de bordado',
        'Embroidery Color on beanie': 'Color de bordado en gorros',
        'Embroidery Color on bib': 'Color de bordado en babero',
        'Embroidery Color on blankets': 'Color de bordado en mantas',
        'Embroidery Color on baby suit': 'Color de bordado en conjunto',
        'Embroidery Color on sock': 'Color de bordado en calcetin',
        'Embroidery color on headband': 'Color de bordado en la cinta para la cabeza',
        'Add a sleep mask? (€14.95)': 'Quieres añadir un antifaz para dormir? <span>(+€14,95)</span>',
        'Yes': 'Sí',
        'No': 'No',
        'Embroidery on the mask': 'Bordado personalizado en el antifaz <span>(+€9,95)</span>',
        'Embroidery on the face mask (€4.95)': 'Bordado personalizado en el antifaz <span>(+€4,95)</span>',
        'Mask embroidery color': 'Color de bordado en el antifaz',
        'Choose a colour for the embroidery.': 'Elija un color para el bordado.',
        'Choose embroidery font': 'Fuente de bordado',
        'Choose embroidery font (capital and le olive font only)': 'Fuente de bordado',
        'Make-up bag Embroidery font': 'Fuente de bordado neceser',
        'Choose embroidery font on bib': 'Fuente de bordado en babero',
        'Choose embroidery font on blankets': 'Fuente de bordado en mantas',
        'Please choose embroidery font.': 'Elija la fuente de bordado.',
        'Gift-wrap this product (€4.95)': 'Añade una caja de regalo (+€4,95)',
        'Gift-wrap this product (€9.95)': 'Añade una caja de regalo (+€9,95)',
        'Personalise initials (+€4.95)': 'Personalizar iniciales (+€4,95)',
        'Personalise Initials (+€4.95)': 'Personalizar iniciales (+€4,95)',
        'Choose your print colour': 'Elige el color de tu grabado',

        'Add a wish card': 'Agregar una tarjeta de deseo',
        'Enter your personal message': 'Introduzca su mensaje personal',
        'Add FREE Sleep Mask Champagne': 'Añade champán antifaz para dormir GRATIS',
        'Add FREE Sleep Mask Midnight Black': 'Añade medianoche negro antifaz para dormir GRATIS',
        'Add FREE Sleep Mask Velvet Bordeaux Red': 'Añade GRATIS el Antifaz para Dormir Velvet Bourdeaux Red',
        'Add FREE Sleep Mask Blossom Pink': 'Añade Rosa Flor antifaz para dormir GRATIS',
        'Add FREE Sleep Mask Rose Pink': 'Añade Rosa Claro antifaz para dormir GRATIS',
        'Add FREE scent card': 'Agregar carta perfumada GRATIS',
        'FREE Embroidery on sleep mask': 'Bordado GRATIS en el antifaz para dormir',
        'No, thanks': 'No, gracias',
        'Embroidery color (for mask)': 'Color del bordado (antifaz)',
        'Embroidery on the sleep mask (€9.95)': 'Bordado en antifaz - nombre <span>(+€9,95)</span>',
        'Embroidery on the sleep mask - initials (€9.95)': 'Bordado en antifaz - iniciales <span>(+€9,95)</span>',
        'Add a scrunchie? (€9.95)': 'Añadir una scrunchie (+€9,95)',
        'Add matching scrunchie? (€9.95)': 'Añadir una scrunchie (+€9,95)',

        'Embroidery on bath capes (€9.95)': 'Bordado personalizado en capas de baño <span>(+€9,95)</span>',
        'Embroidery on poncho (€9.95)': 'Bordado en poncho <span>(+ €9,95)</span>',
        'Embroidery on bath textiles (€9.95)': 'Bordado personalizado en toallas <span>(+€9,95)</span>',
        'Embroidery on the bath textiles (€9.95)': 'Bordado personalizado en el toallas <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Bordado personalizado en mantas <span>(+€9,95)</span>',
        'Embroidery on sheets (€9.95)': 'Bordado personalizado en sábanas <span>(+€9,95)</span>',
        'Embroidery on cuddle and pacifier cloths (€9.95)': 'Bordado personalizado en mantas abrazo y chupeteros<span>(+€9,95)</span>',
        'Embroidery on pacifier (€9.95)': 'Bordado en clip para chupete <span>(+€9,95)</span>',
        'Embroidery on cuddle (€9.95)': 'Bordado personalizado en abrazo <span>(+€9,95)</span>',
        'Embroidery on hydrophilic cloths (€9.95)': 'Bordado personalizado en paños hidrofílicos<span>(+€9,95)</span>',
        'Embroidery on backpacks (€9.95)': 'Bordado personalizado en mochilas<span>(+€9,95)</span>',
        'Gift-wrap this product': 'Añade una caja de regalo',
        'Embroidery on the sleeve (€9.95)': 'Borbado en la manga <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials (€9.95)': 'Borbado en la manga - iniciales <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials 3 (€9.95)': 'Borbado en la manga - iniciales <span>(+€9,95)</span>',
        'Embroidery on the belt (€9.95)': 'Bordado en el cinturón <span>(+€9,95)</span>',

        'Embroidery on laptop pouch (€9.95)': 'Bordado en fundas de portátil <span>(+€9,95)</span>',
        'Embroidery on baby suit (€9.95)': 'Bordado en conjunto <span>(+€9,95)</span>',
        'Embroidery on the baby suit (€9.95)': 'Bordado en conjunto <span>(+€9,95)</span>',
        'Embroidery on bracelet (€9.95)': 'Bordado en pulseras <span>(+€9,95)</span>',
        'Embroidery on hat (€9.95)': 'Bordado en sombrero <span>(+€9,95)</span>',
        'Embroidery on the hat (€9.95)': 'Bordado en sombrero <span>(+€9,95)</span>',
        'Embroidery on sun hat (€9.95)': 'Bordado en sombrero de sol <span>(+€9,95)</span>',
        'Embroidery on the headband (€9.95)': 'Bordado en la cinta para la cabeza <span>(+€9,95)</span>',
        'Embroidery at the bottom (€9.95)': 'Bordado bajo top <span>(+€9,95)</span>',
        'Embroidery on cardigan (€9.95)': 'Bordado en cárdigans <span>(+€9,95)</span>',
        'Embroidery on footmuff (€9.95)': 'Bordado en saco para pies  <span>(+€9,95)</span>',
        'Embroidery on storage bag (€9.95)': 'Bordado en bolsa para caja <span>(+€9,95)</span>',
        'Embroidery on cover (€9.95)': 'Bordado en cubierta de ropa <span>(+€9,95)</span>',
        'Embroidery on front (€9.95)': 'Bordado en la parte delantera <span>(+€9,95)</span>',
        'Embroidery on teddy front (€14.95)': 'Bordado en la parte delantera <span>(+€14,95)</span>',
        'Embroidery on teddy (+€9,95)': 'Bordado en teddy <span>(+€9,95)</span>',
        'Embroidery on shopper (€9,95)': 'Bordado en la parte delantera <span>(+€9,95)</span>',
        'Embroidery on the front (€9.95)': 'Bordado en la parte delantera <span>(+€9,95)</span>',
        'Embroidery on beanie (€9.95)': 'Bordado en gorros <span>(+€9,95)</span>',
        'Embroidery on bib (€9.95)': 'Bordado en babero <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Bordado en mantas <span>(+€9,95)</span>',
        'Embroidery on sock (€9.95)': 'Bordado en calcetin <span>(+€9,95)</span>',
        'Embroidery on mittens (€9.95)': 'Bordado en guantes <span>(+€9,95)</span>',
        'Embroidery on the chest (€9.95) - kimono': 'Bordado personalizado en el pecho - quimono <span>(+€9,95)</span>',
        'Embroidery on the back (€19.95) - kimono': 'Bordado personalizado en la espalda - quimono <span>(+€19,95)</span>',
        'Embroidery on the chest (€9.95) - pyjama': 'Bordado personalizado en el pecho - pijama <span>(+€9,95)</span>',
        'Embroidery color on kimono': 'Color del bordado en quimono',
        'Embroidery color on pyjama': 'Color del bordado en pijama',
        'Embroidery on the chest (€9.95) - pyjama kids': 'Bordado personalizado en el pecho - pijama niños <span>(+€9,95)</span>',
        'Embroidery color on pyjama kids': 'Color del bordado en pijama niños',
        'Embroidery on the slipper (€9.95)': 'Bordado en pantuflas <span>(+€9,95)</span>',
        'Embroidery color on slipper': 'Color del bordado en pantuflas',
        'Embroidery on pillow - initials (€9.95)': 'Bordado en funda de almohada - iniciales <span>(+€9,95)</span>',
        'Embroidery on pillow - name (€9.95)': 'Bordado en funda de almohada - nombre <span>(+€9,95)</span>',
        'Embroidery on chair (€9.95)': 'Bordado en silla <span>(+€9,95)</span>',
        'Added': 'Añadido',
        'FREE Sleep mask': 'Máscara de dormir GRATIS',
        'FREE Make-up bag': 'GRATIS Bolsa',
        'Embroidery on cat collar (€9.95)': 'Bordado en collar para gato <span>(+€9,95)</span>',
        'Embroidery on dog collar - name (€9.95)': 'Bordado en collar para perro - nombre<span>(+€9,95)</span>',
        'Embroidery on dog collar - number (€9.95)': 'Bordado en collar para perro - número de teléfono <span>(+€9,95)</span>',
        'Printing on label (€4.95)': 'Impresión en etiqueta <span>(+€4,95)</span>',
        'Embroidery on harness - name (€9.95)': 'Bordado en arnés - nombre <span>(+€9,95)</span>',
        'Embroidery on harness - number (€9.95)': 'Bordado en arnés - número de teléfono <span>(+€9,95)</span>',
        'Embroidery on leash - name (€9.95)': 'Bordado en correa - nombre <span>(+€9,95)</span>',
        'Embroidery on leash - number (€9.95)': 'Bordado en correa - número de teléfono <span>(+€9,95)</span>',
        'Printing on leash (€9.95)': 'Impresión en correa <span>(+€9,95)</span>',
        'Embroidery on poop bag holder (€9.95)': 'Bordado en portabolsas para excrementos <span>(+€9,95)</span>',
        'Printing on poop bag holder (€4.95)': 'Impresión en portabolsas para excrementos <span>(+€4,95)</span>',
        'Choose your leather tag': 'Elige tu etiqueta de cuero',
        'Heart': 'Corazón',
        'Original': 'Original',
        'Embroidery color for pets': 'Color de bordado',
        'Choose your print colour for pets': 'Elige el color de tu grabado',
        'Embroidery on tanga (+€9,95)': 'Bordado en tanga <span>(+€9,95)</span>',
        'Embroidery on veil (+€9,95)': 'Bordado en velo <span>(+€9,95)</span>',
        'Embroidery on scarf - initials (+€9,95)': 'Bordado en bufanda <span>(+€9,95)</span>',
        'Embroidery on scarf (+€9,95)': 'Bordado en bufanda - iniciales <span>(+€9,95)</span>', 
        'Embroidery on dog cushion (+ €9,95)': 'Bordado en cojín perro <span>(+€9,95)</span>',
        'Embroidery on make-up bag (+€9,95)': 'Bordado en neceser de maquillaje <span>(+€9,95)</span>',
        'Embroidery on toiletry bag (+€9,95)': 'Bordado en neceser <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Bordado en la pouch <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Bordado en la pouch <span>(+€9,95)</span>',
        'Embroidery on the changing mat (€9.95)': 'Bordado en el cambiador <span>(+€9,95)</span>',

        'GRATIS Geurkaart Bundel': 'Pack de Tarjetas Aromáticas GRATIS',
        'Le Olive font': 'Fuente Le Olive',
        'Modern font': 'Fuente moderna',
        'Modern font - ALL CAPS only': 'Fuente moderna - SÓLO EN MAYÚSCULAS',
        'Black': 'Negro',
        'Red': 'Rojo',
        'White': 'Blanco',
        'Silver': 'Plata',
        'Gold': 'Oro',
        'Brown': 'Marrón',
        'Light Brown': 'Marrón Claro',
        'Dark Brown': 'Marrón Oscuro',
        'Lilac': 'Lila',
        'Grey': 'Gris',
        'Neon Pink': 'Rosa Neón',
        'Light Pink': 'Rosa Claro',
        'Dark Pink': 'Rosa Oscuro',
        'Purple': 'Violeta',
        'Orange': 'Naranja',
        'Blue': 'Azul',
        'Light Blue': 'Azul Claro',
        'Powder Pink': 'Polvo Rosado',
        'Metallic Rose': 'Rosado Metálico',
//        'Champagne': 'Champán',
        'Coral Pink': 'Rosa Coral',
        'Metallic Green': 'Verde metalizado',
        'Sand': 'Arena',
        'Soft Pink': 'Rosa suave',
        'Rose Gold': 'Oro rosa',
        'Mint Green': 'Verde Meta',
        'Bordeaux Red': 'Burdeos',
        'Blind Debossed - without color': 'Grabado en bajorrelieve (sin color)'
      },
      fr: {
        'Embroidery on the glove (+€9.95)': 'Broderie sur le gant <span>(+€9.95)</span>',
        'Embroidery on the chest - kids (€9,95)': 'Broderie sur la poitrine – enfants <span>(€9,95)</span>',
        'Choose three symbols (+ €9.95)': 'Choisissez trois symboles <span>(+ 9,95 €)</span>',
        'Choose up to three symbols (+ €3.95 per symbol)': 'Choisissez jusqu’à trois symboles <span>(+ €3,95 par symbole)</span>',
        'You are [xxx.xx] away from getting a FREE Christmas Stocking': 'You are [xxx.xx] away from getting a FREE Christmas Stocking',
        'Close popup': 'Close popup',
        'Continue shopping': 'Continue shopping',
        'Total (Item Price + extras)': 'Prix de l`article',
        'Item Price (without extras)': 'Prix de l`article <span>(sans suppléments)</span>',
        'Congratulations! You get a FREE item! (embroidery not included)': 'Congratulations! You get a FREE item! (embroidery not included)',
        'Get FREE Christmas Stocking Now': 'Get FREE Christmas Stocking Now',
        'Choose one': 'Choisissez',
        'Enter here': 'Remplissez ici',
//        "Discount codes and gift cards can be added on the checkout page.": "Les codes de réduction et les cartes-cadeaux peuvent être ajoutés lors de votre prochaine étape sur la page de paiement.",
        "Discount codes and gift cards can be added on the checkout page.": "Discount codes can be used below and gift cards can be added on the checkout page.",
        'You have now exceeded the maximum number of 150 characters. Shorten your text a bit!': 'Vous avez maintenant dépassé le nombre maximum de 150 caractères. Raccourcissez un peu votre texte !',
        'Choose your wish card': 'Choisissez votre carte de vœux',
        'You get free shipping!': 'Vous bénéficiez de la livraison gratuite !',

        'Embroidery on the back': 'Broderie sur le dos <span>(+€19,95)</span>',
        'Embroidery on the back (€19.95)': 'Broderie sur le dos <span>(+€19,95)</span>',
        'Back embroidery color': 'Couleur de broderie sur le dos',
        'Embroidery on the chest': 'Broderie sur la poitrine <span>(+€9,95)</span>',
        'Embroidery on the chest (€9.95)': 'Broderie sur la poitrine <span>(+€9,95)</span>',
        'Embroidery on the towel (€14.95)': 'Broderie sur la serviette <span>(+€14,95)</span>',
        'Chest embroidery color': 'Couleur de broderie sur la poitrine <span>(+€9,95)</span>',
        'Embroidery color': 'Couleur de la broderie',
        'Embroidery Color': 'Couleur de la broderie',
        'Embroidery color (bracelet)': 'Couleur de la broderie',
        'Embroidery Color on beanie': 'Couleur de la broderie sur bonnet',
        'Embroidery Color on bib': 'Couleur de la broderie sur bavoir',
        'Embroidery Color on blankets': 'Couleur de la broderie sur couvertures',
        'Embroidery Color on baby suit': 'Couleur de la broderie sur ensemble',
        'Embroidery Color on sock': 'Couleur de la broderie sur chaussette',
        'Embroidery color on headband': 'Couleur de la broderie sur le bandeau',
        'Add a sleep mask? (€14.95)': 'Ajouter un masque de sommeil? <span>(+€14,95)</span>',
        'Yes': 'Oui',
        'No': 'Non',
        'Embroidery on the mask': 'Broderie sur le masque <span>(+€9,95)</span>',
        'Embroidery on the face mask (€9.95)': 'Broderie sur le masque <span>(+€9,95)</span>',
        'Mask embroidery color': 'Couleur de broderie sur le masque',
        'Choose a colour for the embroidery.': 'Choisissez une couleur pour la broderie.',
        'Choose embroidery font': 'Police de broderie',
        'Choose embroidery font (capital and le olive font only)': 'Police de broderie',
        'Make-up bag Embroidery font': 'Police de broderie trousse de maquillage',
        'Choose embroidery font on bib': 'Police de broderie sur bavoir',
        'Choose embroidery font on blankets': 'Police de broderie sur couvertures',
        'Please choose embroidery font.': 'Veuillez choisir la police de broderie.',
        'Gift-wrap this product (€4.95)': 'Ajouter une boîte cadeau (+€4,95)',
        'Gift-wrap this product (€9.95)': 'Ajouter une boîte cadeau (+€9,95)',
        'Personalise initials (+€4.95)': 'Personnaliser les initiales (+€4,95)',
        'Personalise Initials (+€4.95)': 'Personnaliser les initiales (+€4,95)',
        'Choose your print colour': 'Choisissez votre couleur d impression',
        'Add a wish card': 'Ajouter une carte de vœux',
        'Enter your personal message': 'Entrez votre message personnel',
        'Add FREE Sleep Mask Champagne': 'Ajouter un masque de sommeil au champagne GRATUIT',
        'Add FREE Sleep Mask Midnight Black': 'Ajouter un masque de sommeil minuit noir GRATUIT',
        'Add FREE Sleep Mask Velvet Bordeaux Red': 'Ajouter un masque de sommeil GRATUIT Velvet Bordeaux Red',
        'Add FREE Sleep Mask Blossom Pink': 'Ajouter un masque de sommeil au Rose Fleur GRATUIT',
        'Add FREE Sleep Mask Rose Pink': 'Ajouter un masque de sommeil au rose pâle GRATUIT',
        'Add FREE scent card': 'Ajouter une carte de parfumée GRATUITE',
        'FREE Embroidery on sleep mask': 'Broderie GRATUITE sur le masque de sommeil',
        'No, thanks': 'Non merci',
        'Embroidery color (for mask)': 'Couleur de la broderie (masque)',
        'Embroidery on the sleep mask (€9.95)': 'Broderie sur masque de sommeil - le nom <span>(+€9,95)</span>',
        'Embroidery on the sleep mask - initials (€9.95)': 'Broderie sur masque de sommeil - initiales <span>(+€9,95)</span>',
        'Add a scrunchie? (€9.95)': 'Ajouter un scrunchie (+€9,95)',
        'Add matching scrunchie? (€9.95)': 'Ajouter un scrunchie (+€9,95)',
        'Gift-wrap this product': 'Ajouter une boîte cadeau',

        'Embroidery on bath capes (€9.95)': 'Broderie sur capes de bain <span>(+€9,95)</span>',
        'Embroidery on poncho (€9.95)': 'Broderie sur poncho <span>(+€9,95)</span>',
        'Embroidery on bath textiles (€9.95)': 'Broderie sur linge de bain <span>(+€9,95)</span>',
        'Embroidery on the bath textiles (€9.95)': 'Broderie sur le linge de bain <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Broderie sur couvertures <span>(+€9,95)</span>',
        'Embroidery on sheets (€9.95)': 'Broderie sur draps <span>(+€9,95)</span>',
        'Embroidery on cuddle and pacifier cloths (€9.95)': 'Broderie sur doudous et tétines <span>(+€9,95)</span>',
        'Embroidery on pacifier (€9.95)': 'Broderie sur attache-tétine <span>(+€9,95)</span>',
        'Embroidery on cuddle (€9.95)': 'Broderie sur câlin <span>(+€9,95)</span>',
        'Embroidery on hydrophilic cloths (€9.95)': 'Broderie sur lingettes hydrophiles <span>(+€9,95)</span>',
        'Embroidery on backpacks (€9.95)': 'Broderie sur sacs à dos <span>(+€9,95)</span>',
        'Embroidery on the sleeve (€9.95)': 'Broderie sur la manche <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials (€9.95)': 'Broderie sur la manche - initiales <span>(+€9,95)</span>',
        'Embroidery on sleeve - initials 3 (€9.95)': 'Broderie sur la manche - initiales <span>(+€9,95)</span>',
        'Embroidery on the belt (€9.95)': 'Broderie sur la ceinture <span>(+€9,95)</span>',

        'Embroidery on laptop pouch (€9.95)': 'Broderie sur pochette d ordinateur <span>(+€9,95)</span>',
        'Embroidery on baby suit (€9.95)': 'Broderie sur ensemble <span>(+€9,95)</span>',
        'Embroidery on the baby suit (€9.95)': 'Broderie sur ensemble <span>(+€9,95)</span>',
        'Embroidery on bracelet (€9.95)': 'Broderies sur bracelets <span>(+€9,95)</span>',
        'Embroidery on hat (€9.95)': 'Broderies sur le chapeau <span>(+€9,95)</span>',
        'Embroidery on the hat (€9.95)': 'Broderies sur le chapeau <span>(+€9,95)</span>',
        'Embroidery on sun hat (€9.95)': 'Broderie sur chapeau de soleil <span>(+€9,95)</span>',
        'Embroidery at the bottom (€9.95)': 'Broderie bas haut <span>(+€9,95)</span>',
        'Embroidery on cardigan (€9.95)': 'Broderie sur cardigan <span>(+€9,95)</span>',
        'Embroidery on footmuff (€9.95)': 'Broderie sur chancelière <span>(+€9,95)</span>',
        'Embroidery on storage bag (€9.95)': 'Broderie sur sac pour boîte <span>(+€9,95)</span>',
        'Embroidery on cover (€9.95)': 'Broderie sur couverture (de vêtement) <span>(+€9,95)</span>',
        'Embroidery on front (€9.95)': 'Broderie sur le devant <span>(+€9,95)</span>',
        'Embroidery on teddy front (€14.95)': 'Broderie sur le devant <span>(+€14,95)</span>',
        'Embroidery on teddy (+€9,95)': 'Broderie sur teddy <span>(+€9,95)</span>',
        'Embroidery on shopper (€9,95)': 'Broderie sur le devant <span>(+€9,95)</span>',
        'Embroidery on the front (€9.95)': 'Broderie sur le devant <span>(+€9,95)</span>',
        'Embroidery on beanie (€9.95)': 'Broderie sur bonnet <span>(+€9,95)</span>',
        'Embroidery on bib (€9.95)': 'Broderie sur bavoir <span>(+€9,95)</span>',
        'Embroidery on blankets (€9.95)': 'Broderies sur couvertures <span>(+€9,95)</span>',
        'Embroidery on sock (€9.95)': 'Broderie sur chaussette <span>(+€9,95)</span>',
        'Embroidery on mittens (€9.95)': 'Broderies sur moufles <span>(+€9,95)</span>',
        'Embroidery on the chest (€9.95) - kimono': 'Broderie sur la poitrine - kimono <span>(+€9,95)</span>',
        'Embroidery on the back (€19.95) - kimono': 'Broderie sur le dos - kimono <span>(+€19,95)</span>',
        'Embroidery on the chest (€9.95) - pyjama': 'Broderie sur la poitrine - pyjama <span>(+€9,95)</span>',
        'Embroidery color on kimono': 'Couleur de la broderie sur kimono',
        'Embroidery color on pyjama': 'Couleur de la broderie sur pyjama',
        'Embroidery on the chest (€9.95) - pyjama kids': 'Broderie sur la poitrine - pyjama enfant <span>(+€9,95)</span>',
        'Embroidery color on pyjama kids': 'Couleur de la broderie sur pyjama enfant',
        'Embroidery on the slipper (€9.95)': 'Broderies sur chausson <span>(+€9,95)</span>',
        'Embroidery color on slipper': 'Couleur de la broderie sur chausson',
        'Embroidery on pillow - initials (€9.95)': 'Broderie sur taie d`oreiller - initiales <span>(+€9,95)</span>',
        'Embroidery on pillow - name (€9.95)': 'Broderie sur taie d`oreiller - nom <span>(+€9,95)</span>',
        'Embroidery on chair (€9.95)': 'Broderie sur chaise <span>(+€9,95)</span>',
        'Added': 'Ajouté',
        'FREE Sleep mask': 'Masque de sommeil GRATUIT',
        'FREE Make-up bag': 'GRATUIT Pochette',
        'Embroidery on cat collar (€9.95)': 'Broderie sur collier pour chat <span>(+€9,95)</span>',
        'Embroidery on dog collar - name (€9.95)': 'Broderie sur collier pour chien - le nom <span>(+€9,95)</span>',
        'Embroidery on dog collar - number (€9.95)': 'Broderie sur collier pour chien - le numéro de téléphone <span>(+€9,95)</span>',
        'Printing on label (€4.95)': 'Impression sur étiquette <span>(+€4,95)</span>',
        'Embroidery on harness - name (€9.95)': 'Broderie sur harnais - le nom <span>(+€9,95)</span>',
        'Embroidery on harness - number (€9.95)': 'Broderie sur harnais - le numéro de téléphone<span>(+€9,95)</span>',
        'Embroidery on leash - name (€9.95)': 'Broderie sur laisse - le nom <span>(+€9,95)</span>',
        'Embroidery on leash - number (€9.95)': 'Broderie sur laisse - le numéro de téléphone <span>(+€9,95)</span>',
        'Printing on leash (€9.95)': 'Impression sur laisse <span>(+€9,95)</span>',
        'Embroidery on poop bag holder (€9.95)': 'Broderie sur porte-sac à crottes <span>(+€9,95)</span>',
        'Printing on poop bag holder (€4.95)': 'Impression sur porte-sac à crottes <span>(+€4,95)</span>',
        'Choose your leather tag': 'Choisissez votre étiquette en cuir',
        'Heart': 'Cœur',
        'Original': 'Original',
        'Embroidery color for pets': 'Couleur de la broderie',
        'Choose your print colour for pets': 'Choisissez votre couleur d impression',
        'Embroidery on tanga (+€9,95)': 'Broderie sur tanga <span>(+€9,95)</span>',
        'Embroidery on veil (+€9,95)': 'Broderie sur voile <span>(+€9,95)</span>',
        'Embroidery on scarf - initials (+€9,95)': 'Broderie sur écharpe <span>(+€9,95)</span>',
        'Embroidery on scarf (+€9,95)': 'Broderie sur écharpe - initiales <span>(+€9,95)</span>', 
        'Embroidery on dog cushion (+ €9,95)': 'Broderie sur coussin chien <span>(+€9,95)</span>',
        'Embroidery on make-up bag (+€9,95)': 'Broderie sur trousse de maquillage <span>(+€9,95)</span>',
        'Embroidery on toiletry bag (+€9,95)': 'Broderie sur trousse de toilette <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Broderie sur la pochette <span>(+€9,95)</span>',
        'Embroidery on pouch (€9.95)': 'Broderie sur la pochette <span>(+€9,95)</span>',
        'Embroidery on the changing mat (€9.95)': 'Broderie sur le tapis à langer  <span>(+€9,95)</span>',

        'GRATIS Geurkaart Bundel': 'Lot de Cartes Parfumées GRATUIT',
        'Le Olive font': 'Le Olive police',
        'Modern font': 'Police modern',
        'Modern font - ALL CAPS only': 'Police modern - TOUTES MAJUSCULES uniquement',
        'Black': 'Noir',
        'Red': 'Rouge',
        'White': 'Blanc',
        'Silver': 'Argent',
        'Gold': 'Doré',
        'Brown': 'Marron',
        'Light Brown': 'Marron clair',
        'Dark Brown': 'Marron foncé',
        'Lilac': 'Lilas',
        'Metallic Rose': 'Rose métallique',
        'Grey': 'Gris',
        'Neon Pink': 'Rose fluo',
        'Light Pink': 'Rose clair',
        'Dark Pink': 'Rose foncé',
        'Purple': 'Violet',
        'Orange': 'Orange',
        'Blue': 'Bleu',
        'Light Blue': 'Bleu clair',
        'Powder Pink': 'Rose poudré',
        'Coral Pink': 'Rose corail',
        'Metallic Green': 'Vert Métallique',
        'Sand': 'Sable',
        'Soft Pink': 'Rose Pâle',
        'Rose Gold': 'Or Rose',
        'Mint Green': 'Vert Menthe',
        'Bordeaux Red': 'Rouge Bordeaux',
        'Blind Debossed - without color': 'Gaufrage sans encre (sans couleur)'
      }
    }
  };

  obj.data.defaultLangauge = 'nl';
  obj.data.language = $('html').attr('lang');

//     if (/^\/([a-z]{2})(\/.*|)$/.test(window.location.pathname)) {
//       obj.data.language = window.location.pathname.replace(/^\/([a-z]{2})(\/.*|)$/, "$1");

//     } else {
//       obj.data.language = 'nl';
//     }

  if (obj.data.language in obj.data.translations) {
    obj.data.translation = obj.data.translations[obj.data.language];

  } else {
    obj.data.language = obj.data.defaultLangauge;
    obj.data.translation = obj.data.translations[obj.data.language];
  }

  obj.init = function () {
    obj.currency();


    /* Collection cover video */
//     var collectionCoverVideo = $('.collection-cover > video[data-muted="false"]');

//     if (collectionCoverVideo.length) {
//       collectionCoverVideo[0].muted = false;
//       collectionCoverVideo[0].volume = 1;
//       collectionCoverVideo[0].play();
//     }
    /* /Collection cover video */


    var sectionTitles = $('.section-header__title');

    if (sectionTitles.length) {

      sectionTitles.each(function() {
        var sectionTitle = $(this);
        var sectionTitleText = sectionTitle.text().trim();

        sectionTitle.html(
          sectionTitleText.replace(/\s([^\s]+)$/, ' <b>$1</b>')
        );
      });
    }

    obj.header();

    var templateBase = String(
      (document.body && document.body.getAttribute('data-template')) || ''
    ).split('.')[0].split('/')[0];

    if (templateBase === 'index') {
      obj.indexPage();

    } else if (templateBase === 'product') {
      try {
        obj.productPage();
      } catch (err) {
        console.error('productPage failed', err);
      }

    } else if (templateBase === 'collection') {

      $(window).on('load resize', function() {
        var products = $('.product-miniatures__wrapper > .product-miniatures > div');

        if (products.length) {
          products.removeClass('clear-md-left');

          var productsWrapper = $('.product-miniatures__wrapper');
          var productsWrapperPosition = parseInt(productsWrapper.offset().left + productsWrapper.outerWidth());

          products.each(function() {
            var product = $(this);
            var productPosition = parseInt(product.offset().left + product.outerWidth());

              if ((productPosition + 1) == productsWrapperPosition) {
                var productPosition = productPosition + 1;
              }

            if ($(window).width() < 768) {

              if (productPosition == productsWrapperPosition) {

                if (product.next().length) {
                  product.next().addClass('clear-sm-left');
                }

              } else {

                if (product.next().length) {
                  product.next().removeClass('clear-sm-left');
                }
              }

            } else {

              if (productPosition == productsWrapperPosition) {

                if (product.next().length) {
                  product.next().addClass('clear-md-left');
                }

              } else {

                if (product.next().length) {
                  product.next().removeClass('clear-md-left');
                }
              }
            }
          });
        }
      });

      /* Klaviyo popup */
      $(document).on('click', '.ps__klaviyo-popup__bg, .ps__klaviyo-popup__close', function() {
        $('body').removeClass('ps__klaviyo-popup__visible');
      });

      $(document).on('click', '.article-miniature__newsletter button.btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $('body').addClass('ps__klaviyo-popup__visible');
      });
      /* /Klaviyo popup */

    } else if (templateBase === 'cart') {
      obj.cartPage();

    } else if (templateBase === 'page') {

      if (($('body#b2b-test').length || $('body#b2b').length) && $('.index-single__intro').length) {
        var pageContent = $('#MainContent .rte');

        if (pageContent.length) {
          pageContent.parents('.shopify-section').remove();
          
        }
      }

    }

    $(document).on('click', function(e) {

      /* Language switcher */
      if ($('.site-header__languages-wrapper.active').length &&
          !$(this).hasClass('site-header__languages') &&
          $(e.target).closest('.site-header__languages').length === 0 &&

          $(e.target).closest('.site-header__languages-title').length === 0 &&
          !$(this).hasClass('site-header__languages-title')) {
        $('.site-header__languages-wrapper').removeClass('active');
      }
      /* /Language switcher */

      /* Header menu */
      if ($('.site-nav__submenu:visible').length &&
          !$(this).hasClass('site-nav__submenu') &&
          $(e.target).closest('.site-nav__submenu').length === 0 &&

          $(e.target).closest('.site-nav__link').length === 0 &&
          !$(this).hasClass('site-nav__link')) {

        var submenuDropdown = $('.site-nav__submenu:visible');
        var submenuTitle = submenuDropdown.siblings('.site-nav__link');

        submenuTitle.addClass('site-nav__expand').removeClass('site-nav__collapse');
        submenuDropdown.addClass('site-nav__submenu--expanded').removeClass('site-nav__submenu--collapsed').attr('aria-hidden', true).hide();
      }
      /* /Header menu */
    });

    $(document).on('click', '#shopify-section-header .list--nav .site-nav__item button.site-nav__link', function() {
      var btn = $(this);
      var list = btn.next('.site-nav__submenu');

      if (btn.hasClass('site-nav__collapse')) {
        btn.removeClass('site-nav__collapse').addClass('site-nav__expand');
        list.removeClass('site-nav__submenu--collapsed').addClass('site-nav__submenu--expanded').attr('aria-hidden', true).hide();

      } else {
        btn.addClass('site-nav__collapse').removeClass('site-nav__expand');
        list.addClass('site-nav__submenu--collapsed').removeClass('site-nav__submenu--expanded').attr('aria-hidden', false).show();
      }
    });



    $(document).scroll(function() {
      obj.scrollEvent();
    });

    $(window).resize(function() {
      obj.scrollEvent();
    });

    obj.scrollEvent();

    var headerMenu = $('#shopify-section-header .site-nav');
    var sidebarMenu = $('#shopify-section-sidebar .site-nav');

    if (headerMenu.length && sidebarMenu.length && !headerMenu.html().trim()) {
      headerMenu.html(sidebarMenu.html());
    }
    var headerBabyMenu = $('#shopify-section-baby-header .site-nav');
    var sidebarBabyMenu = $('#shopify-section-baby-sidebar .site-nav');

    if (headerBabyMenu.length && sidebarBabyMenu.length && !headerBabyMenu.html().trim()) {
      headerBabyMenu.html(sidebarBabyMenu.html());
    }
    obj.languages();
    obj.moodImagesSliders();

    return obj;
  };

  obj.moodImagesSliders = function() {
    var moodImagesSlidersItems = $('.moodimages__slider-items');

    if (moodImagesSlidersItems.length) {

      moodImagesSlidersItems.each(function() {
        var moodImagesSliderItems = $(this);

        moodImagesSliderItems.owlCarousel({
          dots: false,
          loop: false,
          responsiveClass: true,
          margin: 0,
          responsive: {
            0: {
              nav: false,
              margin: 18,
              items: 1
            },
            750: {
              margin: 30,
              items: 2
            },
            990: {
              nav: true,
              margin: 30,
              items: moodImagesSliderItems.attr('data-slider-items-desktop')
            }
          }
        });
      });
    }

    return obj;
  };

  obj.currency = function() {
    obj.currencySymbol = $('body').attr('data-currency-symbol');
    obj.originalCurrencySymbol = $('body').attr('data-original-currency-symbol');

    return obj;
  };

  obj.header = function() {
    var collections = $('#shopify-section-sidebar .site-nav__item > .site-nav__submenu:first');

    $(window).on('load resize', function() {

      if ($(window).width() >= 768) {

        if (collections.length) {
          collections.removeClass('owl-carousel').removeClass('owl-theme');
        }

      } else {

        if (collections.length) {
          collections.addClass('owl-carousel').addClass('owl-theme');
        }
      }
    });

    $(document).on('click', '#headerMenuBtn', function(e) {
      e.preventDefault();
      e.stopPropagation();

      //$('body').toggleClass('header-menu__opened');

      //$('.site-nav--has-submenu > button.site-nav__expand').click();
      $('#header-mobile-menu').addClass('open')
      $('body').addClass('header-mobile-menu-opened');
      /*
      if (collections.length) {

        setTimeout(function() {

          if (collections.hasClass('owl-loaded')) {
            collections.trigger('destroy.owl.carousel');
          }

//           collections.owlCarousel({
//             dots: false,
//             nav: false,
//             items: 1,
//             loop: false,
//             responsiveClass: true,
//             margin: 0
//           });

        }, 1000);
      }
       */

      //     $('.site-nav__submenu--active').removeClass('site-nav__submenu--active').attr({
      //       'aria-hidden': 'true'
      //     }).hide();
    });

    return obj;
  };

  obj.timer = function() {

    setInterval(function() {
      const currentTopDate = new Date();

      const startTopDate = new Date('Thu Jul 03 2020 00:00:00 GMT+0100');

      const endTopDate = new Date('Tue Jul 25 2023 00:00:00 GMT+0200');

      const showTopInfoToolTip = false;
      const showTopLogo = false;

      const hideTopTimerCounter = false;
      const hideTopTimerButton = false;
      const currentCountry = window.language;
      const countryToShow = ['fr'];
      const showForALLCountry = true;
      let showForCurrentCountry = false;

      if(countryToShow.includes(currentCountry) || showForALLCountry ){
        showForCurrentCountry = true;
      }
      if (
//         (/DEVMODE/.test(window.location.href)) && // DEVMODE for MAIN timer
        (currentTopDate.getTime() >= startTopDate.getTime() && currentTopDate.getTime() <= endTopDate.getTime()) && showForCurrentCountry
      ) {
        const distanceTopDate = endTopDate.getTime() - currentTopDate.getTime();

        const topTimer = $('.site-header__timer.top__timer');

        if (showTopLogo) {
          topTimer.attr('data-banner-logo', true);
        }

        const topDays = Math.floor(distanceTopDate / (1000 * 60 * 60 * 24));
        const topHours = Math.floor((distanceTopDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const topMinutes = Math.floor((distanceTopDate % (1000 * 60 * 60)) / (1000 * 60));
        const topSeconds = Math.floor((distanceTopDate % (1000 * 60)) / 1000);

        topTimer.find('.site-header__timer-days b').text(topDays);

        if (showTopInfoToolTip) {
          topTimer.find('.site-header__timer-subtitle').attr('data-infotooltip', true);
          $(document).on('click', '.top__timer .site-header__timer-link', function(e) {
            e.preventDefault();
            e.stopPropagation();

            $('body').addClass('wsp__popup-visible');
          });
        }

        if (hideTopTimerButton === true && hideTopTimerCounter === true) {
          topTimer.find('.site-header__timer-subtitle > span').addClass('flex-center');
          topTimer.find('.site-header__timer-right').addClass('mobile-padding-reset');
        }
        if (topDays < 1) {
          topTimer.find('.site-header__timer-left').addClass('site-header__timer-nodays');
          topTimer.find('.site-header__timer-days').hide();
        }


        if (!hideTopTimerCounter) {

          if (topDays > 14) {
            topTimer.addClass('site-header__timer__counter-hidden').removeClass('site-header__timer__counter-visible');

          } else {
            topTimer.removeClass('site-header__timer__counter-hidden').addClass('site-header__timer__counter-visible');
          }
        }

        topTimer.find('.site-header__timer-hours').text(topHours < 10 ? '0' + topHours : topHours);
        topTimer.find('.site-header__timer-minutes').text(topMinutes < 10 ? '0' + topMinutes : topMinutes);
        topTimer.find('.site-header__timer-seconds').text(topSeconds < 10 ? '0' + topSeconds : topSeconds);


        if (hideTopTimerCounter) {
          topTimer.find('.site-header__timer-left').addClass('hidden');
        }

        if (hideTopTimerButton) {
          topTimer.find('.site-header__timer-more').addClass('hidden');
        }

        $('body').addClass('header-top-timer__enabled');

      } else {
        $('body').removeClass('header-top-timer__enabled');
      }

    }, 1000);


    if ( $('.site-header__banner').length ) {
      $('.site-header__banner').remove();
    }




    $(document).on('click', '.wsp__popup-bg,.wsp__popup-close', function(e) {
        e.preventDefault();
        e.stopPropagation();

      var popup = $(this).parents('.wsp__popup-wrapper');
      $('body').removeClass('wsp__popup-visible');

      var popupLink = $('.site-header__timer-link');
      window.location.href = popupLink.attr('href');
    });

    return obj;
  };


  obj.secondTimer = function () {
    setInterval(function() {
      const currentBottomDate = new Date();

      const startBottomDate = new Date('Wed Apr 11 2023 00:00:00 GMT+0100');

      const endBottomDate = new Date('Mon May 15 2023 00:00:00 GMT+0200');

      const showBottomInfoToolTip = false;
      const showBottomLogo = false;

      const hideBottomTimerCounter = true;
      const hideBottomTimerButton = false;
      const bottomCurrentCountry = window.language;
      const bottomCountryToShow = ['fr'];
      const bottomShowForALLCountry = false;
      let bottomShowForCurrentCountry = false;

      if(bottomCountryToShow.includes(bottomCurrentCountry) || bottomShowForALLCountry ){
        bottomShowForCurrentCountry = true;
      }
      if (
//       (/DEVMODE/.test(window.location.href)) && // DEVMODE for BABY timer
              (currentBottomDate.getTime() >= startBottomDate.getTime() && currentBottomDate.getTime() <= endBottomDate.getTime()) && bottomShowForCurrentCountry
      ) {
        const distanceBottomDate = endBottomDate.getTime() - currentBottomDate.getTime();

        const bottomTimer = $('.site-header__timer.bottom__timer');

        if (showBottomLogo) {
          bottomTimer.attr('data-banner-logo', true);
        }

        const bottomDays = Math.floor(distanceBottomDate / (1000 * 60 * 60 * 24));
        const bottomHours = Math.floor((distanceBottomDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const bottomMinutes = Math.floor((distanceBottomDate % (1000 * 60 * 60)) / (1000 * 60));
        const bottomSeconds = Math.floor((distanceBottomDate % (1000 * 60)) / 1000);

        bottomTimer.find('.site-header__timer-days b').text(bottomDays);

        if (showBottomInfoToolTip) {
          bottomTimer.find('.site-header__timer-subtitle').attr('data-infotooltip', true);
          $(document).on('click', '.site-header__timer-link', function(e) {
            e.preventDefault();
            e.stopPropagation();

            $('body').addClass('wsp__popup-visible1');
          });
        }
        if (hideBottomTimerButton === true && hideBottomTimerCounter === true) {
          bottomTimer.find('.site-header__timer-subtitle > span').addClass('flex-center');
          bottomTimer.find('.site-header__timer-right').addClass('mobile-padding-reset');
        }
        if (bottomDays < 1) {
          bottomTimer.find('.site-header__timer-left').addClass('site-header__timer-nodays');
          bottomTimer.find('.site-header__timer-days').hide();
        }


        if (!hideBottomTimerCounter) {

          if (bottomDays > 14) {
            bottomTimer.addClass('site-header__timer__counter-hidden').removeClass('site-header__timer__counter-visible');

          } else {
            bottomTimer.removeClass('site-header__timer__counter-hidden').addClass('site-header__timer__counter-visible');
          }
        }

        bottomTimer.find('.site-header__timer-hours').text(bottomHours < 10 ? '0' + bottomHours : bottomHours);
        bottomTimer.find('.site-header__timer-minutes').text(bottomMinutes < 10 ? '0' + bottomMinutes : bottomMinutes);
        bottomTimer.find('.site-header__timer-seconds').text(bottomSeconds < 10 ? '0' + bottomSeconds : bottomSeconds);


        if (hideBottomTimerCounter) {
          bottomTimer.find('.site-header__timer-left').addClass('hidden');
        }

        if (hideBottomTimerButton) {
          bottomTimer.find('.site-header__timer-more').addClass('hidden');
        }

        $('body').addClass('header-bottom-timer__enabled');

      } else {
        $('body').removeClass('header-bottom-timer__enabled');
      }

    }, 1000);


    if ( $('.site-header__banner').length ) {
      $('.site-header__banner').remove();
    }

    $(document).on('click', '.wsp__popup-bg,.wsp__popup-close', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var popup = $(this).parents('.wsp__popup-wrapper');
      $('body').removeClass('wsp__popup-visible1');

      var popupLink = $('.site-header__timer-link');
      window.location.href = popupLink.attr('href');
    });

    return obj
  }


  obj.languages = function() {
    var lyLanguagesSwitcher = $('.ly-languages-switcher');

    if (lyLanguagesSwitcher.length) {
      var lyLanguages = $('.ly-languages-switcher-link');
      var newLanguages = $('.site-header__languages');
      var newSidebarLanguages = $('.site-sidebar__languages');

      lyLanguages.each(function() {
        var lyLanguage = $(this);
//         var lyLanguageISO = lyLanguage.attr('data-ly-code');
        var lyLanguageISO = lyLanguage.attr('data-language-code');
        var lyLanguageValue = lyLanguage.text().trim();
        var lyLanguageHTML = lyLanguage[0].outerHTML;

        if (/^\/([a-z]{2}(|\/.*))$/.test(window.location.pathname)) {
          var newLink = window.location.pathname.replace(/^\/([a-z]{2}(|\/.*))$/, "$2") + window.location.search;

        } else {
          var newLink = window.location.pathname + window.location.search;
        }

        if (lyLanguageISO != 'nl') {
          var newLink = '/' + lyLanguageISO + newLink;
        }

        if (!newLink) {
          var newLink = '/';
        }

        var lyLanguageLink = lyLanguage;

        if (!$('.site-header__language[data-language-text="' + lyLanguageValue + '"]').length) {
          newLanguages.append(
            '<div class="site-header__language" data-language-iso="' + lyLanguageISO + '" data-language-text="' + lyLanguageValue + '" data-href="' + newLink + '">' +
            lyLanguageISO +
            '</div>'
          );
        }

        if (!$('.site-sidebar__language[data-language-text="' + lyLanguageValue + '"]').length) {
          newSidebarLanguages.append(
            '<div class="site-sidebar__language" data-language-text="' + lyLanguageValue + '" data-href="' + newLink + '">' +
            lyLanguageISO +
            '</div>'
          );
        }
      });
    }

    $(document).on('click', '.site-header__languages-title', function() {
      $('.site-header__languages-wrapper').toggleClass('active');
    });

    $(document).on('click', '.site-header__language', function() {
      var language = $(this);
      window.location.href = language.attr('data-href');
    });

    $(document).on('click', '.site-sidebar__languages-title', function() {
      $('.site-sidebar__languages-wrapper').toggleClass('active');
    });

    $(document).on('click', '.site-sidebar__language', function() {
      var language = $(this);
      window.location.href = language.attr('data-href');
    });

    return obj;
  };

  obj.scrollEvent = function() {
    var st = $(window).scrollTop();
    var floatingBg = $('.site-header__floating-bg');

    var header = $('#shopify-section-header');

    if (st > floatingBg.offset().top) {
      $('body').addClass('site-header__floating');

    } else {
      $('body').removeClass('site-header__floating');
    }

    if (st > 0 && st > header.height()) {

      if (obj.lastSt > st) {
        $('body').removeClass('site-header__floating-hidden');

      } else {
        $('body').addClass('site-header__floating-hidden');
      }

    } else {
      $('body').addClass('site-header__floating-hidden');
    }

    obj.lastSt = st;

    return obj;
  };

  obj.checkT = function(t) {
    var newT = obj.data.translation[t];

    if (typeof newT !== 'undefined') {
      /* Found */
      return true;

    } else {
      /* Not found */
      return false;
    }
  };

  obj.t = function (t) {
    var newT = obj.data.translation[t];

    if (typeof newT !== 'undefined') {
      /* Found */

    } else {
      var newT = t;
    }

    return newT;
  };

  obj.stripCombiningStrike = function (text) {
    return String(text || '').replace(/\u0336/g, '');
  };

  obj.isTeddyEmbroideryNameKey = function (key) {
    var plain = obj.stripCombiningStrike(key);
    if (/charge/i.test(plain)) return false;
    return /^Embroidery on teddy/i.test(plain);
  };

  /* Restore original paid embroidery property names (undo old free/strikethrough labels). */
  obj.teddyEmbroideryCheckoutPropertyKey = function (key) {
    if (!obj.isTeddyEmbroideryNameKey(key)) return key;
    var hasStrike = /\u0336/.test(String(key || ''));
    var original = obj.stripCombiningStrike(key).trim();
    var plain = original.replace(/\s*[—–-]\s*(free|gratis|gratuit)\s*$/i, '').trim();
    if (!hasStrike && plain === original) return key;
    var priceMatch = plain.match(/\(\+?[^)]*\)/);
    var price = priceMatch ? priceMatch[0] : '(+€9,95)';
    return 'Embroidery on teddy ' + price;
  };

  obj.teddyEmbroideryCartNeedsRewrite = function (cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var props = items[i].properties || {};
      var keys = Object.keys(props);
      for (var k = 0; k < keys.length; k++) {
        if (obj.teddyEmbroideryCheckoutPropertyKey(keys[k]) !== keys[k]) return true;
      }
    }
    return false;
  };

  obj.syncTeddyEmbroideryCheckoutProperties = function (cart, done) {
    if (obj._teddyStrikeSyncing) {
      if (typeof done === 'function') done(false, cart);
      return;
    }

    var items = (cart && cart.items) || [];
    var updates = [];

    items.forEach(function (item) {
      var props = item.properties;
      if (!props) return;
      var nextProps = {};
      var changed = false;
      Object.keys(props).forEach(function (key) {
        var nextKey = obj.teddyEmbroideryCheckoutPropertyKey(key);
        if (nextKey !== key) changed = true;
        nextProps[nextKey] = props[key];
      });
      if (changed) {
        updates.push({
          id: item.key,
          quantity: item.quantity,
          properties: nextProps
        });
      }
    });

    if (!updates.length) {
      if (typeof done === 'function') done(false, cart);
      return;
    }

    obj._teddyStrikeSyncing = true;

    var runTeddy = function () {
      var chain = Promise.resolve();
      updates.forEach(function (payload) {
        chain = chain.then(function () {
          return fetch('/cart/change.js?teddyStrike=1', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(payload)
          }).then(function (response) {
            return response.json();
          });
        });
      });

      return chain.then(function (lastCart) {
        obj._teddyStrikeSyncing = false;
        if (typeof done === 'function') done(true, lastCart || cart);
      }).catch(function () {
        obj._teddyStrikeSyncing = false;
        if (typeof done === 'function') done(false, cart);
      });
    };

    if (window.__leOliveCartGiftLock && window.__leOliveCartGiftLock.run) {
      window.__leOliveCartGiftLock.run(runTeddy);
    } else {
      runTeddy();
    }
  };

  /* Set true in snippets/zero-bag-embroidery-free.liquid to turn this back on. */
  obj.isZeroBagEmbroideryFreeEnabled = function () {
    return window.leOliveZeroBagEmbroideryFree === true;
  };

  obj.zeroBagEmbroideryFreeWord = function () {
    var lang = typeof getCurrentLang === 'function'
      ? getCurrentLang()
      : String(window.langify_lang || document.documentElement.lang || 'en').split('-')[0].toLowerCase();
    if (lang === 'en') return 'free';
    if (lang === 'fr') return 'gratuit';
    if (lang === 'de' || lang === 'nl' || lang === 'es') return 'gratis';
    return 'gratis';
  };

  obj.strikeThroughText = function (text) {
    return String(text || '').split('').map(function (ch) {
      if (ch === '\u0336') return '';
      return ch + '\u0336';
    }).join('');
  };

  obj.isZeroBagEmbroideryChargeKey = function (key) {
    var plain = obj.stripCombiningStrike(key).trim();
    return /^Embroidery on bag\s*-\s*charge$/i.test(plain);
  };

  obj.hasZeroBagEmbroideryCharge = function (props) {
    if (!props) return false;
    var keys = Object.keys(props);
    var i;
    for (i = 0; i < keys.length; i++) {
      if (obj.isZeroBagEmbroideryChargeKey(keys[i])) return true;
    }
    return false;
  };

  obj.isZeroBagEmbroideryContext = function (root) {
    var $root = $(root || document);
    if ($root.find('input[name="properties[Embroidery on bag - charge]"]').length) return true;
    if ($root.closest('form').find('input[name="properties[Embroidery on bag - charge]"]').length) return true;
    if ($('form.product-form input[name="properties[Embroidery on bag - charge]"]').length) return true;
    return false;
  };

  obj.isZeroBagEmbroideryTextKey = function (key) {
    var plain = obj.stripCombiningStrike(key);
    if (/charge/i.test(plain) || /font/i.test(plain) || /color/i.test(plain)) return false;
    return /Embroidery on make-up bag/i.test(plain) ||
      /Embroidery on toiletry bag/i.test(plain) ||
      /Embroidery on toilettas/i.test(plain) ||
      /^Embroidery on bag/i.test(plain) ||
      /toilettasje/i.test(plain) ||
      /Toiletttasche/i.test(plain) ||
      /trousse de toilette/i.test(plain) ||
      /Bordado en neceser/i.test(plain);
  };

  obj.zeroBagEmbroideryDefaultPrefix = function (plain) {
    if (/toiletry|toilettas|toilettasje|Toiletttasche|trousse de toilette|neceser/i.test(plain) &&
        !/make-up|makeup|maquillaje/i.test(plain)) {
      return 'Embroidery on toiletry bag';
    }
    if (/make-up|makeup|maquillaje/i.test(plain)) return 'Embroidery on make-up bag';
    return 'Embroidery on bag';
  };

  obj.zeroBagEmbroideryOriginalPropertyKey = function (key) {
    if (!obj.isZeroBagEmbroideryTextKey(key)) return key;
    var raw = String(key || '');
    var hasStrike = /\u0336/.test(raw);
    var original = obj.stripCombiningStrike(key).trim();
    var plain = original.replace(/\s*[—–-]\s*(free|gratis|gratuit)\s*$/i, '').trim();
    if (!hasStrike && plain === original) return key;
    var priceMatch = plain.match(/\(\+?[^)]*\d[^)]*\)/);
    var prefix = plain.replace(/\(\+?[^)]*\d[^)]*\)/, '').trim();
    if (!prefix) prefix = obj.zeroBagEmbroideryDefaultPrefix(plain);
    if (priceMatch) return prefix + ' ' + priceMatch[0];
    return prefix || key;
  };

  obj.zeroBagEmbroideryCheckoutPropertyKey = function (key) {
    if (!obj.isZeroBagEmbroideryTextKey(key)) return key;
    if (!obj.isZeroBagEmbroideryFreeEnabled()) {
      return obj.zeroBagEmbroideryOriginalPropertyKey(key);
    }
    var original = obj.zeroBagEmbroideryOriginalPropertyKey(key);
    var priceMatch = original.match(/\(\+?[^)]*\d[^)]*\)/);
    var price = priceMatch ? priceMatch[0] : '(+€9,95)';
    var prefix = original.replace(/\(\+?[^)]*\d[^)]*\)/, '').trim();
    if (!prefix) prefix = obj.zeroBagEmbroideryDefaultPrefix(original);
    return prefix + ' ' + obj.strikeThroughText(price) + ' - free';
  };

  obj.formatZeroBagEmbroideryPropertyLabel = function (key) {
    var freeWord = obj.zeroBagEmbroideryFreeWord();
    var plain = obj.stripCombiningStrike(key)
      .replace(/\s*[—–-]\s*(free|gratis|gratuit)\s*$/i, '')
      .trim();
    return plain.replace(/(\(\+?[^)]*\d[^)]*\))/g, '<s>$1</s>') + ' - ' + freeWord;
  };

  obj.clearFreeZeroBagEmbroideryLabels = function (root) {
    var $root = $(root || document);
    var bagEmbroideryInputs =
      'input[name^="properties[Embroidery on make-up bag ("],' +
      'input[name^="properties[Embroidery on toiletry bag ("],' +
      'input[name^="properties[Embroidery on toilettas ("],' +
      'input[name^="properties[Embroidery on bag ("],' +
      'input[name*="toiletry bag"],' +
      'input[name*="toilettas"]';
    $root.find('.cart__row__property-name, .header-cart__sidebar-item__property').each(function () {
      var $el = $(this);
      var source = $el.attr('data-text') || $el.text();
      var keyOnly = source.replace(/:\s*.*$/, '');
      if (!obj.isZeroBagEmbroideryTextKey(keyOnly) && !obj.isZeroBagEmbroideryTextKey(source)) return;
      var original = obj.zeroBagEmbroideryOriginalPropertyKey(keyOnly);
      if ($el.hasClass('header-cart__sidebar-item__property')) {
        var valueMatch = source.match(/:\s*(.*)$/);
        $el.text(original + (valueMatch ? ': ' + valueMatch[1] : ''));
        return;
      }
      if (original === source && !$el.find('s').length) return;
      $el.text(original);
    });
    $root.find('.bold_option_title').each(function () {
      var $title = $(this);
      var text = $title.text();
      if (!obj.isZeroBagEmbroideryTextKey(text)) return;
      if (!$title.find('s').length && !/\s-\s(free|gratis|gratuit)\s*$/i.test(text)) return;
      $title.text(obj.zeroBagEmbroideryOriginalPropertyKey(text));
    });
    $root.find(bagEmbroideryInputs).each(function () {
      var $title = $(this).closest('.bold_option').find('.bold_option_title').first();
      if (!$title.length) return;
      if (!$title.find('s').length && !/\s-\s(free|gratis|gratuit)\s*$/i.test($title.text())) return;
      var html = $title.html()
        .replace(/<s>(.*?)<\/s>/gi, '$1')
        .replace(/\s*[—–-]\s*(free|gratis|gratuit)\s*$/i, '')
        .trim();
      $title.html(html);
    });
  };

  obj.applyFreeZeroBagEmbroideryLabels = function (root) {
    if (!obj.isZeroBagEmbroideryFreeEnabled()) {
      obj.clearFreeZeroBagEmbroideryLabels(root);
      return;
    }
    var $root = $(root || document);
    var freeWord = obj.zeroBagEmbroideryFreeWord();
    if (obj.isZeroBagEmbroideryContext($root)) {
      $root.find(
        'input[name^="properties[Embroidery on make-up bag ("],' +
        'input[name^="properties[Embroidery on toiletry bag ("],' +
        'input[name^="properties[Embroidery on toilettas ("],' +
        'input[name^="properties[Embroidery on bag ("]'
      ).each(function () {
        var $title = $(this).closest('.bold_option').find('.bold_option_title').first();
        if (!$title.length || $title.find('s').length) return;
        var html = $title.html();
        var next = html.replace(/(\(\+?[^)]*\d[^)]*\))/g, '<s>$1</s>');
        if (next === html) return;
        if (!/\s-\s(free|gratis|gratuit)\s*$/i.test($title.text())) {
          next += ' - ' + freeWord;
        }
        $title.html(next);
      });
    }
    $root.find('.cart__row[data-zero-bag-embroidery="true"] .cart__row__property-name').each(function () {
      var $el = $(this);
      var source = $el.attr('data-text') || $el.text();
      if (!obj.isZeroBagEmbroideryTextKey(source)) return;
      if ($el.find('s').length) return;
      $el.html(obj.formatZeroBagEmbroideryPropertyLabel($el.html() || $el.text()));
    });
  };

  obj.rewriteZeroBagEmbroideryPropertyInputs = function (form) {
    if (!obj.isZeroBagEmbroideryFreeEnabled()) return;
    if (!form || !obj.isZeroBagEmbroideryContext(form)) return;
    $(form).find('input[name^="properties["]').each(function () {
      var name = this.name || '';
      var match = name.match(/^properties\[(.*)\]$/);
      if (!match) return;
      var next = obj.zeroBagEmbroideryCheckoutPropertyKey(match[1]);
      if (next !== match[1]) this.setAttribute('name', 'properties[' + next + ']');
    });
  };
  window.leOliveRewriteZeroBagEmbroideryPropertyInputs = obj.rewriteZeroBagEmbroideryPropertyInputs;

  window.leOliveRestoreZeroBagEmbroidery = function () {
    return new Promise(function (resolve) {
      $.getJSON('/cart.js?ts=' + Date.now(), function (cart) {
        if (typeof obj.zeroBagEmbroideryCartNeedsRewrite === 'function' &&
            !obj.zeroBagEmbroideryCartNeedsRewrite(cart)) {
          resolve();
          return;
        }
        obj.syncZeroBagEmbroideryCheckoutProperties(cart, function () {
          resolve();
        });
      }).fail(function () {
        resolve();
      });
    });
  };

  obj.zeroBagEmbroideryCartNeedsRewrite = function (cart) {
    var items = (cart && cart.items) || [];
    var i;
    var keys;
    var k;
    for (i = 0; i < items.length; i++) {
      keys = Object.keys(items[i].properties || {});
      for (k = 0; k < keys.length; k++) {
        if (!obj.isZeroBagEmbroideryTextKey(keys[k])) continue;
        if (obj.zeroBagEmbroideryCheckoutPropertyKey(keys[k]) !== keys[k]) return true;
      }
    }
    return false;
  };

  obj.syncZeroBagEmbroideryCheckoutProperties = function (cart, done) {
    if (obj._zeroBagStrikeSyncing) {
      if (typeof done === 'function') done(false, cart);
      return;
    }

    var updates = [];
    ((cart && cart.items) || []).forEach(function (item) {
      var props = item.properties;
      if (!props) return;
      var nextProps = {};
      var changed = false;
      Object.keys(props).forEach(function (key) {
        var nextKey = obj.zeroBagEmbroideryCheckoutPropertyKey(key);
        if (nextKey !== key) changed = true;
        nextProps[nextKey] = props[key];
      });
      if (changed) {
        updates.push({
          id: item.key,
          quantity: item.quantity,
          properties: nextProps
        });
      }
    });

    if (!updates.length) {
      if (typeof done === 'function') done(false, cart);
      return;
    }

    obj._zeroBagStrikeSyncing = true;

    var runZeroBag = function () {
      var chain = Promise.resolve();
      updates.forEach(function (payload) {
        chain = chain.then(function () {
          return fetch('/cart/change.js?zeroBagStrike=1', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(payload)
          }).then(function (response) {
            if (!response.ok) throw new Error('zero bag embroidery rewrite failed');
            return response.json();
          });
        });
      });
      return chain.finally(function () {
        obj._zeroBagStrikeSyncing = false;
      }).then(function () {
        if (typeof done === 'function') done(true);
      }).catch(function () {
        if (typeof done === 'function') done(false, cart);
      });
    };

    if (window.__leOliveCartGiftLock && window.__leOliveCartGiftLock.run) {
      window.__leOliveCartGiftLock.run(runZeroBag);
    } else {
      runZeroBag();
    }
  };

  /* BOLD app */
  obj.boldFormFields = [
    {
      name: {
        regEx: /^Embroidery on the chest (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 9.95
        },
        {
          currency: 'GBP',
          price: 9.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on the back (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 19.95
        },
        {
          currency: 'GBP',
          price: 19.95
        }
      ]
    },
        {
      name: {
        regEx: /^Embroidery on the sleeve (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 9.95
        },
        {
          currency: 'GBP',
          price: 9.95
        }
      ]
    },
        {
      name: {
        regEx: /^Embroidery on the belt (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 4.95
        },
        {
          currency: 'GBP',
          price: 4.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on bathcapes (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 9.95
        },
        {
          currency: 'GBP',
          price: 9.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on bath textiles (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 4.95
        },
        {
          currency: 'GBP',
          price: 4.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on the bath textiles (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 9.95
        },
        {
          currency: 'GBP',
          price: 9.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on sheets (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 9.95
        },
        {
          currency: 'GBP',
          price: 9.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on cuddle and pacifier cloths (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 4.95
        },
        {
          currency: 'GBP',
          price: 4.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on hydrophilic cloths (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 4.95
        },
        {
          currency: 'GBP',
          price: 4.95
        }
      ]
    },
    {
      name: {
        regEx: /^Add a sleep mask\? (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 14.95
        },
        {
          currency: 'GBP',
          price: 14.95
        }
      ]
    },
    {
      name: {
        regEx: /^Add a scrunchie\? (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 8.95
        },
        {
          currency: 'GBP',
          price: 8.95
        }
      ]
    },
    {
      name: {
        regEx: /^Add matching scrunchie\? (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 8.95
        },
        {
          currency: 'GBP',
          price: 8.95
        }
      ]
    },
    {
      name: {
        regEx: /^Personalise initials (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 4.95
        },
        {
          currency: 'GBP',
          price: 4.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on the slipper (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 4.95
        },
        {
          currency: 'GBP',
          price: 4.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on the towel (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 13.95
        },
        {
          currency: 'GBP',
          price: 13.95
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on teddy \(\+/
      },
      prices: [
        {
          currency: 'USD',
          price: 0
        },
        {
          currency: 'GBP',
          price: 0
        }
      ]
    },
    {
      name: {
        regEx: /^Embroidery on the stocking (\-|\()/
      },
      prices: [
        {
          currency: 'USD',
          price: 4.95
        },
        {
          currency: 'GBP',
          price: 4.95
        }
      ]
    },
    {
      name: {
        regEx: /^Add a wish card$/
      },
      updateLabelPrice: false,
      prices: [
        {
          currency: 'USD',
          price: 3.50
        },
        {
          currency: 'GBP',
          price: 3.50
        }
      ],
      options: [
        {
          name: {
            regEx: /^Mother\'s Day Card \[\+[^0-9]{1}([0-9\,\.]+)\]$/
          },
          prices: [
            {
              currency: 'USD',
              price: 3.50
            },
            {
              currency: 'GBP',
              price: 3.50
            }
          ]
        }
      ]
    }
  ];
  /* /BOLD app */

   const stockTranslations = {
  "Low in stock": {
    "nl": "Weinig op voorraad",
    "fr": "Peu en stock",
    "de": "Wenig auf Lager",
    "es": "Pocas existencias",
    "en": "Low in stock"
  },
  "Low in Stock": {
    "nl": "Weinig op voorraad",
    "fr": "Peu en stock",
    "de": "Wenig auf Lager",
    "es": "Pocas existencias",
    "en": "Low in stock"
  },
  "Almost Sold Out": {
    "nl": "Bijna uitverkocht",
    "fr": "Presque épuisé",
    "de": "Fast ausverkauft",
    "es": "Casi agotado",
    "en": "Almost Sold Out"
  },
  "PRE-ORDER SHIPPING END OF APRIL": {
    "nl": "S/M PRE-ORDER VERZENDING EIND APRIL",
    "fr": "S/M PRÉCOMMANDE EXPÉDITION FIN AVRIL",
    "de": "S/M VORBESTELLUNG VERSAND ENDE APRIL",
    "es": "S/M PREVENTA ENVÍO A FINALES DE ABRIL",
    "en": "S/M PRE-ORDER SHIPPING END OF APRIL"
  }
};

function getCurrentLang() {
  var lang = window.langify_lang || document.documentElement.lang || 'en';
  return String(lang).split('-')[0].toLowerCase();
}



  window.leOliveSyncBoldOptionProperties = function (root) {
    root = root || document.querySelector('.product-form') || document;
    if (!root || !root.querySelectorAll) return;
    var form = (root.tagName === 'FORM' ? root : (root.querySelector && root.querySelector('form')) || (root.closest && root.closest('form'))) || document.querySelector('.product-form') || root;
    if (!form || !form.querySelectorAll) return;

    function publicName(el) {
      var match = String((el && el.name) || '').match(/^properties\[(.*)\]$/);
      return match ? match[1] : '';
    }

    function isPublic(name) {
      return !!(name && name.charAt(0) !== '_');
    }

    function isPlaceholder(value, name) {
      var text = String(value == null ? '' : value).trim();
      if (!text) return true;
      if (/^(on|true|false)$/i.test(text)) return true;
      if (/^please choose/i.test(text)) return true;
      if (/^kies (een|je|uw)\b/i.test(text)) return true;
      if (/^elija\b/i.test(text) || /^choisissez\b/i.test(text) || /^wählen sie\b/i.test(text)) return true;
      if (/^choose (a |your |the )?(colour|color|font|wish card|embroidery font|leather tag|print colour|print color)\b/i.test(text)) return true;
      if (/^choose a wish card$/i.test(text) || /^choose one$/i.test(text)) return true;
      if (/^--\s*choose\b/i.test(text)) return true;
      if (/wish card/i.test(String(name || '')) && /choose/i.test(text)) return true;
      if (name && text.toLowerCase() === String(name).toLowerCase()) return true;
      return false;
    }

    function selectedLabel(valueEl) {
      if (!valueEl) return '';
      var title = valueEl.querySelector('.bold_option_value_title');
      var text = title ? title.textContent.trim() : '';
      if (text) return text;
      var img = valueEl.querySelector('img');
      if (img && (img.getAttribute('alt') || img.getAttribute('title'))) {
        return String(img.getAttribute('alt') || img.getAttribute('title')).trim();
      }
      return String(valueEl.textContent || '').replace(/\s+/g, ' ').trim();
    }

    function fieldValue(el) {
      if (!el) return '';
      var type = String(el.type || '').toLowerCase();
      if (type === 'file') return '';
      if (type === 'checkbox' || type === 'radio') {
        if (!el.checked) return '';
        var val = String(el.value || '').trim();
        if (!val || /^(on|true|false)$/i.test(val)) val = selectedLabel(el.closest('.bold_option_value'));
        return val;
      }
      if (el.tagName === 'SELECT') {
        var opt = el.options && el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null;
        var selectVal = String(el.value || '').trim();
        if (isPlaceholder(selectVal, publicName(el)) && opt) {
          selectVal = String(opt.textContent || '').trim();
        }
        return selectVal;
      }
      return String(el.value || '').trim();
    }

    function pickedSwatchTitleValue(block, name) {
      var pickedTitle = block.querySelector('.bold_option_swatch__title[data-user-picked="1"]');
      if (!pickedTitle) return '';
      var span = pickedTitle.querySelector('span');
      var picked = span ? String(span.textContent || '').trim() : '';
      if (!picked || isPlaceholder(picked, name)) return '';
      return normalizeSingleSelectValue(picked, name);
    }

    // Embroidery color is a single-select swatch. Never allow "White, Silver".
    function isEmbroideryColorName(name) {
      return /embroidery color|borduurkleur|stickfarbe|farbe der stickerei|color de bordado|couleur de (la )?broderie/i.test(String(name || ''));
    }

    function isSingleSelectSwatch(block, name) {
      if (!block || !block.classList) return false;
      if (!block.classList.contains('bold_option_swatch')) return false;
      if (block.classList.contains('bold_option_font_swatch')) return false;
      return isEmbroideryColorName(name) || !!block.querySelector('.bold_option_swatch__title');
    }

    function normalizeSingleSelectValue(value, name) {
      var text = String(value == null ? '' : value).trim();
      if (!text || text.indexOf(',') === -1) return text;
      if (!isEmbroideryColorName(name)) return text;
      var parts = text.split(/\s*,\s*/).map(function (part) {
        return String(part || '').trim();
      }).filter(Boolean);
      return parts.length ? parts[parts.length - 1] : text;
    }

    function selectedValue(block) {
      var nameHint = findPublicName(block);
      var singleSelect = isSingleSelectSwatch(block, nameHint);
      var values = [];
      var checkedInputs = block.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
      checkedInputs.forEach(function (input) {
        var val = fieldValue(input);
        if (val && values.indexOf(val) === -1) values.push(val);
      });
      if (values.length) {
        if (singleSelect) {
          // Heal leftover multi-checked Bold color checkboxes after remount.
          var keepInput = null;
          var activeValue = block.querySelector('.bold_option_value.active, .bold_option_value.visually_active, .bold_option_value.is-active');
          if (!activeValue) {
            var activeSwatch = block.querySelector('.bold_swatch_selected');
            activeValue = activeSwatch ? activeSwatch.closest('.bold_option_value') : null;
          }
          if (activeValue) keepInput = activeValue.querySelector('input[type="checkbox"], input[type="radio"]');
          if (!keepInput || !keepInput.checked) keepInput = checkedInputs[checkedInputs.length - 1];
          Array.prototype.forEach.call(checkedInputs, function (input) {
            if (input !== keepInput) input.checked = false;
          });
          var singleVal = fieldValue(keepInput);
          return normalizeSingleSelectValue(singleVal || values[values.length - 1], nameHint);
        }
        return values.join(', ');
      }

      var selected = block.querySelector('.bold_option_value.active, .bold_option_value.visually_active, .bold_option_value.is-active');
      if (!selected) {
        var swatchSelected = block.querySelector('.bold_swatch_selected');
        selected = swatchSelected ? swatchSelected.closest('.bold_option_value') : null;
      }
      if (selected) {
        var input = selected.querySelector('input[type="checkbox"], input[type="radio"]');
        var val = input ? fieldValue(input) : '';
        if (!val || !input || !input.checked) val = selectedLabel(selected);
        if (val && !isPlaceholder(val, nameHint)) return normalizeSingleSelectValue(val, nameHint);
      }

      var select = block.querySelector('select[name^="properties["]');
      if (select) {
        var selectVal = fieldValue(select);
        if (selectVal && !isPlaceholder(selectVal, nameHint)) return normalizeSingleSelectValue(selectVal, nameHint);
      }

      var text = block.querySelector('input[type="text"][name^="properties["], input[type="number"][name^="properties["], textarea[name^="properties["]');
      if (text) {
        var textVal = fieldValue(text);
        if (textVal && !isPlaceholder(textVal, nameHint)) return normalizeSingleSelectValue(textVal, nameHint);
      }

      var hidden = block.querySelector('input[type="hidden"][name^="properties["]');
      if (hidden && isPublic(publicName(hidden))) {
        var hiddenVal = fieldValue(hidden);
        if (hiddenVal && !isPlaceholder(hiddenVal, nameHint)) return normalizeSingleSelectValue(hiddenVal, nameHint);
      }

      // Color swatches can keep a picked title after Bold re-renders and clears the hidden field
      // (common on kimono when second embroidery line appears). Read that title as the value.
      return pickedSwatchTitleValue(block, nameHint);
    }

    function findPublicName(block) {
      var remembered = block.getAttribute && block.getAttribute('data-lo-property-name');
      if (remembered) return remembered;
      var fields = block.querySelectorAll('[name^="properties["]');
      var i;
      var fallback = '';
      for (i = 0; i < fields.length; i++) {
        var n = publicName(fields[i]);
        if (!isPublic(n)) continue;
        if (fields[i].type === 'hidden') return n;
        if (!fallback) fallback = n;
      }
      return fallback;
    }

    function propertySelector(name) {
      return '[name="properties[' + String(name).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + ']"]';
    }

    function ensureProperty(name, value) {
      if (!isPublic(name) || isPlaceholder(value, name)) return null;
      value = normalizeSingleSelectValue(String(value).trim(), name);
      if (!value || isPlaceholder(value, name)) return null;
      var hidden = null;
      var liveTextarea = null;
      var named = [];
      try {
        named = Array.prototype.slice.call(form.querySelectorAll(propertySelector(name)));
      } catch (err) {}
      named.forEach(function (el) {
        if (!liveTextarea && String(el.tagName || '').toUpperCase() === 'TEXTAREA' && !el.disabled) {
          liveTextarea = el;
        }
        if (el.type === 'hidden' && !hidden) hidden = el;
      });
      // Wish-card personal message (and any other option textarea): keep the live
      // field as the single submit source. A hidden twin with the same name made
      // FormData send the value twice and Shopify stored the message doubled.
      if (liveTextarea) {
        liveTextarea.value = value;
        named.forEach(function (el) {
          if (el === liveTextarea) return;
          if (String(el.type || '').toLowerCase() !== 'hidden') return;
          el.disabled = true;
          el.setAttribute('disabled', 'disabled');
        });
        var liveOwner = liveTextarea.closest ? liveTextarea.closest('.bold_option') : null;
        if (liveOwner) liveOwner.setAttribute('data-lo-property-name', name);
        return liveTextarea;
      }
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[' + name + ']';
        named.push(hidden);
      }
      hidden.disabled = false;
      hidden.removeAttribute('disabled');
      hidden.value = value;
      // Moving Bold's own input to the form root leaves its option block without
      // a named field; remember the name so later picks in that block still sync.
      var ownerBlock = hidden.closest ? hidden.closest('.bold_option') : null;
      if (ownerBlock) ownerBlock.setAttribute('data-lo-property-name', name);
      form.appendChild(hidden);
      named.forEach(function (el) {
        if (el === hidden) return;
        if (el.type !== 'hidden') return;
        // Embroidery color must never keep a second live hidden with an older color
        // (remount/stash left "White" while the new pick wrote "Silver").
        if (isEmbroideryColorName(name) || isPlaceholder(el.value, name)) {
          el.value = isEmbroideryColorName(name) ? value : el.value;
          el.disabled = true;
          el.setAttribute('disabled', 'disabled');
        }
      });
      if (isEmbroideryColorName(name)) {
        window.__loLastEmbroideryColors = window.__loLastEmbroideryColors || {};
        window.__loLastEmbroideryColors[name] = value;
      }
      return hidden;
    }

    // A text field that was filled and then cleared must not keep submitting
    // its old value through a hidden copy (or the SC JSON): Shopify uses the
    // last input with a given name, and the charge sync only reads the text field.
    var emptiedTextNames = {};
    var filledTextNames = {};
    form.querySelectorAll('input[type="text"][name^="properties["], textarea[name^="properties["]').forEach(function (field) {
      var name = publicName(field);
      if (!isPublic(name)) return;
      if (String(field.value || '').trim()) filledTextNames[name] = true;
      else emptiedTextNames[name] = true;
    });
    Object.keys(emptiedTextNames).forEach(function (name) {
      if (filledTextNames[name]) {
        delete emptiedTextNames[name];
        return;
      }
      var copies = [];
      try {
        copies = form.querySelectorAll('input[type="hidden"]' + propertySelector(name));
      } catch (err) {}
      Array.prototype.forEach.call(copies, function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    });

    form.querySelectorAll('.bold_option, .bold_option_swatch, .bold_option_dropdown, .bold_option_textbox, .bold_option_textarea, .bold_option_radio, .bold_option_checkbox').forEach(function (block) {
      var name = findPublicName(block);
      var val = selectedValue(block);
      if (!name || !val || isPlaceholder(val, name)) return;
      ensureProperty(name, val);
    });

    // Narrow hardening: embroidery color must land on the line item even when Bold
    // cleared the hidden input after conditional option re-render
    // (kimono / badjas 2nd line, pyjama bottom embroidery, etc.).
    form.querySelectorAll('.bold_option_swatch').forEach(function (swatch) {
      var name = findPublicName(swatch);
      if (!name || !/embroidery color|borduurkleur|stickfarbe|farbe der stickerei|color de bordado|couleur de (la )?broderie/i.test(name)) return;
      if (swatch.classList.contains('bold_option_font_swatch')) return;
      var val = selectedValue(swatch);
      if (!val || isPlaceholder(val, name)) {
        val = pickedSwatchTitleValue(swatch, name);
      }
      if ((!val || isPlaceholder(val, name)) && window.__loLastEmbroideryColors && window.__loLastEmbroideryColors[name]) {
        val = normalizeSingleSelectValue(window.__loLastEmbroideryColors[name], name);
      }
      if ((!val || isPlaceholder(val, name)) && window.__loLastEmbroideryColors) {
        Object.keys(window.__loLastEmbroideryColors).some(function (stashName) {
          if (!isEmbroideryColorName(stashName)) return false;
          var stashVal = normalizeSingleSelectValue(window.__loLastEmbroideryColors[stashName], stashName);
          if (!stashVal || isPlaceholder(stashVal, stashName)) return false;
          val = stashVal;
          return true;
        });
      }
      if (!val || isPlaceholder(val, name)) return;
      ensureProperty(name, normalizeSingleSelectValue(val, name));
    });

    if (window.__loLastEmbroideryColors) {
      var embroideryTextFilled = false;
      var hasColorSwatch = false;
      form.querySelectorAll('input[type="text"][name^="properties["], textarea[name^="properties["]').forEach(function (el) {
        var n = publicName(el);
        if (!n || !/embroidery|borduur|stickerei|bordado|broderie/i.test(n)) return;
        if (/color|font|charge|wish|gift|scrunchie/i.test(n)) return;
        if (String(el.value || '').trim()) embroideryTextFilled = true;
      });
      form.querySelectorAll('.bold_option_swatch [name^="properties["]').forEach(function (el) {
        var n = publicName(el);
        if (n && isEmbroideryColorName(n)) {
          hasColorSwatch = true;
        }
      });
      if (embroideryTextFilled || hasColorSwatch) {
        Object.keys(window.__loLastEmbroideryColors).forEach(function (name) {
          var val = normalizeSingleSelectValue(window.__loLastEmbroideryColors[name], name);
          if (!val || isPlaceholder(val, name)) return;
          var existing = '';
          try {
            var field = form.querySelector(propertySelector(name));
            existing = field ? String(field.value || '').trim() : '';
          } catch (err) {}
          if (existing && !isPlaceholder(existing, name)) return;
          ensureProperty(name, val);
        });
      }
    }

    [
      'Make-up bag Embroidery font',
      'Embroidery font',
      'Apron Embroidery font',
      'Gloves Embroidery font',
      'Hat Embroidery font'
    ].forEach(function (name) {
      var field = null;
      try {
        field = form.querySelector(propertySelector(name));
      } catch (err) {}
      if (!field || isPlaceholder(field.value, name)) return;
      field.disabled = false;
      field.removeAttribute('disabled');
      ensureProperty(name, field.value);
    });

    var collected = {};
    var collectedOrder = [];

    function collect(name, value) {
      if (!isPublic(name) || isPlaceholder(value, name)) return;
      value = normalizeSingleSelectValue(String(value).trim(), name);
      if (!value || isPlaceholder(value, name)) return;
      if (Object.prototype.hasOwnProperty.call(collected, name)) {
        // Embroidery color is single-select: never comma-join leftover duplicates.
        if (isEmbroideryColorName(name)) {
          return;
        }
        var parts = collected[name].split(/\s*,\s*/);
        if (parts.indexOf(value) === -1) collected[name] += ', ' + value;
      } else {
        collectedOrder.push(name);
        collected[name] = value;
      }
      ensureProperty(name, collected[name]);
    }

    // Final collapse before collect: one live embroidery color only.
    form.querySelectorAll('.bold_option_swatch').forEach(function (swatch) {
      var name = findPublicName(swatch);
      if (!name || !isEmbroideryColorName(name) || swatch.classList.contains('bold_option_font_swatch')) return;
      var val = selectedValue(swatch);
      if (!val || isPlaceholder(val, name)) val = pickedSwatchTitleValue(swatch, name);
      if ((!val || isPlaceholder(val, name)) && window.__loLastEmbroideryColors && window.__loLastEmbroideryColors[name]) {
        val = normalizeSingleSelectValue(window.__loLastEmbroideryColors[name], name);
      }
      if (!val || isPlaceholder(val, name)) return;
      ensureProperty(name, val);
    });

    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var name = publicName(el);
      if (!isPublic(name) || el.type === 'file') return;
      if (el.disabled && !/embroidery font/i.test(name)) return;
      var type = String(el.type || '').toLowerCase();
      if (type === 'checkbox' || type === 'radio') {
        if (el.checked) collect(name, fieldValue(el));
        return;
      }
      if (el.tagName === 'SELECT' || el.tagName === 'TEXTAREA' || el.tagName === 'INPUT') {
        collect(name, fieldValue(el));
      }
    });

    var sc = form.querySelector('input[name="properties[_scAllPropertyValues]"]');
    if (!sc) return;

    var map = {};
    var order = [];
    try {
      var existing = JSON.parse(sc.value || '[]');
      if (Array.isArray(existing)) {
        existing.forEach(function (item) {
          if (!item || !isPublic(item.name) || isPlaceholder(item.value, item.name)) return;
          if (emptiedTextNames[item.name]) return;
          map[item.name] = item.value;
          order.push(item.name);
        });
      }
    } catch (err) {}

    collectedOrder.forEach(function (name) {
      if (!Object.prototype.hasOwnProperty.call(map, name)) order.push(name);
      map[name] = collected[name];
    });

    sc.value = JSON.stringify(order.map(function (name) {
      return { name: name, value: map[name] };
    }).filter(function (item) {
      return item && !isPlaceholder(item.value, item.name);
    }));
  };

  window.leOliveDisablePlaceholderOptionFields = function (form) {
    if (!form || !form.querySelectorAll) return function () {};
    var disabled = [];
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var match = String(el.name || '').match(/^properties\[(.*)\]$/);
      var name = match ? match[1] : '';
      if (!name || name.charAt(0) === '_') return;
      var val = String(el.value || '').trim();
      var isWishPlaceholder = /wish card/i.test(name) && /choose/i.test(val);
      var isChoosePlaceholder = /^--\s*choose\b/i.test(val) || /^choose a wish card$/i.test(val);
      if (!isWishPlaceholder && !isChoosePlaceholder) return;
      if (!el.disabled) {
        el.disabled = true;
        disabled.push(el);
      }
    });
    return function () {
      disabled.forEach(function (el) {
        el.disabled = false;
        el.removeAttribute('disabled');
      });
    };
  };

  function loPublicPropertyName(el) {
    var match = String((el && el.name) || '').match(/^properties\[(.*)\]$/);
    return match ? match[1] : '';
  }

  function loSplitCsv(val) {
    return String(val || '')
      .split(',')
      .map(function (part) { return part.trim(); })
      .filter(Boolean);
  }

  function loSlugHandle(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function loIsCheckedChargeValue(val) {
    var text = String(val == null ? '' : val).trim();
    return text === '✓' || text === '✔' || /^checked$/i.test(text) || /^yes$/i.test(text);
  }

  function loIsEmbroideryTextKey(name) {
    if (!name || name.charAt(0) === '_') return false;
    if (/^Back Embroidery\s*-\s*second line/i.test(name)) return true;
    if (!/embroidery|personalise initials|printing on /i.test(name)) return false;
    if (/color|font|wish|gift|scrunchie|message|charge/i.test(name)) return false;
    return true;
  }

  function loNormalizeChargeKey(name) {
    return String(name || '')
      .replace(/\u0336/g, '')
      .replace(/\s*\([^)]*\)\s*/g, ' ')
      .replace(/\s*[—–-]\s*charge\s*$/i, ' - charge')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function loChargeNameFromTextName(name) {
    name = String(name || '').replace(/^properties\[/, '').replace(/\]$/, '');
    if (/^Back Embroidery\s*-\s*second line/i.test(name)) {
      return 'Embroidery on the back - charge';
    }
    if (!loIsEmbroideryTextKey(name) && !/\s*-\s*charge$/i.test(name)) return '';
    var base = name
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/\s*[—–-]\s*charge$/i, '')
      .trim();
    if (!base) return '';
    return base + ' - charge';
  }

  // Bold uses either "Embroidery on make-up bag - charge" or the shared
  // "Embroidery on bag - charge" depending on the option set. Try both.
  function loChargeNameCandidates(nameOrCharge) {
    var primary = loChargeNameFromTextName(nameOrCharge);
    if (!primary && /\s*-\s*charge$/i.test(String(nameOrCharge || ''))) {
      primary = loNormalizeChargeKey(nameOrCharge);
    }
    if (!primary) return [];

    var out = [];
    var seen = Object.create(null);
    function add(n) {
      n = loNormalizeChargeKey(n);
      if (!n) return;
      var key = n.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(n);
    }

    add(primary);
    if (/embroidery on (make-up bag|toiletry bag|toilettas|bag)\s*-\s*charge/i.test(primary)) {
      add('Embroidery on make-up bag - charge');
      add('Embroidery on toiletry bag - charge');
      add('Embroidery on bag - charge');
    }
    return out;
  }

  function loChargeIsFilled(filled, chargeName) {
    if (!filled) return false;
    if (filled[chargeName]) return true;
    var candidates = loChargeNameCandidates(chargeName);
    var i;
    for (i = 0; i < candidates.length; i++) {
      if (filled[candidates[i]]) return true;
    }
    return false;
  }

  function loFindChargeHelper(form, chargeName) {
    if (!form || !form.querySelector) return null;
    var candidates = loChargeNameCandidates(chargeName);
    var i;
    var helper = null;
    for (i = 0; i < candidates.length; i++) {
      helper = form.querySelector('[name="properties[' + candidates[i] + ']"]');
      if (helper) return helper;
    }
    // Fallback: match checkbox block title (priced / translated labels)
    var blocks = form.querySelectorAll('.bold_option_checkbox');
    var candidateKeys = candidates.map(function (c) { return c.toLowerCase(); });
    for (i = 0; i < blocks.length; i++) {
      var title = ((blocks[i].querySelector('.bold_option_title') || {}).textContent || '').trim();
      if (!title || !/charge/i.test(title)) continue;
      var titleKey = loNormalizeChargeKey(loChargeNameFromTextName(title) || title).toLowerCase();
      if (!titleKey) continue;
      if (candidateKeys.indexOf(titleKey) === -1) continue;
      return blocks[i].querySelector('input[type="hidden"][name*="charge"]') ||
        blocks[i].querySelector('input[type="hidden"][name^="properties["]');
    }
    return null;
  }

  function loChargeHandleFromName(chargeName) {
    var handle = loSlugHandle(chargeName);
    var aliases = {
      'embroidery-on-backpacks-charge': 'embroidery-on-bags-charge',
      'embroidery-on-the-chest-kids-charge': 'embroidery-on-the-chest-charge',
      'embroidery-on-make-up-bag-charge': 'embroidery-on-bag-charge',
      'embroidery-on-toiletry-bag-charge': 'embroidery-on-bag-charge',
      'embroidery-on-toilettas-charge': 'embroidery-on-bag-charge'
    };
    return aliases[handle] || handle;
  }

  function loIsEmbroideryChargeName(name) {
    name = String(name || '');
    return /embroidery|personalise initials|printing on /i.test(name) && /\s*-\s*charge$/i.test(name);
  }

  function loFormFilledEmbroideryCharges(form) {
    var filled = {};
    if (!form || !form.querySelectorAll) return filled;
    form.querySelectorAll('input[type="text"][name^="properties["], textarea[name^="properties["]').forEach(function (el) {
      var name = loPublicPropertyName(el);
      if (!String(el.value || '').trim()) return;
      loChargeNameCandidates(name).forEach(function (chargeName) {
        filled[chargeName] = true;
      });
    });
    return filled;
  }

  function loPropsFilledEmbroideryCharges(props) {
    var filled = {};
    props = props || {};
    Object.keys(props).forEach(function (name) {
      var val = props[name];
      if (!loIsEmbroideryTextKey(name) || !String(val == null ? '' : val).trim()) return;
      loChargeNameCandidates(name).forEach(function (chargeName) {
        filled[chargeName] = true;
      });
    });
    return filled;
  }

  function loSetPropertyField(form, name, value) {
    if (!form) return null;
    var el = form.querySelector('[name="properties[' + name + ']"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + name + ']';
      form.appendChild(el);
    }
    el.disabled = false;
    el.removeAttribute('disabled');
    el.value = value == null ? '' : String(value);
    return el;
  }

  function loFilterPricedOptionLists(namesCsv, idsCsv, productsCsv, pricesCsv, qtysCsv, allowedEmbroideryCharges) {
    var names = loSplitCsv(namesCsv);
    var ids = loSplitCsv(idsCsv);
    var products = loSplitCsv(productsCsv);
    var prices = loSplitCsv(pricesCsv);
    var qtys = loSplitCsv(qtysCsv);
    var keepNames = [];
    var keepIds = [];
    var keepProducts = [];
    var keepPrices = [];
    var keepQtys = [];
    var i;
    for (i = 0; i < Math.max(names.length, ids.length); i++) {
      var name = names[i] || '';
      var id = ids[i] || '';
      if (!id && !name) continue;
      if (loIsEmbroideryChargeName(name) && !(allowedEmbroideryCharges && allowedEmbroideryCharges[name])) {
        continue;
      }
      if (name) keepNames.push(name);
      if (id) keepIds.push(id);
      if (products[i]) keepProducts.push(products[i]);
      if (prices[i]) keepPrices.push(prices[i]);
      if (qtys[i]) keepQtys.push(qtys[i]);
    }
    return {
      names: keepNames.join(','),
      ids: keepIds.join(','),
      products: keepProducts.join(','),
      prices: keepPrices.join(','),
      qtys: keepQtys.join(',')
    };
  }

  window.leOliveFindEmbroideryChargeCheckbox = function (input) {
    if (!input) return null;
    var $input = window.jQuery ? window.jQuery(input) : null;
    var form = (input.closest && input.closest('form')) || document.querySelector('.product-form') || document;
    var chargeName = loChargeNameFromTextName(input.name || ($input && $input.attr('name')) || '');
    if (chargeName) {
      var helper = loFindChargeHelper(form, chargeName);
      var cb = loFindCheckboxForChargeHelper(helper);
      if (cb) return cb;
      var handle = loChargeHandleFromName(chargeName);
      cb = form.querySelector(
        '.bold_option_checkbox input[type="checkbox"][data-product-handle="' + handle + '"]'
      ) || document.querySelector(
        '.bold_option_checkbox input[type="checkbox"][data-product-handle="' + handle + '"]'
      );
      if (cb) return cb;
    }
    if ($input && $input.length) {
      var prev = $input.closest('.bold_option').prev('.bold_option_checkbox').find('input[type="checkbox"]');
      if (prev.length) return prev[0];
    }
    return null;
  };

  function loFindCheckboxForChargeHelper(helper) {
    if (!helper) return null;
    if (helper.previousElementSibling && helper.previousElementSibling.type === 'checkbox') {
      return helper.previousElementSibling;
    }
    var block = helper.closest && helper.closest('.bold_option_checkbox');
    if (block) {
      var cb = block.querySelector('input[type="checkbox"]');
      if (cb) return cb;
    }
    // Helper may have been moved out of the checkbox block — match by class
    // (cb_123_helper → cb_123).
    var helperClass = String(helper.className || '')
      .split(/\s+/)
      .filter(Boolean)
      .find(function (cls) { return /_helper$/.test(cls); });
    if (helperClass) {
      var cbClass = helperClass.replace(/_helper$/, '');
      try {
        var match = document.querySelector('input[type="checkbox"].' + cbClass);
        if (match) return match;
      } catch (err) {}
    }
    var chargeName = loPublicPropertyName(helper);
    if (chargeName) {
      var handle = loChargeHandleFromName(chargeName);
      var byHandle = document.querySelector(
        '.bold_option_checkbox input[type="checkbox"][data-product-handle="' + handle + '"]'
      );
      if (byHandle) return byHandle;
    }
    return null;
  }

  function loEnsureChargeHelperInBlock(helper, checkbox) {
    if (!helper || !checkbox) return;
    var block = checkbox.closest('.bold_option_checkbox');
    if (!block) return;
    var mount = block.querySelector('.bold_option_element') || block;
    if (helper.parentElement !== mount) {
      mount.appendChild(helper);
    }
  }

  function loParseEuroToCents(text) {
    var raw = String(text || '').replace(/[^\d.,]/g, '').trim();
    if (!raw) return 0;
    if (raw.indexOf(',') !== -1) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    }
    return Math.round(parseFloat(raw) * 100) || 0;
  }

  function loFormatEuroFromCents(cents) {
    return '€' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
  }

  function loAttrPriceToCents(el) {
    if (!el || !el.getAttribute) return 0;
    var raw = el.getAttribute('data-price-value') || el.getAttribute('data-price') || '';
    if (!raw) return 0;
    // Shop Circle often stores integer cents ("995") or decimal euros ("9.95").
    if (/^\d+$/.test(String(raw).trim()) && Number(raw) >= 100) {
      return parseInt(raw, 10) || 0;
    }
    return loParseEuroToCents(raw);
  }

  function loScheduleProductOptionPriceRefresh(form) {
    if (typeof window.leOliveRefreshProductOptionPrice !== 'function') return;
    window.leOliveRefreshProductOptionPrice(form);
    // Bold/Shop Circle paints .bold_option_price_display asynchronously —
    // re-assert our base+extras total so Yes/No and text clear stay correct.
    clearTimeout(window.__loOptionPriceT1);
    clearTimeout(window.__loOptionPriceT2);
    window.__loOptionPriceT1 = setTimeout(function () {
      window.leOliveRefreshProductOptionPrice(form);
    }, 60);
    window.__loOptionPriceT2 = setTimeout(function () {
      window.leOliveRefreshProductOptionPrice(form);
    }, 280);
  }

  window.leOliveRefreshProductOptionPrice = function (form) {
    form = form || document.querySelector('.product-form') || document;
    var priceEl = document.getElementById('ProductPrice');
    if (!priceEl) return;

    // Always start from the real variant base — never from #ProductPrice
    // (that node is already mutated by Bold / previous refreshes).
    // Prefer the active size/amount option first (gift cards, multi-price
    // variants). data-original-price is only the page-load variant and goes
    // stale when the customer picks another option.
    var baseCents = 0;
    var pricesWrap = document.querySelector('.product-single__prices');
    var activeOpt = document.querySelector('.product-form__option.active');
    if (activeOpt && activeOpt.getAttribute('data-option-price-value')) {
      baseCents = Math.round(parseFloat(activeOpt.getAttribute('data-option-price-value')) * 100) || 0;
    }
    if (!baseCents) {
      var original = pricesWrap && pricesWrap.getAttribute('data-original-price');
      if (original) baseCents = loParseEuroToCents(original);
    }
    if (!baseCents) {
      var moneyScript = document.querySelector('[data-product-price], .product-single__price[data-product-price]');
      if (moneyScript) baseCents = loParseEuroToCents(moneyScript.getAttribute('data-product-price') || moneyScript.textContent);
    }
    if (pricesWrap && baseCents) {
      pricesWrap.setAttribute(
        'data-original-price',
        (baseCents / 100).toFixed(2).replace('.', ',')
      );
    }

    var extraCents = 0;
    var root = form.querySelector ? form : document;
    var embroideryChargeCounted = false;

    function addCents(cents) {
      cents = Number(cents) || 0;
      if (cents > 0) extraCents += cents;
    }

    function priceFromText(text) {
      return loParseEuroToCents(text);
    }

    function isAffirmativeValue(text) {
      return /^(yes|ja|oui|sí|si)$/i.test(String(text || '').trim());
    }

    function isNegativeValue(text) {
      return /^(no|nee|non|nein)$/i.test(String(text || '').trim());
    }

    // Paid embroidery / printing charge checkboxes (usually visually hidden)
    root.querySelectorAll('.bold_option_checkbox').forEach(function (block) {
      var titleEl = block.querySelector('.bold_option_title');
      var title = ((titleEl && titleEl.textContent) || '').trim();
      var cb = block.querySelector('input[type="checkbox"]');
      var nameBlob = title + ' ' + ((cb && cb.name) || '') + ' ' + ((cb && cb.getAttribute('data-product-handle')) || '');
      var isCharge =
        loIsEmbroideryChargeName(title) ||
        loIsEmbroideryChargeName(cb && cb.name) ||
        (/embroidery|personalise initials|printing on |borduur|stickerei|bordado|broderie/i.test(nameBlob) &&
          /charge|toeslag|aufpreis|suplemento|suppl[eé]ment/i.test(nameBlob));
      if (!isCharge) return;
      if (!cb || !cb.checked) return;
      var priceNode = block.querySelector('.bold_option_value_price');
      var cents = priceNode ? priceFromText(priceNode.textContent) : 0;
      if (!cents) cents = loAttrPriceToCents(titleEl) || loAttrPriceToCents(cb);
      if (!cents) cents = priceFromText(title) || priceFromText(cb && cb.name);
      addCents(cents);
      embroideryChargeCounted = true;
    });

    // If embroidery text is filled but the charge checkbox is missing/unchecked,
    // take the priced textbox title once (e.g. "… (+€9,95)").
    if (!embroideryChargeCounted) {
      root.querySelectorAll('.bold_option_textbox, .bold_option_textarea').forEach(function (block) {
        var input = block.querySelector('input[type="text"], textarea');
        if (!input || !String(input.value || '').trim()) return;
        var name = String(input.name || '');
        var titleEl = block.querySelector('.bold_option_title');
        var title = ((titleEl && titleEl.textContent) || '').trim();
        if (!/embroidery|borduur|stickerei|bordado|broderie|personalise initials|printing on /i.test(name + ' ' + title)) {
          return;
        }
        if (/color|font|charge/i.test(name)) return;
        var priceNode = block.querySelector('.bold_option_value_price');
        var cents = priceNode ? priceFromText(priceNode.textContent) : 0;
        if (!cents) cents = loAttrPriceToCents(titleEl) || loAttrPriceToCents(input);
        if (!cents) cents = priceFromText(title) || priceFromText(name);
        addCents(cents);
      });
    }

    // Gift wrap / other radios — only the selected value; CSS hides .bold_option_value_price
    root.querySelectorAll('.bold_option_radio').forEach(function (block) {
      var checked = block.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var valueWrap = checked.closest('.bold_option_value');
      var valueTitle = (
        (valueWrap && valueWrap.querySelector('.bold_option_value_title')) ||
        {}
      ).textContent || checked.value || '';
      valueTitle = String(valueTitle).trim();
      if (isNegativeValue(valueTitle) || isNegativeValue(checked.value)) return;

      var titleEl = block.querySelector('.bold_option_title');
      var optTitle = ((titleEl && titleEl.textContent) || '').trim();
      var nameBlob = optTitle + ' ' + String(checked.name || '');

      var priceNode = valueWrap && valueWrap.querySelector('.bold_option_value_price');
      var cents = priceNode ? priceFromText(priceNode.textContent) : 0;
      if (!cents) cents = loAttrPriceToCents(checked) || loAttrPriceToCents(valueWrap) || loAttrPriceToCents(titleEl);
      if (!cents) cents = priceFromText(valueTitle);
      if (!cents) cents = priceFromText(String(checked.name || ''));
      if (!cents && isAffirmativeValue(valueTitle)) {
        cents = priceFromText(optTitle) || loAttrPriceToCents(titleEl);
      }
      // Gift-wrap: title may be translated without (€9,95) — price still in input name
      // or on the hidden Yes value price node elsewhere in the block.
      if (!cents && /gift-wrap|geschenk|cadeau|regalo|gift ?box/i.test(nameBlob) && isAffirmativeValue(valueTitle)) {
        block.querySelectorAll('.bold_option_value_price').forEach(function (node) {
          var c = priceFromText(node.textContent);
          if (c > cents) cents = c;
        });
        if (!cents) cents = priceFromText(String(checked.name || ''));
      }
      addCents(cents);
    });

    // Dropdowns (wish cards, etc.)
    root.querySelectorAll('.bold_option_dropdown select').forEach(function (select) {
      if (!select || select.selectedIndex < 0) return;
      var opt = select.options[select.selectedIndex];
      if (!opt || !opt.value) return;
      var label = String(opt.text || opt.value || '').trim();
      if (!label || /^--|choose|kies|wähle|elige|choisis/i.test(label)) return;
      var cents = priceFromText(label) || loAttrPriceToCents(opt) || loAttrPriceToCents(select);
      addCents(cents);
    });

    var totalCents = baseCents + extraCents;
    var formatted = loFormatEuroFromCents(totalCents);
    priceEl.textContent = formatted;
    // Keep content as the live total so schema stays in sync, but never use it as base.
    priceEl.setAttribute('content', (totalCents / 100).toFixed(2));

    var floating = document.querySelector('.product-single__floating-bar__price');
    if (floating) floating.textContent = formatted;

    // Sale products show both prices — bump the struck-through compare by the same extras.
    var compareEl = document.getElementById('ComparePrice');
    if (compareEl) {
      var compareBaseCents = 0;
      var storedCompare = compareEl.getAttribute('data-original-compare');
      if (storedCompare) {
        compareBaseCents = loParseEuroToCents(storedCompare);
      } else {
        compareBaseCents =
          loParseEuroToCents(compareEl.getAttribute('content')) ||
          loParseEuroToCents(compareEl.textContent);
        if (compareBaseCents) {
          compareEl.setAttribute(
            'data-original-compare',
            (compareBaseCents / 100).toFixed(2).replace('.', ',')
          );
        }
      }
      if (compareBaseCents > 0) {
        var compareTotalCents = compareBaseCents + extraCents;
        window.__loComparePriceWriting = true;
        compareEl.textContent = loFormatEuroFromCents(compareTotalCents);
        window.__loComparePriceWriting = false;
      }
    }
  };

  // Keep Subtotaal in sync for gift wrap / dropdowns / charges — not only embroidery text.
  if (!window.__loOptionPriceListenersBound) {
    window.__loOptionPriceListenersBound = true;
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (
          !t.closest(
            '.bold_option_radio, .bold_option_dropdown, .bold_option_checkbox, .bold_option_textbox, .bold_option_swatch'
          )
        ) {
          return;
        }
        var form =
          (t.closest && t.closest('form')) ||
          document.querySelector('.product-form') ||
          document.querySelector('.bold_lightbox form');
        setTimeout(function () {
          if (
            typeof window.leOliveSyncEmbroideryChargeCheckboxes === 'function' &&
            t.matches &&
            (t.matches('input[type="text"]') || t.matches('textarea'))
          ) {
            window.leOliveSyncEmbroideryChargeCheckboxes(form);
          }
          loScheduleProductOptionPriceRefresh(form);
        }, 20);
      },
      true
    );
    document.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        if (!t.matches('.bold_option_textbox input[type="text"], .bold_option_textarea textarea')) return;
        var form =
          (t.closest && t.closest('form')) ||
          document.querySelector('.product-form') ||
          document.querySelector('.bold_lightbox form');
        setTimeout(function () {
          if (typeof window.leOliveSyncEmbroideryChargeCheckboxes === 'function') {
            window.leOliveSyncEmbroideryChargeCheckboxes(form);
          }
          loScheduleProductOptionPriceRefresh(form);
        }, 20);
      },
      true
    );
  }

  window.leOliveSyncEmbroideryChargeCheckboxes = function (form) {
    form = form || document.querySelector('.product-form');
    if (!form || !form.querySelectorAll) return;
    var filledByCharge = loFormFilledEmbroideryCharges(form);
    var toggled = false;

    function setChargeChecked(cb, helper, shouldCheck) {
      if (!cb) return;
      if (helper) loEnsureChargeHelperInBlock(helper, cb);
      if (shouldCheck === !!cb.checked) {
        if (helper) helper.value = shouldCheck ? '✓' : '';
        return;
      }
      // Bold/Shop Circle only process the click while enabled.
      if (window.jQuery) {
        var $cb = window.jQuery(cb);
        $cb.addClass('enabled');
        $cb.trigger('click');
        if (!shouldCheck) $cb.removeClass('enabled');
      } else {
        cb.classList.add('enabled');
        cb.checked = shouldCheck;
        cb.dispatchEvent(new Event('click', { bubbles: true }));
        cb.dispatchEvent(new Event('change', { bubbles: true }));
        if (!shouldCheck) cb.classList.remove('enabled');
      }
      if (helper) helper.value = shouldCheck ? '✓' : '';
      toggled = true;
    }

    // Prefer helpers still inside checkbox blocks.
    form.querySelectorAll('.bold_option_checkbox input[type="hidden"][name*="charge]"]').forEach(function (helper) {
      var chargeName = loNormalizeChargeKey(loPublicPropertyName(helper));
      if (!loIsEmbroideryChargeName(chargeName) && !(/embroidery|personalise initials|printing on /i.test(chargeName) && /charge/i.test(chargeName))) {
        return;
      }
      var cb = loFindCheckboxForChargeHelper(helper);
      setChargeChecked(cb, helper, loChargeIsFilled(filledByCharge, chargeName));
    });

    // Also sync orphaned helpers (moved to form root) + any filled charges
    // whose helper was never found in the loop above.
    Object.keys(filledByCharge).forEach(function (chargeName) {
      var helper = loFindChargeHelper(form, chargeName);
      var cb = loFindCheckboxForChargeHelper(helper);
      if (!cb) {
        var handle = loChargeHandleFromName(chargeName);
        cb = form.querySelector(
          '.bold_option_checkbox input[type="checkbox"][data-product-handle="' + handle + '"]'
        ) || document.querySelector(
          '.bold_option_checkbox input[type="checkbox"][data-product-handle="' + handle + '"]'
        );
      }
      setChargeChecked(cb, helper, true);
    });

    // Untick embroidery charges that are no longer filled — including when
    // the helper was orphaned outside .bold_option_checkbox.
    form.querySelectorAll('.bold_option_checkbox input[type="checkbox"]').forEach(function (cb) {
      var block = cb.closest('.bold_option_checkbox');
      var title = ((block && block.querySelector('.bold_option_title')) || {}).textContent || '';
      title = String(title).trim();
      if (!loIsEmbroideryChargeName(title) && !( /embroidery|personalise initials|printing on /i.test(title) && /charge/i.test(title))) {
        return;
      }
      var chargeName = loNormalizeChargeKey(loChargeNameFromTextName(title) || title);
      if (!/\s*-\s*charge$/i.test(chargeName)) {
        chargeName = String(chargeName).replace(/\s*\([^)]*\)\s*$/, '').trim() + ' - charge';
      }
      if (loChargeIsFilled(filledByCharge, chargeName)) return;
      var helper =
        (block && block.querySelector('input[type="hidden"][name*="charge]"]')) ||
        loFindChargeHelper(form, chargeName);
      setChargeChecked(cb, helper, false);
    });

    if (typeof window.leOliveRefreshProductOptionPrice === 'function') {
      // SC price paint can lag behind the checkbox toggle.
      loScheduleProductOptionPriceRefresh(form);
    }
  };

  window.leOliveStripEmptyEmbroideryChargesFromForm = function (form) {
    form = form || document.querySelector('.product-form');
    if (!form || !form.querySelector) return {};
    var filled = loFormFilledEmbroideryCharges(form);

    form.querySelectorAll('input[name^="properties["]').forEach(function (el) {
      var name = loPublicPropertyName(el);
      if (!loIsEmbroideryChargeName(name)) return;
      if (filled[name]) {
        if (el.type === 'hidden' || el.type === 'checkbox') {
          if (el.type === 'hidden') el.value = '✓';
        }
        return;
      }
      if (el.type === 'checkbox') {
        el.checked = false;
      } else {
        el.value = '';
      }
    });

    function scrubPair(namesKey, idsKey, productsKey, pricesKey, qtysKey) {
      var get = function (key) {
        var el = form.querySelector('[name="properties[' + key + ']"]');
        return el ? String(el.value || '').trim() : '';
      };
      var filtered = loFilterPricedOptionLists(
        get(namesKey),
        get(idsKey),
        get(productsKey),
        get(pricesKey),
        get(qtysKey),
        filled
      );
      if (form.querySelector('[name="properties[' + namesKey + ']"]') || filtered.names) {
        loSetPropertyField(form, namesKey, filtered.names);
      }
      if (form.querySelector('[name="properties[' + idsKey + ']"]') || filtered.ids) {
        loSetPropertyField(form, idsKey, filtered.ids);
      }
      if (form.querySelector('[name="properties[' + productsKey + ']"]') || filtered.products) {
        loSetPropertyField(form, productsKey, filtered.products);
      }
      if (form.querySelector('[name="properties[' + pricesKey + ']"]') || filtered.prices) {
        loSetPropertyField(form, pricesKey, filtered.prices);
      }
      if (form.querySelector('[name="properties[' + qtysKey + ']"]') || filtered.qtys) {
        loSetPropertyField(form, qtysKey, filtered.qtys);
      }
      return filtered;
    }

    scrubPair('_scVariantNames', '_scVariantIds', '_scProductIds', '_scVariantPrices', '_scVariantQtys');
    scrubPair('_boldVariantNames', '_boldVariantIds', '_boldProductIds', '_boldVariantPrices', '_boldVariantQtys');
    return filled;
  };

  window.leOliveMirrorScOptionProperties = function (form) {
    form = form || document.querySelector('.product-form');
    if (!form || !form.querySelector) return;
    // Mirror ids/names/builder for linking only.
    // Do NOT mirror prices — cart already has real OPTIONS_HIDDEN_PRODUCT
    // charge lines, and copying prices into _boldVariantPrices double-counts
    // (€9.95 + €9.95) in the cart / drawer display.
    var pairs = [
      ['_scVariantIds', '_boldVariantIds'],
      ['_scVariantNames', '_boldVariantNames'],
      ['_scProductIds', '_boldProductIds'],
      ['_scVariantQtys', '_boldVariantQtys'],
      ['_scBuilderId', '_boldBuilderId']
    ];
    pairs.forEach(function (pair) {
      var sc = form.querySelector('[name="properties[' + pair[0] + ']"]');
      if (!sc) return;
      var bold = form.querySelector('[name="properties[' + pair[1] + ']"]');
      if (!bold) {
        bold = document.createElement('input');
        bold.type = 'hidden';
        bold.name = 'properties[' + pair[1] + ']';
        form.appendChild(bold);
      }
      bold.value = String(sc.value || '');
    });

    // Clear bold prices whenever SC priced options are present so cart UI
    // does not add option prices on top of real charge line items.
    var scIds = form.querySelector('[name="properties[_scVariantIds]"]');
    if (scIds && String(scIds.value || '').trim()) {
      loSetPropertyField(form, '_boldVariantPrices', '');
    }
  };

  window.leOliveDisableHiddenEmptyEmbroideryFields = function (form) {
    if (!form || !form.querySelectorAll) return function () {};
    var disabled = [];
    form.querySelectorAll('.bold_option__invisible, .bold_option.invisible').forEach(function (block) {
      block.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if (el.disabled || String(el.value || '').trim()) return;
        el.disabled = true;
        disabled.push(el);
      });
      var prev = block.previousElementSibling;
      if (prev && /\bbold_option_checkbox\b/.test(prev.className)) {
        prev.querySelectorAll('[name^="properties["], input[type="checkbox"]').forEach(function (el) {
          if (el.disabled) return;
          if (el.type === 'checkbox' && el.checked) return;
          if (el.type !== 'checkbox' && String(el.value || '').trim()) return;
          el.disabled = true;
          disabled.push(el);
        });
      }
    });
    return function () {
      disabled.forEach(function (el) {
        el.disabled = false;
        el.removeAttribute('disabled');
      });
    };
  };

  window.leOliveCollectFormOptionCharges = function (form) {
    if (!form || !form.querySelector) return [];
    var filled = loFormFilledEmbroideryCharges(form);
    var get = function (name) {
      var el = form.querySelector('[name="properties[' + name + ']"]');
      return el ? String(el.value || '').trim() : '';
    };
    var filtered = loFilterPricedOptionLists(
      get('_scVariantNames') || get('_boldVariantNames'),
      get('_scVariantIds') || get('_boldVariantIds'),
      get('_scProductIds') || get('_boldProductIds'),
      get('_scVariantPrices') || get('_boldVariantPrices'),
      get('_scVariantQtys') || get('_boldVariantQtys'),
      filled
    );
    var ids = loSplitCsv(filtered.ids);
    var names = loSplitCsv(filtered.names);
    var builder = get('_scBuilderId') || get('_boldBuilderId');
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    return ids.map(function (id, i) {
      return {
        id: Number(id),
        quantity: qty,
        name: names[i] || '',
        builderId: builder
      };
    }).filter(function (item) { return item.id; });
  };

  window.leOlivePrepareOptionForm = function (form) {
    if (!form) return { restore: function () {}, pendingCharges: [] };
    window.leOliveSyncEmbroideryChargeCheckboxes(form);
    window.leOliveStripEmptyEmbroideryChargesFromForm(form);
    window.leOliveMirrorScOptionProperties(form);
    if (typeof window.leOliveSyncBoldOptionProperties === 'function') {
      window.leOliveSyncBoldOptionProperties(form);
    }
    window.leOliveStripEmptyEmbroideryChargesFromForm(form);
    if (typeof window.leOliveRewriteZeroBagEmbroideryPropertyInputs === 'function') {
      window.leOliveRewriteZeroBagEmbroideryPropertyInputs(form);
    }
    var restoreHidden = window.leOliveDisableHiddenEmptyEmbroideryFields(form);
    var restorePlaceholders = typeof window.leOliveDisablePlaceholderOptionFields === 'function'
      ? window.leOliveDisablePlaceholderOptionFields(form)
      : function () {};
    window.__loPendingOptionCharges = [];
    return {
      restore: function () {
        restoreHidden();
        restorePlaceholders();
      },
      pendingCharges: []
    };
  };

  var loChargeVariantCache = {
    'embroidery-on-the-chest-charge': 43706897924318,
    'embroidery-on-the-back-charge': 43706897891550,
    'embroidery-on-blankets-charge': 43706891600094
  };

  function loResolveChargeVariantId(handle) {
    handle = loChargeHandleFromName(handle);
    if (loChargeVariantCache[handle]) {
      return Promise.resolve(loChargeVariantCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('missing charge product');
        return res.json();
      })
      .then(function (product) {
        var variant = (product.variants || [])[0];
        var id = variant && Number(variant.id);
        if (id) loChargeVariantCache[handle] = id;
        return id || 0;
      })
      .catch(function () { return 0; });
  }

  function loIsOptionChargeLine(item) {
    var props = (item && item.properties) || {};
    if (!item) return false;
    if (item.product_type === 'OPTIONS_HIDDEN_PRODUCT') return true;
    if (props._lo_option_charge === 'true') return true;
    if (props._bogo_free_robe_charge === 'true') return true;
    if (props._kimono_sleep_mask_charge === 'true') return true;
    if (props._boldBuilderId && !props._boldVariantIds) return true;
    if (props._scBuilderId && !props._scVariantIds && !props._boldVariantIds) return true;
    return false;
  }

  var loOptionChargeSyncPromise = null;

  window.leOliveEnsureOptionChargesInCart = function () {
    if (loOptionChargeSyncPromise) return loOptionChargeSyncPromise;
    window.__loOptionChargeSyncing = true;

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (res) {
        if (!res.ok) throw new Error('option charge change failed');
        return res.json();
      });
    }

    // Never add theme fallback charge lines (_lo_option_charge).
    // Shop Circle already inserts OPTIONS_HIDDEN_PRODUCT charges; adding again
    // double-billed customers (€9.95 twice). We only:
    // 1) remove theme-added duplicate charges
    // 2) remove orphan embroidery charges when no parent has embroidery text
    loOptionChargeSyncPromise = fetch('/cart.js?ts=' + Date.now())
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !(cart.items || []).length) return cart;

        var needed = {};
        var lookups = [];

        (cart.items || []).forEach(function (item) {
          if (loIsOptionChargeLine(item)) return;
          var props = item.properties || {};
          if (props._bogo_free_robe === 'true') return;
          var qty = Number(item.quantity) || 1;
          var filled = loPropsFilledEmbroideryCharges(props);
          var parentIds = {};
          var names = loSplitCsv(props._scVariantNames || props._boldVariantNames);
          var ids = loSplitCsv(props._scVariantIds || props._boldVariantIds);

          ids.forEach(function (id, i) {
            var name = names[i] || '';
            if (loIsEmbroideryChargeName(name) && !filled[name]) return;
            parentIds[String(id)] = true;
          });

          var filledLookups = [];
          Object.keys(filled).forEach(function (chargeName) {
            filledLookups.push(
              loResolveChargeVariantId(chargeName).then(function (id) {
                if (id) parentIds[String(id)] = true;
              })
            );
          });

          lookups.push(Promise.all(filledLookups).then(function () {
            Object.keys(parentIds).forEach(function (id) {
              needed[id] = (needed[id] || 0) + qty;
            });
          }));
        });

        return Promise.all(lookups).then(function () {
          window.__loPendingOptionCharges = [];

          var chargeEntries = [];
          (cart.items || []).forEach(function (item) {
            if (!loIsOptionChargeLine(item)) return;
            chargeEntries.push(item);
          });

          // Prefer keeping Shop Circle "Part of" charges; delete theme duplicates first.
          chargeEntries.sort(function (a, b) {
            var aTheme = (a.properties || {})._lo_option_charge === 'true' ? 0 : 1;
            var bTheme = (b.properties || {})._lo_option_charge === 'true' ? 0 : 1;
            return aTheme - bTheme;
          });

          var remainingWant = {};
          Object.keys(needed).forEach(function (id) {
            remainingWant[id] = needed[id];
          });

          var removals = Promise.resolve(cart);
          chargeEntries.forEach(function (item) {
            var key = String(item.variant_id);
            var have = Number(item.quantity) || 0;
            var props = item.properties || {};
            var title = String(item.product_title || item.title || '');
            var isEmbroideryCharge = loIsEmbroideryChargeName(title) || /embroidery/i.test(title);
            var isThemeCharge = props._lo_option_charge === 'true';

            // Always remove theme-added embroidery charges — SC owns these lines.
            if (isThemeCharge && isEmbroideryCharge) {
              removals = removals.then(function () {
                return changeLine(item.key, 0);
              });
              return;
            }

            if (!isEmbroideryCharge && !isThemeCharge) return;

            var wantLeft = remainingWant[key] || 0;
            var keep = Math.min(have, wantLeft);
            remainingWant[key] = Math.max(0, wantLeft - keep);
            if (keep >= have) return;

            removals = removals.then(function () {
              return changeLine(item.key, keep);
            });
          });

          return removals.then(function (latestCart) {
            try {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            } catch (err) {}
            return latestCart || cart;
          });
        });
      })
      .catch(function (err) {
        console.error('[Le Olive] Could not sync embroidery charges:', err);
      })
      .then(function (result) {
        window.__loOptionChargeSyncing = false;
        loOptionChargeSyncPromise = null;
        return result;
      }, function (err) {
        window.__loOptionChargeSyncing = false;
        loOptionChargeSyncPromise = null;
        throw err;
      });
    return loOptionChargeSyncPromise;
  };

  if (!window.__loOptionChargeCartBound) {
    window.__loOptionChargeCartBound = true;
    document.addEventListener('ajaxProduct:added', function () {
      // Wait for Shop Circle to insert its charge line first, then only
      // fill gaps / remove duplicates.
      setTimeout(function () {
        window.leOliveEnsureOptionChargesInCart();
      }, 900);
      setTimeout(function () {
        window.leOliveEnsureOptionChargesInCart();
      }, 1800);
    });
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () {
        window.leOliveEnsureOptionChargesInCart();
      }, 800);
    });
  }

  if (!window.__loBoldOptionSyncBound) {
    window.__loBoldOptionSyncBound = true;
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name || String(t.name).indexOf('properties[') !== 0) return;
      var form = t.closest('form') || document.querySelector('.product-form');
      window.leOliveSyncBoldOptionProperties(form);
    }, true);
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.name || String(t.name).indexOf('properties[') !== 0) return;
      if (t.tagName !== 'TEXTAREA' && t.type !== 'text' && t.type !== 'number') return;
      var form = t.closest('form') || document.querySelector('.product-form');
      window.leOliveSyncBoldOptionProperties(form);
    }, true);
  }

  window.leOliveInjectAssignedFontsFromCart = function (root) {
    root = root || document.querySelector('.bold_lightbox form') || document.querySelector('.product-form');
    if (!root || !root.querySelector) return;

    var names = [
      'Embroidery font',
      'Make-up bag Embroidery font',
      'Apron Embroidery font',
      'Gloves Embroidery font',
      'Hat Embroidery font'
    ];
    var jsonEl = document.querySelector('script.js-cart-json');
    var itemKey = window.leOliveLastCartItemKey;
    var props = {};

    if (jsonEl && itemKey) {
      try {
        var cart = JSON.parse(jsonEl.textContent || '{}');
        var items = (cart && cart.items) || [];
        var i;
        for (i = 0; i < items.length; i++) {
          if (String(items[i].key) === String(itemKey)) {
            props = items[i].properties || {};
            break;
          }
        }
      } catch (err) {}
    }

    names.forEach(function (name) {
      var selector = 'input[name="properties[' + name + ']"]';
      var existing = root.querySelector(selector) || document.querySelector('.product-form ' + selector);
      var value = (existing && existing.value) || props[name] || '';
      value = String(value || '').trim();
      if (!value) return;
      if (!root.querySelector(selector)) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.value = value;
        root.appendChild(input);
      }
    });
  };

  obj.productPage = function () {
    var productObj = function () {
    };

    /* Arrow down (mobile) */
    $(document).on('click', '.product-single__photos__arrow-down', function() {
      var btn = $(this);
      var productForm = $('.product-form');

      $('html,body').animate({
        scrollTop: productForm.offset().top - parseFloat(productForm.css('marginTop'))
      }, 500);
    });

    $(document).scroll(function() {
      var st = $(window).scrollTop();
      var btn = $('.product-single__photos__arrow-down');
      var productForm = $('.product-form');
      if (!productForm.length || !productForm.offset()) return;

      if (st + $(window).height() > productForm.offset().top) {
        btn.addClass('invisible');

      } else {
        btn.removeClass('invisible');
      }
    });
    /* /Arrow down (mobile) */

    productObj.scrollEvent = function() {
      var st = $(window).scrollTop();
      var addToCart = $('#AddToCartNew');

      if (addToCart.length && addToCart.offset() && st > addToCart.offset().top + addToCart.outerHeight()) {
        $('body').addClass('product-single__floating-bar__visible');

      } else {
        $('body').removeClass('product-single__floating-bar__visible');
      }

      return productObj;
    };

    productObj.banner = function() {
      var banner = $('.product-single__form-banner[data-banner-type="timer"]');

      if (banner.length) {
        var currentDate = new Date();
        var endDate = new Date('Sat Apr 30 2022 23:59:59 GMT+0100');

        if (currentDate.getTime() >= endDate.getTime()) {
          banner.remove();
        }
      }

      return productObj;
    };

    productObj.init = function() {
      productObj.banner();

      $(document).on('click', '.product-single__tab-title', function (e) {
        e.preventDefault();

        var $title = $(this);
        var $tab   = $title.closest('li.product-single__tab');
        var $tabs  = $tab.closest('ul.product-single__tabs');

        // 1) capture where the clicked title is BEFORE changing layout
        var beforeTop = $title.offset().top;

        // 2) toggle
        $tab.toggleClass('active')
            .siblings('li.product-single__tab.active')
            .removeClass('active');

        // 3) after layout updates, restore scroll so the title stays in place
        requestAnimationFrame(function () {
          var afterTop = $title.offset().top;
          var diff = afterTop - beforeTop;
          if (diff !== 0) window.scrollBy(0, diff);
        });

        return false;
      });

      /* Gallery */
      // $(document).on('click', '.product-single__thumbnails > .product-single__image:not(.active) .product-single__thumbnail', function() {
      //   var thumbnail = $(this);
      //   var image = thumbnail.parents('.product-single__image');
      //   image.addClass('active').siblings('.active').removeClass('active');
      // });

      // $(document).on('click', '.product-single__photo', function() {
      //   var cover = $(this);

      //   var thumbnails = $('.product-single__thumbnails');

      //   if (!thumbnails.hasClass('zoom-enabled')) {
      //     var activeThumbnail = $('.product-single__thumbnails > li.active > a');
      //     activeThumbnail.click();

      //     cover.click();
      //   }
      // });

      // $(document).on('click', '.product-single__thumbnails > li > a', function(e) {
      //   e.preventDefault();
      //   e.stopPropagation();

      //   var thumbnails = $('.product-single__thumbnails');
      //   thumbnails.addClass('zoom-enabled');

      //   var thumbnailLink = $(this);

      //   var imageI = thumbnailLink.attr('data-image-i');

      //   var images = $('#productCoverImages > .product-single__featured-image-wrapper');

      //   var image = images.filter('[data-image-i="' + imageI + '"]');
      //   var imageVideo = image.find('video');

      //   if (imageVideo.length) {
      //     imageVideo.prop('muted', true).prop('controls', false).prop('loop', true);
      //     imageVideo[0].play();

      //   } else {
      //     var videos = images.find('video');

      //     if (videos.length) {

      //       $.each(videos, function() {
      //         this.pause();
      //       });
      //     }
      //   }
      // });

      // var activeProductImage = $('.product-single__thumbnails > li:first > a');

      // if (activeProductImage.length) {
      //   activeProductImage.click();
      // }
      /* /Gallery */

      /* ✅ Swiper Gallery (desktop + mobile) + keep zoom (mobile fixed) */
(function ($) {
  "use strict";

  var swiper = null;

  function pauseAllVideos() {
    var $videos = $("#productCoverImages video");
    if ($videos.length) $videos.each(function () { this.pause(); });
  }

  function playVideoInSlide($slide) {
    var $video = $slide.find("video");
    if ($video.length) {
      $video.prop("muted", true).prop("controls", false).prop("loop", true);
      $video[0].play();
    }
  }

  function onSlideActivated($slide) {
    pauseAllVideos();
    playVideoInSlide($slide);
  }

  function buildSwiper() {
    var $cover = $("#productCoverImages");
    if (!$cover.length) return;

    $(".product-single__thumbnails").addClass("zoom-enabled");

    // destroy if already exists
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }

    // unwrap if previously wrapped
    if ($cover.hasClass("swiper")) {
      $cover.removeClass("swiper");
      $cover.find(".swiper-pagination, .swiper-button-prev, .swiper-button-next").remove();

      var $wrapper = $cover.find(".swiper-wrapper");
      if ($wrapper.length) {
        $wrapper.children().removeClass("swiper-slide");
        $wrapper.replaceWith(function () { return $(this).children(); });
      }
    }

    var $slides = $cover.children(".product-single__featured-image-wrapper");
    if (!$slides.length) return;

    $slides.removeClass("hidden");

    $cover.addClass("swiper");
    $slides.wrapAll('<div class="swiper-wrapper"></div>');
    $cover.find(".swiper-wrapper").children().addClass("swiper-slide");

    // ✅ Pagination + Navigation
    $cover.append('<div class="swiper-pagination"></div>');
    $cover.append('<div class="swiper-button-prev"></div>');
    $cover.append('<div class="swiper-button-next"></div>');

    swiper = new Swiper("#productCoverImages.swiper", {
      slidesPerView: 1,
      loop: false,
      threshold: 10,

      pagination: {
        el: "#productCoverImages .swiper-pagination",
        clickable: true,
      },

      navigation: {
        nextEl: "#productCoverImages .swiper-button-next",
        prevEl: "#productCoverImages .swiper-button-prev",
      },

      on: {
        init: function () {
          $(".product-single__thumbnails").addClass("zoom-enabled");
          var $active = $("#productCoverImages .swiper-slide").eq(this.activeIndex);
          onSlideActivated($active);
        },
        slideChange: function () {
          var $active = $("#productCoverImages .swiper-slide").eq(this.activeIndex);
          onSlideActivated($active);
        },
      },
    });
  }

  // ✅ Keep zoom behavior (only block real swipe clicks)
  $(document).on("click", "#productCoverImages .product-single__photo", function (e) {
    if (swiper && swiper.touches && Math.abs(swiper.touches.diff || 0) > 10) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  $(document).ready(function () {
    try { buildSwiper(); } catch (err) {}
  });

  // rebuild on variant change
  $(document).on("variant:change product:variant-change", function () {
    setTimeout(function () {
      try { buildSwiper(); } catch (err) {}
    }, 80);
  });

})(jQuery);
/* ✅ /Gallery */
    

      $(document).on('click', function (e) {

        if ($('.bcpo__color-title.active').length &&
            !$(this).hasClass('bcpo-medium-swatches') &&
            !$(this).hasClass('bcpo__color-title') &&
            $(e.target).closest('.bcpo__color-title.active').length === 0 &&
            $(e.target).closest('.bcpo-medium-swatches.active').length === 0) {

          $('.bcpo__color-title.active').removeClass('active');
        }
      });


      $(document).scroll(function() {
        productObj.scrollEvent();
      });

      $(window).resize(function() {
        productObj.scrollEvent();
      });

      productObj.scrollEvent();


      $(document).on('click', '.product-single__thumbnails > li:not(.active)', function() {
        var thumbnail = $(this);
        thumbnail.addClass('active').siblings('.active').removeClass('active');
      });


      $(document).on('click', '.product-single__floating-bar__actions .btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var addToCartBtn = $('#AddToCartNew');
        addToCartBtn.click();
      });


      $(document).on('click', '.cart-side__popup-bg,.cart-side__popup-close,.cart-side__popup-actions .btn--secondary', function() {
        $('body').removeClass('cart-side__popup-visible');
      });


      $(document).on('click', '.cart-side__popup-actions .btn--primary', function() {
        var cartLink = $('.site-header__cart').attr('href');
        window.location.href = cartLink;
      });




      productObj.checkFormByCircle = setInterval(function () {
        if (typeof productObj.checkForm === 'function') productObj.checkForm();
      }, 100);
      productObj.checkFormChecks = 0;
      if (typeof productObj.checkForm === 'function') productObj.checkForm();


      /* Fix changing total price */
      var d = new Date();
      var n = d.getTime();

      var totalPrice = $('.bold_option_price_display');
      productObj.checkFormTotalPrice = {
        text: totalPrice.text(),
        value: totalPrice.attr('content'),
        lastTime: d.getTime()
      };



      try {
        $('.product-form__option.active').click();
        updateStockLevel($('.product-form__option.active'));
      } catch (e) {}

function getCurrentLang() {
  var lang = window.langify_lang || document.documentElement.lang || 'en';
  return String(lang).split('-')[0].toLowerCase();
}

      function updateStockLevel($option) {
     console.log("running updateStockLevel");
    if (!$option || !$option.length) return;

    var stockLevel = $option.attr('data-stockLevel');
    const lang = getCurrentLang();

  if ($('.stock-level-container').hasClass('stock-level-container--singleVariant')) {
    
     var stockLevel = $('.stock-level-container--singleVariant').attr('data-stocklevel');
     console.log("variant stock level:", stockLevel);
  $('.stock-level-container--singleVariant #variantStockLevel').text(stockTranslations[stockLevel]?.[lang] || stockLevel);
  return;
}

    if ($option.is('[data-stockLevel]') && stockLevel && stockLevel.trim() !== '') {
        $('.stock-level-container').addClass('visible');

        const translatedText = stockTranslations[stockLevel]?.[lang] || stockLevel;
        $('#variantStockLevel').text(translatedText);
    } else {
        $('.stock-level-container').removeClass('visible');
        $('#variantStockLevel').text('');
    }
}










      /* Size */
      $(document).on('click', '.product-form__option', function() {
        var newOption = $(this);
        var newOptionI = newOption.index();
        var newOptionValue = newOption.attr('data-option-value');

        var stockLevel = newOption.attr('data-stockLevel');
          updateStockLevel(newOption);


                var chestTextboxFieldHide = $('.chestTextboxFieldHide').val();

        var addToCartNew = $('#AddToCartNew');
        var preorderMessage = $('.product-single__pre-order__message');

        if (preorderMessage.length) {

          if (/\s\(Pre\-Order\)$/i.test(newOptionValue)) {
            addToCartNew.children('span').text(addToCartNew.attr('data-preorder-text'));
            preorderMessage.removeClass('hidden');

          } else {
            addToCartNew.children('span').text(addToCartNew.attr('data-addtocart-text'));
            preorderMessage.addClass('hidden');
          }
        }

        var options = $('.single-option-selector');
        if (options.length) {
          options.val(newOptionValue).trigger('change').trigger('click');
          if (options[0]) {
            options[0].dispatchEvent(new Event('change'));
            options[0].dispatchEvent(new Event('click'));
          }
        }

        var variantId = newOption.attr('data-option-id');
        var variantSelect = $('.product-form .product-single__variants, .product-form select[name="id"]').first();
        if (variantSelect.length && variantId) {
          variantSelect.val(variantId).trigger('change');
        }

        if (newOption.hasClass('disabled') && !document.querySelector('body').classList.contains('pets-wrapper')) {
          addToCartNew.addClass('disabled');

          $('body').addClass('ps__klaviyo-popup__visible');

        } else {
          newOption.addClass('active').siblings('.active').removeClass('active');
          addToCartNew.removeClass('disabled');
        }

        $('.ps__klaviyo-popup__content p > b').text(newOptionValue);


        var chestTextboxField = $('.product-form .bold_option.bold_option_textbox input[name^="properties[Embroidery on the chest"]');

        if (chestTextboxField.length) {
          var chestField = chestTextboxField.parents('.bold_option');
          var chestChargeField = chestField.prev('.bold_option_checkbox');
          var hideChest = /^(Baby|Bebé|Bébé)(|\s*40cm)$/i.test(newOptionValue) ||
            (/^1\-2 (years|jaar|ans|años|Jahre)(|\s*50cm)$/i.test(newOptionValue) && chestTextboxFieldHide == 'hide-true');

          if (hideChest) {
            chestField.addClass('bold_option__invisible');
            chestChargeField.addClass('bold_option__invisible');
            if (chestTextboxField.val()) {
              chestTextboxField.val('').trigger('keyup').trigger('change');
            }

          } else {
            chestField.removeClass('bold_option__invisible');
            chestChargeField.removeClass('bold_option__invisible');
          }

          var chestTextboxFieldCount = chestField.find('.bold_option_element__count');

          if (chestTextboxFieldCount.length) {
            var chestTextboxFieldLength = chestTextboxField.val().trim().length;

            var formAlert = $('.product-form__alert');

            if (/^(1\-2|3\-4|5\-6|7\-8)\s/.test(newOptionValue)) {
              chestTextboxField.attr('maxlength', 6);

              if (chestTextboxFieldLength < 6) {
                formAlert.addClass('hidden');
              }

              chestTextboxFieldCount.html('<span>' + chestTextboxFieldLength + '</span>/6');

            } else {
              chestTextboxField.attr('maxlength', 9);

              if (chestTextboxFieldLength < 9) {
                formAlert.addClass('hidden');
              }

              chestTextboxFieldCount.html('<span>' + chestTextboxField.val().trim().length + '</span>/9');
            }
          }
        }

        if (/DEVMODE/.test(window.location.href)) {
//           productObj.refreshComparePrice();
        }

        if (typeof window.leOliveRefreshProductOptionPrice === 'function') {
          var optionPriceValue = newOption.attr('data-option-price-value');
          var pricesWrap = document.querySelector('.product-single__prices');
          if (pricesWrap && optionPriceValue) {
            var optionCents = Math.round(parseFloat(optionPriceValue) * 100) || 0;
            if (optionCents) {
              pricesWrap.setAttribute(
                'data-original-price',
                (optionCents / 100).toFixed(2).replace('.', ',')
              );
            }
          }
          setTimeout(function () {
            window.leOliveRefreshProductOptionPrice(document.querySelector('.product-form'));
          }, 50);
        }
      });
      /* /Size */

























      if (/DEVMODE123/.test(window.location.href)) {

        /* Fix changing total price */
        $(document).on('click', '.product-form__option__', function() {

          var d = new Date();
          var n = d.getTime();

          if (productObj.checkFormTotalPrice.lastTime + 500 < d.getTime()) {
            var totalPrice = $('.bold_option_price_display');
            productObj.checkFormTotalPrice = {
              text: totalPrice.text(),
              value: totalPrice.attr('content'),
              lastTime: d.getTime()
            };

            var correcredTotalPriceValue = totalPrice.text().trim().replace(/^(\$|\€|\£)([0-9\.]+)$/, '$2');
            productObj.checkFormTotalPrice.value = correcredTotalPriceValue;

            totalPrice.attr('content', productObj.checkFormTotalPrice.value);

            setTimeout(function() {
              totalPrice.text(productObj.checkFormTotalPrice.text).attr('content', productObj.checkFormTotalPrice.value);
            }, 50);
          }
        });
        /* /Fix changing total price */


        /* Size */
        $(document).on('click', '.product-form__option', function() {
          var newOption = $(this);
          var newOptionI = newOption.index();
          var newOptionValue = newOption.attr('data-option-value').trim();
updateStockLevel(newOption);
          var chestTextboxFieldHide = $('.chestTextboxFieldHide').val();

          var addToCartNew = $('#AddToCartNew');
          var preorderMessage = $('.product-single__pre-order__message');

          if (preorderMessage.length) {

            if (/\s\(Pre\-Order\)$/i.test(newOptionValue)) {
              addToCartNew.children('span').text(addToCartNew.attr('data-preorder-text'));
              preorderMessage.removeClass('hidden');

            } else {
              addToCartNew.children('span').text(addToCartNew.attr('data-addtocart-text'));
              preorderMessage.addClass('hidden');
            }
          }

          var options = $('.single-option-selector');
          if (options.length) {
            options.val(newOptionValue).change();
            if (options[0]) {
              options[0].dispatchEvent(new Event('change'));
            }
          }

          var variantId = newOption.attr('data-option-id');
          var variantSelect = $('.product-form .product-single__variants, .product-form select[name="id"]').first();
          if (variantSelect.length && variantId) {
            variantSelect.val(variantId).trigger('change');
          }

          if (newOption.hasClass('disabled')) {
            addToCartNew.addClass('disabled');

            $('body').addClass('ps__klaviyo-popup__visible');

          } else {
            newOption.addClass('active').siblings('.active').removeClass('active');
            addToCartNew.removeClass('disabled');
          }

          $('.ps__klaviyo-popup__content p > b').text(newOptionValue);

          var chestTextboxField = $('.product-form .bold_option.bold_option_textbox input[name^="properties[Embroidery on the chest"]');

          if (chestTextboxField.length) {
            var chestField = chestTextboxField.parents('.bold_option');

            if (/^(Baby|Bebé|Bébé)(| 40cm)$/i.test(newOptionValue)) {
              chestField.addClass('bold_option__invisible');
            } else if (/^1\-2$/i.test(newOptionValue) && chestTextboxFieldHide == 'hide-true') {
              chestField.addClass('bold_option__invisible');

            } else {
              chestField.removeClass('bold_option__invisible');
            }
          }
        });
        /* /Size */
      }

      /* Gift wrapper */
      $(document).on('click', '.product-form__giftwrapper-icon', function() {
        $('body').addClass('ps__giftwrapper-popup__visible');
      });

      $(document).on('click', '.ps__giftwrapper-popup__bg, .ps__giftwrapper-popup__close', function() {
        $('body').removeClass('ps__giftwrapper-popup__visible');
      });
      /* /Gift wrapper */

      /* Klaviyo popup */
      $(document).on('click', '.ps__klaviyo-popup__bg, .ps__klaviyo-popup__close', function() {
          $('body').removeClass('ps__klaviyo-popup__visible');
      });
      $(document).on('click', '#NotifyMeBtn2', function () {
        $('span#NotifyMeBtn[data-notify="true"]')[0].click();
      })
      $(document).on('click', 'span#NotifyMeBtn[data-notify="true"]', function () {
        $('body').addClass('ps__klaviyo-popup__visible');
        $('.ps__klaviyo-popup__content p > b').text('default');
      })
      $(document).on('click', '.ps__klaviyo-popup__btn', function() {
        var btn = $(this);
        var emailFieldText = $('.ps__klaviyo-popup__email').val();

        if (emailFieldText.length) {
          btn.prop('disabled');

          var ajaxData = {
            a: 'VLFQ9y',
            email: emailFieldText,
            product: $('.ps__klaviyo-popup__wrapper[data-product-id]').attr('data-product-id'),
            platform: 'shopify'
          };

          var variantTitle = $('.ps__klaviyo-popup__content p > b').text().trim();
          if ($('span#NotifyMeBtn').length) {
            var variantButton = $('span#NotifyMeBtn');
          } else {
            var variantButton = $('.product-form__option.disabled[data-option-value="' + variantTitle + '"]');
          }

          if (variantButton.length) {
            ajaxData.variant = variantButton.attr('data-option-id');
          }

          $.ajax({
            type: "POST",
            data: ajaxData,
            url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
            success: function(response){
              $('.ps__klaviyo-popup__before').addClass('hidden');
              $('.ps__klaviyo-popup__after').removeClass('hidden');
            },
            // Custom START
            error: function(xhr, status, error) {
              $('.ps__klaviyo-popup__before').addClass('hidden');
              $('.ps__klaviyo-popup__after').removeClass('hidden');
            }
            // Custom END
          });
        }
      });
      /* /Klaviyo popup */

      $(document).on('click', '.t-shirt-options .bold_options .bold_option_value', function (evt) {
        setTimeout(function() {
          productObj.checkBoldColors();
        }, 125);

      });
      $(document).on('click', '.t-shirt-options .bold_options .bold_option_value[data-color^="Font "]', function (evt) {
        setTimeout(function() {
          if ( $(document).find('.bold_option [name^="properties[Design Options]"]').length ) {
            var tShirtTextboxInput = $(document).find('.bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt]"]');
            if (tShirtTextboxInput.length) {
              tShirtTextboxInput
                      .attr('maxlength', 12)


              if (!tShirtTextboxInput.siblings('.bold_option_element__count').length) {
                tShirtTextboxInput.after(
                        '<span class="__count"><span>0</span>/12</span>'
                );
              }
            }
            var tShirt2TextboxInput = $(document).find(' .bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt - second line]"]');

            if (tShirt2TextboxInput.length) {
              tShirt2TextboxInput
                      .attr('maxlength', 12)
              if (!tShirt2TextboxInput.siblings('.bold_option_element__count').length) {
                tShirt2TextboxInput.after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
              }
            }
            var tShirt3TextboxInput = $(document).find(' .bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt - third line]"]');

            if (tShirt3TextboxInput.length) {
              tShirt3TextboxInput
                      .attr('maxlength', 12)
              if (!tShirt3TextboxInput.siblings('.bold_option_element__count').length) {
                tShirt3TextboxInput.after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
              }
            }
          }
        }, 200);
      })



      return productObj;
    };






















































    /* Gift wrapper */
    productObj.giftWrapper = function() {

      /* Gift wrapper */
      $(document).on('click', '.bold_option_select_image', function () {
        const popupImageUrl = $(this).find("img").attr("src");
        const popupImage = $('.ps__giftwrapper-popup__image');

        if (popupImageUrl) {
          popupImage.attr('src', popupImageUrl);
        }
        popupImage.show();

        $('body').addClass('ps__giftwrapper-popup__visible');
      })

      $(document).on('click', '.product-form__giftwrapper-icon', function() {
        var boldOption = $(this).parents('.bold_option');
        var boldOptionInputName = boldOption.find('input[name]:first,select[name]:first').attr('name');

        var giftWrapperImage = $('.ps__giftwrapper-popup__image');
        giftWrapperImage.attr('src', '').hide();

        var cancerFight = true;

        if (cancerFight === true) {

          if (/^properties\[Embroidery on the pocket/.test(boldOptionInputName)) {
            var popupEmbroideryImage = $('.ps__giftwrapper-popup__image');
            popupEmbroideryImage.attr('src', '').hide();

              var popupEmbroideryImageUrl = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/embroidery_pocket_fightcancer_infotooltip.jpg?v=1662024974';

            if (popupEmbroideryImageUrl) {
              popupEmbroideryImage.attr('src', popupEmbroideryImageUrl);
            }

            popupEmbroideryImage.show();

            $('body').addClass('ps__giftwrapper-popup__visible');

          }


        }
        if (/^properties\[(Gift\-wrap this product|Add a gift box)/.test(boldOptionInputName)) {
          var productType = $('.product-form__header').attr('data-product-type');

          var boldOptionText = boldOption.find('.bold_help_text');

          if (boldOptionText.length) {
            var giftWrapSize = boldOptionText.text().trim();

            switch (giftWrapSize) {
              case '(M)':
                var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/Gift_Wrap_GW4_Medium_2_infotooltip.jpg?v=1656437665';
                break;

              case '(R)':
                var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/Gift_Wrap_GW5_Regular_2_infotooltip.jpg?v=1656437665';
                break;

              case '(L)':
                var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/Gift_Wrap_GW3_Large_2_infotooltip.jpg?v=1656437666';
                break;

              case '(S)':
                var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/Gift_Wrap_GW7_Small_infotooltip.jpg?v=1725810862';
                break;

             case '(S2)':
                var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/Gift_Wrap_GW6_Small_2_infotooltip.jpg?v=1656437665';
                break;   

              case '(MB)':
                var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/BABY_Giftwrap_v2_GW9_MED_infotooltip.jpg?v=1679495510';
                break;

              case '(RB)':
                var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/BABY_Giftwrap_v2_GW8_REG_infotooltip.jpg?v=1679495510';
                break;
            }

          }
          else {

            if (productType == 'Robe') {
              var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0260/4613/6383/files/Giftwrap-LARGE.png?v=1641835353';


            } else if (productType == 'Kimono') {
              var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0260/4613/6383/files/Giftwrap-REGULAR.png?v=1641837517';
            }
          }

        } else if (/^properties\[Add FREE Sleep Mask Velvet Bordeaux Red/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/freemask_tooltip_redvelvet.jpg?v=1705249501';

        } else if (/^properties\[Add FREE Sleep Mask Champagne/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/freemask_tooltip_champagne.jpg?v=1705249501';

        } else if (/^properties\[Add FREE Sleep Mask Midnight Black/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/freemask_tooltip_black.jpg?v=1705249501';

        } else if (/^properties\[Add FREE Sleep Mask Rose Pink/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/freemask_tooltip_rosepink.jpg?v=1705249501';

        } else if (/^properties\[Add FREE Sleep Mask Blossom Pink/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/freemask_tooltip_blossompink.jpg?v=1705249501';

        } else if (/^properties\[Add a scrunchie\? \(/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0260/4613/6383/files/Scrunchie_add-on.png?v=1641840045';

        }
        else if (/^properties\[Add a wish card/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/Birthday_LotsofLove_info_tooltip.png?v=1652182721';

        } else if (/^properties\[Add FREE Scent Card/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0432/5526/7479/files/info_tooltip_Scent_Card.jpg?v=1649938195';

        } else if (/^properties\[Add a sleep mask\? \(/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0260/4613/6383/files/FaceMask_add-on.png?v=1641842172';

        } else if (/^properties\[Choose your leather tag/.test(boldOptionInputName)) {
          var giftWrapperImageURL = 'https://cdn.shopify.com/s/files/1/0279/2567/6171/files/pets_leatherlabel_info_tooltip.jpg?v=1725275929';

        }

        if (giftWrapperImageURL) {
          giftWrapperImage.attr('src', giftWrapperImageURL);
        }

        giftWrapperImage.show();

        $('body').addClass('ps__giftwrapper-popup__visible');
      });

      // Size Chart
      $(document).on('click', '.size-chart', function(e) {
        const target = e.currentTarget;
        const image = target.getAttribute("data-image");

        var giftWrapperImage = $('.ps__giftwrapper-popup__image');

        giftWrapperImage.attr('src', '').hide();

        var giftWrapperImageURL = image;

        if (giftWrapperImageURL) {
          giftWrapperImage.attr('src', giftWrapperImageURL);
        }

        giftWrapperImage.show();

        $('body').addClass('ps__giftwrapper-popup__visible');
      });

      $(document).on('click', '.ps__giftwrapper-popup__bg, .ps__giftwrapper-popup__close', function() {
          $('body').removeClass('ps__giftwrapper-popup__visible');
      });
      /* /Gift wrapper */


















































      return productObj;
    };

    productObj.giftWrapper();

    productObj.giftWrapperAddIconsToFormFields = function() {
      var giftFields = $(
        '.bold_option.bold_option_radio input[name^="properties[Gift-wrap this product"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Add a gift box"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Add FREE Sleep Mask Velvet Bordeaux Red"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Add FREE Sleep Mask Champagne"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Add FREE Sleep Mask Midnight Black"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Add FREE Sleep Mask Blossom Pink"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Add FREE Sleep Mask Rose Pink"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Add FREE Scent Card]"]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Embroidery on the pocket ("]:first,' +
        '.bold_option.bold_option_radio input[name^="properties[Choose your leather tag"]:first,' +
        '.bold_option.bold_option_dropdown select[name^="properties[Add a wish card]"]:first'
      );



      if (giftFields.length) {

        giftFields.each(function() {
          var giftField = $(this);
          var giftFieldLabel = giftField.parents('.bold_option_element').siblings('.bold_option_title');
          if (!giftFieldLabel.length) {
            giftFieldLabel = giftField.closest('.bold_option').children('.bold_option_title');
          }
          if (giftFieldLabel.length && !giftFieldLabel.find('.product-form__giftwrapper-icon').length) {
            giftFieldLabel.append(
              '<span class="product-form__giftwrapper-icon"></span>'
            );
          }
        });
      }

      return productObj;
    };
    /* /Gift wrapper */


    productObj.checkForm = function () {

      if ($('.bold_options.bold_options_loaded > .bold_option_set').length) {
        productObj.translateAttributes();

        clearInterval(productObj.checkFormByCircle);

      } else if (productObj.checkFormChecks > 25) {
        clearInterval(productObj.checkFormByCircle);

      } else {
        productObj.checkFormChecks++;
      }


      /* Add to cart */
      $(document).on('click', '.product-single__cart-submit-wrapper #AddToCartNew', function() {
        productObj.validForm(true, null);

        productObj.checkAddToCartBtnByCircle = setInterval(productObj.checkAddToCartBtn, 250);
        productObj.checkAddToCartBtnChecks = 0;
        productObj.checkAddToCartBtn();
      });
      /* /Add to cart */

      return productObj;
    };

    productObj.checkAddToCartBtnRedirect = false;

    productObj.checkAddToCartBtn = function() {
      var addToCartAlert = $('.product-single__notification');
      var originalCartBtn = $('#addToCart');
      var viewCartBtn = $('.product-single__cart-submit-wrapper > .btn--view-cart');

      if (addToCartAlert.length && viewCartBtn.length) {

        if (!productObj.checkAddToCartBtnRedirect) {

          setTimeout(function() {
            var cartURL = $('.product-single__cart-submit-wrapper > .product-single__cart-submit[data-cart-url]').attr('data-cart-url');


            /* LO#001 - Cart widget - AB test */
            if ($('.header-cart__sidebar').length) {
              $('.header-cart__sidebar-open').click();

            } else {
              window.location.href = cartURL;
            }
            /* /LO#001 - Cart widget - AB test */


            productObj.checkAddToCartBtnRedirect = true;
          }, 100);
        }

        clearInterval(productObj.checkAddToCartBtnByCircle);
        return;

      } else if (productObj.checkAddToCartBtnChecks > 25) {
        clearInterval(productObj.checkAddToCartBtnByCircle);

      } else {
        productObj.checkAddToCartBtnChecks++;
      }

      return productObj;
    };



    productObj.refreshComparePrice = function() {
      setTimeout(function() {
        if (typeof window.leOliveRefreshProductOptionPrice === 'function') {
          window.leOliveRefreshProductOptionPrice(
            document.querySelector('.product-form') || document
          );
          return;
        }
        var productPrice = $('#ProductPrice');
        var productComparePrice = $('#ComparePrice');
        if (!productPrice.length || !productComparePrice.length) return;

        var pricesWrap = productPrice.closest('.product-single__prices');
        var originalPrice = parseFloat(
          String(pricesWrap.attr('data-original-price') || '')
            .replace(/\./g, '')
            .replace(',', '.')
        );
        var currentPrice = parseFloat(
          productPrice
            .text()
            .replace(/[^0-9,]+/g, '')
            .replace(/\./g, '')
            .replace(',', '.')
        );
        if (!isFinite(originalPrice) || !isFinite(currentPrice)) return;

        var compareBase = productComparePrice.attr('data-original-compare');
        if (!compareBase) {
          compareBase = productComparePrice.attr('content') || productComparePrice.text();
          productComparePrice.attr('data-original-compare', compareBase);
        }
        var compareBaseValue = parseFloat(
          String(compareBase)
            .replace(/[^0-9,.-]+/g, '')
            .replace(/\./g, '')
            .replace(',', '.')
        );
        if (!isFinite(compareBaseValue)) return;

        var extra = currentPrice - originalPrice;
        var newCompare = compareBaseValue + (isFinite(extra) ? extra : 0);
        productComparePrice.text(
          (obj.currencySymbol || '€') + newCompare.toFixed(2).replace('.', ',')
        );
      }, 50);

      return productObj;
    };

    productObj.translateAttributes = function () {
      var formBoldOptions = $('.bold_options');
      formBoldOptions.addClass('bold_options_custom_loaded');


      /* Dropdowns */
      let formBoldOptionsDropdowns = $('.bold_option_dropdown .bold_option_element > select');

      if (formBoldOptionsDropdowns.length) {

        formBoldOptionsDropdowns.each(function() {

          $(this).children('option').each(function() {

//            if (/^Mother\'s Day Card/i.test($(this).text().trim()) && window.Shopify.locale != 'fr') {
//              $(this).remove();
//            }
          });
        });
      }
      /* /Dropdowns */

      const uppercaseInputs = $('.bold_options .bold_option_element input[name^="properties[Embroidery on the hat "],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on hat"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on the slipper"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on front"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on teddy front"],' +                 
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on wallet"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on laptop pouch"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on bracelet"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on cardigan"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on the headband"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on the bag"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on mittens"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on scarf"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on footmuff"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on pillow - initials"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on sleeve - initials"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on scrunchie - initials"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on the sleep mask - initials"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on pillow and mask - initials"],' +  
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on scarf - initials"],' +                    
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on storage bag"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on toiletry bag"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on sock"],' +                  
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on chair"],' + 
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on leash - name"],' +
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on dog collar - name"],' + 
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on cat collar"],' +   
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on harness - name"],' + 
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on poop bag holder"],' + 
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on dog cushion"],' +                  
              ' .bold_options .bold_option_element  input[name^="properties[Embroidery on backpacks"]');

      if (uppercaseInputs.length) {
        uppercaseInputs.each(function () {
          $(this).css('text-transform', 'uppercase')
          $(this).on('change keyup', function () {
            $(this).val(function (i, v) {
              return v.toUpperCase();
            })
          })
        })
      }

      /* Labels */
      var formBoldOptionsLabels = formBoldOptions.find('.bold_option > label > .bold_option_title, .bold_option > .bold_option_title');

      if (formBoldOptionsLabels.length) {

        formBoldOptionsLabels.each(function() {
          var formBoldOptionsLabel = $(this);
          var formBoldOptionsLabelText = formBoldOptionsLabel.text().trim();

          var formBoldOption = formBoldOptionsLabel.parents('.bold_option');

          var newFormBoldOptionsLabelText = obj.t(formBoldOptionsLabelText).replace(/(<([^>]+)>)/gi, "");

          if (obj.originalCurrencySymbol) {

            for (var i = 0; i < obj.boldFormFields.length; i++) {
              var boldFormField = obj.boldFormFields[i];

              if (boldFormField.name.regEx.test(formBoldOptionsLabelText)) {

                for (var i2 = 0; i2 < boldFormField.prices.length; i2++) {

                  /* Label without a price */
                  if (typeof boldFormField.updateLabelPrice !== 'undefined' && !boldFormField.updateLabelPrice) {

                  /* Label with a price */
                  } else if (/^(.+) \([\+]{0,1}(.+){1}([0-9\,\.]+)\)$/.test(formBoldOptionsLabelText)) {
                    var newFormBoldOptionsLabelPrice = parseFloat(formBoldOptionsLabelText.replace(/^.+ \([\+]{0,1}(.{1})([0-9\,\.]+)\)$/, '$2'));
                    var newFormBoldOptionsLabelConvertedPrice = newFormBoldOptionsLabelPrice * parseFloat(window.Shopify.currency.rate);

                    var boldFormFieldPrice = boldFormField.prices[i2];

                    if (boldFormFieldPrice.currency == window.Shopify.currency.active) {
                      var newFormBoldOptionsLabelConvertedPrice = boldFormFieldPrice.price;

                      formBoldOptionsLabel.attr('data-price-value', newFormBoldOptionsLabelConvertedPrice.toFixed(2));

                      var newFormBoldOptionsLabelText = newFormBoldOptionsLabelText.replace(/^(.+) \([\+]{0,1}.{1}([0-9\,\.]+)\)$/, '$1') + ' (+' + obj.currencySymbol + newFormBoldOptionsLabelConvertedPrice.toFixed(2) + ')';
                    }
                  }

                  /* DEVMODE */
//                   if (/DEVMODE/.test(window.location.href)) {

                    if (formBoldOption.hasClass('bold_option_dropdown') && typeof boldFormField.options !== 'undefined') {

                      formBoldOption.find('select > option').each(function() {
                        var formBoldOptionDropdownOption = $(this);
                        var formBoldOptionDropdownOptionText = formBoldOptionDropdownOption.text().trim();

                        if (/ \[\+[^0-9]{1}[0-9\.\,]+\]$/.test(formBoldOptionDropdownOptionText)) {

                          // Options */
                          for (var i3 = 0; i3 < boldFormField.options.length; i3++) {

                            if (boldFormField.options[i3].name.regEx.test(formBoldOptionDropdownOptionText)) {

                              // Option prices
                              for (var i4 = 0; i4 < boldFormField.options[i3].prices.length; i4++) {

                                if (boldFormField.options[i3].prices[i4].currency == window.Shopify.currency.active) {
                                  formBoldOptionDropdownOption.text(formBoldOptionDropdownOptionText.replace(/ \[\+([^0-9]{1})([0-9\,\.]+)\]$/, ' [+$1' + boldFormField.options[i3].prices[i4].price.toFixed(2) + ']'));
                                }
                              }
                            }
                          }
                        }
                      });
                    }
//                   }
                  /* /DEVMODE */
                }
              }
            }
          }

          formBoldOptionsLabel.html(newFormBoldOptionsLabelText);
        });
        obj.applyFreeZeroBagEmbroideryLabels(formBoldOptions);
        setTimeout(function () { obj.applyFreeZeroBagEmbroideryLabels(formBoldOptions); }, 300);
        setTimeout(function () { obj.applyFreeZeroBagEmbroideryLabels(formBoldOptions); }, 1200);
      }
      /* /Labels */


      var formHeader = $('.product-form > .product-form__header');
      formBoldOptions.insertAfter(formHeader);


      var activeVariant = $('.product-form .product-form__option.active');

      if (activeVariant.length) {
        activeVariant.click();
      
      }


      /* Options */
      var options = $('.single-option-selector > option');

      if (options.length) {
        var newOptions = $('.product-form__options-wrapper');

        if (!newOptions.find('.product-form__option.active').length) {
          var addToCartBtn = $('.product-single__cart-submit-wrapper > .addtocart.btn');
          addToCartBtn.prop('disabled', true);
        }
      }
      /* /Options */









      /* Textbox field */
      var boldTextboxFields = $('.product-form .bold_option_textbox');

      if (boldTextboxFields.length) {

        boldTextboxFields.each(function() {
          var boldTextboxField = $(this);
          var boldTextboxFieldInput = boldTextboxField.find('.bold_option_element > input[type="text"]');

          if (boldTextboxFieldInput.is('[name^="properties[Personalise initials ("]')) {
            boldTextboxField.addClass('medium-up--one-whole').addClass('large-up--one-half');
          }

          var boldTextboxFieldTitle = boldTextboxField.find('.bold_option_title').text().trim();
          var productTitle = $('h1.product-single__title').text().trim();

          if ($('html[lang="de"]').length && /^Personalisierte Stickerei Rücken/i.test(boldTextboxFieldTitle)) {
            formBoldOptions.attr('data-embroidery-back', true);
          }

          var boldTextboxInput = boldTextboxField.find('input[type="text"]');
          boldTextboxInput.attr('placeholder', obj.t('Enter here'));
        });
      }


     // ADDING TEXT FIELD COUNTER

      /* Personalise initials */
      var leatherTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Personalise initials ("]');

      if (leatherTextboxInput.length) {
        leatherTextboxInput
        .attr('maxlength', 4)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/4</span>'
        );
      }

      var iphoneleatherTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Personalise Initials ("]');

      if (iphoneleatherTextboxInput.length) {
        iphoneleatherTextboxInput
        .attr('maxlength', 3)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/3</span>'
        );
      }
      /* /Personalise initials */

       var toilettasTextboxInput = $(
  '.product-form .bold_option_textbox .bold_option_element input[type="text"]' +
  '[name*="Embroidery on toiletry bag"]'
);




      /* Towel */
      var towelTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the towel ("]');

      if (towelTextboxInput.length) {
        towelTextboxInput
        .attr('maxlength', 12)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/12</span>'
        );
      }
      /* /Towel */


      /* Face mask */
      var facemaskTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the face mask ("]');

      if (facemaskTextboxInput.length) {
        facemaskTextboxInput
        .attr('maxlength', 8)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/8</span>'
        );
      }
      /* /Face mask */


      /* Sleep mask */
      var sleepmaskTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the sleep mask ("]');

      if (sleepmaskTextboxInput.length) {
        sleepmaskTextboxInput
        .attr('maxlength', 12)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/12</span>'
        );
      }

      var freemaskTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[FREE Embroidery on sleep mask ("]');

      if (freemaskTextboxInput.length) {
        freemaskTextboxInput
        .attr('maxlength', 12)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/12</span>'
        );
      }

      var sleepmaskinitialsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the sleep mask - initials ("]');

      if (sleepmaskinitialsEmbroidery.length) {
        sleepmaskinitialsEmbroidery
        .attr('maxlength', 2)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/2</span>'
        );
      }
      /* /Sleep mask */

      /* Embroidery on scrunchie */
      var scrunchieinitialsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on scrunchie - initials ("]');

      if (scrunchieinitialsEmbroidery.length) {
        scrunchieinitialsEmbroidery
        .attr('maxlength', 2)
        .after(
                '<span class="bold_option_element__count"><span>0</span>/2</span>'
        );
      }

      /* /Embroidery on scrunchie */

      /* /Embroidery on chair */

      var chairEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on chair ("]');

      if (chairEmbroidery.length) {
        chairEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      
      /* /Embroidery on chair */

      /* Embroidery on the hat, hatv2, sunhat */
      var hatEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the hat ("]');

      if (hatEmbroidery.length) {
        hatEmbroidery
                .attr('maxlength', 3)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/3</span>'
                );
      }

      var hatv2Embroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on hat ("]');

      if (hatv2Embroidery.length) {
        hatv2Embroidery
                .attr('maxlength', 6)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/6</span>'
                );
      }

      var sunhatEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sun hat ("]');

      if (sunhatEmbroidery.length) {
        sunhatEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }
      /* /Embroidery on the hat, hatv2, sunhat */

      /* Embroidery on the headband */
      var headbandEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the headband ("]');

      if (headbandEmbroidery.length) {
        headbandEmbroidery
                .attr('maxlength', 2)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/2</span>'
                );
      }
      /* /Embroidery on the headband */

      /* /Embroidery at the bottom */
      var bottomEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery at the bottom ("]');

      if (bottomEmbroidery.length) {
        bottomEmbroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }

      /* Embroidery on the slipper */
      var slipperEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the slipper ("]');

      if (slipperEmbroidery.length) {
        slipperEmbroidery
                .attr('maxlength', 2)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/2</span>'
                );
      }
      /* /Embroidery on the slipper */

      /* Embroidery on backpacks */
      var backpacksEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on backpacks ("]');

      if (backpacksEmbroidery.length) {
        backpacksEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on backpacks */

      /* Embroidery on the bag */
      var bagEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the bag ("]');

      if (bagEmbroidery.length) {
        bagEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on the bag */

      /* Embroidery on mittens */
      var mittensEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on mittens ("]');

      if (mittensEmbroidery.length) {
        mittensEmbroidery
                .attr('maxlength', 1)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/1</span>'
                );
      }
      /* /Embroidery on mittens */

      /* Embroidery on scarf */
      var scarfEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on scarf ("]');

      if (scarfEmbroidery.length) {
        scarfEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }

      var scarfinitialsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on scarf - initials ("]');

      if (scarfinitialsEmbroidery.length) {
        scarfinitialsEmbroidery
                .attr('maxlength', 2)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/2</span>'
                );
      }
      /* /Embroidery on scarf */

      /* Embroidery on veil */
      var veilEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on veil ("]');

      if (veilEmbroidery.length) {
        veilEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }
      /* Embroidery on veil */

      /* Embroidery on front bag */
      var frontbagEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on front ("]');

      if (frontbagEmbroidery.length) {
        frontbagEmbroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }
      /* /Embroidery on front bag */

      /* Embroidery on chest kids */
      var chestkidsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the chest - kids ("]');

      if (chestkidsEmbroidery.length) {
        chestkidsEmbroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }
      /* /Embroidery on front bag */

      /* Embroidery on glove */
        var gloveEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the glove ("]');

        if (gloveEmbroidery.length) {
          gloveEmbroidery.each(function () {
            var $input = $(this);

            if ($input.hasClass('tb_2382555_917841')) {
              $input.attr('maxlength', 8);
            } else {
              $input.attr('maxlength', 9);
            }

            if (!$input.next('.bold_option_element__count').length) {
              var max = $input.attr('maxlength');
              $input.after('<span class="bold_option_element__count"><span>0</span>/' + max + '</span>');
            }
          });
        }
      /* /Embroidery on glove */

      /* Embroidery on TEDDY front bag */
      var teddyfrontbagEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on teddy front ("]');

      if (teddyfrontbagEmbroidery.length) {
        teddyfrontbagEmbroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }
      /* /Embroidery on TEDDY front bag */

      /* Embroidery on SHOPPER front bag */
      var shopperEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on shopper ("]');

      if (shopperEmbroidery.length) {
        shopperEmbroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }
      /* /Embroidery on SHOPPER front bag */

      /* Embroidery on THE front */
      var frontEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the front ("]');

      if (frontEmbroidery.length) {
        frontEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on THE front  */

      /* Embroidery on baby suit */
      var babysuitEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on baby suit ("]');

      if (babysuitEmbroidery.length) {
        babysuitEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on baby suit  */

      /* Embroidery on THE baby suit */
      var selectbabysuitEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the baby suit ("]');

      if (selectbabysuitEmbroidery.length) {
        selectbabysuitEmbroidery
                .attr('maxlength', 2)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/2</span>'
                );
      }
      /* /Embroidery on THE baby suit  */

      /* Embroidery on cover */
      var coverEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cover ("]');

      if (coverEmbroidery.length) {
        coverEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on cover */

      /* Embroidery on pouch */
      var pouchEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pouch ("]');

      if (pouchEmbroidery.length) {
        pouchEmbroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }

      var pouchv2Embroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pouch v2 ("]');

      if (pouchv2Embroidery.length) {
        pouchv2Embroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }
      /* /Embroidery on pouch */

      /* Embroidery on laptop pouch */
      var laptoppouchEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on laptop pouch ("]');

      if (laptoppouchEmbroidery.length) {
        laptoppouchEmbroidery
                .attr('maxlength', 3)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/3</span>'
                );
      }
      /* /Embroidery on laptop pouch */

      /* Embroidery on make-up pouch*/
      var makeuppouchEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on make-up bag ("]');

      if (makeuppouchEmbroidery.length) {
        makeuppouchEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }
      /* /Embroidery on make-up pouch */

      /* Embroidery on toilettas*/
      var toilettasEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on toiletry bag ("]');

      if (toilettasEmbroidery.length) {
        toilettasEmbroidery
                .attr('maxlength', 3)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/3</span>'
                );
      }
      /* /Embroidery on toilettas */

      /* Embroidery on changing mat*/
      var changingmatEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the changing mat ("]');

      if (changingmatEmbroidery.length) {
        changingmatEmbroidery
                .attr('maxlength', 9)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/9</span>'
                );
      }
      /* /Embroidery on changing mat */

      /* Embroidery on bracelet*/
      var braceletEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bracelet ("]');

      if (braceletEmbroidery.length) {
        braceletEmbroidery
                .attr('maxlength', 7)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/7</span>'
                );
      }
      /* /Embroidery on bracelet*/

      /* Embroidery on cardigan*/
      var cardiganEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cardigan ("]');

      if (cardiganEmbroidery.length) {
        cardiganEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on cardigan*/

      /* Embroidery on footmuff*/
      var footmuffEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on footmuff ("]');

      if (footmuffEmbroidery.length) {
        footmuffEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on footmuff*/

      /* Embroidery on storage bag*/
      var storagebagEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on storage bag ("]');

      if (storagebagEmbroidery.length) {
        storagebagEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on storage bag*/

      /* Embroidery on beanie*/
      var beanieEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on beanie ("]');

      if (beanieEmbroidery.length) {
        beanieEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on beanie*/

      /* Embroidery on bib*/
      var bibEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bib ("]');

      if (bibEmbroidery.length) {
        bibEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }
      /* /Embroidery on bib*/

       /* Embroidery on wallet */
      var walletEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on wallet ("]');

      if (walletEmbroidery.length) {
        walletEmbroidery
                .attr('maxlength', 3)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/3</span>'
                );
      }
      /* /Embroidery on wallet */

      /* Embroidery on sock */
      var socksEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sock ("]');

      if (socksEmbroidery.length) {
        socksEmbroidery
                .attr('maxlength', 2)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/2</span>'
                );
      }
      /* /Embroidery on sock */

       /* Embroidery on bath capes */
      var bathcapesEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bath capes ("]');

      if (bathcapesEmbroidery.length) {
        bathcapesEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }
      /* /Embroidery bath capes */

      /* Embroidery on poncho */
      var ponchoEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on poncho ("]');

      if (ponchoEmbroidery.length) {
        ponchoEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }
      /* /Embroidery poncho */

       /* Embroidery on blankets */
      var blanketsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on blankets ("]');

      if (blanketsEmbroidery.length) {
        blanketsEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }
      /* /Embroidery on blankets */

      /* Embroidery on pillow */
      var pillowinitialsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pillow - initials ("]');

      if (pillowinitialsEmbroidery.length) {
        pillowinitialsEmbroidery
        .attr('maxlength', 2)
        .after(
                '<span class="bold_option_element__count"><span>0</span>/2</span>'
        );
      }

      var pillownameEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pillow - name ("]');

      if (pillownameEmbroidery.length) {
        pillownameEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }

      var pillowmaskinitialsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pillow and mask - initials ("]');

      if (pillowmaskinitialsEmbroidery.length) {
        pillowmaskinitialsEmbroidery
        .attr('maxlength', 2)
        .after(
                '<span class="bold_option_element__count"><span>0</span>/2</span>'
        );
      }
      /* /Embroidery on pillow */

        /* Embroidery on sheets */
      var sheetsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sheets ("]');

      if (sheetsEmbroidery.length) {
        sheetsEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }
      /* /Embroidery on sheets */

        /* Embroidery on cloths */
      var clothsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cuddle and pacifier cloths ("]');

      if (clothsEmbroidery.length) {
        clothsEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }

      var hydrophilicclothsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on hydrophilic cloths ("]');

      if (hydrophilicclothsEmbroidery.length) {
        hydrophilicclothsEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }

      var pacifierEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pacifier ("]');

      if (pacifierEmbroidery.length) {
        pacifierEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }
      /* /Embroidery on cloths */

      /* /Embroidery on cuddle */
      var cuddleEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cuddle ("]');

      if (cuddleEmbroidery.length) {
        cuddleEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }

      /* Embroidery on teddy */
      var teddyEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on teddy ("]');

      if (teddyEmbroidery.length) {
        teddyEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }
      /* /Embroidery on teddy */

      /* Embroidery on Bath Textiles */
      var thebathtextilesTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the bath textiles ("]');

      if (thebathtextilesTextboxInput.length) {
        thebathtextilesTextboxInput
        .attr('maxlength', 12)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/12</span>'
        );
      }

      var bathtextilesTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bath textiles ("]');

      if (bathtextilesTextboxInput.length) {
        bathtextilesTextboxInput
        .attr('maxlength', 8)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/8</span>'
        );
      }
      /* /Embroidery on Bath Textiles */


      /* Embroidery on gift set */
      var caregiftsetTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on care gift set ("]');

      if (caregiftsetTextboxInput.length) {
        caregiftsetTextboxInput
        .attr('maxlength', 8)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/8</span>'
        );
      }

      var bathgiftsetTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bath gift set ("]');

      if (bathgiftsetTextboxInput.length) {
        bathgiftsetTextboxInput
        .attr('maxlength', 8)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/8</span>'
        );
      }

      var cuddlegiftsetTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cuddle gift set ("]');

      if (cuddlegiftsetTextboxInput.length) {
        cuddlegiftsetTextboxInput
        .attr('maxlength', 8)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/8</span>'
        );
      }
      /* /Embroidery on gift set */


      /* Christmas Stocking */
      var facemaskTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery ("]');

      if (facemaskTextboxInput.length) {
        facemaskTextboxInput
        .attr('maxlength', 10)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/10</span>'
        );
      }
      /* /Christmas Stocking */

      /* Embroidery on tanga */
      var tangaEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on tanga ("]');

      if (tangaEmbroidery.length) {
        tangaEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }
      /* /Embroidery on tanga */
      
      
      /* Embroidery on the belt */
      var beltEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the belt ("]');

      if (beltEmbroidery.length) {
        beltEmbroidery
                .attr('maxlength', 4)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/4</span>'
                );
      }
      /* /Embroidery on the belt */

      /* Embroidery on the sleeve */
      var sleeveEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the sleeve ("]');

      if (sleeveEmbroidery.length) {
        sleeveEmbroidery
                .attr('maxlength', 10)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/10</span>'
                );
      }

      var sleeveinitialsEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sleeve - initials ("]');

      if (sleeveinitialsEmbroidery.length) {
        sleeveinitialsEmbroidery
                .attr('maxlength', 2)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/2</span>'
                );
      }

      var sleeveinitials3Embroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sleeve - initials 3 ("]');

      if (sleeveinitials3Embroidery.length) {
        sleeveinitials3Embroidery
                .attr('maxlength', 3)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/3</span>'
                );
      }
      /* /Embroidery on the sleeve */


  /* Chest */
var chestTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the chest ("]');

if (chestTextboxInput.length) {
  var activeOption = $('.product-form__options-wrapper .product-form__option.active');
  var activeOptionText = activeOption.text().trim();
  var urlParams = new URLSearchParams(window.location.search);
  var variantId = urlParams.get('variant');

  
  var robesWithFourChars = [
    '49365852750160', 
    '49365822767440', 
    '49365772140880'
  ];
  if (variantId && robesWithFourChars.includes(variantId)) { 
    chestTextboxInput
      .attr('maxlength', 4)
      .after('<span class="bold_option_element__count"><span>0</span>/4</span>');
  } else if (/^(1\-2|3\-4|5\-6|7\-8)\s/.test(activeOptionText)) {  
    chestTextboxInput
      .attr('maxlength', 6)
      .after('<span class="bold_option_element__count"><span>0</span>/6</span>');
  } else {
    chestTextboxInput
      .attr('maxlength', 9)
      .after('<span class="bold_option_element__count"><span>0</span>/9</span>');
  }
}
/* /Chest */



      /* Back */
      var backTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the back ("]');

      if (backTextboxInput.length) {
        backTextboxInput
        .attr('maxlength', 15)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/12</span>'
        );
      }
      /* /Back */


      /* 2nd Back Line */
      var back2ndTextboxInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Back Embroidery - second line"]');

      if (back2ndTextboxInput.length) {
        back2ndTextboxInput.attr('maxlength', 12)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/12</span>'
        );
      }
      /* /2nd Back Line */


      /* Enter your personal message */
      var formField = $('.bold_options .bold_option_textarea .bold_option_element > textarea[name="properties[Enter your personal message]"]');

      if (formField.length) {
        formField.attr('maxlength', 150)
        .before(
          '<span class="bold_option_textarea__subtitle hidden">' + obj.t('The greeting cards are handwritten, therefore it is not possible to add Emojis.') + '</span>'
        )
        .after(
          '<span class="bold_option_element__count"><span>0</span>/150</span>'
        );
      }
      /* /Enter your personal message */


      /* LE OLIVE PETS */
      /* Embroidery on cat collar */
      var catcollarEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cat collar ("]');

      if (catcollarEmbroidery.length) {
        catcollarEmbroidery
                .attr('maxlength', 7)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/7</span>'
                );
      }

      /* /Embroidery on dog collar*/
      var dogcollarnameEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on dog collar - name ("]');

      if (dogcollarnameEmbroidery.length) {
        dogcollarnameEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }

      var dogcollarnumEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on dog collar - number ("]');

      if (dogcollarnumEmbroidery.length) {
        dogcollarnumEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }

      /* /Embroidery on harness*/
      var harnessnameEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on harness - name ("]');

      if (harnessnameEmbroidery.length) {
        harnessnameEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }

      var harnessnumEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on harness - number ("]');

      if (harnessnumEmbroidery.length) {
        harnessnumEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }

      /* /Embroidery on leash*/
      var leashnameEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on leash - name ("]');

      if (leashnameEmbroidery.length) {
        leashnameEmbroidery
                .attr('maxlength', 8)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/8</span>'
                );
      }

      var leashnumEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on leash - number ("]');

      if (leashnumEmbroidery.length) {
        leashnumEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }

      /* /Embroidery on poop bag holder*/
      var poopbagEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on poop bag holder ("]');

      if (poopbagEmbroidery.length) {
        poopbagEmbroidery
                .attr('maxlength', 1)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/1</span>'
                );
      }

      /* /Embroidery on dog cushion*/
      var dogcushionEmbroidery = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on dog cushion ("]');

      if (dogcushionEmbroidery.length) {
        dogcushionEmbroidery
                .attr('maxlength', 12)
                .after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
      }

      /* Printing on label */
      var labelPrintInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Printing on label ("]');

      if (labelPrintInput.length) {
        labelPrintInput
        .attr('maxlength', 1)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/1</span>'
        );
      }

      /* Printing on leash */
      var leashPrintInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Printing on leash ("]');

      if (leashPrintInput.length) {
        leashPrintInput
        .attr('maxlength', 8)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/8</span>'
        );
      }

      /* Printing on poop bag holder */
      var poopbagPrintInput = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Printing on poop bag holder ("]');

      if (poopbagPrintInput.length) {
        poopbagPrintInput
        .attr('maxlength', 8)
        .after(
          '<span class="bold_option_element__count"><span>0</span>/8</span>'
        );
      }

      /* LE OLIVE PETS */


      $(document).on('change keyup', '.product-form .bold_option_textbox .bold_option_element > input[type="text"], .product-form .bold_option_textarea .bold_option_element > textarea', function() {
        var input = $(this);
        var inputCount = input.next('.bold_option_element__count');

        if (inputCount.length) {
          inputCount.children('span').text(input.val().length);
        }

        /* Open Expivi 3D model after an embroidery was entered */
//         var expiviBtn = $('#expivi-viewer-toggle');

//         if (expiviBtn.length && !expiviBtn.hasClass('is-hidden')) {
//           expiviBtn.click();
//         }
        /* /Open Expivi 3D model after an embroidery was entered */
      });


      /* 2nd Back Embroidery line */
      if (backTextboxInput.length && back2ndTextboxInput.length) {
//         backTextboxInput.attr('maxlength', 12);
//         back2ndTextboxInput.attr('maxlength', 12);

        var backTextboxFieldElement = backTextboxInput.parent('.bold_option_element');
        var backTextboxFieldTitle = backTextboxFieldElement.siblings('.bold_option_title');

        backTextboxFieldTitle.append(
          '<i class="bold_option_title__info-btn"></i>' +
          '<span class="bold_option_title__info-tooltip">' + obj.t('Back embroidery allows for 2 lines, no less than 3 characters on a line.') + '</span>'
        );

        var back2ndTextboxFieldElement = back2ndTextboxInput.parent('.bold_option_element');

        back2ndTextboxInput.parents('.bold_option_textbox').addClass('invisible');
        backTextboxFieldElement.after(back2ndTextboxFieldElement);

        $(document).on('change keyup', '.product-form .bold_option_textbox input[type="text"][name^="properties[Embroidery on the back"]', function() {
          var input = $(this);
          var inputName = input.attr('name');
          var inputValue = input.val().trim();

          if (inputValue.length >= 10) {

          } else if (inputValue.length < 3) {
            back2ndTextboxInput.val('');
          }
        });
      }
      /* /2nd Back Embroidery line */
      /* /Textbox field */


      /* Radio */
      var radios = $('.product-form .bold_option_radio');

      if (radios.length) {

        radios.each(function() {
          var radio = $(this);
          var radioInput = radio.find('input[type="radio"]');
          radioInput.after('<span></span>');

          var radioOptions = radio.find(' > .bold_option_element > .bold_option_value');

          if (radioOptions.length) {

            radioOptions.each(function() {
              var radioOption = $(this);
              var radioOptionTitle = radioOption.find(' > label > .bold_option_value_title');
              var radioOptionTitleText = radioOptionTitle.text().trim();
              var newRadioOptionTitleText = obj.t(radioOptionTitleText);
              radioOptionTitle.text(newRadioOptionTitleText);
            });
          }
        });
      }
      /* /Radio */

      $(document).on('input', '.product-single__meta .product-form', function() {

        productObj.refreshComparePrice();
      });
      /* Color */
      productObj.checkBoldColors();

      $(document).on('change', '.bold_options .bold_option_checkbox .bold_option_element > input[type="checkbox"]', function() {
        var checkbox = $(this);
        var checkboxName = checkbox.next('input[type="hidden"]').attr('name');

        /* Sleep mask */
        if (/^properties\[Add a sleep mask\? \(/.test(checkboxName)) {

          setTimeout(function() {
            productObj.checkBoldColors();
          }, 125);
        }
      });

      $(document).on('click', '.bold_options .bold_option_swatch > .bold_option_title', function() {
        var title = $(this);

        var dropdown = title.siblings('.bold_option_element');
        dropdown.click();
      });

      $(document).on('click', '.bold_options .bold_option_swatch > .bold_option_swatch__title', function() {
        var title = $(this);
        title.toggleClass('opened');
      });

      function loSyncBoldSwatchProperty($color) {
        var $swatch = $color.closest('.bold_option_swatch');
        var $block = $color.closest('.bold_option');
        var $input = $color.find('input[type="checkbox"], input[type="radio"]');
        // Enforce single-select on Bold color checkboxes (prevents White + Silver).
        if ($input.length && $input.is(':checkbox')) {
          $swatch.find('input[type="checkbox"]').each(function () {
            this.checked = this === $input[0];
          });
        } else if ($input.length && $input.is(':radio')) {
          $input.prop('checked', true);
        }
        var $hidden = ($block.length ? $block : $swatch).find('input[type="hidden"][name^="properties["]').filter(function() {
          return !/^properties\[_/.test(this.name || '');
        }).first();
        var val = ($input.val() || '').trim();
        if (!val || /^(on|true|false)$/i.test(val)) val = ($color.find('.bold_option_value_title').text() || '').trim();
        if (!val) val = ($color.find('img').attr('alt') || $color.find('img').attr('title') || '').trim();
        if (val && /,/.test(val)) {
          var parts = val.split(/\s*,\s*/).filter(Boolean);
          val = parts.length ? parts[parts.length - 1] : val;
        }
        if ($hidden.length && val) {
          $hidden.prop('disabled', false).removeAttr('disabled').val(val).trigger('input').trigger('change');
        }
        var form = $swatch.closest('form')[0] || document.querySelector('.product-form');
        if (typeof window.leOliveSyncBoldOptionProperties === 'function') {
          window.leOliveSyncBoldOptionProperties(form);
        }
      }

      $(document).on('click', '.product-form .bold_option_swatch > .bold_option_element > .bold_option_value', function() {
        var color = $(this);
        var colorsTitle = color.parents('.bold_option_element').siblings('.bold_option_swatch__title');
        var $swatchEl = color.closest('.bold_option_element');
        var $pickedInput = color.find('input[type="checkbox"], input[type="radio"]');
        if ($pickedInput.length && $pickedInput.is(':checkbox')) {
          $swatchEl.find('input[type="checkbox"]').each(function () {
            this.checked = this === $pickedInput[0];
          });
        } else if ($pickedInput.length && $pickedInput.is(':radio')) {
          $pickedInput.prop('checked', true);
        }

        if (!color.hasClass('active')) {
          var colorText = color.text().trim();


          color.addClass('active').siblings('.active').removeClass('active').removeClass('visually_active');
          colorsTitle.children('span').text(colorText);

          if (colorText.length > 7) {
            colorsTitle.children('span').addClass('bold_option_swatch__title-twolines');

          } else {
            colorsTitle.children('span').removeClass('bold_option_swatch__title-twolines');
          }


          /* LO - Embroidery Color Options - New View (NF21033) */
          var colorsTitleBg = color.find('.bold_option_value_swatch > span');
          var colorsTitleBgImage = colorsTitleBg.css('backgroundImage');
          var colorsTitleBgColor = colorsTitleBg.css('backgroundColor');

          if (colorsTitleBgImage != 'none') {
            colorsTitle.children('i').css('backgroundColor', 'none').css('backgroundImage', colorsTitleBgImage);

          } else {
            colorsTitle.children('i').css('backgroundColor', colorsTitleBgColor).css('backgroundImage', 'none');
          }
          /* /LO - Embroidery Color Options - New View (NF21033) */


          var formAlert = $('.product-form__alert');
          formAlert.addClass('hidden');

          var newAddToCartBtn = $('#AddToCartNew');
          if (!$('.badge.badge--sold-out')) {
            newAddToCartBtn.attr('disabled', false);
          }
        }

        loSyncBoldSwatchProperty(color);
        setTimeout(function () { loSyncBoldSwatchProperty(color); }, 0);
        setTimeout(function () { loSyncBoldSwatchProperty(color); }, 50);
        colorsTitle.removeClass('opened');
      });
      /* /Color */

      $(document).on('click', '.bold_lightbox_buttons button, .bold_options_edit_in_cart [type="submit"]', function () {
        if (typeof window.leOliveSyncBoldOptionProperties !== 'function') return;
        var form = $(this).closest('form')[0]
          || document.querySelector('.bold_lightbox form')
          || document.querySelector('.product-form');
        if (typeof window.leOliveInjectAssignedFontsFromCart === 'function') {
          window.leOliveInjectAssignedFontsFromCart(form);
        }
        window.leOliveSyncBoldOptionProperties(form);
        if (typeof obj.rewriteZeroBagEmbroideryPropertyInputs === 'function') {
          obj.rewriteZeroBagEmbroideryPropertyInputs(form);
        }
        if (typeof window.leOliveDisablePlaceholderOptionFields === 'function') {
          window.leOliveDisablePlaceholderOptionFields(form);
        }
      });


      /* Expivi */
      /*
      productObj.expivi = function() {

          var btn = $('#expiviViewerToggle');
          btn.removeClass('hide');

          var originalBtn = $('#expivi-viewer-toggle');
          originalBtn.addClass('hide');

          $(document).on('click', '#expiviViewerToggle', function() {
            var btn = $(this);
            btn.addClass('hide');

            $.getScript('https://admin.expivi.net/widgets/assets/v1.466/viewer.js', function() {
              expiviPreloadEvent();
            });
          });

      };

      productObj.expivi();
      */
      /* /Expivi */


      /* Gift */
      productObj.giftWrapperAddIconsToFormFields();
      /* /Gift */


      /* Face mask */
      var facemaskField = $('.bold_option_checkbox input[name^="properties[Add a sleep mask? ("]');

      if (facemaskField.length) {
        var facemaskFieldLabel = facemaskField.parents('label');

        facemaskFieldLabel.after(
          '<div class="bold_option_checkbox__options">' +
          '<span class="bold_option_checkbox__option' + (facemaskField.is(':checked') ? ' active' : '') + '">' + obj.t('Yes') + '</span>' +
          '<span class="bold_option_checkbox__option' + (!facemaskField.is(':checked') ? ' active' : '') + '">' + obj.t('No') + '</span>' +
          '</div>'
        );

        facemaskFieldLabel.parents('.bold_option_checkbox').addClass('bold_option_checkbox__options-wrapper');
      }
      /* /Face mask */

      /* Checkbox */
      $(document).on('click', '.bold_options .bold_option_checkbox__options-wrapper .bold_option_checkbox__options .bold_option_checkbox__option', function() {
        var checkbox = $(this);
        var checkboxI = checkbox.index();

        if (!checkbox.hasClass('active')) {
          checkbox.addClass('active').siblings('.active').removeClass('active');

          var checkboxLabel = checkbox.parent().siblings('label');
          var checkboxLabelText = checkboxLabel.text().trim();

          if (/^Add a sleep mask\? \(/.test(checkboxLabelText)) {
            var facemaskChargeHiddenInput = $('.bold_options .bold_option_element input[name^="properties[Embroidery on the sleep mask - charge"]');

            if (facemaskChargeHiddenInput.length) {
              var facemaskChargeCheckbox = facemaskChargeHiddenInput.prev('input[type="checkbox"]');

              // No
              if (checkboxI) {
                var facemaskInput = $('.bold_options .bold_option_element input[name^="properties[Embroidery on the sleep mask ("]');

                if (facemaskInput.length) {
                  facemaskInput.val('').change();
                }

                if (facemaskChargeCheckbox.is(':checked')) {
                  facemaskChargeCheckbox.click();
               }


                // Yes
              } else {

                setTimeout(function() {
                  var facemaskEmbroideryInput = $('.bold_options .bold_option_element input[name^="properties[Embroidery on the sleep mask ("]');

                  if (facemaskEmbroideryInput.length) {
                    var facemaskEmbroideryField = facemaskEmbroideryInput.parents('.bold_option_textbox');
                    var facemaskColorField = facemaskEmbroideryField.next('.bold_option_swatch');

                    if (facemaskColorField.length) {
                      var facemaskColorTitle = facemaskColorField.children('.bold_option_title');
                      var facemaskColorNewTitle = facemaskColorTitle.next('.bold_option_swatch__title');

                      if (!facemaskColorNewTitle.length) {
                        facemaskColorTitle.after(
                          '<div class="bold_option_swatch__title">' +
                          '<i></i>' +
                          '<span></span>' +
                          '</div>'
                        );
                      }
                    }
                  }
                }, 100);
              }
            }
          }

          checkboxLabel.click();
        }
      });
      /* /Checkbox */

      // Wishcard images

      if ( $('.template-product select[name="properties[Add a wish card]"]').length ) {
        let selectImageUrl

        const textArea = $('.bold_option.bold_option_textarea');

        const selectImageHtmlWrapper = `<div class="bold_option_select_image hidden">

                           </div>`
        const $parent = $('select[name="properties[Add a wish card]"]').closest(".bold_option");
        $parent.find('.product-form__giftwrapper-icon').remove();
        $parent.after(selectImageHtmlWrapper);

        const selectImageWrapper = $(document).find('.bold_option_select_image');
        textArea.hide();

        $(document).on('change', 'select[name="properties[Add a wish card]"]', function (evt) {

          const $this = $(this);
          const $options = $this.find("option");


          $options.each(function () {
            const $selectedOption = $(this).is(":selected");

            if ( $selectedOption ) {
              if ( $(this)[0].value === 'Birthday Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/products/mockup-birthday-card-MOOD_2048x.jpg?v=1650461269'
              }
      // area to copy and edit *START*
              else if ( $(this)[0].value === 'Lots of Love Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/products/mockup-lostoflove-card-MOOD_2048x.jpg?v=1650461358'
              }

              else if ( $(this)[0].value === 'I Love Mom Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/products/mockup-moederdag-card-MOOD_2048x.jpg?v=1650460707'
              }

              else if ( $(this)[0].value === 'Congratulations Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_Congratulations_card.jpg?v=1662977797'
              }

              else if ( $(this)[0].value === 'Welcome Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_Welcome_card.jpg?v=1662977797'
              }

              else if ( $(this)[0].value === 'Bride Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_bride.png?v=1682674443'
              }

              else if ( $(this)[0].value === 'Valentine Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_ValentinesCard.png?v=1673931977'
              }

              else if ( $(this)[0].value === 'Christmas Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_christmas.jpg?v=1670183564'
              }

              else if ( $(this)[0].value === 'Happy Holidays Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_happyholidays.jpg?v=1670183564'
              }

              else if ( $(this)[0].value === 'Holidays Card' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_holidays.jpg?v=1701257573'
              }

              else if ( $(this)[0].value === 'A Gift for You' ) {
                selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_pets_giftforyou.jpg?v=1721316041'
              }  
   // area to copy and edit *END*
              else {
                selectImageUrl = null
              }


              let imageHtml = `<img width="150"
                                height="150"
                                src="${selectImageUrl}"
                                alt="Option image">`

              if ( selectImageUrl !== null && selectImageUrl !== undefined  ) {
                selectImageWrapper.closest('.bold_option_set').addClass('wishcard__inner');
                selectImageWrapper[0].innerHTML = imageHtml;
                selectImageWrapper.removeClass('hidden')
              } else {
                selectImageWrapper[0].innerHTML = '';
                selectImageWrapper.addClass('hidden');
                selectImageWrapper.closest('.bold_option_set').removeClass('wishcard__inner');
              }

              if ( $(this).attr("data-option_value_key") >= 0 ) {
                textArea.show();

              } else {
                textArea.hide();
              }
            }

          })


        })
      }

      /* Textarea */
      $(document).on('change keyup', '.bold_options .bold_option_textarea .bold_option_element > textarea', function() {
        var textarea = $(this);
        var textareaName = textarea.attr('name');
        var textareaValue = textarea.val();

        var textareaSpan = textarea.prev('.bold_option_textarea__text');

        if (!textareaSpan.length) {
          textarea.before('<span class="bold_option_textarea__text"></span>');
          var textareaSpan = textarea.next('.bold_option_textarea__text');
        }

        textareaSpan.html(textareaValue.replace(/(?:\r\n|\r|\n)/g, '<br>'));
        textarea.css('height', textareaSpan.outerHeight(true));

        if (textareaName == 'properties[Enter your personal message]') {
          var dropdown = $('.bold_options .bold_option_dropdown .bold_option_element > select[name="properties[Add a wish card]"]');

          if (dropdown.length) {
          var textareaSubtitle = textarea.siblings('.bold_option_textarea__subtitle');

            if (textareaValue.length && dropdown.val() != 'Choose a wish card') {
              textareaSubtitle.removeClass('hidden');

            } else {
              textareaSubtitle.addClass('hidden');
            }
          }
        }
      });
      /* /Textarea */













      /* Text */
      $(document).on('change keyup input', '.bold_options .bold_option_textbox .bold_option_element > input[type="text"], .bold_options .bold_option_textarea .bold_option_element > textarea', function() {
        var input = $(this);
        var inputName = input.attr('name');
        var inputValue = input.val().trim();

        if (typeof window.leOliveSyncEmbroideryChargeCheckboxes === 'function') {
          window.leOliveSyncEmbroideryChargeCheckboxes(
            (input.closest('form')[0]) || document.querySelector('.product-form') || document.querySelector('.bold_lightbox form')
          );
        } else {
          var checkbox = input.parents('.bold_option').prev('.bold_option_checkbox');

          if (checkbox.length) {
            var checkboxInput = checkbox.find('input[type="checkbox"]');

            if (inputValue.length > 0) {

              if (!checkboxInput.prop('checked')) {
                checkboxInput.addClass('enabled').click();
              }

            } else {

              if (checkboxInput.prop('checked')) {
                checkboxInput.addClass('enabled').click();
                checkboxInput.removeClass('enabled');
              }
            }
          }
          if (typeof window.leOliveRefreshProductOptionPrice === 'function') {
            window.leOliveRefreshProductOptionPrice(
              (input.closest('form')[0]) || document.querySelector('.product-form')
            );
          }
        }

        var formAlert = $('.product-form__alert');
        var addToCartBtn = $('.product-form .btn.addtocart');
        var newAddToCartBtn = $('#AddToCartNew');

        var activeOption = $('.product-form__options-wrapper .product-form__option.active');
        var activeOptionText = activeOption.text().trim();

        var productType = $('.product-form__header').attr('data-product-type');


//      ADDING ALERT_PROMPT NOTIFICATION

        if (/^properties\[Enter your personal message\]$/.test(inputName) && inputValue.length >= 150) {
          var alertMessageText = obj.t('You have now exceeded the maximum number of 150 characters. Shorten your text a bit!');
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the towel \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
        } else if (/^properties\[Embroidery on the slipper \(/.test(inputName) && /[^a-zA-Z\s]/.test(activeOptionText)  && inputValue.length >= 2) {
          var alertMessageText = 'You have reached the maximum limit of 2 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on bath capes \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on blankets \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on sheets \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on cuddle and pacifier cloths \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on pacifier \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');   

        } else if (/^properties\[Embroidery on cuddle \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on hydrophilic cloths \(/.test(inputName) && inputValue.length >= 12) {
           var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
           formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on care gift set \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on bath gift set \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on cuddle gift set \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on bath textiles \(/.test(inputName) && inputValue.length >= 8) {
           var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
           formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the bath textiles \(/.test(inputName) && inputValue.length >= 12) {
           var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
           formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the face mask \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the hat \(/.test(inputName) && inputValue.length >= 3) {
          var alertMessageText = 'You have reached the maximum limit of 3 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

       } else if (/^properties\[Embroidery on wallet \(/.test(inputName) && inputValue.length >= 3) {
          var alertMessageText = 'You have reached the maximum limit of 3 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on hat \(/.test(inputName) && inputValue.length >= 6) {
          var alertMessageText = 'You have reached the maximum limit of 6 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

       } else if (/^properties\[Embroidery on the headband \(/.test(inputName) && inputValue.length >= 3) {
          var alertMessageText = 'You have reached the maximum limit of 2 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

       } else if (/^properties\[Embroidery at the bottom \(/.test(inputName) && inputValue.length >= 9) {
           var alertMessageText = 'You have reached the maximum limit of 9 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
           formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on backpacks \(/.test(inputName) && inputValue.length >= 10) {
          var alertMessageText = 'You have reached the maximum limit of 10 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the bag \(/.test(inputName) && inputValue.length >= 10) {
          var alertMessageText = 'You have reached the maximum limit of 10 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the sleep mask \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

       } else if (/^properties\[FREE Embroidery on sleep mask \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery \(/.test(inputName) && inputValue.length >= 10) {
          var alertMessageText = 'You have reached the maximum limit of 10 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the chest \(/.test(inputName) && /^(1\-2|3\-4|5\-6|7\-8)\s/.test(activeOptionText) && inputValue.length >= 6) {
          var alertMessageText = 'You have reached the maximum limit of characters (letters & numbers): 6 characters for sizes 1-8years and 9 characters for sizes 9-12 years. Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the chest \(/.test(inputName) && /^(9\-10|11\-12)\s/.test(activeOptionText) && inputValue.length >= 9) {
          var alertMessageText = 'You have reached the maximum limit of characters (letters & numbers): 6 characters for sizes 1-8years and 9 characters for sizes 9-12 years. Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the chest \(/.test(inputName) && inputValue.length >= 9) {
          var alertMessageText = 'You have reached the maximum limit of 9 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Embroidery on the back \(/.test(inputName) && inputValue.length > 12) {
          var alertMessageText = 'You can add upon a maximum amount of 15 characters (letters & numbers), but we advise you to enter no more than 12 characters for the best result of the embroidery. Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Back Embroidery - second line \(\]$/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');

        } else if (/^properties\[Enter your personal message\]$/.test(inputName) && inputValue.length < 150) {
          formAlert.addClass('hidden');
          newAddToCartBtn.prop('disabled', false);
        } else if (/^properties\[Embroidery on the sleep mask - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          newAddToCartBtn.prop('disabled', true);
        }  else if (/^properties\[Personalise initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
        }  else if (/^properties\[Printing on label \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
        }  else if (/^properties\[Printing on leash \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);  
        } else if (/^properties\[Printing on poop bag holder \(/.test(inputName) && /[^a-zA-Z\s]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);    
        }  else if (/^properties\[Embroidery on laptop pouch \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
         }  else if (/^properties\[Embroidery on the slipper \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
         }  else if (/^properties\[Embroidery on the hat \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);

          }  else if (/^properties\[Embroidery on the headband \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
        } else if (/^properties\[Embroidery on sleeve - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
        } else if (
    /^properties\[Embroidery on the sleeve \(/.test(inputName) &&
    /[^A-Za-z0-9\s.\-&@*,'"-]/.test(inputValue)
) {
    var alertMessageText = 'Please use letters, numbers, and allowed symbols only.';
    formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
    addToCartBtn.prop('disabled', true);
    newAddToCartBtn.prop('disabled', true);
} else if (/^properties\[Embroidery on pillow - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
        } else if (/^properties\[Embroidery on pillow and mask - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);  
        } else if (/^properties\[Embroidery on scrunchie - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
            var alertMessageText = 'Please use letters only.';
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            addToCartBtn.prop('disabled', true);
            newAddToCartBtn.prop('disabled', true);
        } else if (inputValue.length && /^[a-zA-Z0-9\s\á\à\â\æ\ã\å\ā\ä\ë\ê\ē\ė\ę\é\è\î\ī\į\ì\í\ï\ô\ò\œ\ø\ō\õ\ó\ö\û\ù\ū\ú\ü\*\&\#\'\@\-\!\.]+$/i.test(inputValue)) {
          formAlert.addClass('hidden');
          newAddToCartBtn.prop('disabled', false);
        } else if (inputValue.length) {
          var alertMessageText = obj.t('Please use only: numbers, letters, . * & # @ - ! ');
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          newAddToCartBtn.prop('disabled', true);
        } else {
          formAlert.addClass('hidden');
          newAddToCartBtn.prop('disabled', false);
        }


        // disabled dot
        if (
                /^properties\[Embroidery on hat/.test(inputName) ||
                // /^properties\[Embroidery on the hat/.test(inputName) ||
                // /^properties\[Embroidery on the headband/.test(inputName) ||
                /^properties\[Embroidery on backpacks/.test(inputName) ||
                /^properties\[Embroidery on bracelet/.test(inputName)
//                /^properties\[Embroidery on the slipper/.test(inputName)
        ) {
          if (inputValue.length && /^[A-z0-9\s\á\à\â\æ\ã\å\ā\ä\ë\ê\ē\ė\ę\é\è\î\ī\į\ì\í\ï\ô\ò\œ\ø\ō\õ\ó\ö\û\ù\ū\ú\ü\*\&\#\'\@\-\!\.]+$/i.test(inputValue)) {
            formAlert.addClass('hidden');
            newAddToCartBtn.prop('disabled', false);

          } else if (inputValue.length) {
            var alertMessageText = obj.t('Please use only: numbers, letters, . * & # @ - !');
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            newAddToCartBtn.prop('disabled', true);
          } else {
            formAlert.addClass('hidden');
            newAddToCartBtn.prop('disabled', false);
          }
        }

        //only . and -

        // if (
        //         /^properties\[Embroidery on the sleeve/.test(inputName)
        // ) {
        //   if (inputValue.length && /^[0-9\-\. \-]+$/i.test(inputValue)) {
        //     formAlert.addClass('hidden');
        //     newAddToCartBtn.prop('disabled', false);

        //   } else if (inputValue.length) {
        //     var alertMessageText = obj.t('Please use only: numbers, "-" and "."');
        //     formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
        //     newAddToCartBtn.prop('disabled', true);
        //   } else {
        //     formAlert.addClass('hidden');
        //     newAddToCartBtn.prop('disabled', false);
        //   }
        // }

        // only numbers 0-9, + and -
        if (
                /^properties\[Embroidery on dog collar - number/.test(inputName) || 
                /^properties\[Embroidery on harness - number/.test(inputName) || 
                /^properties\[Embroidery on leash - number/.test(inputName)
        ) {
          if (inputValue.length && /^[0-9+-]+$/i.test(inputValue)) {
            formAlert.addClass('hidden');
            newAddToCartBtn.prop('disabled', false);

          } else if (inputValue.length) {
            var alertMessageText = obj.t('Please use + - and numbers only.');
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            newAddToCartBtn.prop('disabled', true);
          } else {
            formAlert.addClass('hidden');
            newAddToCartBtn.prop('disabled', false);
          }
        }
      });
      /* /Text */

      return productObj;
    };


    productObj.checkBoldColors = function() {
      var colorFields = $('.bold_options .bold_option_swatch > .bold_option_title');

      if (colorFields.length) {

        colorFields.each(function() {
          var colorField = $(this);

          if (!colorField.next('.bold_option_swatch__title').length) {

            if (colorField.text().trim() == 'Choose your print colour') {
              colorField.parents('.bold_option_swatch').addClass('medium-up--one-whole').addClass('large-up--one-half');
            }
             const keywords = ['font', 'borduurlettertype', 'Stickschrift', 'fuente', 'police' , 'la police'];
            if (keywords.some(keyword => colorField.text().trim().includes(keyword))){
                colorField.parents('.bold_option_swatch').addClass('bold_option_font_swatch');
            }

            colorField.after(
              '<div class="bold_option_swatch__title">' +
              '<i></i>' +
              '<span></span>' +
              '</div>'
            );

            var colors = $('.product-form .bold_option_swatch > .bold_option_element > .bold_option_value');

            var newColorField = $('.product-single__form-option[data-option-type="color"]');
            var colorFieldTitleText = colorField.children('.bold_option_title').text().trim();

            var newColorTitle = newColorField.children('.product-single__form-option__title');
            newColorTitle.text(colorFieldTitleText);

            var newColorSelector = newColorField.children('.product-single__form-option__selector');
            var newColors = newColorField.children('.product-single__form-option__colors');

            colors.each(function(colorI) {
              var color = $(this);

              var colorBg = color.find('.bold_option_value_swatch > span').css('backgroundColor');
              var colorValue = color.find('.bold_option_value_element > input').val();

              var newColorText = obj.t(colorValue);
              color.attr('data-color', newColorText);

              var colorLabel = color.find(' > label > .bold_option_swatch_title > .bold_option_value_title');
              colorLabel.text(newColorText);

              newColors.append(
                '<span class="product-single__form-option__color">' +
                '<i style="background: ' + colorBg + '"></i>' +
                '<span>' + newColorText + '</span>' +
                '</span>'
              );
            });
          }
        });
      }

      return productObj;
    };

    productObj.validForm = function(submitForm, fieldForm) {
      var originalBtn = $('.product-single__cart-submit-wrapper > button[id="AddToCart"].bold_clone:first');

      if (!originalBtn.length) {
        var originalBtn = $('.product-single__cart-submit-wrapper > button[id="AddToCart"]:first');
      }

      if (!originalBtn.attr('data-clicked')) {
        var btn = $('#AddToCartNew');
        var alert = $('.product-form__alert');

        if (alert.length) {
          alert.addClass('hidden').html('');
        }

        var form = $('.product-form');

        var tShirtDesignField = $('.product-form .bold_option input[name="properties[Design Options]"]');

        if (tShirtDesignField.length) {
          var tShirtDesignFieldValue = $('.product-form .bold_option input[name="properties[Design Options]"]:checked');

          if (tShirtDesignFieldValue.length) {

            var tShirtTextField = $(document).find('.bold_option_textbox input[name^="properties[Text on the t-shirt]"]')
            if (tShirtTextField.length) {
              var tShirtTextFieldValue = tShirtTextField.val().trim();
            }
            var tShirtText2Field = $(document).find('.bold_option_textbox input[name^="properties[Text on the t-shirt - second line]"]')
            if (tShirtText2Field.length) {
              var tShirtText2FieldValue = tShirtText2Field.val().trim();
            }
            var tShirtText3Field = $(document).find('.bold_option_textbox input[name^="properties[Text on the t-shirt - third line]"]')
            if (tShirtText3Field.length) {
              var tShirtText3FieldValue = tShirtText3Field.val().trim();
            }

            if (tShirtTextField.length && !tShirtTextFieldValue.length ||
                    tShirtText2Field.length && !tShirtText2FieldValue.length
            ) {
              var alertMessageText = obj.t('Please add text on t-shirt.');
              alert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            }



            var tShirtColorFields = $('.t-shirt-options').find('.bold_option_swatch:not(.bold_option_hidden)');

            tShirtColorFields.each(function () {
                var title = $(this).find('.bold_option_swatch__title').text();
                if ( !title.length ) {

                  if ($('.bold_option_value_element input[value="Custom Design"]:checked').length) {
                    var alertMessageText = obj.t('Please choose a font and color options.');
                    alert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
                  } else {
                    var alertMessageText = obj.t('Please choose a fixed design and color options.');
                    alert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
                  }
                }
            })
          } else {
            var alertMessageText = obj.t('You cannot order this item unpersonalised, so choose a design option.');
            alert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          }
        }



        var leatherField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Personalise initials ("]');

        if (leatherField.length) {
          var leatherFieldValue = leatherField.val().trim();
        }
//
        var iphoneleatherField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Personalise Initials ("]');

        if (iphoneleatherField.length) {
          var iphoneleatherFieldValue = iphoneleatherField.val().trim();
        }
//
        var chestField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the chest ("]');

        if (chestField.length) {
          var chestFieldValue = chestField.val().trim();
        }
//
        var gloveField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the glove ("]');

        if (gloveField.length) {
          var gloveFieldValue = gloveField.val().trim();
        }
//

//
        var glovekidsField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the glove - kids ("]');

        if (glovekidsField.length) {
          var glovekidsFieldValue = glovekidsField.val().trim();
        }
//

        var backField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the back ("]');

        if (backField.length) {
          var backFieldValue = backField.val().trim();
        }

        var backSecondField = $('.product-form .bold_option_element > input[type="text"][name="properties[Back Embroidery - second line]"]');

        if (backSecondField.length) {
          var backSecondFieldValue = backSecondField.val().trim();
        }

        var faceMaskField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the face mask ("]');

        if (faceMaskField.length) {
          var faceMaskFieldValue = faceMaskField.val().trim();
        }

        var chairEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on chair ("]');

        if (chairEmbroideryField.length) {
          var chairEmbroideryFieldValue = chairEmbroideryField.val().trim();
        }
        
        var hatEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the hat ("]');

        if (hatEmbroideryField.length) {
          var hatEmbroideryFieldValue = hatEmbroideryField.val().trim();
        }

        var hatv2EmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on hat ("]');

        if (hatv2EmbroideryField.length) {
          var hatv2EmbroideryFieldValue = hatv2EmbroideryField.val().trim();
        }

        var sunhatEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sun hat ("]');

        if (sunhatEmbroideryField.length) {
          var sunhatEmbroideryFieldValue = sunhatEmbroideryField.val().trim();
        }

        var headbandEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the headband ("]');

        if (headbandEmbroideryField.length) {
          var headbandEmbroideryFieldValue = headbandEmbroideryField.val().trim();
        }

        var bottomEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery at the bottom ("]');

        if (bottomEmbroideryField.length) {
          var bottomEmbroideryFieldValue = bottomEmbroideryField.val().trim();
        }

        var beltEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the belt ("]');

        if (beltEmbroideryField.length) {
          var beltEmbroideryFieldValue = beltEmbroideryField.val().trim();
        }

        var sleeveEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the sleeve ("]');

        if (sleeveEmbroideryField.length) {
          var sleeveEmbroideryFieldValue = sleeveEmbroideryField.val().trim();
        }

        var sleeveinitialsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sleeve - initials ("]');

        if (sleeveinitialsEmbroideryField.length) {
          var sleeveinitialsEmbroideryFieldValue = sleeveinitialsEmbroideryField.val().trim();
        }

        var sleeveinitials3EmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sleeve - initials 3 ("]');

        if (sleeveinitials3EmbroideryField.length) {
          var sleeveinitials3EmbroideryFieldValue = sleeveinitials3EmbroideryField.val().trim();
        }

        var scrunchieinitialsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on scrunchie - initials ("]');

        if (scrunchieinitialsEmbroideryField.length) {
          var scrunchieinitialsEmbroideryFieldValue = scrunchieinitialsEmbroideryField.val().trim();
        }

        var slipperEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the slipper ("]');

        if (slipperEmbroideryField.length) {
          var slipperEmbroideryFieldValue = slipperEmbroideryField.val().trim();
        }

        var bathtextilesEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bath textiles ("]');

        if (bathtextilesEmbroideryField.length) {
          var bathtextilesEmbroideryFieldValue = bathtextilesEmbroideryField.val().trim();
        }

        var thebathtextilesEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the bath textiles ("]');

        if (thebathtextilesEmbroideryField.length) {
          var thebathtextilesEmbroideryFieldValue = thebathtextilesEmbroideryField.val().trim();
        }

        var backpacksEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on backpacks ("]');

        if (backpacksEmbroideryField.length) {
          var backpacksEmbroideryFieldValue = backpacksEmbroideryField.val().trim();
        }

        var bagEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the bag ("]');

        if (bagEmbroideryField.length) {
          var bagEmbroideryFieldValue = bagEmbroideryField.val().trim();
        }

        var mittensEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on mittens ("]');

        if (mittensEmbroideryField.length) {
          var mittensEmbroideryFieldValue = mittensEmbroideryField.val().trim();
        }

        var scarfEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on scarf ("]');

        if (scarfEmbroideryField.length) {
          var scarfEmbroideryFieldValue = scarfEmbroideryField.val().trim();
        }

        var scarfinitialsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on scarf - initials ("]');

        if (scarfinitialsEmbroideryField.length) {
          var scarfinitialsEmbroideryFieldValue = scarfinitialsEmbroideryField.val().trim();
        }

        var veilEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on veil ("]');

        if (veilEmbroideryField.length) {
          var veilEmbroideryFieldValue = veilEmbroideryField.val().trim();
        }

        var frontbagEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on front ("]');

        if (frontbagEmbroideryField.length) {
          var frontbagEmbroideryFieldValue = frontbagEmbroideryField.val().trim();
        }

        var pouchEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pouch ("]');

        if (pouchEmbroideryField.length) {
          var pouchEmbroideryFieldValue = pouchEmbroideryField.val().trim();
        }

        var pouchv2EmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pouch v2 ("]');

        if (pouchv2EmbroideryField.length) {
          var pouchv2EmbroideryFieldValue = pouchv2EmbroideryField.val().trim();
        }

        var laptoppouchEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on laptop pouch ("]');

        if (laptoppouchEmbroideryField.length) {
          var laptoppouchEmbroideryFieldValue = laptoppouchEmbroideryField.val().trim();
        }

        var makeuppouchEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on make-up bag ("]');

        if (makeuppouchEmbroideryField.length) {
          var makeuppouchEmbroideryFieldValue = makeuppouchEmbroideryField.val().trim();
        }

        var toilettasEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on toiletry bag ("]');

        if (toilettasEmbroideryField.length) {
          var toilettasEmbroideryFieldValue = toilettasEmbroideryField.val().trim();
        }

        var changingmatEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the changing mat ("]');

        if (changingmatEmbroideryField.length) {
          var changingmatEmbroideryFieldValue = changingmatEmbroideryField.val().trim();
        }

        var braceletEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bracelet ("]');

        if (braceletEmbroideryField.length) {
          var braceletEmbroideryFieldValue = braceletEmbroideryField.val().trim();
        }

        var cardiganEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cardigan ("]');

        if (cardiganEmbroideryField.length) {
          var cardiganEmbroideryFieldValue = cardiganEmbroideryField.val().trim();
        }

        var footmuffEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on footmuff ("]');

        if (footmuffEmbroideryField.length) {
          var footmuffEmbroideryFieldValue = footmuffEmbroideryField.val().trim();
        }

        var storagebagEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on storage bag ("]');

        if (storagebagEmbroideryField.length) {
          var storagebagEmbroideryFieldValue = storagebagEmbroideryField.val().trim();
        }

        var beanieEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on beanie ("]');

        if (beanieEmbroideryField.length) {
          var beanieEmbroideryFieldValue = beanieEmbroideryField.val().trim();
        }

        var bibEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bib ("]');

        if (bibEmbroideryField.length) {
          var bibEmbroideryFieldValue = bibEmbroideryField.val().trim();
        }

        var frontEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the front ("]');

        if (frontEmbroideryField.length) {
          var frontEmbroideryFieldValue = frontEmbroideryField.val().trim();
        }

        var babysuitEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on baby suit ("]');

        if (babysuitEmbroideryField.length) {
          var babysuitEmbroideryFieldValue = babysuitEmbroideryField.val().trim();
        }

        var selectbabysuitEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the baby suit ("]');

        if (selectbabysuitEmbroideryField.length) {
          var selectbabysuitEmbroideryFieldValue = selectbabysuitEmbroideryField.val().trim();
        }

        var teddyfrontEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on teddy front ("]');

        if (teddyfrontEmbroideryField.length) {
          var teddyfrontEmbroideryFieldValue = teddyfrontEmbroideryField.val().trim();
        }

        var shopperEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on shopper ("]');

        if (shopperEmbroideryField.length) {
          var shopperEmbroideryFieldValue = shopperEmbroideryField.val().trim();
        }

        var coverEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cover ("]');

        if (coverEmbroideryField.length) {
          var coverEmbroideryFieldValue = coverEmbroideryField.val().trim();
        }

        var walletEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on wallet ("]');

        if (walletEmbroideryField.length) {
          var walletEmbroideryFieldValue = walletEmbroideryField.val().trim();
        }

        var socksEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sock ("]');

        if (socksEmbroideryField.length) {
          var socksEmbroideryFieldValue = socksEmbroideryField.val().trim();
        }

        var bathcapesEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bath capes ("]');

        if (bathcapesEmbroideryField.length) {
          var bathcapesEmbroideryFieldValue = bathcapesEmbroideryField.val().trim();
        }

        var ponchoEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on poncho ("]');

        if (ponchoEmbroideryField.length) {
          var ponchoEmbroideryFieldValue = ponchoEmbroideryField.val().trim();
        }

        var blanketsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on blankets ("]');

        if (blanketsEmbroideryField.length) {
          var blanketsEmbroideryFieldValue = blanketsEmbroideryField.val().trim();
        }

        var sleepmaskinitialsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on the sleep mask - initials ("]');

        if (sleepmaskinitialsEmbroideryField.length) {
          var sleepmaskinitialsEmbroideryFieldValue = sleepmaskinitialsEmbroideryField.val().trim();
        }

        var pillowinitialsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pillow - initials ("]');

        if (pillowinitialsEmbroideryField.length) {
          var pillowinitialsEmbroideryFieldValue = pillowinitialsEmbroideryField.val().trim();
        }

        var pillownameEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pillow - name ("]');

        if (pillownameEmbroideryField.length) {
          var pillownameEmbroideryFieldValue = pillownameEmbroideryField.val().trim();
        }

        var pillowmaskinitialsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pillow and mask - initials ("]');

        if (pillowmaskinitialsEmbroideryField.length) {
          var pillowmaskinitialsEmbroideryFieldValue = pillowmaskinitialsEmbroideryField.val().trim();
        }



        var sheetsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on sheets ("]');

        if (sheetsEmbroideryField.length) {
          var sheetsEmbroideryFieldValue = sheetsEmbroideryField.val().trim();
        }

        var clothsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cuddle and pacifier cloths ("]');

        if (clothsEmbroideryField.length) {
          var clothsEmbroideryFieldValue = clothsEmbroideryField.val().trim();
        }

        var pacifierEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on pacifier ("]');

        if (pacifierEmbroideryField.length) {
          var pacifierEmbroideryFieldValue = pacifierEmbroideryField.val().trim();
        }

        var cuddleEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cuddle ("]');

        if (cuddleEmbroideryField.length) {
          var cuddleEmbroideryFieldValue = cuddleEmbroideryField.val().trim();
        }

        var hydrophilicclothsEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on hydrophilic cloths ("]');

        if (hydrophilicclothsEmbroideryField.length) {
          var hydrophilicclothsEmbroideryFieldValue = hydrophilicclothsEmbroideryField.val().trim();
        }

        var caregiftsetEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on care gift set ("]');

        if (caregiftsetEmbroideryField.length) {
          var caregiftsetEmbroideryFieldValue = caregiftsetEmbroideryField.val().trim();
        }

        var cuddlegiftsetEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cuddle gift set ("]');

        if (cuddlegiftsetEmbroideryField.length) {
          var cuddlegiftsetEmbroideryFieldValue = cuddlegiftsetEmbroideryField.val().trim();
        }

        var bathgiftsetEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on bath gift set ("]');

        if (bathgiftsetEmbroideryField.length) {
          var bathgiftsetEmbroideryFieldValue = bathgiftsetEmbroideryField.val().trim();
        }

        var sleepMaskField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the sleep mask ("]');

        if (sleepMaskField.length) {
          var sleepMaskFieldValue = sleepMaskField.val().trim();
        }

        var tangaEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on tanga ("]');

        if (tangaEmbroideryField.length) {
          var tangaEmbroideryFieldValue = tangaEmbroideryField.val().trim();
        }

        var catcollarEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on cat collar ("]');

        if (catcollarEmbroideryField.length) {
          var catcollarEmbroideryFieldValue = catcollarEmbroideryField.val().trim();
        }

        var dogcollarnameEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on dog collar - name ("]');

        if (dogcollarnameEmbroideryField.length) {
          var dogcollarnameEmbroideryFieldValue = dogcollarnameEmbroideryField.val().trim();
        }

        var dogcollarnumEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on dog collar - number ("]');

        if (dogcollarnumEmbroideryField.length) {
          var dogcollarnumEmbroideryFieldValue = dogcollarnumEmbroideryField.val().trim();
        }

        var harnessnameEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on harness - name ("]');

        if (harnessnameEmbroideryField.length) {
          var harnessnameEmbroideryFieldValue = harnessnameEmbroideryField.val().trim();
        }

        var harnessnumEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on harness - number ("]');

        if (harnessnumEmbroideryField.length) {
          var harnessnumEmbroideryFieldValue = harnessnumEmbroideryField.val().trim();
        }

        var leashnameEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on leash - name ("]');

        if (leashnameEmbroideryField.length) {
          var leashnameEmbroideryFieldValue = leashnameEmbroideryField.val().trim();
        }

        var leashnumEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on leash - number ("]');

        if (leashnumEmbroideryField.length) {
          var leashnumEmbroideryFieldValue = leashnumEmbroideryField.val().trim();
        }

        var poopbagEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on poop bag holder ("]');

        if (poopbagEmbroideryField.length) {
          var poopbagEmbroideryFieldValue = poopbagEmbroideryField.val().trim();
        }

        var dogcushionEmbroideryField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Embroidery on dog cushion ("]');

        if (dogcushionEmbroideryField.length) {
          var dogcushionEmbroideryFieldValue = dogcushionEmbroideryField.val().trim();
        }

        var labelPrintInputField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Printing on label ("]');

        if (labelPrintInputField.length) {
          var labelPrintInputFieldValue = labelPrintInputField.val().trim();
        }

        var leashPrintInputField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Printing on leash ("]');

        if (leashPrintInputField.length) {
          var leashPrintInputFieldValue = leashPrintInputField.val().trim();
        }

        var poopbagPrintInputField = $('.product-form .bold_option_textbox .bold_option_element input[type="text"][name^="properties[Printing on poop bag holder ("]');

        if (poopbagPrintInputField.length) {
          var poopbagPrintInputFieldValue = poopbagPrintInputField.val().trim();
        }



        var towelField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the towel ("]');

        if (towelField.length) {
          var towelFieldValue = towelField.val().trim();
        }

        var freeMaskField = $('.product-form .bold_option_element > input[type="text"][name^="properties[FREE Embroidery on sleep mask]"]');

        if (freeMaskField.length) {
          var freeMaskFieldValue = freeMaskField.val().trim();
          var freeMaskColorValue = freeMaskField.closest('.bold_option_set').find('.bold_option_swatch .bold_option_swatch__title > i + span').text();
          var freeMaskCheckbox = freeMaskField.closest('.bold_option_set').find('.bold_option_radio input[value="Yes"]');

        }

        var stockingField = $('.product-form .bold_option_element > input[type="text"][name^="properties[Embroidery on the stocking ("]');

        if (stockingField.length) {
          var stockingFieldValue = stockingField.val().trim();
        }

        var isSwatchChosen = function($swatch) {
          if (!$swatch || !$swatch.length) return false;
          var $title = $swatch.find('.bold_option_swatch__title').first();
          var titleText = ($title.find('span').first().text() || '').trim();
          var titleLooksReal = titleText.length > 0 && !/^(choose|kies |elija|choisissez|wählen|please choose)/i.test(titleText);
          if ($title.attr('data-user-picked') === '1' && titleLooksReal) return true;
          if (
            $swatch.find('.bold_option_value.active, .bold_option_value.visually_active, .bold_option_value_element.bold_swatch_selected').length &&
            titleLooksReal
          ) return true;
          var hiddenVal = ($swatch.find('input[type="hidden"][name^="properties["]').filter(function() {
            return !/^properties\[_/.test(this.name || '');
          }).first().val() || '').trim();
          return hiddenVal.length > 0 && !/^(on|true|false)$/i.test(hiddenVal);
        };

        var colorSwatches = $('.product-form .bold_option_swatch:not(.bold_option_font_swatch)');
        var colorChosen = false;
        colorSwatches.each(function() {
          if (isSwatchChosen($(this))) colorChosen = true;
        });

        var newColorTitle = colorSwatches.find('.bold_option_swatch__title > span');

        if (newColorTitle.length) {

          if ((leatherField.length && leatherFieldValue.length) ||
             (labelPrintInputField.length && labelPrintInputFieldValue.length) || 
             (leashPrintInputField.length && leashPrintInputFieldValue.length) || 
             (poopbagPrintInputField.length && poopbagPrintInputFieldValue.length) ||  
             (iphoneleatherField.length && iphoneleatherFieldValue.length)) {

            if (!colorChosen) {
              var alertMessageText = obj.t('Choose a colour for the print.');
              alert.append('<p>' + alertMessageText + '</p>').removeClass('hidden');
            }

          } else if ((chestField.length && chestFieldValue.length) ||
                  (backField.length && backFieldValue.length) ||
                  (gloveField.length && gloveFieldValue.length) ||
                  (glovekidsField.length && glovekidsFieldValue.length) ||
                  (chairEmbroideryField.length && chairEmbroideryFieldValue.length) ||   
                  (hatEmbroideryField.length && hatEmbroideryFieldValue.length) ||
                  (hatv2EmbroideryField.length && hatv2EmbroideryFieldValue.length) ||
                  (sunhatEmbroideryField.length && sunhatEmbroideryFieldValue.length) ||   
                  (beltEmbroideryField.length && beltEmbroideryFieldValue.length) ||
                  (sleeveEmbroideryField.length && sleeveEmbroideryFieldValue.length) ||
                  (sleeveinitialsEmbroideryField.length && sleeveinitialsEmbroideryFieldValue.length) ||
                  (sleeveinitials3EmbroideryField.length && sleeveinitials3EmbroideryFieldValue.length) ||
                  (scrunchieinitialsEmbroideryField.length && scrunchieinitialsEmbroideryFieldValue.length) ||
                  (bathtextilesEmbroideryField.length && bathtextilesEmbroideryFieldValue.length) ||
                  (thebathtextilesEmbroideryField.length && thebathtextilesEmbroideryFieldValue.length) ||
                  (backpacksEmbroideryField.length && backpacksEmbroideryFieldValue.length) ||
                  (bagEmbroideryField.length && bagEmbroideryFieldValue.length) ||
                  (mittensEmbroideryField.length && mittensEmbroideryFieldValue.length) ||
                  (scarfEmbroideryField.length && scarfEmbroideryFieldValue.length) ||
                  (scarfinitialsEmbroideryField.length && scarfinitialsEmbroideryFieldValue.length) ||   
                  (veilEmbroideryField.length && veilEmbroideryFieldValue.length) ||   
                  (frontbagEmbroideryField.length && frontbagEmbroideryFieldValue.length) ||
                  (pouchEmbroideryField.length && pouchEmbroideryFieldValue.length) ||
                  (pouchv2EmbroideryField.length && pouchv2EmbroideryFieldValue.length) ||
                  (laptoppouchEmbroideryField.length && laptoppouchEmbroideryFieldValue.length) ||
                  (makeuppouchEmbroideryField.length && makeuppouchEmbroideryFieldValue.length) ||
                  (toilettasEmbroideryField.length && toilettasEmbroideryFieldValue.length) ||
                  (changingmatEmbroideryField.length && changingmatEmbroideryFieldValue.length) ||   
                  (braceletEmbroideryField.length && braceletEmbroideryFieldValue.length) ||
                  (cardiganEmbroideryField.length && cardiganEmbroideryFieldValue.length) ||
                  (beanieEmbroideryField.length && beanieEmbroideryFieldValue.length) ||
                  (bibEmbroideryField.length && bibEmbroideryFieldValue.length) ||
                  (frontEmbroideryField.length && frontEmbroideryFieldValue.length) ||
                  (babysuitEmbroideryField.length && babysuitEmbroideryFieldValue.length) ||
                  (selectbabysuitEmbroideryField.length && selectbabysuitEmbroideryFieldValue.length) ||
                  (teddyfrontEmbroideryField.length && teddyfrontEmbroideryFieldValue.length) ||
                  (shopperEmbroideryField.length && shopperEmbroideryFieldValue.length) ||   
                  (coverEmbroideryField.length && coverEmbroideryFieldValue.length) ||
                  (walletEmbroideryField.length && walletEmbroideryFieldValue.length) ||
                  (socksEmbroideryField.length && socksEmbroideryFieldValue.length) ||
                  (bathcapesEmbroideryField.length && bathcapesEmbroideryFieldValue.length) ||
                  (ponchoEmbroideryField.length && ponchoEmbroideryFieldValue.length) ||   
                  (blanketsEmbroideryField.length && blanketsEmbroideryFieldValue.length) ||
                  (sleepmaskinitialsEmbroideryField.length && sleepmaskinitialsEmbroideryFieldValue.length) ||
                  (pillowinitialsEmbroideryField.length && pillowinitialsEmbroideryFieldValue.length) ||
                  (pillownameEmbroideryField.length && pillownameEmbroideryFieldValue.length) ||
                  (pillowmaskinitialsEmbroideryField.length && pillowmaskinitialsEmbroideryFieldValue.length) ||   
                  (sheetsEmbroideryField.length && sheetsEmbroideryFieldValue.length) ||
                  (clothsEmbroideryField.length && clothsEmbroideryFieldValue.length) ||
                  (pacifierEmbroideryField.length && pacifierEmbroideryFieldValue.length) ||   
                  (cuddleEmbroideryField.length && cuddleEmbroideryFieldValue.length) ||
                  (hydrophilicclothsEmbroideryField.length && hydrophilicclothsEmbroideryFieldValue.length) ||
                  (caregiftsetEmbroideryField.length && caregiftsetEmbroideryFieldValue.length) ||
                  (cuddlegiftsetEmbroideryField.length && cuddlegiftsetEmbroideryFieldValue.length) ||
                  (bathgiftsetEmbroideryField.length && bathgiftsetEmbroideryFieldValue.length) ||
                  (slipperEmbroideryField.length && slipperEmbroideryFieldValue.length) ||
                  (footmuffEmbroideryField.length && footmuffEmbroideryFieldValue.length) ||
                  (storagebagEmbroideryField.length && storagebagEmbroideryFieldValue.length) ||
                  (backSecondField.length && backSecondFieldValue.length) ||
                  (faceMaskField.length && faceMaskFieldValue.length) ||
                  (sleepMaskField.length && sleepMaskFieldValue.length) ||
                  (towelField.length && towelFieldValue.length) ||
                  (headbandEmbroideryField.length && headbandEmbroideryFieldValue.length) ||
                  (bottomEmbroideryField.length && bottomEmbroideryFieldValue.length) ||
                  (tangaEmbroideryField.length && tangaEmbroideryFieldValue.length) ||   
                  (catcollarEmbroideryField.length && catcollarEmbroideryFieldValue.length) ||
                  (dogcollarnameEmbroideryField.length && dogcollarnameEmbroideryFieldValue.length) ||  
                  (dogcollarnumEmbroideryField.length && dogcollarnumEmbroideryFieldValue.length) ||  
                  (harnessnameEmbroideryField.length && harnessnameEmbroideryFieldValue.length) || 
                  (harnessnumEmbroideryField.length && harnessnumEmbroideryFieldValue.length) || 
                  (leashnameEmbroideryField.length && leashnameEmbroideryFieldValue.length) || 
                  (leashnumEmbroideryField.length && leashnumEmbroideryFieldValue.length) ||  
                  (poopbagEmbroideryField.length && poopbagEmbroideryFieldValue.length) ||
                  (dogcushionEmbroideryField.length && dogcushionEmbroideryFieldValue.length) ||   
                  (stockingField.length && stockingFieldValue.length)) {

            if (!colorChosen) {
              var alertMessageText = obj.t('Choose a colour for the embroidery.');
              alert.append('<p>' + alertMessageText + '</p>').removeClass('hidden');
            }

          }

          if ((freeMaskField.length && freeMaskFieldValue.length)) {
            if (!freeMaskColorValue.length) {
              var alertMessageText = obj.t('Choose a colour for the embroidery.');
              alert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            }
          }
        }

        var newFontTitle = $('.bold_option_swatch.bold_option_font_swatch .bold_option_swatch__title > span');
        var hasAssignedEmbroideryFont = $('.product-form input[name="properties[Make-up bag Embroidery font]"], .product-form input[name="properties[Embroidery font]"], .product-form input[name="properties[Gloves Embroidery font]"], .product-form input[name="properties[Apron Embroidery font]"], .product-form input[name="properties[Hat Embroidery font]"]').filter(function () {
          return String($(this).val() || '').trim().length > 0;
        }).length > 0;

        if (newFontTitle.length && !hasAssignedEmbroideryFont) {

          if ((leatherField.length && leatherFieldValue.length) ||
             (labelPrintInputField.length && labelPrintInputFieldValue.length) || 
             (leashPrintInputField.length && leashPrintInputFieldValue.length) || 
             (poopbagPrintInputField.length && poopbagPrintInputFieldValue.length) || 
             (iphoneleatherField.length && iphoneleatherFieldValue.length)) {
            var newFontTitleText = newFontTitle.text().trim();

            if (!newFontTitleText.length) {
              var alertMessageText = obj.t('Please choose embroidery font.');
              alert.append('<p>' + alertMessageText + '</p>').removeClass('hidden');
            }

          } else if ((chestField.length && chestFieldValue.length) ||
                  (backField.length && backFieldValue.length) ||
                  (gloveField.length && gloveFieldValue.length) ||
                  (chairEmbroideryField.length && chairEmbroideryFieldValue.length) ||  
                  (hatEmbroideryField.length && hatEmbroideryFieldValue.length) ||
                  (hatv2EmbroideryField.length && hatv2EmbroideryFieldValue.length) ||
                  (sunhatEmbroideryField.length && sunhatEmbroideryFieldValue.length) ||   
                  (beltEmbroideryField.length && beltEmbroideryFieldValue.length) ||
                  (sleeveEmbroideryField.length && sleeveEmbroideryFieldValue.length) ||
                  (sleeveinitialsEmbroideryField.length && sleeveinitialsEmbroideryFieldValue.length) ||
                  (sleeveinitials3EmbroideryField.length && sleeveinitials3EmbroideryFieldValue.length) ||
                  (scrunchieinitialsEmbroideryField.length && scrunchieinitialsEmbroideryFieldValue.length) ||
                  (bathtextilesEmbroideryField.length && bathtextilesEmbroideryFieldValue.length) ||
                  (thebathtextilesEmbroideryField.length && thebathtextilesEmbroideryFieldValue.length) ||
                  (backpacksEmbroideryField.length && backpacksEmbroideryFieldValue.length) ||
                  (bagEmbroideryField.length && bagEmbroideryFieldValue.length) ||
                  (mittensEmbroideryField.length && mittensEmbroideryFieldValue.length) ||
                  (scarfEmbroideryField.length && scarfEmbroideryFieldValue.length) ||
                  (scarfinitialsEmbroideryField.length && scarfinitialsEmbroideryFieldValue.length) || 
                  (veilEmbroideryField.length && veilEmbroideryFieldValue.length) ||   
                  (frontbagEmbroideryField.length && frontbagEmbroideryFieldValue.length) ||
                  (pouchEmbroideryField.length && pouchEmbroideryFieldValue.length) ||
                  (pouchv2EmbroideryField.length && pouchv2EmbroideryFieldValue.length) ||
                  (laptoppouchEmbroideryField.length && laptoppouchEmbroideryFieldValue.length) ||
                  (makeuppouchEmbroideryField.length && makeuppouchEmbroideryFieldValue.length) ||
                  (toilettasEmbroideryField.length && toilettasEmbroideryFieldValue.length) ||
                  (changingmatEmbroideryField.length && changingmatEmbroideryFieldValue.length) ||
                  (braceletEmbroideryField.length && braceletEmbroideryFieldValue.length) ||
                  (cardiganEmbroideryField.length && cardiganEmbroideryFieldValue.length) ||
                  (beanieEmbroideryField.length && beanieEmbroideryFieldValue.length) ||
                  (bibEmbroideryField.length && bibEmbroideryFieldValue.length) ||
                  (frontEmbroideryField.length && frontEmbroideryFieldValue.length) ||
                  (babysuitEmbroideryField.length && babysuitEmbroideryFieldValue.length) ||
                  (selectbabysuitEmbroideryField.length && selectbabysuitEmbroideryFieldValue.length) ||
                  (teddyfrontEmbroideryField.length && teddyfrontEmbroideryFieldValue.length) ||
                  (shopperEmbroideryField.length && shopperEmbroideryFieldValue.length) ||   
                  (coverEmbroideryField.length && coverEmbroideryFieldValue.length) ||
                  (walletEmbroideryField.length && walletEmbroideryFieldValue.length) ||
                  (socksEmbroideryField.length && socksEmbroideryFieldValue.length) ||
                  (bathcapesEmbroideryField.length && bathcapesEmbroideryFieldValue.length) ||
                  (ponchoEmbroideryField.length && ponchoEmbroideryFieldValue.length) ||   
                  (blanketsEmbroideryField.length && blanketsEmbroideryFieldValue.length) ||
                  (sleepmaskinitialsEmbroideryField.length && sleepmaskinitialsEmbroideryFieldValue.length) ||
                  (pillowinitialsEmbroideryField.length && pillowinitialsEmbroideryFieldValue.length) ||
                  (pillowmaskinitialsEmbroideryField.length && pillowmaskinitialsEmbroideryFieldValue.length) ||
                  (pillownameEmbroideryField.length && pillownameEmbroideryFieldValue.length) ||
                  (sheetsEmbroideryField.length && sheetsEmbroideryFieldValue.length) ||
                  (clothsEmbroideryField.length && clothsEmbroideryFieldValue.length) ||
                  (pacifierEmbroideryField.length && pacifierEmbroideryFieldValue.length) ||   
                  (cuddleEmbroideryField.length && cuddleEmbroideryFieldValue.length) ||
                  (hydrophilicclothsEmbroideryField.length && hydrophilicclothsEmbroideryFieldValue.length) ||
                  (caregiftsetEmbroideryField.length && caregiftsetEmbroideryFieldValue.length) ||
                  (cuddlegiftsetEmbroideryField.length && cuddlegiftsetEmbroideryFieldValue.length) ||
                  (bathgiftsetEmbroideryField.length && bathgiftsetEmbroideryFieldValue.length) ||
                  (slipperEmbroideryField.length && slipperEmbroideryFieldValue.length) ||
                  (footmuffEmbroideryField.length && footmuffEmbroideryFieldValue.length) ||
                  (storagebagEmbroideryField.length && storagebagEmbroideryFieldValue.length) ||
                  (backSecondField.length && backSecondFieldValue.length) ||
                  (faceMaskField.length && faceMaskFieldValue.length) ||
                  (sleepMaskField.length && sleepMaskFieldValue.length) ||
                  (towelField.length && towelFieldValue.length) ||
                  (headbandEmbroideryField.length && headbandEmbroideryFieldValue.length) ||
                  (bottomEmbroideryField.length && bottomEmbroideryFieldValue.length) ||
                  (tangaEmbroideryField.length && tangaEmbroideryFieldValue.length) ||   
                  (catcollarEmbroideryField.length && catcollarEmbroideryFieldValue.length) ||
                  (dogcollarnameEmbroideryField.length && dogcollarnameEmbroideryFieldValue.length) ||  
                  (dogcollarnumEmbroideryField.length && dogcollarnumEmbroideryFieldValue.length) ||  
                  (harnessnameEmbroideryField.length && harnessnameEmbroideryFieldValue.length) || 
                  (harnessnumEmbroideryField.length && harnessnumEmbroideryFieldValue.length) || 
                  (leashnameEmbroideryField.length && leashnameEmbroideryFieldValue.length) || 
                  (leashnumEmbroideryField.length && leashnumEmbroideryFieldValue.length) ||  
                  (poopbagEmbroideryField.length && poopbagEmbroideryFieldValue.length) || 
                  (dogcushionEmbroideryField.length && dogcushionEmbroideryFieldValue.length) ||    
                  (stockingField.length && stockingFieldValue.length)) {
            var newFontTitleText = newFontTitle.text().trim();

            if (!newFontTitleText.length) {
              var alertMessageText = obj.t('Please choose embroidery font.');
              alert.append('<p>' + alertMessageText + '</p>').removeClass('hidden');
            }

          }
        }


        /* Add a wish card & personal message */
        var formField = $('.bold_options .bold_option_dropdown .bold_option_element > select[name="properties[Add a wish card]"]');
        var textareaField = $('.bold_options .bold_option_textarea .bold_option_element > textarea[name="properties[Enter your personal message]"]');

        if (formField.length && textareaField.length) {

          if (textareaField.val().trim().length && formField.val() == 'Choose a wish card') {
            var alertMessageText = obj.t('Choose your wish card');
            alert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          }
        }
        /* /Add a wish card & personal message */


        if (!alert.length || alert.hasClass('hidden')) {

          if (submitForm) {
            var formEl = form && form[0] ? form[0] : document.querySelector('.product-form');
            if (typeof window.leOlivePrepareOptionForm === 'function') {
              window.leOlivePrepareOptionForm(formEl);
            } else {
              if (typeof window.leOliveSyncBoldOptionProperties === 'function') {
                window.leOliveSyncBoldOptionProperties(formEl);
              }
              if (typeof obj.rewriteZeroBagEmbroideryPropertyInputs === 'function') {
                obj.rewriteZeroBagEmbroideryPropertyInputs(formEl);
              }
              if (typeof window.leOliveDisablePlaceholderOptionFields === 'function') {
                window.leOliveDisablePlaceholderOptionFields(formEl);
              }
            }
            btn.siblings('.addtocart[disabled]').prop('disabled', false);
            btn.attr('disabled', 'disabled');

            originalBtn.attr('data-clicked', true).click();
          }
        }
      }

      return obj;
    };

    productObj.checkBabySizeVariant = function() {
      var sizeDropdown = $('.product-form #bcpo .selector-wrapper.bcpo-default .single-option-selector');

      if (sizeDropdown.length) {
        var sizeDropdownValue = sizeDropdown.val();

        var field = $('.selector-wrapper.bcpo-simple.bcpo-text input[name^="properties[Embroidery on the chest"]');

        if (sizeDropdownValue && sizeDropdownValue.length && field.length) {
          var sizeDropdownValue = sizeDropdownValue.trim();
          var fieldWrapper = field.parents('.selector-wrapper');

          if (sizeDropdownValue == 'Baby' || sizeDropdownValue == 'Baby 40cm') {
            fieldWrapper.addClass('bcpo-text__hidden');

          } else {
            fieldWrapper.removeClass('bcpo-text__hidden');
          }
        }
      }

      return productObj;
    };

    productObj.init();

    return obj;
  };

  obj.currencySymbol = $('body').attr('data-currency-symbol');

  /* Upsell alert */
  obj.upsellAlert = function() {
    var upsellAlertObj = function () {};

    upsellAlertObj.checkUpsellAlert = function() {
      var upsellAlert = $('#saso-notifications > .saso-notification > p');

      if (upsellAlert.length) {
        upsellAlert.text($('.cart-upsell__translation').attr('data-upsell-alert'));

        clearInterval(upsellAlertObj.checkUpsellAlertByCircle);

      } else if (upsellAlertObj.checkUpsellAlertChecks > 50) {
        clearInterval(upsellAlertObj.checkUpsellAlertByCircle);

      } else {
        upsellAlertObj.checkUpsellAlertChecks++;
      }
    };

    upsellAlertObj.checkUpsellAlertChecks = 0;
    upsellAlertObj.checkUpsellAlertByCircle = setInterval(upsellAlertObj.checkUpsellAlert, 250);
    upsellAlertObj.checkUpsellAlert();

    return obj;
  };

  obj.upsellAlert();
  /* /Upsell alert */


  obj.cartPage = function () {
    var cartPageObj = function () {};



    cartPageObj.init = function() {
      obj.applyFreeZeroBagEmbroideryLabels(document);
      $.getJSON('/cart.js?ts=' + Date.now(), function (cart) {
        obj.syncTeddyEmbroideryCheckoutProperties(cart, function () {
          $.getJSON('/cart.js?ts=' + Date.now(), function (nextCart) {
            obj.syncZeroBagEmbroideryCheckoutProperties(nextCart || cart, function () {
              obj.applyFreeZeroBagEmbroideryLabels(document);
            });
          });
        });
      });

      //cart rows labels

      if ($('.cart__header-labels').length) {
        $('th.cart__table-cell--price').html(obj.t('Item Price (without extras)'));
        $('th.cart__table-cell--line-price').html(obj.t('Total (Item Price + extras)'));
      }


        $('.responsive-table__row .cart__table-cell--price').attr('data-label', obj.t('Item Price (without extras)').replace('<span>','').replace('</span>', ''));
        $('.responsive-table__row .cart__table-cell--line-price').attr('data-label', obj.t('Total (Item Price + extras)').replace('<span>','').replace('</span>', ''));



      //total prices


      const cartJson = $('.js-cart-json');

      const cartJsonParsed = JSON.parse(cartJson.text());
      const cartJsonItems = cartJsonParsed.items;

      const cartLineItems = $('tr.cart__row');

      //json data
      if (cartLineItems.length && cartJson.length) {
      cartLineItems.each(function () {
        const cartLineItem = $(this);
        const cartLineItemKey = cartLineItem.attr('data-item-key');

        // Free scent cards, BOGO free-robe and Room Spray 1+1 rows have fixed Liquid prices — don't overwrite.
        if (
          cartLineItem.hasClass('cart__row--free-gift') ||
          cartLineItem.hasClass('cart__row--bogo-free') ||
          cartLineItem.hasClass('cart__row--rs-bogo') ||
          cartLineItem.find('.cart__scent-card-price').length
        ) {
          return;
        }

        $.each(cartJsonItems, function (index, lineItem) {
          const lineItemKey = lineItem['key'];

          if (lineItemKey === cartLineItemKey) {

            const itemProductPrice = lineItem['line_price'];
            const props = lineItem['properties'] || {};
            const quantity = lineItem['quantity'] || 1;
            const builderId = String(props._scBuilderId || props._boldBuilderId || '');
            let optionExtra = 0;

            if (builderId) {
              cartJsonItems.forEach(function (other) {
                const op = other.properties || {};
                const otherBuilder = String(op._scBuilderId || op._boldBuilderId || '');
                if (otherBuilder !== builderId) return;
                const isCharge =
                  other.product_type === 'OPTIONS_HIDDEN_PRODUCT' ||
                  op._lo_option_charge === 'true' ||
                  op._bogo_free_robe_charge === 'true' ||
                  op._kimono_sleep_mask_charge === 'true' ||
                  (op._boldBuilderId && !op._boldVariantIds) ||
                  (op._scBuilderId && !op._scVariantIds && !op._boldVariantIds);
                if (!isCharge) return;
                optionExtra += Number(other.final_line_price || other.line_price || 0) || 0;
              });
            }

            // Legacy Bold / sleep-mask only — never fold Shop Circle property prices
            // (those double-count on top of real OPTIONS_HIDDEN_PRODUCT lines).
            if (
              optionExtra === 0 &&
              !props._scVariantPrices &&
              !props._scVariantIds &&
              props._boldVariantPrices
            ) {
              optionExtra =
                String(props._boldVariantPrices)
                  .split(',')
                  .reduce(function (a, b) {
                    return (+a) + (+b);
                  }, 0) * quantity;
            }

            const itemTotalPriceFormatted = Shopify.money(itemProductPrice + optionExtra);
            cartLineItem.find('.total-product-cell-price').html(itemTotalPriceFormatted);


          }
        })
      })
      }

      if ( $('.cart__notification').length ) {
        $('.cart__notification').html(obj.t("Discount codes and gift cards can be added on the checkout page."))
      }

      /* Upsell */
      $('body').on('click', '.cart__upsell-popup__item-button', function(e) {
        var btn = $(this);
        btn.prop('disabled', true);
        var originalBtn = btn.siblings('.saso-add-to-cart');

        var productId = originalBtn.attr('data-product-id');
        var productVariantId = originalBtn.attr('data-variant-id');

        var dataArr = {
          'form_type': 'product',
          'utf8': '✓',
          'id': productVariantId,
          'properties[Embroidery on the stocking - charge]': '',
          'properties[Embroidery on the stocking (€4.95)]': '',
          'properties[Embroidery Color]': '',
          'properties[Gift-wrap this product (€4.95)]': 'No',
          'properties[_boldOptionLocalStorageId]': productId + '_' + productVariantId + '_' + ($('.cart-table tr.cart__row').length + 1)
        };

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: dataArr,
          success: function(result) {
            window.location.href = '/cart';
          }
        });
      });

      cartPageObj.checkUpsellPopup = function() {
        var cartItemMessage = $('.cart__row:not([data-upsell-inited]) .cart__table-cell--meta .saso-cart-item-discount-notes:not(:empty):first');

        if (cartItemMessage.length && cartItemMessage.text().trim().length) {
          var cartItem = cartItemMessage.parents('.cart__row');
          cartItem.attr('data-upsell-inited', true);

          var cartItemQuantity = cartItem.find('.cart__table-cell--quantity');
          cartItemQuantity.find('.quantity-selector').remove();
          cartItemQuantity.append('<div>1</div>');

          var cartItemPrice = cartItem.find('.cart__table-cell--price');
          cartItemPrice.children('span:last').text(cartItemPrice.attr('data-free-label'));

          var cartItemLinePrice = cartItem.find('.cart__table-cell--line-price');
          cartItemLinePrice.children('span:last').text(cartItemLinePrice.attr('data-free-label'));
        }

        var upsellButtons = $('.mfp-wrap .saso-product-container > .saso-add-to-cart.saso-crosssell-nav');

        if (upsellButtons.length) {

          upsellButtons.each(function() {
            var upsellButton = $(this);

            upsellButton.after(
              '<button type="button" class="cart__upsell-popup__item-button">' + upsellButton.text().trim() + '</button>'
            );
          });

          var upsellPopupAlert = $('.saso-cross-sell-popup .saso-message');

          if (upsellPopupAlert.length) {
            upsellPopupAlert.text($('.cart-upsell__translation').attr('data-upsell-popup-title'));
          }

          clearInterval(cartPageObj.checkUpsellPopupByCircle);

        } else if (cartPageObj.checkUpsellPopupChecks > 50) {
          clearInterval(cartPageObj.checkUpsellPopupByCircle);

        } else {
          cartPageObj.checkUpsellPopupChecks++;
        }
      };

      cartPageObj.checkUpsellPopupChecks = 0;
      cartPageObj.checkUpsellPopupByCircle = setInterval(cartPageObj.checkUpsellPopup, 250);
      cartPageObj.checkUpsellPopup();
      /* /Upsell */





      var cartItems = $('table.cart-table > tbody > tr.cart__row');

      if (cartItems.length) {

        cartItems.each(function () {
          var cartItem = $(this);
          var attributes = cartItem.find(' > td.cart__table-cell--meta .cart__row-property');

          if (attributes.length) {

            attributes.each(function () {
              var attribute = $(this);

              var attributeName = attribute.children('.cart__row__property-name');
              var attributeValue = attribute.children('.cart__row__property-value');

              if (attributeName.length && attributeValue.length) {
                var attributeNameText = attributeName.text().trim();
                attributeName.attr('data-text', attributeNameText);
                attributeName.text(obj.t(attributeNameText).replace(/(<([^>]+)>)/gi, ''));

                var attributeValueText = attributeValue.text().trim();
                attributeValue.text(obj.t(attributeValueText));
              }
            });
          }
        });
        obj.applyFreeZeroBagEmbroideryLabels(document);
      }

      $(document).on('click', '.cart__header__checkout', function(e) {
        e.preventDefault();
        var href = $('.cart__footer__checkout-btn').attr('href') || '/checkout';
        window.location.href = href;
      });

      $(document).on('change', '.cart__row .quantity-selector', function() {
        // Update ONLY the line that changed, keyed by its line-item key.
        // Run inside the gift lock so this cannot overlap scent-card add/remove
        // (parallel cart writes were dropping products and leaving the free card).
        var $input = $(this);
        if ($input.prop('readonly')) {
          return;
        }

        var key = $input.attr('data-id');
        var raw = $input.val();
        var quantity = parseInt(raw, 10);

        // Ignore empty/invalid blurs — those were wiping lines when clicking away.
        if (!key || raw === '' || isNaN(quantity) || quantity < 0) {
          return;
        }

        cartPageObj._pendingQty = cartPageObj._pendingQty || {};
        cartPageObj._pendingQty[key] = quantity;

        clearTimeout(cartPageObj._qtyUpdateTimer);
        cartPageObj._qtyUpdateTimer = setTimeout(function () {
          var updates = cartPageObj._pendingQty || {};
          cartPageObj._pendingQty = {};
          var keys = Object.keys(updates);
          if (!keys.length) {
            return;
          }

          window.__leOliveSkipGiftSync = true;

          var runUpdate = function () {
            var chain = Promise.resolve();

            keys.forEach(function (lineKey) {
              var qty = updates[lineKey];
              chain = chain.then(function () {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  credentials: 'same-origin',
                  body: JSON.stringify({
                    id: lineKey,
                    quantity: qty
                  })
                }).then(function (response) {
                  if (!response.ok) {
                    throw new Error('Cart update failed');
                  }
                  return response.json();
                });
              });
            });

            return chain;
          };

          var afterUpdate = function () {
            window.__leOliveSkipGiftSync = false;
            var roomspray = (window.leOliveRoomsprayBogo && typeof window.leOliveRoomsprayBogo.sync === 'function')
              ? window.leOliveRoomsprayBogo.sync()
              : null;
            return Promise.resolve(roomspray).then(function () {
              return (typeof window.handleFreeScentCard === 'function')
                ? window.handleFreeScentCard({ force: true, skipRefresh: true })
                : null;
            }).then(function () {
              if (typeof window.syncBottleWarmers === 'function') {
                return window.syncBottleWarmers();
              }
            }).then(function () {
              location.reload();
            }).catch(function () {
              location.reload();
            });
          };

          var run = (window.__leOliveCartGiftLock && window.__leOliveCartGiftLock.run)
            ? window.__leOliveCartGiftLock.run(runUpdate)
            : runUpdate();

          Promise.resolve(run).then(afterUpdate).catch(afterUpdate);
        }, 400);
      });

      cartPageObj.boldForm();
      cartPageObj.boldItems();
      if ( $(document).find('.saso-cart-original-total').length ) {
        const productTotalPrices = $(document).find('.total-product-cell-price');
        const pricesArr = [];
        if ( productTotalPrices.length ) {
          productTotalPrices.each(function () {
            const priceNonFormat = $(this).html();

            const formattedPrice = +priceNonFormat.replace(/[^0-9]+/g, "");

            pricesArr.push(formattedPrice);

          })

          const sum = pricesArr.reduce(function(a,b){
            return(a + b)
          });

          // Prefer live cart total so hidden Bold embroidery charges stay in the subtotal.
          $.ajax({
            url: '/cart.js?ts=' + Date.now(),
            dataType: 'json',
            type: 'get',
            success: function (cart) {
              var total = (cart && typeof cart.total_price === 'number') ? cart.total_price : sum;
              $(document).find('.saso-cart-original-total').html(Shopify.money(total));
              $(document).find('.cart__free-shipping__message').attr('data-total-price', total);
            },
            error: function () {
              $(document).find('.saso-cart-original-total').html(Shopify.money(sum));
              $(document).find('.cart__free-shipping__message').attr('data-total-price', sum);
            }
          });



          //Christmas Promotions
          const christmasPromotions = true;
          const christmasPromotionsPopup = $('.christmas__popup');

          if (christmasPromotions === true && christmasPromotionsPopup.length) {

            christmasPromotionsPopup.attr('data-total', sum);

            const christmasRequiredTotal =  parseFloat(christmasPromotionsPopup.attr('data-required-total') );
            const christmasTotal =  parseFloat(christmasPromotionsPopup.attr('data-total'));
            const deficiency = (christmasRequiredTotal - christmasTotal);

             var christmasPopupTitle;
             var christmasPopupHref;
             var christmasPopupButtonLabel;
             var freeStocking;

            var closeButtonLabel = obj.t('Close popup');

            console.log(christmasTotal)
            console.log(christmasRequiredTotal)
            if (christmasTotal > christmasRequiredTotal) {
              christmasPopupTitle = window.cartModalWindowTranslate.cartMinimumDoneHeading;
              christmasPopupButtonLabel = window.cartModalWindowTranslate.cartMinimumDoneLinkText;
              christmasPopupHref = window.cartModalWindowTranslate.cartMinimumDoneLinkUrl;
              christmasPromotionsPopup.addClass('success');
            } else {
              localStorage.removeItem('free_stocking');
              christmasPopupTitle = window.cartModalWindowTranslate.cartMinimumHeading.replace('{price}', Shopify.money(deficiency));
              christmasPopupButtonLabel = window.cartModalWindowTranslate.cartMinimumLinkText;
              christmasPopupHref = window.cartModalWindowTranslate.cartMinimumLinkUrl;
            }

            christmasPromotionsPopup.find('.h4').html(christmasPopupTitle);
            christmasPromotionsPopup.find('.christmas__btn-collections').text(christmasPopupButtonLabel).attr('href', christmasPopupHref);
            christmasPromotionsPopup.find('.christmas__btn--close').text(closeButtonLabel);


            if (localStorage.getItem('free_stocking') === 'false' || !localStorage.getItem('free_stocking')) {
              christmasPromotionsPopup.addClass('active');
              $('.christmas__popup--overlay').addClass('active');
            }


            $(document).on('click', '.christmas__popup--overlay', function () {
              if (christmasPromotionsPopup.hasClass('active')) {
                christmasPromotionsPopup.removeClass('active');
                $(this).removeClass('active');

                if (christmasPromotionsPopup.hasClass('success')) {
                  localStorage.setItem('free_stocking', 'true')
                } else {
                  localStorage.setItem('free_stocking', 'false')
                }
              }
            })

            $(document).on('click', '.christmas__popup a', function () {
              if (christmasPromotionsPopup.hasClass('active')) {
                christmasPromotionsPopup.removeClass('active');
                $('.christmas__popup--overlay').removeClass('active');

                if (christmasPromotionsPopup.hasClass('success')) {
                  localStorage.setItem('free_stocking', 'true')
                } else {
                  localStorage.setItem('free_stocking', 'false')
                }
              }
            })
          }
        }
      }
      /* Shipping message */
      var shippingMessage = $(document).find('.cart__free-shipping__message');

      if (shippingMessage.length) {
        var shippingMessagePrice = shippingMessage.children('b');

        var totalPriceValue = parseFloat(shippingMessage.attr('data-total-price')) / 100;
        var freeShippingValue = parseFloat(shippingMessage.attr('data-free-shipping-price'));

        var shippingMessagePriceValue = (freeShippingValue - totalPriceValue);

        if (shippingMessagePriceValue > 0) {
          shippingMessagePrice.text(Shopify.money(shippingMessagePriceValue.toFixed(2)));
          shippingMessage.removeClass('hide');
        } else {
          shippingMessage.removeClass('hide');
          shippingMessage.text(obj.t('You get free shipping!'));
        }
      }
      /* /Shipping message */

      return cartPageObj;
    };

    cartPageObj.boldForm = function() {

      $(document).on('change', '.bold_option_checkbox .bold_option_element > input[type="checkbox"]', function() {
        var fieldCheckobox = $(this);

        if (fieldCheckobox.next('input[type="hidden"][name^="properties[Add a sleep mask?"]').length) {
          var facemaskEmbroideryHidden = $('.bold_lightbox .bold_option_checkbox .bold_option_element > input[type="hidden"][name="properties[Embroidery on the face mask - charge]"]');

          if (facemaskEmbroideryHidden.length) {
            var facemaskEmbroideryChekbox = facemaskEmbroideryHidden.prev('input[type="checkbox"]');

            if (fieldCheckobox.is(':checked')) {
              var facemaskEmbroideryText = $('.bold_lightbox .bold_option_textbox .bold_option_element > input[name^="properties[Embroidery on the face mask ("]');

              if (facemaskEmbroideryText.length && facemaskEmbroideryText.val().trim().length) {

                if (fieldCheckobox.is(':checked') != facemaskEmbroideryChekbox.is(':checked')) {
                  facemaskEmbroideryChekbox.click().change();
                }
              }

            } else {

              if (facemaskEmbroideryChekbox.is(':checked')) {
                facemaskEmbroideryChekbox.click().change();
              }
            }
          }
        }
      });

      $(document).on('keyup change input', '.bold_option_element > input[type="text"]', function() {
        var fieldInput = $(this);
        var fieldInputName = fieldInput.attr('name');

//        if (/^properties\[Embroidery on the (chest|back|face mask|bag|towel|slipper|baby suit|bath textiles|belt|front|hat|headband|pocket|sleep mask|sleeve|stocking)\s/i.test(fieldInputName)) {
        if (
          (/^properties\[Embroidery on the (chest|back|changing mat|face mask|bag|towel|slipper|baby suit|bath textiles|belt|front|hat|headband|pocket|sleep mask|sleep mask - initials|sleeve|stocking)(\s|])/i.test(fieldInputName)) || (/^properties\[Embroidery on (baby suit|backpacks|bath capes|bath gift set|bath textiles|beanie|bib|blankets|bracelet|cardigan|care gift set|cat collar|chair|cover|cuddle and pacifier cloths|cuddle|cuddle gift set|dog collar - name|dog collar - number|dog cushion|footmuff|front|mittens|harness - name|harness - number|hat|hydrophilic cloths|laptop pouch|leash - name|leash - number|make-up bag|pacifier|pillow - initials|pillow - name|pillow and mask - initials|poncho|poop bag holder|pouch|pouch v2|scarf|scarf - initials|scrunchie - initials|sheets|shopper|sleeve - initials|sleeve - initials 3|sock|storage bag|sun hat|tanga|teddy front|toilettas|veil|wallet)(\s|])/i.test(fieldInputName)) || (/^properties\[Embroidery at (the bottom)(\s|])/i.test(fieldInputName)) || (/^properties\[Personalise initials(\s|])/i.test(fieldInputName)) || (/^properties\[Printing on (label|leash|poop bag holder)(\s|])/i.test(fieldInputName))
          ){
          if (typeof window.leOliveSyncEmbroideryChargeCheckboxes === 'function') {
            window.leOliveSyncEmbroideryChargeCheckboxes(
              fieldInput.closest('form')[0] || document.querySelector('.product-form') || document.querySelector('.bold_lightbox form')
            );
          } else {
            var field = fieldInput.parents('.bold_option');
            var prevHiddenField = field.prev('.bold_option_checkbox');
            var prevHiddenFieldInput = prevHiddenField.find('input[type="checkbox"]');

            /* Make it checked */
            if (fieldInput.val().trim().length) {

              if (!prevHiddenFieldInput.prop('checked')) {
                prevHiddenFieldInput.addClass('enabled').click();
              }

              /* Make it unchecked */
            } else {

              if (prevHiddenFieldInput.prop('checked')) {
                prevHiddenFieldInput.addClass('enabled').click();
                prevHiddenFieldInput.removeClass('enabled');
              }
            }
            if (typeof window.leOliveRefreshProductOptionPrice === 'function') {
              window.leOliveRefreshProductOptionPrice(
                fieldInput.closest('form')[0] || document.querySelector('.product-form')
              );
            }
          }
        }
      });

//      $(document).on('keyup change', '.bold_option_element > input[type="text"]', function() {
//        var fieldInput = $(this);
//        var fieldInputName = fieldInput.attr('name');

//        if (/^properties\[Embroidery on (baby suit|backpacks|bath capes|bath gift set|bath textiles|beanie|bib|blankets|bracelet|cardigan|care gift set|cover|cuddle and pacifier cloths|cuddle|cuddle gift set|footmuff|front|mittens|hat|hydrophilic cloths|laptop pouch|pouch|scarf|sheets|sock|storage bag|teddy front|wallet)\s/i.test(fieldInputName)) {
//          var field = fieldInput.parents('.bold_option');
//          var prevHiddenField = field.prev('.bold_option_checkbox');
//          var prevHiddenFieldInput = prevHiddenField.find('input[type="checkbox"]');

          /* Make it checked */
//          if (fieldInput.val().trim().length) {

//            if (!prevHiddenFieldInput.prop('checked')) {
//              prevHiddenFieldInput.click();
//            }

            /* Make it unchecked */
//          } else {

//            if (prevHiddenFieldInput.prop('checked')) {
//              prevHiddenFieldInput.click();
//            }
//          }
//        }
//      });

//      $(document).on('keyup change', '.bold_option_element > input[type="text"]', function() {
//        var fieldInput = $(this);
//        var fieldInputName = fieldInput.attr('name');

//        if (/^properties\[Embroidery at the (bottom)\s/i.test(fieldInputName)) {
//          var field = fieldInput.parents('.bold_option');
//          var prevHiddenField = field.prev('.bold_option_checkbox');
//          var prevHiddenFieldInput = prevHiddenField.find('input[type="checkbox"]');

          /* Make it checked */
//          if (fieldInput.val().trim().length) {

//            if (!prevHiddenFieldInput.prop('checked')) {
//              prevHiddenFieldInput.click();
//            }

            /* Make it unchecked */
//          } else {

//            if (prevHiddenFieldInput.prop('checked')) {
//              prevHiddenFieldInput.click();
//           }
//          }
//        }
//      });

      setInterval(function() {
        /* Edit button */
        var boldItemsButtons = $('.cart__row .bold_edit_in_cart > .bold_cart_edit_button');

        if (boldItemsButtons.length) {
          boldItemsButtons.wrap(
            '<span class="bold_option_edit__cpbp__edit-btn"></div>'
          );
        }
        /* Edit button */

        var boldItemForm = $('.bold_lightbox .bold_lightbox_content:visible');

        if (boldItemForm.length) {
          /* Text */
          var boldTextboxFields = boldItemForm.find('.bold_option_textbox:not(.bold_option_checkbox-loaded)');

          if (boldTextboxFields.length) {
            var productVariantTitle = $(`tr[data-item-key^=${boldItemForm.find('input[name="id"]').val()}]`).attr('data-variant-title');

            boldTextboxFields.each(function() {
              var boldTextboxField = $(this);

              if (!boldTextboxField.hasClass('invisible')) {
                var boldTextboxFieldTitle = boldTextboxField.find('.bold_option_title').text().trim();

                /*
                if (/^(Baby(| 40cm)|1\-2 (years|jaar)(| 50cm))$/.test(productVariantTitle) && /^Embroidery on the chest/i.test(boldTextboxFieldTitle)) {
                  boldTextboxField.addClass('invisible');
                }
                 */

                if(boldTextboxField.find('input[name^="properties[Embroidery on the chest"]').length > 0){
                  console.log(productVariantTitle)
                  if (/^(Baby|Baby|Bebé|Bébé)(|40cm)$/i.test(productVariantTitle)) {
                    boldTextboxField.addClass('invisible');

                  } else if (/^1\-2 (years|jaar|ans|años|Jahre)(| 50cm)$/i.test(productVariantTitle)) {
                    boldTextboxField.addClass('invisible');

                  } else {
                    boldTextboxField.removeClass('invisible');
                  }
                }
              }
            });
          }
          /* /Text */

          /* Message */
          var boldItemFormAlert = boldItemForm.find('.bold_option_edit__cpbp-popup__alert');

          if (!boldItemFormAlert.length) {
            boldItemForm.append(
              '<div class="bold_option_edit__cpbp-popup__alert hide"></div>'
            );
            var boldItemFormAlert = boldItemForm.find('.bold_option_edit__cpbp-popup__alert');
          }
          /* /Message */

          /* Update popup button */
          var boldItemFormButton = $('.bold_lightbox .bold_lightbox_buttons > button[type="button"].bold_options_lightbox_cart_edit_update_btn');

          if (boldItemFormButton.length) {
            boldItemFormButton.wrap(
              '<span class="bold_option_edit__cpbp-popup__update-btn"></span>'
            );
          }
          /* /Update popup button */

          /* Checkbox */
          var boldCheckboxFields = boldItemForm.find('.bold_option_checkbox:not(.bold_option_checkbox-loaded)');

          if (boldCheckboxFields.length) {
            var itemName = boldItemForm.parents('.cart__table-cell--meta').find('.cart__row-link').text().trim();

            boldCheckboxFields.each(function() {
              var boldCheckboxField = $(this);

              boldCheckboxField.addClass('bold_option_checkbox-loaded');
              var boldCheckboxFieldTitle = boldCheckboxField.find('.bold_option_title').text().trim();

              if (/^Add a sleep mask\? \(/i.test(boldCheckboxFieldTitle)) {
                boldCheckboxField.addClass('bold_option_checkbox-visible');
              }
            });
          }
          /* /Checkbox */
        }

      }, 250);

      /* Text */
      $(document).on('change keyup', '.bold_option_edit_container .bold_option_textbox .bold_option_element > input[type="text"], .bold_option_edit_container .bold_option_textarea .bold_option_element > textarea', function() {
        var boldFieldInput = $(this);
        var boldFieldCount = boldFieldInput.siblings('.bold_option_element__count');

        if (boldFieldCount.length) {
          boldFieldCount.children('span').text(boldFieldInput.val().trim().length);
        }
      });
      /* /Text */

      /* Textarea */
      $(document).on('change keyup', '.bold_options .bold_option_textarea .bold_option_element > textarea', function() {
        var textarea = $(this);
        var textareaName = textarea.attr('name');
        var textareaValue = textarea.val();

        if (textareaName == 'properties[Enter your personal message]') {
          var dropdown = $('.bold_options .bold_option_dropdown .bold_option_element > select[name="properties[Add a wish card]"]');

          if (dropdown.length) {
            var textareaSubtitle = textarea.siblings('.bold_option_textarea__subtitle');

            if (textareaValue.length && dropdown.val() != 'No, thanks') {
              textareaSubtitle.removeClass('hidden');

            } else {
              textareaSubtitle.addClass('hidden');
            }
          }
        }
      });
      /* /Textarea */
      $(document).on('change', '.bold_lightbox input[name^="properties[Design Options]"]', function (evt) {
            var tShirtTextboxInput = $(document).find('.bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt]"]');
            if (tShirtTextboxInput.length) {
              tShirtTextboxInput
                      .attr('maxlength', 12)


              if (!tShirtTextboxInput.siblings('.bold_option_element__count').length) {
                tShirtTextboxInput.after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
              }
            }
            var tShirt2TextboxInput = $(document).find(' .bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt - second line]"]');

            if (tShirt2TextboxInput.length) {
              tShirt2TextboxInput
                      .attr('maxlength', 12)
              if (!tShirt2TextboxInput.siblings('.bold_option_element__count').length) {
                tShirt2TextboxInput.after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
              }
            }
            var tShirt3TextboxInput = $(document).find(' .bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt - third line]"]');

            if (tShirt3TextboxInput.length) {
              tShirt3TextboxInput
                      .attr('maxlength', 12)
              if (!tShirt3TextboxInput.siblings('.bold_option_element__count').length) {
                tShirt3TextboxInput.after(
                        '<span class="bold_option_element__count"><span>0</span>/12</span>'
                );
              }
            }

            var swatches = $(this).closest('.bold_lightbox').find('.bold_option_swatch:not(.bold_option_hidden)')

            if (swatches.length) {
              $(document).on('click', swatches, function () {
                setTimeout(function (){
                  var tShirtTextboxInput = $(document).find('.bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt]"]');
                  if (tShirtTextboxInput.length) {
                    tShirtTextboxInput
                            .attr('maxlength', 12)


                    if (!tShirtTextboxInput.siblings('.bold_option_element__count').length) {
                      tShirtTextboxInput.after(
                              '<span class="bold_option_element__count"><span>0</span>/12</span>'
                      );
                    }
                  }
                  var tShirt2TextboxInput = $(document).find(' .bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt - second line]"]');

                  if (tShirt2TextboxInput.length) {
                    tShirt2TextboxInput
                            .attr('maxlength', 12)
                    if (!tShirt2TextboxInput.siblings('.bold_option_element__count').length) {
                      tShirt2TextboxInput.after(
                              '<span class="bold_option_element__count"><span>0</span>/12</span>'
                      );
                    }
                  }
                  var tShirt3TextboxInput = $(document).find(' .bold_option_textbox .bold_option_element input[type="text"][name="properties[Text on the t-shirt - third line]"]');

                  if (tShirt3TextboxInput.length) {
                    tShirt3TextboxInput
                            .attr('maxlength', 12)
                    if (!tShirt3TextboxInput.siblings('.bold_option_element__count').length) {
                      tShirt3TextboxInput.after(
                              '<span class="bold_option_element__count"><span>0</span>/12</span>'
                      );
                    }
                  }
                },150)
              })
            }
      });


      $(document).on('click', '.bold_options .bold_option_swatch > .bold_option_swatch__title', function() {
        var title = $(this);
        title.toggleClass('opened');

      });
      $(document).on('click', '.product-form .bold_option_swatch > .bold_option_element > .bold_option_value', function() {
        var color = $(this);
        var colorsTitle = color.parents('.bold_option_element').siblings('.bold_option_swatch__title');
        var $swatchEl = color.closest('.bold_option_element');
        var $pickedInput = color.find('input[type="checkbox"], input[type="radio"]');
        if ($pickedInput.length && $pickedInput.is(':checkbox')) {
          $swatchEl.find('input[type="checkbox"]').each(function () {
            this.checked = this === $pickedInput[0];
          });
        } else if ($pickedInput.length && $pickedInput.is(':radio')) {
          $pickedInput.prop('checked', true);
        }

        if (!color.hasClass('active')) {
          var colorText = color.text().trim();


          color.addClass('active').siblings('.active').removeClass('active').removeClass('visually_active');
          colorsTitle.children('span').text(colorText);

          if (colorText.length > 7) {
            colorsTitle.children('span').addClass('bold_option_swatch__title-twolines');

          } else {
            colorsTitle.children('span').removeClass('bold_option_swatch__title-twolines');
          }


          /* LO - Embroidery Color Options - New View (NF21033) */
          var colorsTitleBg = color.find('.bold_option_value_swatch > span');
          var colorsTitleBgImage = colorsTitleBg.css('backgroundImage');
          var colorsTitleBgColor = colorsTitleBg.css('backgroundColor');

          if (colorsTitleBgImage != 'none') {
            colorsTitle.children('i').css('backgroundColor', 'none').css('backgroundImage', colorsTitleBgImage);

          } else {
            colorsTitle.children('i').css('backgroundColor', colorsTitleBgColor).css('backgroundImage', 'none');
          }
          /* /LO - Embroidery Color Options - New View (NF21033) */


          var formAlert = $('.product-form__alert');
          formAlert.addClass('hidden');

          var newAddToCartBtn = $('#AddToCartNew');
          if (!$('.badge.badge--sold-out')) {
            newAddToCartBtn.attr('disabled', false);
          }
        }

        var $swatch = color.closest('.bold_option_swatch');
        var $hidden = $swatch.find('input[type="hidden"][name^="properties["]').filter(function() {
          return !/^properties\[_/.test(this.name || '');
        }).first();
        var swatchVal = (color.find('input[type="checkbox"], input[type="radio"]').val() || '').trim();
        if (!swatchVal) swatchVal = (color.find('.bold_option_value_title').text() || '').trim();
        if (swatchVal && /,/.test(swatchVal)) {
          var swatchParts = swatchVal.split(/\s*,\s*/).filter(Boolean);
          swatchVal = swatchParts.length ? swatchParts[swatchParts.length - 1] : swatchVal;
        }
        if ($hidden.length && swatchVal) {
          $hidden.prop('disabled', false).removeAttr('disabled').val(swatchVal).trigger('input').trigger('change');
        }
        colorsTitle.attr('data-user-picked', '1');
        var form = $swatch.closest('form')[0] || document.querySelector('.product-form');
        if (typeof window.leOliveSyncBoldOptionProperties === 'function') {
          window.leOliveSyncBoldOptionProperties(form);
        }
        colorsTitle.removeClass('opened');
      });



      /* Checkbox */
      $(document).on('click', '.bold_options .bold_option_checkbox__options-wrapper .bold_option_checkbox__options .bold_option_checkbox__option', function() {
        var checkbox = $(this);
        var checkboxI = checkbox.index();

        if (!checkbox.hasClass('active')) {
          checkbox.addClass('active').siblings('.active').removeClass('active');

          var checkboxLabel = checkbox.parent().siblings('label');
          var checkboxLabelText = checkboxLabel.text().trim();

          if (/^Add a sleep mask\? \(/.test(checkboxLabelText)) {
            var facemaskChargeHiddenInput = $('.bold_options .bold_option_element input[name^="properties[Embroidery on the sleep mask - charge"]');

            if (facemaskChargeHiddenInput.length) {
              var facemaskChargeCheckbox = facemaskChargeHiddenInput.prev('input[type="checkbox"]');

              // No
              if (checkboxI) {
                var facemaskInput = $('.bold_options .bold_option_element input[name^="properties[Embroidery on the sleep mask ("]');

                if (facemaskInput.length) {
                  facemaskInput.val('').change();
                }

                if (facemaskChargeCheckbox.is(':checked')) {
                  facemaskChargeCheckbox.click();
                }


                // Yes
              } else {

                setTimeout(function() {
                  var facemaskEmbroideryInput = $('.bold_options .bold_option_element input[name^="properties[Embroidery on the sleep mask ("]');

                  if (facemaskEmbroideryInput.length) {
                    var facemaskEmbroideryField = facemaskEmbroideryInput.parents('.bold_option_textbox');
                    var facemaskColorField = facemaskEmbroideryField.next('.bold_option_swatch');

                    if (facemaskColorField.length) {
                      var facemaskColorTitle = facemaskColorField.children('.bold_option_title');
                      var facemaskColorNewTitle = facemaskColorTitle.next('.bold_option_swatch__title');

                      if (!facemaskColorNewTitle.length) {
                        facemaskColorTitle.after(
                                '<div class="bold_option_swatch__title">' +
                                '<i></i>' +
                                '<span></span>' +
                                '</div>'
                        );
                      }
                    }
                  }
                }, 100);
              }
            }
          }

          checkboxLabel.click();
        }
      });
      $(document).on('change', '.bold_lightbox_content.product-form select[name="properties[Add a wish card]"]', function (evt) {

        const $this = $(this);
        const $options = $this.find("option");
        const textArea = $this.closest(".bold_option_set").find('.bold_option_textarea');


        $options.each(function () {
          const $selectedOption = $(this).is(":selected");
          const selectImageWrapper = $(document).find('.bold_option_select_image');
          let selectImageUrl = '';
          if ( $selectedOption ) {
            if ( $(this)[0].value === 'Birthday Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/products/mockup-birthday-card-MOOD_2048x.jpg?v=1650461269'
            }
            // area to copy and edit *START*
            else if ( $(this)[0].value === 'Lots of Love Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/products/mockup-lostoflove-card-MOOD_2048x.jpg?v=1650461358'
            }

            else if ( $(this)[0].value === 'I Love Mom Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/products/mockup-moederdag-card-MOOD_2048x.jpg?v=1650460707'
            }

            else if ( $(this)[0].value === 'Congratulations Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_Congratulations_card.jpg?v=1662977797'
            }

            else if ( $(this)[0].value === 'Welcome Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_Welcome_card.jpg?v=1662977797'
            }

            else if ( $(this)[0].value === 'Bride Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_bride.png?v=1682674443'
            }

            else if ( $(this)[0].value === 'Valentine Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_ValentinesCard.png?v=1673931977'
            }

            else if ( $(this)[0].value === 'Christmas Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_christmas.jpg?v=1670183564'
            }

            else if ( $(this)[0].value === 'Happy Holidays Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_happyholidays.jpg?v=1670183564'
            }

            else if ( $(this)[0].value === 'Holidays Card' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_holidays.jpg?v=1701257573'
            }

            else if ( $(this)[0].value === 'A Gift for You' ) {
              selectImageUrl = '//cdn.shopify.com/s/files/1/0279/2567/6171/files/wishcard_tooltip_pets_giftforyou.jpg?v=1721316041'
            }
            // area to copy and edit *END*
            else {
              selectImageUrl = null
            }


            let imageHtml = `<img width="150"
                                height="150"
                                src="${selectImageUrl}"
                                alt="Option image">`

            if ( selectImageUrl !== null && selectImageUrl !== undefined  ) {
              selectImageWrapper.closest('.bold_option_set').addClass('wishcard__inner');
              selectImageWrapper[0].innerHTML = imageHtml;
              selectImageWrapper.removeClass('hidden')
            } else {
              selectImageWrapper[0].innerHTML = '';
              selectImageWrapper.addClass('hidden');
              selectImageWrapper.closest('.bold_option_set').removeClass('wishcard__inner');
            }

            if ( $(this).attr("data-option_value_key") >= 0 ) {
              textArea.show();

            } else {
              textArea.hide();
            }
          }

        })


      })


      $(document).on('click', '.bold_option_edit__cpbp__edit-btn', function(e) {

        if (e.target.nodeName == 'SPAN' && e.target.className == 'bold_option_edit__cpbp__edit-btn') {
          var btn = $(this).children('button');
          btn.click();


          setTimeout(function (){
            $('.bold_lightbox_content').addClass('product-form');
            $('.bold_lightbox .bold_lightbox_buttons button').addClass('btn').addClass('btn--primary');
            /* Face mask */
            var facemaskField = $('.bold_option_checkbox input[name^="properties[Add a sleep mask? ("]').closest('.bold_option_element').find('input[type="checkbox"]');

            if (facemaskField.length) {
              var facemaskFieldLabel = facemaskField.parents('label');

              facemaskFieldLabel.after(
                      '<div class="bold_option_checkbox__options">' +
                      '<span class="bold_option_checkbox__option' + (facemaskField.is(':checked') ? ' active' : '') + '">' + obj.t('Yes') + '</span>' +
                      '<span class="bold_option_checkbox__option' + (!facemaskField.is(':checked') ? ' active' : '') + '">' + obj.t('No') + '</span>' +
                      '</div>'
              );

              facemaskFieldLabel.parents('.bold_option_checkbox').addClass('bold_option_checkbox__options-wrapper');
            }
            /* /Face mask */

            // Wishcard images

            if ( $('.bold_lightbox_content.product-form select[name="properties[Add a wish card]"]').length ) {
              let selectImageUrl

              const textArea = $('.bold_lightbox_content.product-form .bold_option.bold_option_textarea');
              const selectImageHtmlWrapper = `<div class="bold_option_select_image hidden">

                           </div>`
              const $parent = $('select[name="properties[Add a wish card]"]').closest(".bold_option");
              $parent.find('.product-form__giftwrapper-icon').remove();
              $parent.after(selectImageHtmlWrapper);


              textArea.hide();

            }

          },500)
          /* Text */
          setInterval(function() {
            var boldItemForm = $('.bold_lightbox_content').find('form.bold_options');

            /* Textboxes */
            var boldTextboxFields = boldItemForm.find('.bold_option_textbox:not(.bold_option_textbox-loaded):not(.bold_option_hidden)');


            if (boldTextboxFields.length) {

              boldTextboxFields.each(function() {
                var boldTextboxField = $(this);
                var boldTextboxFieldTitle = boldTextboxField.find('.bold_option_title').text().trim();

                var boldTextboxFieldInput = boldTextboxField.find('.bold_option_element > input[type="text"]');
                var boldTextboxFieldInputName = boldTextboxFieldInput.attr('name');
                var boldTextboxFieldInputLength = boldTextboxFieldInput.val().trim().length;

                if (/^properties\[Personalise initials \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 4)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/4</span>'
                  );

                } else if (/^properties\[Personalise Initials \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 3)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/3</span>'
                  );

                } else if (/^properties\[Embroidery on the towel \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 12)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/12</span>'
                  );

                } else if (/^properties\[Embroidery on backpacks \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 10)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/10</span>'
                  );

                } else if (/^properties\[Embroidery on the bag \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 10)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/10</span>'
                  );

                } else if (/^properties\[Embroidery on mittens \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 1)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/1</span>'
                  );

                } else if (/^properties\[Embroidery on scarf \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 8)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/8</span>'
                  );

                } else if (/^properties\[Embroidery on the face mask \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 8)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/8</span>'
                  );

                } else if (/^properties\[Embroidery on the sleep mask \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 12)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/12</span>'
                  );

                } else if (/^properties\[FREE Embroidery on sleep mask \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 12)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/12</span>'
                  );

                } else if (/^properties\[Embroidery \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 10)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/10</span>'
                  );

                } else if (/^properties\[Embroidery on the chest \(/.test(boldTextboxFieldInputName)) {
                  var cartItemVariantTitle = btn.parents('.cart__row').attr('data-variant-title');

                  if (/^(1\-2|3\-4|5\-6|7\-8)\s/.test(cartItemVariantTitle)) {
                    boldTextboxFieldInput
                    .attr('maxlength', 6)
                    .after(
                      '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/6</span>'
                    );

                  } else {
                    boldTextboxFieldInput
                    .attr('maxlength', 11)
                    .after(
                      '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/11</span>'
                    );
                  }

                } else if (/^properties\[Embroidery on the towel \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 12)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/12</span>'
                  );

                } else if (/^properties\[Embroidery on wallet \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 3)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/3</span>'
                  );

               } else if (/^properties\[Embroidery on bib \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 12)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/12</span>'
                  );

                } else if (/^properties\[Embroidery on the slipper \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 3)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/3</span>'
                  );

                } else if (/^properties\[Embroidery on the back \(/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 15)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/12</span>'
                  );

                } else if (/^properties\[Back Embroidery - second line\]$/.test(boldTextboxFieldInputName)) {
                  boldTextboxFieldInput
                  .attr('maxlength', 12)
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextboxFieldInputLength + '</span>/12</span>'
                  );
                }

                boldTextboxField.addClass('bold_option_textbox-loaded');
              });
            }
            /* /Textboxes */


            /* Textareas */
            var boldTextareasFields = boldItemForm.find('.bold_option_textarea:not(.bold_option_textarea-loaded)');

            if (boldTextareasFields.length) {

              boldTextareasFields.each(function() {
                var boldTextareaField = $(this);
                var boldTextareaFieldTitle = boldTextareaField.find('.bold_option_title').text().trim();

                var boldTextarea = boldTextareaField.find('.bold_option_element > textarea');
                var boldTextareaName = boldTextarea.attr('name');
                var boldTextareaLength = boldTextarea.val().trim().length;

                if (/^properties\[Enter your personal message\]$/.test(boldTextareaName)) {
                  boldTextarea
                  .attr('maxlength', 150)
                  .before(
                    '<span class="bold_option_textarea__subtitle hidden">' + obj.t('The greeting cards are handwritten, therefore it is not possible to add Emojis or special characters') + '</span>'
                  )
                  .after(
                    '<span class="bold_option_element__count"><span>' + boldTextareaLength + '</span>/150</span>'
                  );
                }

                boldTextareaField.addClass('bold_option_textarea-loaded');
              });
            }
            /* /Textareas */

            /* /Color */
            var colorFields = $('.bold_options .bold_option_swatch > .bold_option_title');

            if (colorFields.length) {

              colorFields.each(function() {
                var colorField = $(this);

                if (!colorField.next('.bold_option_swatch__title').length) {

                  if (colorField.text().trim() == 'Choose your print colour') {
                    colorField.parents('.bold_option_swatch').addClass('medium-up--one-whole').addClass('large-up--one-half');
                  }
                  const keywords = ['font', 'borduurlettertype', 'Stickschrift', 'fuente', 'police' , 'la police'];
                  if (keywords.some(keyword => colorField.text().trim().includes(keyword))){
                    colorField.parents('.bold_option_swatch').addClass('bold_option_font_swatch');
                  }

                  colorField.after(
                          '<div class="bold_option_swatch__title">' +
                          '<i></i>' +
                          '<span></span>' +
                          '</div>'
                  );

                  let selectedColor = colorField.parents('.bold_option_swatch').find('.bold_option_element .bold_option_value_element.bold_swatch_selected');



                    if (selectedColor.length) {
                      var colorParent = selectedColor.closest('.bold_option_value ')
                      var colorText = colorParent.find('input[type="checkbox"]').val().trim();
                      var colorsTitle = colorParent.parents('.bold_option ').find('.bold_option_swatch__title');

                      
                      colorsTitle.children('span').text(colorText);

                      if (colorText.length > 7) {
                        colorsTitle.children('span').addClass('bold_option_swatch__title-twolines');

                      } else {
                        colorsTitle.children('span').removeClass('bold_option_swatch__title-twolines');
                      }


                      /* LO - Embroidery Color Options - New View (NF21033) */
                      var colorsTitleBg = colorParent.find('.bold_option_value_swatch > span');
                      var colorsTitleBgImage = colorsTitleBg.css('backgroundImage');
                      var colorsTitleBgColor = colorsTitleBg.css('backgroundColor');

                      if (colorsTitleBgImage != 'none') {
                        colorsTitle.children('i').css('backgroundColor', 'none').css('backgroundImage', colorsTitleBgImage);

                      } else {
                        colorsTitle.children('i').css('backgroundColor', colorsTitleBgColor).css('backgroundImage', 'none');
                      }
                      /* /LO - Embroidery Color Options - New View (NF21033) */

                    }



                }
              });
            }

            /* Radio */
            var radios = $('.product-form .bold_option_radio');

            if (radios.length) {

              radios.each(function() {
                var radio = $(this);
                var radioInput = radio.find('input[type="radio"]');
                radioInput.after('<span></span>');

                var radioOptions = radio.find(' > .bold_option_element > .bold_option_value');

                if (radioOptions.length) {

                  radioOptions.each(function() {
                    var radioOption = $(this);
                    var radioOptionTitle = radioOption.find(' > label > .bold_option_value_title');
                    var radioOptionTitleText = radioOptionTitle.text().trim();
                    var newRadioOptionTitleText = obj.t(radioOptionTitleText);
                    radioOptionTitle.text(newRadioOptionTitleText);
                  });
                }
              });
            }
            /* /Radio */




            /********** NEW **********/
            var formBoldOptions = $('.bold_options');

            if (!formBoldOptions.hasClass('bold_options_custom_loaded')) {
              formBoldOptions.addClass('bold_options_custom_loaded');


              /* Labels */
              var formBoldOptionsLabels = formBoldOptions.find('.bold_option > label > .bold_option_title, .bold_option > .bold_option_title');

              if (formBoldOptionsLabels.length) {

                formBoldOptionsLabels.each(function() {
                  var formBoldOptionsLabel = $(this);
                  var formBoldOptionsLabelText = formBoldOptionsLabel.text().trim();

                  var formBoldOption = formBoldOptionsLabel.parents('.bold_option');

                  if (obj.originalCurrencySymbol) {

                    for (var i = 0; i < obj.boldFormFields.length; i++) {
                      var boldFormField = obj.boldFormFields[i];

                      if (boldFormField.name.regEx.test(formBoldOptionsLabelText)) {

                        for (var i2 = 0; i2 < boldFormField.prices.length; i2++) {


                          /* DEVMODE */
//                           if (/DEVMODE/.test(window.location.href)) {

                            /* Dropdowns */

                            if (formBoldOption.hasClass('bold_option_dropdown') && typeof boldFormField.options !== 'undefined') {

                              formBoldOption.find('select > option').each(function() {
                                var formBoldOptionDropdownOption = $(this);
                                var formBoldOptionDropdownOptionText = formBoldOptionDropdownOption.text().trim();

                                if (/ \[\+[^0-9]{1}[0-9\.\,]+\]$/.test(formBoldOptionDropdownOptionText)) {

                                  // Options */
                                  for (var i3 = 0; i3 < boldFormField.options.length; i3++) {

                                    if (boldFormField.options[i3].name.regEx.test(formBoldOptionDropdownOptionText)) {

                                      // Option prices
                                      for (var i4 = 0; i4 < boldFormField.options[i3].prices.length; i4++) {

                                        if (boldFormField.options[i3].prices[i4].currency == window.Shopify.currency.active) {
                                          formBoldOptionDropdownOption.text(formBoldOptionDropdownOptionText.replace(/ \[\+([^0-9]{1})([0-9\,\.]+)\]$/, ' [+$1' + boldFormField.options[i3].prices[i4].price.toFixed(2) + ']'));
                                        }
                                      }
                                    }
                                  }
                                }
                              });
                              /* /Dropdowns */
                            }
//                           }
                          /* /DEVMODE */


                        }
                      }
                    }
                  }
                });
              }
            }
            /********** /NEW **********/


            /* Labels */
            var formBoldOptionsLabels = formBoldOptions.find('.bold_option > label > .bold_option_title, .bold_option > .bold_option_title');

            if (formBoldOptionsLabels.length) {

              formBoldOptionsLabels.each(function() {
                var formBoldOptionsLabel = $(this);
                var formBoldOptionsLabelText = formBoldOptionsLabel.text().trim();

                var formBoldOption = formBoldOptionsLabel.parents('.bold_option');

                var newFormBoldOptionsLabelText = obj.t(formBoldOptionsLabelText).replace(/(<([^>]+)>)/gi, "");

                if (obj.originalCurrencySymbol) {

                  for (var i = 0; i < obj.boldFormFields.length; i++) {
                    var boldFormField = obj.boldFormFields[i];

                    if (boldFormField.name.regEx.test(formBoldOptionsLabelText)) {

                      for (var i2 = 0; i2 < boldFormField.prices.length; i2++) {

                        /* Label without a price */
                        if (typeof boldFormField.updateLabelPrice !== 'undefined' && !boldFormField.updateLabelPrice) {

                          /* Label with a price */
                        } else if (/^(.+) \([\+]{0,1}(.+){1}([0-9\,\.]+)\)$/.test(formBoldOptionsLabelText)) {
                          var newFormBoldOptionsLabelPrice = parseFloat(formBoldOptionsLabelText.replace(/^.+ \([\+]{0,1}(.{1})([0-9\,\.]+)\)$/, '$2'));
                          var newFormBoldOptionsLabelConvertedPrice = newFormBoldOptionsLabelPrice * parseFloat(window.Shopify.currency.rate);

                          var boldFormFieldPrice = boldFormField.prices[i2];

                          if (boldFormFieldPrice.currency == window.Shopify.currency.active) {
                            var newFormBoldOptionsLabelConvertedPrice = boldFormFieldPrice.price;

                            formBoldOptionsLabel.attr('data-price-value', newFormBoldOptionsLabelConvertedPrice.toFixed(2));

                            var newFormBoldOptionsLabelText = newFormBoldOptionsLabelText.replace(/^(.+) \([\+]{0,1}.{1}([0-9\,\.]+)\)$/, '$1') + ' (+' + obj.currencySymbol + newFormBoldOptionsLabelConvertedPrice.toFixed(2) + ')';
                          }
                        }

                        /* DEVMODE */
//                   if (/DEVMODE/.test(window.location.href)) {

                        if (formBoldOption.hasClass('bold_option_dropdown') && typeof boldFormField.options !== 'undefined') {

                          formBoldOption.find('select > option').each(function() {
                            var formBoldOptionDropdownOption = $(this);
                            var formBoldOptionDropdownOptionText = formBoldOptionDropdownOption.text().trim();

                            if (/ \[\+[^0-9]{1}[0-9\.\,]+\]$/.test(formBoldOptionDropdownOptionText)) {

                              // Options */
                              for (var i3 = 0; i3 < boldFormField.options.length; i3++) {

                                if (boldFormField.options[i3].name.regEx.test(formBoldOptionDropdownOptionText)) {

                                  // Option prices
                                  for (var i4 = 0; i4 < boldFormField.options[i3].prices.length; i4++) {

                                    if (boldFormField.options[i3].prices[i4].currency == window.Shopify.currency.active) {
                                      formBoldOptionDropdownOption.text(formBoldOptionDropdownOptionText.replace(/ \[\+([^0-9]{1})([0-9\,\.]+)\]$/, ' [+$1' + boldFormField.options[i3].prices[i4].price.toFixed(2) + ']'));
                                    }
                                  }
                                }
                              }
                            }
                          });
                        }
//                   }
                        /* /DEVMODE */
                      }
                    }
                  }
                }

                formBoldOptionsLabel.html(newFormBoldOptionsLabelText);
              });
              obj.applyFreeZeroBagEmbroideryLabels(formBoldOptions);
              setTimeout(function () { obj.applyFreeZeroBagEmbroideryLabels(formBoldOptions); }, 300);
              setTimeout(function () { obj.applyFreeZeroBagEmbroideryLabels(formBoldOptions); }, 1200);
            }
            /* /Labels */

            var swatchColors = $('.bold_lightbox .bold_lightbox_content .bold_options .bold_option_swatch .bold_option_value')

            swatchColors.each(function(colorI) {
              var color = $(this);

              var colorValue = color.find('.bold_option_value_element > input').val();

              var newColorText = obj.t(colorValue);
              color.attr('data-color', newColorText);

              var colorLabel = color.find(' > label > .bold_option_swatch_title > .bold_option_value_title');
              colorLabel.text(newColorText);
              if(color.find('.bold_option_value_element.bold_swatch_selected').length > 0){
                color.closest('.bold_option_swatch').find('.bold_option_swatch__title span').text(newColorText);
              }
            });




          },500)
          /* /Text */

          /* Upsell */
          var cartItemMessage = btn.parents('.cart__table-cell--meta').find('.saso-cart-item-discount-notes');

          if (cartItemMessage.length && cartItemMessage.text().trim().length) {

            cartPageObj.checkBoldUpsellForm = function() {
              var boldItemForm = btn.siblings('.bold_option_edit_container').children('form.bold_options');

              setTimeout(function() {
                var boldCheckboxRadioboxes = boldItemForm.find('.bold_option_radio');

                if (boldCheckboxRadioboxes.length) {

                  boldCheckboxRadioboxes.each(function() {
                    var boldCheckboxRadiobox = $(this);
                    var boldCheckboxRadioboxTitle = boldCheckboxRadiobox.children('.bold_option_title').text().trim();

                    if (/^Gift\-wrap this product .+/i.test(boldCheckboxRadioboxTitle)) {
                      boldCheckboxRadiobox.addClass('hidden');
                    }
                  });

                  var boldCheckboxTextboxes = boldItemForm.find('.bold_option_textbox');

                  boldCheckboxTextboxes.each(function() {
                    var boldCheckboxTextbox = $(this);

                    if (boldCheckboxTextbox.find('input[name^="properties[Embroidery ("]').length) {
                      var boldCheckboxTextboxTitle = boldCheckboxTextbox.find('.bold_option_title');

                      var boldCheckboxTextboxTitleValue = boldCheckboxTextboxTitle.text().trim();
                      var boldCheckboxTextboxNewTitleValue = boldCheckboxTextboxTitleValue.replace(/^(.+) \(.+\)$/, '$1');

                      boldCheckboxTextboxTitle.contents().filter(function(){
                        return this.nodeType == 3;
                      }).first().replaceWith(boldCheckboxTextboxNewTitleValue);

                      boldCheckboxTextbox.attr('data-embroidery-free', true);
                    }
                  });

                  clearInterval(cartPageObj.checkBoldUpsellFormByCircle);

                } else if (cartPageObj.checkBoldUpsellFormChecks > 50) {
                  clearInterval(cartPageObj.checkBoldUpsellFormByCircle);

                } else {
                  cartPageObj.checkBoldUpsellFormChecks++;
                }

              }, 500);
            };

            cartPageObj.checkBoldUpsellFormByCircle = setInterval(cartPageObj.checkBoldUpsellForm, 250);
            cartPageObj.checkBoldUpsellFormChecks = 0;
            cartPageObj.checkBoldUpsellForm();
          }
          /* /Upsell */
        }
      });
      /* Text */
      $(document).on('change keyup input', '.bold_options .bold_option_textbox .bold_option_element > input[type="text"], .bold_options .bold_option_textarea .bold_option_element > textarea', function() {

        var input = $(this);
        var inputName = input.attr('name');
        var inputValue = input.val().trim();

        if (typeof window.leOliveSyncEmbroideryChargeCheckboxes === 'function') {
          window.leOliveSyncEmbroideryChargeCheckboxes(
            (input.closest('form')[0]) || document.querySelector('.product-form') || document.querySelector('.bold_lightbox form')
          );
        } else {
          var checkbox = input.parents('.bold_option').prev('.bold_option_checkbox');

          if (checkbox.length) {
            var checkboxInput = checkbox.find('input[type="checkbox"]');

            if (inputValue.length > 0) {

              if (!checkboxInput.prop('checked')) {
                checkboxInput.addClass('enabled').click();
              }

            } else {

              if (checkboxInput.prop('checked')) {
                checkboxInput.addClass('enabled').click();
                checkboxInput.removeClass('enabled');
              }
            }
          }
          if (typeof window.leOliveRefreshProductOptionPrice === 'function') {
            window.leOliveRefreshProductOptionPrice(
              (input.closest('form')[0]) || document.querySelector('.product-form')
            );
          }
        }

        var formAlert = $('.bold_option_edit__cpbp-popup__alert');


        var activeOption = $('.product-form__options-wrapper .product-form__option.active');
        var activeOptionText = activeOption.text().trim();

        var productType = $('.product-form__header').attr('data-product-type');


//      ADDING ALERT_PROMPT NOTIFICATION

        if (/^properties\[Enter your personal message\]$/.test(inputName) && inputValue.length >= 150) {
          var alertMessageText = obj.t('You have now exceeded the maximum number of 150 characters. Shorten your text a bit!');
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the towel \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the slipper \(/.test(inputName) && /[^a-zA-Z\s]/.test(activeOptionText)  && inputValue.length >= 2) {
          var alertMessageText = 'You have reached the maximum limit of 2 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on bath capes \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on blankets \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on sheets \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on cuddle and pacifier cloths \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on pacifier \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on cuddle \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on hydrophilic cloths \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on care gift set \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on bath gift set \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on cuddle gift set \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on bath textiles \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the bath textiles \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the face mask \(/.test(inputName) && inputValue.length >= 8) {
          var alertMessageText = 'You have reached the maximum limit of 8 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the hat \(/.test(inputName) && inputValue.length >= 3) {
          var alertMessageText = 'You have reached the maximum limit of 3 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on wallet \(/.test(inputName) && inputValue.length >= 3) {
          var alertMessageText = 'You have reached the maximum limit of 3 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on hat \(/.test(inputName) && inputValue.length >= 6) {
          var alertMessageText = 'You have reached the maximum limit of 6 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the headband \(/.test(inputName) && inputValue.length >= 3) {
          var alertMessageText = 'You have reached the maximum limit of 2 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery at the bottom \(/.test(inputName) && inputValue.length >= 9) {
          var alertMessageText = 'You have reached the maximum limit of 9 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on backpacks \(/.test(inputName) && inputValue.length >= 10) {
          var alertMessageText = 'You have reached the maximum limit of 10 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the bag \(/.test(inputName) && inputValue.length >= 10) {
          var alertMessageText = 'You have reached the maximum limit of 10 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the sleep mask \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[FREE Embroidery on sleep mask \(/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery \(/.test(inputName) && inputValue.length >= 10) {
          var alertMessageText = 'You have reached the maximum limit of 10 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the chest \(/.test(inputName) && /^(1\-2|3\-4|5\-6|7\-8)\s/.test(activeOptionText) && inputValue.length >= 6) {
          var alertMessageText = 'You have reached the maximum limit of characters (letters & numbers): 6 characters for sizes 1-8years and 9 characters for sizes 9-12 years. Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the chest \(/.test(inputName) && /^(9\-10|11\-12)\s/.test(activeOptionText) && inputValue.length >= 9) {
          var alertMessageText = 'You have reached the maximum limit of characters (letters & numbers): 6 characters for sizes 1-8years and 9 characters for sizes 9-12 years. Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the chest \(/.test(inputName) && inputValue.length >= 9) {
          var alertMessageText = 'You have reached the maximum limit of 9 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the back \(/.test(inputName) && inputValue.length > 12) {

          var alertMessageText = 'You can add upon a maximum amount of 15 characters (letters & numbers), but we advise you to enter no more than 12 characters for the best result of the embroidery. Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Back Embroidery - second line\]$/.test(inputName) && inputValue.length >= 12) {
          var alertMessageText = 'You have reached the maximum limit of 12 characters (letters & numbers). Unfortunately, it is not possible to use Emojis or special characters to personalize your items with the exception of &#@*,.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Enter your personal message\]$/.test(inputName) && inputValue.length < 150) {
          formAlert.addClass('hide');

        } else if (/^properties\[Embroidery on the sleep mask - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        }  else if (/^properties\[Personalise initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        }  else if (/^properties\[Printing on label \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        }  else if (/^properties\[Printing on leash \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        }  else if (/^properties\[Printing on poop bag holder \(/.test(inputName) && /[^a-zA-Z\s]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        }  else if (/^properties\[Embroidery on laptop pouch \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        }  else if (/^properties\[Embroidery on the slipper \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        }  else if (/^properties\[Embroidery on the hat \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');


        }  else if (/^properties\[Embroidery on the headband \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on sleeve - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on the sleeve \(/.test(inputName) && /^[A-Za-z0-9\s.\-]*$/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on pillow - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on pillow and mask - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (/^properties\[Embroidery on scrunchie - initials \(/.test(inputName) && /[^a-zA-Z]/.test(inputValue)) {
          var alertMessageText = 'Please use letters only.';
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else if (inputValue.length && /^[a-zA-Z0-9\s\á\à\â\æ\ã\å\ā\ä\ë\ê\ē\ė\ę\é\è\î\ī\į\ì\í\ï\ô\ò\œ\ø\ō\õ\ó\ö\û\ù\ū\ú\ü\*\&\#\'\@\-\!\.]+$/i.test(inputValue)) {
          formAlert.addClass('hide');

        } else if (inputValue.length) {
          var alertMessageText = obj.t('Please use only: numbers, letters, . * & # @ - ! ');
          formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
          formAlert.removeClass('hide');

        } else {
          formAlert.addClass('hide');

        }


        // disabled dot
        if (
                /^properties\[Embroidery on hat/.test(inputName) ||
                // /^properties\[Embroidery on the hat/.test(inputName) ||
                // /^properties\[Embroidery on the headband/.test(inputName) ||
                /^properties\[Embroidery on backpacks/.test(inputName) ||
                /^properties\[Embroidery on bracelet/.test(inputName)
//                /^properties\[Embroidery on the slipper/.test(inputName)
        ) {
          if (inputValue.length && /^[A-z0-9\s\á\à\â\æ\ã\å\ā\ä\ë\ê\ē\ė\ę\é\è\î\ī\į\ì\í\ï\ô\ò\œ\ø\ō\õ\ó\ö\û\ù\ū\ú\ü\*\&\#\'\@\-\!\.]+$/i.test(inputValue)) {
            formAlert.addClass('hide');


          } else if (inputValue.length) {
            var alertMessageText = obj.t('Please use only: numbers, letters, . * & # @ - !');
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            formAlert.removeClass('hide');

          } else {
            formAlert.addClass('hide');

          }
        }

        //only . and -

        // if (
        //         /^properties\[Embroidery on the sleeve/.test(inputName)
        // ) {
        //   if (inputValue.length && /^[0-9\-\. \-]+$/i.test(inputValue)) {
        //     formAlert.addClass('hide');


        //   } else if (inputValue.length) {
        //     var alertMessageText = obj.t('Please use only: numbers, "-" and "."');
        //     formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
        //     formAlert.removeClass('hide');

        //   } else {
        //     formAlert.addClass('hide');

        //   }
        // }

        // only numbers 0-9, + and -
        if (
                /^properties\[Embroidery on dog collar - number/.test(inputName) ||
                /^properties\[Embroidery on harness - number/.test(inputName) ||
                /^properties\[Embroidery on leash - number/.test(inputName)
        ) {
          if (inputValue.length && /^[0-9+-]+$/i.test(inputValue)) {
            formAlert.addClass('hide');


          } else if (inputValue.length) {
            var alertMessageText = obj.t('Please use + - and numbers only.');
            formAlert.html('<p>' + alertMessageText + '</p>').removeClass('hidden');
            formAlert.removeClass('hide');

          } else {
            formAlert.addClass('hide');

          }
        }
      });
      /* /Text */

      $(document).on('click', '.bold_option_edit__cpbp__edit-btn > .bold_cart_edit_button', function(e) {
        var btn = $(this);

        var cartItem = btn.parents('.cart__row');
        cartItem.addClass('cart-row__bold-opened');

        cartPageObj.checkBoldFormByCircle = setInterval(cartPageObj.checkBoldForm, 250);
        cartPageObj.checkBoldFormChecks = 0;
        cartPageObj.checkBoldForm();
      });

      $(document).on('click', '.bold_option_edit__cpbp-popup__update-btn', function(e) {

        if (e.target.nodeName == 'SPAN') {


          var boldItemForm = $('.bold_lightbox .bold_lightbox_content:visible');

          var boldItemPopupAlert = boldItemForm.find('.bold_option_edit__cpbp-popup__alert');
          

          var activeEmbroideryLeatherColor = false;
          var leatherField = boldItemForm.find('.bold_option_element > input[name^="properties[Personalise initials ("]:visible');
          var iphoneleatherField = boldItemForm.find('.bold_option_element > input[name^="properties[Personalise Initials ("]:visible');

          var embroideryChestFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery on the chest ("]:visible');
          var embroideryGloveFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery on the glove ("]:visible');
          var embroideryBackFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery on the back ("]:visible');

          var embroideryBack2LineFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Back Embroidery - second line"]:visible');
          var embroideryBottomFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery at the bottom ("]:visible');

          var embroideryColors = boldItemForm.find('.bold_option_swatch:visible');
          var activeEmbroideryColor = false;

          var activeEmbroideryFacemaskColor = false;
          var embroideryFacemaskFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery on the face mask ("]:visible');

          var embroideryTowelField = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery on the towel ("]:visible');
          var embroideryWalletFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery on wallet ("]:visible');
//          var embroideryBibField = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery on bib ("]:visible');


          /* Stocking */
          var embroideryStockingFiled = boldItemForm.find('.bold_option_element > input[name^="properties[Embroidery ("]:visible');
          /* /Stocking */

          /* T-shirts */
          var tShirtDesignDropdown = boldItemForm.find('.bold_option_element input[name="properties[Design Options]"]:visible');

          if (tShirtDesignDropdown.length) {
            var tShirtDesignSwatch = boldItemForm.find('.bold_option_swatch:not(.bold_option_hidden):visible');
            var tShirtTextFields = boldItemForm.find('.bold_option_textbox:not(.bold_option_hidden):visible');

            if (tShirtTextFields.length) {
              var tShirtInput = boldItemForm.find('input[type="text"][name="properties[Text on the t-shirt]"]')
              if (tShirtInput.length) {
                var tShirtInputValue = tShirtInput.val().trim();
              }
              var tShirt2Input = boldItemForm.find('input[type="text"][name="properties[Text on the t-shirt - second line]"]');
              if (tShirt2Input.length) {
                var tShirt2InputValue = tShirt2Input.val().trim();
              }


              if (tShirtInput.length && !tShirtInputValue.length ||
                      tShirt2Input.length && !tShirt2InputValue.length
              ) {
                boldItemPopupAlert.text('Please add text on t-shirt.');
                boldItemPopupAlert.removeClass('hide');
              }

            }
            if (tShirtDesignSwatch.length) {
              tShirtDesignSwatch.each(function () {


                var selectedSwatchElement = $(this).find('.bold_swatch_selected');

                if (!selectedSwatchElement.length) {

                  if (boldItemForm.find('.bold_option_element > input[name="properties[Design Options]"][value="Custom Design"]:checked')) {
                    boldItemPopupAlert.text('Please choose a font and color options.');
                    boldItemPopupAlert.removeClass('hide');
                  } else {
                    boldItemPopupAlert.text('Please choose a fixed design and color options..');
                    boldItemPopupAlert.removeClass('hide');
                  }


                }

              })
            }



          }
          /* /T-shirts */


          if (embroideryColors.length) {

            embroideryColors.each(function() {
              console.log($(this))
              var embroideryColor = $(this);
              var embroideryColorTitle = embroideryColor.find('.bold_option_title').text().trim();
              if (embroideryColor.find('.bold_swatch_selected').length) {
                activeEmbroideryColor = true;
              }
              /*
              if (/^Embroidery color$/i.test(embroideryColorTitle) || embroideryColorTitle == 'Embroidery color (for kimono)') {

                if (embroideryColor.find('.bold_swatch_selected').length) {
                  activeEmbroideryColor = true;
                }

              } else if (embroideryColorTitle == 'Embroidery color (for face mask)') {

                if (embroideryColor.find('.bold_swatch_selected').length) {
                  activeEmbroideryFacemaskColor = true;
                }

              } else if (embroideryColorTitle == 'Choose your print colour') {

                if (embroideryColor.find('.bold_swatch_selected').length) {
                  activeEmbroideryLeatherColor = true;
                }
              }
               */
            });
          }

          if (
            !activeEmbroideryLeatherColor &&
            (
              (leatherField.length && leatherField.val().trim().length)
            )
          ) {
            boldItemPopupAlert.text('Choose a colour for the print.');
            boldItemPopupAlert.removeClass('hide');

          } else if (
            !activeEmbroideryColor &&
            (
              (embroideryChestFiled.length && embroideryChestFiled.val().trim().length) ||
              (embroideryGloveFiled.length && embroideryGloveFiled.val().trim().length) ||
              (embroideryBackFiled.length && embroideryBackFiled.val().trim().length) ||
              (embroideryBack2LineFiled.length && embroideryBack2LineFiled.val().trim().length) ||
              (embroideryBottomFiled.length && embroideryBottomFiled.val().trim().length) ||
              (embroideryWalletFiled.length && embroideryWalletFiled.val().trim().length) ||
//              (embroideryBibField.length && embroideryBibField.val().trim().length) ||


              (embroideryTowelField.length && embroideryTowelField.val().trim().length)
            )
          ) {
            boldItemPopupAlert.text('Choose a colour for the embroidery.');
            boldItemPopupAlert.removeClass('hide');

          } else if (
            !activeEmbroideryFacemaskColor &&
            (
              (embroideryFacemaskFiled.length && embroideryFacemaskFiled.val().trim().length)
            )
          ) {
            boldItemPopupAlert.text('Choose a colour for the embroidery facemask.');
            boldItemPopupAlert.removeClass('hide');

          /* Stocking */
          } else if (
            !activeEmbroideryColor &&
            (
              (embroideryStockingFiled.length && embroideryStockingFiled.val().trim().length)
            )
          ) {
            boldItemPopupAlert.text('Choose a colour for the embroidery.');
            boldItemPopupAlert.removeClass('hide');
          }
          /* custom cart validation */
          if(boldItemForm.find('.bold_option_element input[name*="properties[Embroidery Color"]').length > 0){
              var embroideryColorField = boldItemForm.find('.bold_option_element input[name*="properties[Embroidery Color"]').val();
              if(embroideryColorField.length < 1 ){
                boldItemPopupAlert.text(obj.t('Choose a colour for the embroidery.'));
                boldItemPopupAlert.removeClass('hide');
              }
          }

          if(boldItemForm.find('.bold_option_element input[name*="properties[Choose embroidery font"]').length > 0){
            var embroideryFontField = boldItemForm.find('.bold_option_element input[name*="properties[Choose embroidery font"]').val();
            var assignedFontField = boldItemForm.find('input[name="properties[Make-up bag Embroidery font]"], input[name="properties[Embroidery font]"], input[name="properties[Gloves Embroidery font]"], input[name="properties[Apron Embroidery font]"], input[name="properties[Hat Embroidery font]"]').filter(function () {
              return String($(this).val() || '').trim().length > 0;
            });
            if(embroideryFontField.length < 1 && !assignedFontField.length){
              boldItemPopupAlert.text(obj.t('Please choose embroidery font.'));
              boldItemPopupAlert.removeClass('hide');
            }
          }
          
          if(boldItemForm.find('.bold_option_element input[name*="properties[Choose your print colour"]').length > 0){
            var embroideryFontField = boldItemForm.find('.bold_option_element input[name*="properties[Choose your print colour"]').val();
            if(embroideryFontField.length < 1 ){
              boldItemPopupAlert.text(obj.t('Choose your print colour'));
              boldItemPopupAlert.removeClass('hide');
            }
          }
          if(boldItemForm.find('.bold_option_element input[name*="properties[Embroidery color on"]').length > 0){
            var embroideryFontField = boldItemForm.find('.bold_option_element input[name*="properties[Embroidery color on"]').val();
            if(embroideryFontField.length < 1 ){
              boldItemPopupAlert.text(obj.t('Choose a colour for the embroidery.'));
              boldItemPopupAlert.removeClass('hide');
            }
          }
          if(boldItemForm.find('.bold_option_element input[name*="properties[Embroidery color"]').length > 0){
            var embroideryFontField = boldItemForm.find('.bold_option_element input[name*="properties[Embroidery color"]').val();
            if(embroideryFontField.length < 1 ){
              boldItemPopupAlert.text(obj.t('Choose a colour for the embroidery.'));
              boldItemPopupAlert.removeClass('hide');
            }
          }
          let onlyNumberFields = boldItemForm.find('.bold_option_element input[type="text"][name*="properties[Embroidery on dog collar - number"], .bold_option_element input[type="text"][name*="properties[Embroidery on harness - number"], .bold_option_element input[type="text"][name*="properties[Embroidery on leash - number"]')
          if(onlyNumberFields.length > 0){
            onlyNumberFields.each(function (){
              var inputValue = $(this).val();
                
              if (inputValue.length && /^[0-9+-]+$/i.test(inputValue)) {
               

              } else if (inputValue.length) {
                boldItemPopupAlert.text(obj.t('Please use + - and numbers only.'));
                boldItemPopupAlert.removeClass('hide');
              } 
            })

          }

          /* /Stocking */


          /* Enter your personal message */
          var formField = $('.bold_options .bold_option_dropdown .bold_option_element > select[name="properties[Add a wish card]"]');
          var textareaField = $('.bold_options .bold_option_textarea .bold_option_element > textarea[name="properties[Enter your personal message]"]');

          if (formField.length && textareaField.length) {

            if (textareaField.val().trim().length && formField.val() == 'No, thanks') {
              var alertMessageText = obj.t('Choose your wish card');
              boldItemPopupAlert.html(alertMessageText).removeClass('hide');
            }
          }
          /* /Enter your personal message */

          if (boldItemPopupAlert.hasClass('hide')) {
            var btn = $(this).find('button.bold_options_lightbox_cart_edit_update_btn');
            btn.html('Loading...')
            btn.click();

          }
        }
      });

      return cartPageObj;
    };

    cartPageObj.checkBoldForm = function() {
      var boldItemForm = $('.bold_option_edit_container:visible');

      if (boldItemForm.length &&
          !boldItemForm.hasClass('bold_option_edit_container-loaded') &&
          boldItemForm.find('.bold_option_checkbox').length &&
          boldItemForm.find('.bold_option_swatch .bold_option_value .bold_option_value_title').length &&
          boldItemForm.find('.bold_option_checkbox').length) {
        var productVariantTitle = boldItemForm.parents('tr').attr('data-variant-title');


        /* Text */
//         var boldTextboxFields = boldItemForm.find('.bold_option_textbox:not(.bold_option_checkbox-loaded)');

//         if (boldTextboxFields.length) {

//           boldTextboxFields.each(function() {
//             var boldTextboxField = $(this);
//             var boldTextboxFieldTitle = boldTextboxField.find('.bold_option_title').text().trim();

//             if (/^(Baby|1\-2 years)$/.test(productVariantTitle.trim()) && /^Embroidery on the chest/i.test(boldTextboxFieldTitle.trim())) {
//               boldTextboxField.addClass('invisible');
//             }
//           });
//         }
        /* /Text */


        /* Color */
        var colors = boldItemForm.find('.bold_option_swatch > .bold_option_element > .bold_option_value');

        if (colors.length) {

          colors.each(function() {
            var color = $(this);
            var colorValue = color.find('.bold_option_value_title').text().trim();
          });
        }
        /* /Color */


        boldItemForm.addClass('bold_option_edit_container-loaded');

        clearInterval(cartPageObj.checkBoldFormByCircle);

      } else if (cartPageObj.checkBoldItemChecks > 50) {
        clearInterval(cartPageObj.checkBoldFormByCircle);

      } else {
        cartPageObj.checkBoldItemChecks++;
      }

      return cartPageObj;
    };

    $(document).on('change keyup', '.bold_option_textbox:not(.bold_option_hidden):visible input[type="text"]', function (evt) {
      $('.bold_option_edit__cpbp-popup__alert:visible').addClass('hide');
    })


    $(document).on('change', '.bold_lightbox .bold_option_swatch > .bold_option_element > .bold_option_value input[type="checkbox"]', function() {
      var colorCheckbox = $(this);
      var colorLabel = colorCheckbox.parents('label');
      var color = colorCheckbox.parents('.bold_option_value');

      if (!colorCheckbox.is(':checked')
          && !color.hasClass('bold_option_value__active')
          && !color.siblings('.bold_option_value__active').length) {

        setTimeout(function() {
          colorLabel.click();
        }, 50);
      }

      if (colorCheckbox.is(':checked')) {
        var boldItemPopupAlert = $('.bold_option_edit__cpbp-popup__alert');
        boldItemPopupAlert.html('').addClass('hide');

        color.addClass('bold_option_value__active').siblings('.bold_option_value__active').removeClass('bold_option_value__active');

      } else {
        color.removeClass('bold_option_value__active');
      }
    });

    cartPageObj.boldItems = function() {
      var cartItems = $('table.cart-table tr.cart__row');
      const isPropertyEdit = false;
      if (cartItems.length && isPropertyEdit === true) {

        cartItems.each(function() {
          var cartItem = $(this);
          var cartItemKey = cartItem.attr('data-item-key');
          var cartItemProperties = cartItem.find('.cart__row-property');

          var cartItemBoldInputs = cartItem.nextUntil('.cart__row');

          var cartItemQuantity = cartItem.find('.cart__table-cell--quantity');
          var cartItemQuantityValue = parseInt(cartItemQuantity.find('input.quantity-selector').val());

          if (cartItemProperties.length) {
            var cartItemPropertiesCount = 0;

            cartItemProperties.each(function() {
              var cartItemProperty = $(this);
              var cartItemPropertyTitle = cartItemProperty.find('.cart__row__property-name');
              var cartItemPropertyTitleText = cartItemPropertyTitle.attr('data-text');
              var cartItemPropertyName = null;

              cartItemBoldInputs.each(function() {
                var cartItemBoldInput = $(this);

                if (cartItemPropertyTitleText == 'Add FREE Sleep Mask Champagne') {
                  var cartItemPropertyPriceValue = parseInt(cartItemBoldInputs.filter('[data-title="FREE Sleep Mask Champagne"]').attr('data-price')) / 100;
                  var cartItemPropertyPriceValue = 0;
                  var cartItemPropertyName = cartItemPropertyTitleText;

                } else if (cartItemPropertyTitleText == 'Add a wish card') {
                  var cartItemPropertyName = cartItemPropertyTitleText;

                } else if (cartItemPropertyTitleText == 'Gift-wrap this product') {
                  var cartItemPropertyPriceValue = parseInt(cartItemBoldInputs.filter('[data-title^="Gift-wrap - "]').attr('data-price')) / 100;
                  var cartItemPropertyName = cartItemPropertyTitleText;

                } else if (cartItemBoldInput.attr('data-title').replace(/^(.+) (\(.+\) \- (Yes|checked)|\- [A-z]+ \- Yes|\- charge \- checked)$/, '$1').trim() == cartItemPropertyTitleText.replace(/^(.+) \(.+\)$/, '$1').trim()) {
                  var cartItemPropertyName = cartItemPropertyTitleText.replace(/^(.+) \([\+]{0,1}.+\)$/, '$1').trim();
                  var cartItemPropertyPriceValue = parseInt(cartItemBoldInput.attr('data-price')) / 100;

                } else if (cartItemBoldInput.attr('data-title').replace(/^(.+) \- charge \- checked$/, '$1').trim() == cartItemPropertyTitleText.replace(/^(.+) \(.+\)$/, '$1').trim()) {
                  var cartItemPropertyName = cartItemPropertyTitleText.replace(/^(.+) \([\+]{0,1}.+\)$/, '$1').trim();
                  var cartItemPropertyPriceValue = parseInt(cartItemBoldInput.attr('data-price')) / 100;
                }
                if ( isNaN(cartItemPropertyPriceValue) || cartItemPropertyPriceValue === NaN) {
                  var cartItemPropertyPriceValue = parseInt(cartItemBoldInput.attr('data-price')) / 100;
                }
                if (cartItemPropertyName) {
                  cartItemProperty.attr({
                    'data-id': cartItemBoldInput.attr('id'),
                    'data-quantity': cartItemBoldInput.attr('data-quantity'),
                    'data-name': cartItemPropertyName,
                    'data-price': cartItemPropertyPriceValue
                  });
                }
              });

              cartItemPropertyTitle.text(cartItemPropertyTitleText.replace(/^(.+) \([\+]{0,1}.+\)$/, '$1').trim());
            });

            var cartItemProperties = cartItemProperties.filter('[data-price]');

            if (cartItemProperties.length) {
              /* Prices */
              var cartItemPrice = cartItem.find('.cart__table-cell--price');

              if (cartItemPrice.length) {
                cartItemPrice.append(
                  '<div class="cart__table-cell__bold-prices"></div>'
                );

                var cartItemBoldPrices = cartItemPrice.find('.cart__table-cell__bold-prices');

                cartItemProperties.each(function() {
                  var cartItemProperty = $(this);
                  var cartItemPropertyPrice = cartItemProperty.attr('data-price');
                  cartItemBoldPrices.append(
                    '<div class="cart__table-cell__bold-price">' +
                    '<span>' + obj.preparePrice(cartItemPropertyPrice) + '</span>' +
                    '<small>' + cartItemProperty.attr('data-name') + '</small>' +
                    '</div>'
                  );
                });
              }
              /* /Prices */

              /* Quantities */
              cartItemQuantity.append(
                '<div class="cart__table-cell__bold-quantities"></div>'
              );

              var cartItemBoldQuantites = cartItemQuantity.find('.cart__table-cell__bold-quantities');

              cartItemProperties.each(function(cartItemPropertyI) {
                var cartItemProperty = $(this);
                var cartItemPropertyId = cartItemProperty.attr('data-id');

                if (cartItemPropertyI == 0) {
                  var cartItemPropertyQuantityInput = cartItem.next('input.bold_hidden_input[type="hidden"]');

                } else if (cartItemPropertyI == 1) {
                  var cartItemPropertyQuantityInput = cartItem.next('input.bold_hidden_input[type="hidden"]').next('input.bold_hidden_input[type="hidden"]');
                }

                var cartItemPropertyQuantityInput = $('input.bold_hidden_input[id="' + cartItemPropertyId + '"]');
                var cartItemPropertyQuantityValue = parseInt(cartItemPropertyQuantityInput.attr('data-quantity'));

                cartItemBoldQuantites.append(
                  '<div class="cart__table-cell__bold-quantity" data-id="' + cartItemPropertyId + '">' +
                  '<input type="number" value="' + cartItemPropertyQuantityValue + '" min="1" max="' + cartItemQuantityValue + '"/>' +
                  '</div>'
                );
              });
              /* /Quantities */

              /* Line prices */
              var cartItemLinePrice = cartItem.find('.cart__table-cell--line-price');

              if (cartItemLinePrice.length) {
                cartItemLinePrice.append(
                  '<div class="cart__table-cell__bold-line-prices"></div>'
                );

                var cartItemBoldLinePrices = cartItemLinePrice.find('.cart__table-cell__bold-line-prices');

                cartItemProperties.each(function() {
                  var cartItemProperty = $(this);
                  var cartItemPropertyQuantity = parseInt(cartItemProperty.attr('data-quantity'));
                  var cartItemPropertyLinePrice = parseFloat(cartItemProperty.attr('data-price'));

                  var cartItemPropertyLinesPrice = cartItemPropertyLinePrice * cartItemPropertyQuantity;

                  cartItemBoldLinePrices.append(
                    '<div class="cart__table-cell__bold-line-price">' + obj.preparePrice(cartItemPropertyLinesPrice) + '</div>'
                  );
                });
              }
              /* /Line prices */

              $(document).on('change', '.cart__row .cart__table-cell--quantity .cart__table-cell__bold-quantity input', function() {
                var input = $(this);
                var inputValue = parseInt(input.val());

                var maxInputValue = parseInt(input.attr('max'));

                var cartItemPropertyId = $(this).parent().attr('data-id');
                var cartItemPropertyQuantityInput = $('input.bold_hidden_input[id="' + cartItemPropertyId + '"]');
                var lineKey = cartItemPropertyQuantityInput.attr('data-id');

                if (inputValue > maxInputValue) {
                  input.val(maxInputValue);
                  inputValue = maxInputValue;
                }

                if (!lineKey || isNaN(inputValue)) {
                  return;
                }

                window.__leOliveSkipGiftSync = true;
                fetch('/cart/change.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: lineKey,
                    quantity: inputValue
                  })
                }).then(function () {
                  location.reload();
                }).catch(function () {
                  location.reload();
                });
              });
            }
          }
        });

        var priceProperties = $('.cart-table .bold_hidden_input.cart__product-qty');

        if (priceProperties.length) {

          setInterval(function() {

            priceProperties.each(function() {
              var priceProperty = $(this);
              priceProperty.val(priceProperty.attr('data-quantity'));
            });
          }, 500);
        }
      }

      return cartPageObj;
    };

    cartPageObj.init();

    return obj;
  };

  obj.preparePrice = function(priceValue) {
    var currencySymbol = $('body').attr('data-currency-symbol');
    var price = currencySymbol + parseFloat(priceValue).toFixed(2);
    return price;
  };

  obj.indexPage = function() {
    var indexPageObj = function() {};

    /* Black Friday */
//     if (/BLACKFRIDAYMODE/.test(window.location.href)) {

//     } else {
//       $('body').addClass('template-index__bf');

//       $('.index-single__intro-text h1:first').remove();
//       $('.index-single__intro-text h1.hide').removeClass('hide');

//       $('.index-single__intro-text .featured-row__subtext:first').remove();
//       $('.index-single__intro-text .featured-row__subtext.hide').removeClass('hide');
//     }
    /* /Black Friday */

    /* Christmas */
     if (/CHRISTMAS/.test(window.location.href)) {
      $('body').addClass('template-index__christmas');

      $(window).on('load resize', function() {
        var primaryArticle = $('.index-single__primary-article');

        var primaryArticleImage = $('.index-single__primary-article__image-wrapper');
        primaryArticleImage.removeAttr('style');

        if ($(window).width() >= 990) {
          primaryArticleImage.css({
            'position': 'relative',
            'top': (primaryArticle.outerHeight() - primaryArticleImage.outerHeight()) / 2
          });
        }
      });
     }
    /* /Christmas */

    /* Hero */
    var titleWords = $('.index-single__hero-title__word');

    if (titleWords.length) {

      titleWords.each(function() {
        var titleWord = $(this);

        setInterval(function() {

          if (titleWord.hasClass('up-position')) {
            titleWord.removeClass('up-position').addClass('middle-position');

          } else if (titleWord.hasClass('middle-position')) {
            titleWord.removeClass('middle-position').addClass('down-position');

          } else if (titleWord.addClass('down-position')) {
            titleWord.removeClass('down-position').addClass('up-position');
          }

        }, 2500);
      });
    }
    /* /Hero */


    /* Collection page */
    var collections = $('.collection-grid > .owl-carousel');

    if (collections.length && !collections.hasClass('owl-loaded')) {
      collections.owlCarousel({
        dots: false,
        loop: false,
        nav: false,
        responsiveClass: true,
        margin: 0,
        responsive: {
          0: {
            nav: false,
            items: 2
          },
          750: {
//             nav: true,
            items: 2
          },
          990: {
//             nav: true,
            items: 4
          }
        }
      });
    }
    /* /Collection page */


    var products = $('.product-miniatures.owl-carousel');

    if (products.length) {

      products.owlCarousel({
        dots: false,
        loop: false,
        responsiveClass: true,
        margin: 0,
        responsive: {
          0: {
            nav: false,
            margin: 18,
            items: 1
          },
          750: {
            margin: 30,
            items: 2
          },
          990: {
            nav: true,
            margin: 30,
            items: 3
          }
        }
      });
    }


    var productGroupField = $('#formProductGroupURL');
    var productFields = $('#formProductURL');

    productFields.children('option').each(function() {
      var productField = $(this);
      var productType = productField.text().trim().replace(/^([A-z0-9]+)\s.+$/, '$1');

      var prevProductField = productField.prev();

      if (prevProductField.length) {
        var prevProductType = prevProductField.text().trim().replace(/^([A-z0-9]+)\s.+$/, '$1');

      } else {
        var prevProductType = productType;
      }

      var productOptGroup = productGroupField.find('optgroup[label="' + productType + '"]');

      if (!prevProductField.length || (prevProductField.length && productType !== prevProductType)) {

        if (!productOptGroup.length) {
          productGroupField.append(
            '<optgroup label="' + productType + '"></optgroup>'
          );
        }
      }

      if (!productOptGroup.length) {
        var productOptGroup = productGroupField.find('optgroup:last');
      }

      productOptGroup.append(productField[0].outerHTML);
    });

    $(document).on('change', '#formProductGroupURL', function() {
      var dropdown = $(this);
      var dropdownValue = $(this).find('option:selected').text();

      var title = dropdown.siblings('.site-index__form-field__title');
      title.text(dropdownValue);
    });

    /* Klaviyo homepage popup */
    if (/DEVMODE/.test(window.location.href)) {
      $(document).on('click', '.ps__klaviyo-popup__bg, .ps__klaviyo-popup__close', function() {
         $('body').removeClass('ps__klaviyo-popup__visible');
       });

      $(document).on('click', '.template-index .index-single__intro .featured-row__action .btn--primary', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $('body').addClass('ps__klaviyo-popup__visible');
     });
     }
     /* /Klaviyo homepage popup */

    return obj;
  };

  obj.showCartPopup = function() {
    var popup = $('.cart-side__popup');
    var cartLink = $('.site-header__cart');

    $.ajax({
      url: cartLink.attr('href'),
      dataType: 'html',
      type: 'get',
      success: function(result) {
        var popupItems = popup.find('.cart-side__popup-items');
        popupItems.html('');

        var popupTotalPrice = popup.find('.cart-side__popup__total-price');
        var ajaxTotalPrice = $(result).find('.cart__subtotal');

        popupTotalPrice.text(ajaxTotalPrice.text());

        var ajaxItems = $(result).find('table.cart-table tr.cart__row.responsive-table__row');

        if (ajaxItems.length) {

          ajaxItems.each(function() {
            var ajaxItem = $(this);

            var ajaxItemImage = ajaxItem.find('.cart__image');
            var ajaxItemLink = ajaxItem.find('.cart__table-cell--meta a:first');
            var ajaxItemPrice = ajaxItem.find('.cart__table-cell--line-price:last');

            popupItems.append(
              '<li class="cart-side__popup-item">' +
              '<div class="cart-side__popup-item__image">' +
              ajaxItemImage[0].outerHTML +
              '</div>' +
              '<div class="cart-side__popup-item__right">' +
              '<a href="' + ajaxItemLink.attr('href') + '" class="cart-side__popup-item__link">' + ajaxItemLink.text() + '</a>' +
              '<div class="cart-side__popup-item__price">' + ajaxItemPrice.text() + '</div>' +
              '</div>' +
              '</li>'
            );
          });
        }

        $('body').addClass('cart-side__popup-visible');
      }
    });

    return obj;
  };

  obj.init();
});


$(theme.init);

$(document).ready(function(){
  var did_remove_colors = false;
  if (typeof window.colors_to_hide != 'undefined') {
    if (window.colors_to_hide.length > 0) {
      var removeInterval = window.setInterval(function () {
        if ($('.bold_options_custom_loaded').length > 0) {
          $(window.colors_to_hide).each(function (ix, em) {
            let current_color = em;
            $(`[data-color="${current_color}"]`).remove();
          });
          clearInterval(removeInterval);
        }
      }, 100);
    }
  }
});



      /* Gift wrapper */


      // Klaviyo popup on unavailable product
      document.querySelectorAll(".pets-wrapper .product-form__option").forEach(item => {
        item.addEventListener('click', (e) => {
          const isAvailable = !e.currentTarget.classList.contains('disabled');
          const button = e.currentTarget.closest('.product-form').querySelector('#AddToCartNew');
          const buttonLabel = e.currentTarget.closest('.product-form').querySelector('#AddToCartNew span');
          const labels = [buttonLabel.textContent.trim(), 'Notify me'];

          if (!isAvailable) {
            buttonLabel.textContent = 'Notify me';
            button.classList.add('allow-klaviyo-open');
          } else {
            buttonLabel.textContent = "Aan winkelwagen toevoegen";
            button.classList.remove('allow-klaviyo-open');
          }

          button.addEventListener('click', e => {
            if (e.currentTarget.classList.contains('allow-klaviyo-open')) {

              // Function to find the errors block once it's loaded
              function waitForBlock(selector) {
                  return new Promise((resolve) => {
                      const observer = new MutationObserver((mutations, me) => {
                          const elem = document.querySelector(selector);
                          if (elem) {
                              me.disconnect(); // stop observing
                              resolve(elem);
                          }
                      });
                      observer.observe(document, {
                          childList: true,
                          subtree: true
                      });
                  });
              }

              waitForBlock('.product-single__cart-submit-wrapper .errors').then((errorElement) => {
                errorElement.style.display = "none";
              });

              $('body').addClass('ps__klaviyo-popup__visible');
            } else {
              document.querySelector('.product-single__cart-submit-wrapper .errors').style.display = "block";
            }
          });
          setTimeout(() => {
            if (button.classList.contains('allow-klaviyo-open')) {
              $('#AddToCartNew').removeAttr('disabled');
            }
          }, 5000);
        });
      })





var gloveTextboxField = $('.product-form input[name="properties[Embroidery on the glove (+€9.95)]"]');
var gloveColorWrapper = $('.product-form .bold_option_swatch:has(input[name="properties[Embroidery color]"])');
var gloveColorHidden = gloveColorWrapper.find('input[name="properties[Embroidery color]"]');

if (gloveTextboxField.length && gloveColorWrapper.length) {

  function validateGloveColor() {
    var textValue = gloveTextboxField.val().trim();
    var colorValue = gloveColorHidden.val();

    if (textValue !== '') {
      gloveColorWrapper.addClass('required');

      // if NO color selected → show error
      if (!colorValue) {
        gloveColorWrapper.addClass('error');
      } else {
        gloveColorWrapper.removeClass('error');
      }

    } else {
      gloveColorWrapper.removeClass('required error');
    }
  }

  // run on load
  validateGloveColor();

  // when typing embroidery
  gloveTextboxField.on('input blur change keyup', function () {
    validateGloveColor();
  });

  // when selecting color (swatch click)
  gloveColorWrapper.on('click', '.bold_option_value_element', function () {
    setTimeout(function () {
      validateGloveColor();
    }, 50);
  });
}



